import * as i from "zod";
import { readonly as md, shallowRef as fe, ref as q, computed as k, toValue as A, provide as pd, inject as fd, reactive as Se, watchEffect as Mt, useTemplateRef as Pn, toRaw as po, createElementBlock as v, openBlock as u, renderSlot as P, defineComponent as C, createElementVNode as l, onScopeDispose as si, unref as n, createCommentVNode as y, createVNode as m, toDisplayString as c, createBlock as b, mergeModels as ve, useModel as Q, withCtx as f, mergeProps as ae, Fragment as I, renderList as te, createTextVNode as $, Teleport as gd, withModifiers as X, resolveComponent as ii, normalizeClass as ke, withDirectives as L, vModelText as j, normalizeStyle as K, watch as De, vShow as xt, isRef as st, effectScope as vd, resolveDynamicComponent as bd, useId as ri, onBeforeMount as yd, onMounted as hd } from "vue";
import { useObservable as Z, from as Ws } from "@vueuse/rxjs";
import * as hn from "remeda";
import { isDeepEqual as Yo, omit as Zs, pick as _d, pipe as ne, sort as $d } from "remeda";
import * as x from "rxjs";
import { isObservable as Sd, firstValueFrom as kd } from "rxjs";
import { prefixStorage as wd } from "unstorage";
import { syncRef as xd, useElementSize as Cd, toRef as Ys } from "@vueuse/core";
import { v4 as ye } from "uuid";
import { v4 as y8 } from "uuid";
import { useI18n as R } from "vue-i18n";
import { SelectIcon as Td, SelectValue as Rd, SelectScrollDownButton as Dd, SelectScrollUpButton as Md, SelectViewport as Ed, SelectItemText as Pd, SelectItem as Ld, SelectGroup as jd, SelectLabel as Ad, SelectItemIndicator as Od, SelectSeparator as Ud, SelectArrow as Vd, SelectContent as Id, SelectPortal as zd, SelectTrigger as Nd, SelectRoot as Fd, AccordionTrigger as Bd, AccordionRoot as Gd, AccordionItem as Hd, AccordionHeader as Kd, AccordionContent as qd, AlertDialogAction as Wd, AlertDialogDescription as Zd, AlertDialogTitle as Yd, AlertDialogCancel as Jd, AlertDialogOverlay as Xd, AlertDialogContent as Qd, AlertDialogPortal as em, AlertDialogTrigger as tm, AlertDialogRoot as nm, AvatarImage as om, AvatarFallback as am, AvatarRoot as sm, CalendarCellTrigger as im, CalendarGridRow as rm, CalendarGridBody as lm, CalendarGridHead as cm, CalendarPrev as um, CalendarNext as dm, CalendarHeadCell as mm, CalendarCell as pm, CalendarGrid as fm, CalendarHeading as gm, CalendarHeader as vm, CalendarRoot as bm, CheckboxIndicator as ym, CheckboxRoot as hm, CheckboxGroupRoot as _m, CollapsibleContent as $m, CollapsibleTrigger as Sm, CollapsibleRoot as km, ComboboxPortal as wm, ComboboxArrow as xm, ComboboxSeparator as Cm, ComboboxItemIndicator as Tm, ComboboxItem as Rm, ComboboxVirtualizer as Dm, ComboboxViewport as Mm, ComboboxContent as Em, ComboboxLabel as Pm, ComboboxGroup as Lm, ComboboxCancel as jm, ComboboxTrigger as Am, ComboboxEmpty as Om, ComboboxAnchor as Um, ComboboxInput as Vm, ComboboxRoot as Im, ContextMenuSubTrigger as zm, ContextMenuSubContent as Nm, ContextMenuSub as Fm, ContextMenuRadioItem as Bm, ContextMenuRadioGroup as Gm, ContextMenuLabel as Hm, ContextMenuItemIndicator as Km, ContextMenuCheckboxItem as qm, ContextMenuSeparator as Wm, ContextMenuGroup as Zm, ContextMenuItem as Ym, ContextMenuArrow as Jm, ContextMenuContent as Xm, ContextMenuPortal as Qm, ContextMenuTrigger as ep, ContextMenuRoot as tp, DateFieldInput as np, DateFieldRoot as op, DatePickerContent as ap, DatePickerTrigger as sp, DatePickerClose as ip, DatePickerArrow as rp, DatePickerAnchor as lp, DatePickerField as cp, DatePickerCalendar as up, DatePickerInput as dp, DatePickerCellTrigger as mp, DatePickerGridRow as pp, DatePickerGridBody as fp, DatePickerGridHead as gp, DatePickerPrev as vp, DatePickerNext as bp, DatePickerHeadCell as yp, DatePickerCell as hp, DatePickerGrid as _p, DatePickerHeading as $p, DatePickerHeader as Sp, DatePickerRoot as kp, DateRangeFieldInput as wp, DateRangeFieldRoot as xp, DateRangePickerContent as Cp, DateRangePickerTrigger as Tp, DateRangePickerClose as Rp, DateRangePickerArrow as Dp, DateRangePickerAnchor as Mp, DateRangePickerField as Ep, DateRangePickerCalendar as Pp, DateRangePickerInput as Lp, DateRangePickerCellTrigger as jp, DateRangePickerGridRow as Ap, DateRangePickerGridBody as Op, DateRangePickerGridHead as Up, DateRangePickerPrev as Vp, DateRangePickerNext as Ip, DateRangePickerHeadCell as zp, DateRangePickerCell as Np, DateRangePickerGrid as Fp, DateRangePickerHeading as Bp, DateRangePickerHeader as Gp, DateRangePickerRoot as Hp, DialogDescription as Kp, DialogTitle as qp, DialogClose as Wp, DialogOverlay as Zp, DialogContent as Yp, DialogPortal as Jp, DialogTrigger as Xp, DialogRoot as Qp, DropdownMenuSubTrigger as ef, DropdownMenuSubContent as tf, DropdownMenuSub as nf, DropdownMenuRadioItem as of, DropdownMenuRadioGroup as af, DropdownMenuLabel as sf, DropdownMenuItemIndicator as rf, DropdownMenuCheckboxItem as lf, DropdownMenuSeparator as cf, DropdownMenuGroup as uf, DropdownMenuItem as df, DropdownMenuArrow as mf, DropdownMenuContent as pf, DropdownMenuPortal as ff, DropdownMenuTrigger as gf, DropdownMenuRoot as vf, EditableEditTrigger as bf, EditableCancelTrigger as yf, EditableSubmitTrigger as hf, EditablePreview as _f, EditableInput as $f, EditableArea as Sf, EditableRoot as kf, HoverCardArrow as wf, HoverCardContent as xf, HoverCardPortal as Cf, HoverCardTrigger as Tf, HoverCardRoot as Rf, ListboxGroupLabel as Df, ListboxGroup as Mf, ListboxVirtualizer as Ef, ListboxItemIndicator as Pf, ListboxItem as Lf, ListboxFilter as jf, ListboxContent as Af, ListboxRoot as Of, MenubarMenu as Uf, MenubarSubTrigger as Vf, MenubarSubContent as If, MenubarSub as zf, MenubarRadioItem as Nf, MenubarRadioGroup as Ff, MenubarLabel as Bf, MenubarItemIndicator as Gf, MenubarCheckboxItem as Hf, MenubarSeparator as Kf, MenubarGroup as qf, MenubarItem as Wf, MenubarArrow as Zf, MenubarContent as Yf, MenubarPortal as Jf, MenubarTrigger as Xf, MenubarRoot as Qf, NavigationMenuViewport as eg, NavigationMenuTrigger as tg, NavigationMenuSub as ng, NavigationMenuList as og, NavigationMenuLink as ag, NavigationMenuItem as sg, NavigationMenuIndicator as ig, NavigationMenuContent as rg, NavigationMenuRoot as lg, NumberFieldDecrement as cg, NumberFieldIncrement as ug, NumberFieldInput as dg, NumberFieldRoot as mg, PaginationPrev as pg, PaginationNext as fg, PaginationListItem as gg, PaginationList as vg, PaginationLast as bg, PaginationFirst as yg, PaginationEllipsis as hg, PaginationRoot as _g, PinInputInput as $g, PinInputRoot as Sg, PopoverAnchor as kg, PopoverClose as wg, PopoverArrow as xg, PopoverContent as Cg, PopoverPortal as Tg, PopoverTrigger as Rg, PopoverRoot as Dg, ProgressIndicator as Mg, ProgressRoot as Eg, RadioGroupIndicator as Pg, RadioGroupItem as Lg, RadioGroupRoot as jg, RangeCalendarCellTrigger as Ag, RangeCalendarGridRow as Og, RangeCalendarGridBody as Ug, RangeCalendarGridHead as Vg, RangeCalendarPrev as Ig, RangeCalendarNext as zg, RangeCalendarHeadCell as Ng, RangeCalendarCell as Fg, RangeCalendarGrid as Bg, RangeCalendarHeading as Gg, RangeCalendarHeader as Hg, RangeCalendarRoot as Kg, ScrollAreaCorner as qg, ScrollAreaThumb as Wg, ScrollAreaScrollbar as Zg, ScrollAreaViewport as Yg, ScrollAreaRoot as Jg, SliderRange as Xg, SliderTrack as Qg, SliderThumb as ev, SliderRoot as tv, SplitterResizeHandle as nv, SplitterPanel as ov, SplitterGroup as av, StepperSeparator as sv, StepperIndicator as iv, StepperTitle as rv, StepperDescription as lv, StepperTrigger as cv, StepperItem as uv, StepperRoot as dv, SwitchThumb as mv, SwitchRoot as pv, TabsIndicator as fv, TabsTrigger as gv, TabsContent as vv, TabsList as bv, TabsRoot as yv, TagsInputClear as hv, TagsInputItemDelete as _v, TagsInputItemText as $v, TagsInputItem as Sv, TagsInputInput as kv, TagsInputRoot as wv, ToastDescription as xv, ToastTitle as Cv, ToastViewport as Tv, ToastClose as Rv, ToastAction as Dv, ToastRoot as Mv, ToastProvider as Ev, ToggleGroupItem as Pv, ToggleGroupRoot as Lv, ToolbarSeparator as jv, ToolbarToggleItem as Av, ToolbarToggleGroup as Ov, ToolbarLink as Uv, ToolbarButton as Vv, ToolbarRoot as Iv, TooltipProvider as zv, TooltipPortal as Nv, TooltipArrow as Fv, TooltipContent as Bv, TooltipTrigger as Gv, TooltipRoot as Hv, TreeVirtualizer as Kv, TreeItem as qv, TreeRoot as Wv } from "reka-ui";
import { AspectRatio as _8, Label as $8, Presence as S8, Separator as k8, Toggle as w8, Viewport as x8 } from "reka-ui";
import { useRoute as Zv, useRouter as Yv } from "vue-router";
const tM = {
  name: "EVAC",
  version: "1.0.0",
  description: "Emergency Evacuation Management System"
}, Jv = "cs", Xv = 16, Qv = {
  MAC: {
    16: /^[0-9a-f]{2}(?:[:-][0-9a-f]{2})*$/i,
    10: /^[0-9]{1,3}(?:[:-][0-9]{1,3})*$/
  }
}, li = i.string().regex(Qv.MAC[Xv]).describe("MAC address in string representation"), Ln = i.codec(i.iso.datetime(), i.date(), {
  decode: (e) => new Date(e),
  encode: (e) => e.toISOString()
}), U = console, eb = "/api";
class Jo extends Error {
  constructor(t, o, a) {
    super(`REST API error ${t}: ${o}`), this.status = t, this.statusText = o, this.body = a, this.name = "RestApiError";
  }
  get isUnauthorized() {
    return this.status === 401;
  }
  get isForbidden() {
    return this.status === 403;
  }
  get isNotFound() {
    return this.status === 404;
  }
}
const tb = 8e3, ht = fe([]), _n = /* @__PURE__ */ new Map();
let nb = 0;
const ob = md(ht);
function en(e, t) {
  const o = ht.value.find((s) => s.key === e && s.detail === t), a = o?.id ?? ++nb;
  o || (ht.value = [...ht.value, { id: a, key: e, detail: t }]), clearTimeout(_n.get(a)), _n.set(
    a,
    setTimeout(() => ci(a), tb)
  );
}
function ci(e) {
  clearTimeout(_n.get(e)), _n.delete(e), ht.value = ht.value.filter((t) => t.id !== e);
}
function ab(e) {
  if (e instanceof i.ZodError) return i.prettifyError(e);
  if (e instanceof Jo) {
    const t = sb(e.body);
    return t ? `${e.status}: ${t}` : e.message;
  }
  return e instanceof Error ? e.message : String(e);
}
function sb(e) {
  return typeof e == "string" ? e.trim() : e && typeof e == "object" && "error" in e && typeof e.error == "string" ? e.error.trim() : "";
}
function H(e) {
  const t = q(!1), o = q(null);
  function a(...s) {
    return t.value = !0, o.value = null, new Promise((r) => r(e(...s))).then(() => !0).catch((r) => {
      U.error(r);
      const d = ab(r);
      return o.value = r instanceof Error ? r : new Error(d), en("notice.actionFailed", d), !1;
    }).finally(() => {
      t.value = !1;
    });
  }
  return {
    ongoing: k(() => t.value),
    error: k(() => o.value),
    submit: a
  };
}
async function Xo(e, t, o) {
  await new Promise((a) => setTimeout(a)), confirm(e) && (await t(), await o?.());
}
function nM(e, t) {
  const o = t.protocol === "https:" ? "wss:" : "ws:", a = t.host;
  return new URL(`${o}//${a}${e}`);
}
function ib(e, t = {}) {
  const { parser: o = JSON.parse, reconnect: a = !1, retry: s = { count: 3, delay: 1e3 }, signal: r = null } = t;
  let d = null, p = 0, g = !1, S = null;
  const h = new EventTarget();
  Object.defineProperty(h, Symbol.asyncIterator, {
    // Gap-free buffered multicast: each consumer keeps a persistent listener and
    // its own queue, so messages are never dropped in the window between one
    // `.next()` resolving and the next being requested. (The previous one-shot
    // listener approach dropped any frame that arrived while the consumer was
    // processing the prior one — e.g. a single `EventRemoved` under load.)
    value: function() {
      const M = [];
      let V = null, N = null, F = !1;
      function oe(_e) {
        const Ze = _e.detail;
        if (V) {
          const { resolve: Bt } = V;
          V = null, Bt({ value: Ze, done: !1 });
        } else
          M.push(Ze);
      }
      function yt() {
        if (F = !0, Re(), V) {
          const { resolve: _e } = V;
          V = null, _e({ value: void 0, done: !0 });
        }
      }
      function gn(_e) {
        if (N = _e.detail, Re(), V) {
          const { reject: Ze } = V;
          V = null, Ze(N);
        }
      }
      function Re() {
        h.removeEventListener("message", oe), h.removeEventListener("close", yt), h.removeEventListener("error", gn);
      }
      return g ? F = !0 : (h.addEventListener("message", oe), h.addEventListener("close", yt), h.addEventListener("error", gn)), {
        next() {
          if (M.length > 0)
            return Promise.resolve({ value: M.shift(), done: !1 });
          if (N !== null) {
            const _e = N;
            return N = null, Promise.reject(_e);
          }
          return F || g ? Promise.resolve({ value: void 0, done: !0 }) : new Promise((_e, Ze) => {
            V = { resolve: _e, reject: Ze };
          });
        },
        return() {
          return F = !0, Re(), Promise.resolve({ value: void 0, done: !0 });
        }
      };
    }
  }), Object.defineProperty(h, Symbol.dispose, {
    value: function() {
      g = !0, S !== null && (clearTimeout(S), S = null), d && (d.close(1e3, "Connection disposed"), d = null);
    }
  }), Object.defineProperty(h, "readyState", {
    get() {
      return d?.readyState ?? WebSocket.CLOSED;
    }
  }), Object.defineProperty(h, "send", {
    value: function(M) {
      if (d && d.readyState === WebSocket.OPEN)
        d.send(_(M));
      else
        throw new Error("WebSocket is not connected");
    }
  });
  function _(O) {
    return typeof O == "string" || O instanceof ArrayBuffer || O instanceof Blob || ArrayBuffer.isView(O) ? O : JSON.stringify(O);
  }
  return w(), r?.addEventListener("abort", () => {
    h[Symbol.dispose]();
  }), h;
  function w() {
    if (g) throw new Error("Connection was disposed");
    const O = new WebSocket(e);
    return d = O, O.onopen = (M) => {
      p = 0, h.dispatchEvent(new CustomEvent("open", { detail: M }));
    }, O.onmessage = (M) => {
      h.dispatchEvent(new CustomEvent("message", { detail: o(M.data) }));
    }, O.onerror = (M) => {
      h.dispatchEvent(new CustomEvent("error", { detail: M }));
    }, O.onclose = (M) => {
      h.dispatchEvent(new CustomEvent("close", { detail: M })), a && !g && M.code !== 1e3 && E();
    }, O;
  }
  function E() {
    if (g || p >= s.count) {
      h.dispatchEvent(
        new CustomEvent("failed", {
          detail: {
            message: `WebSocket connection failed after ${s.count} retry attempts`,
            attempts: p
          }
        })
      );
      return;
    }
    p++;
    const O = s.delay * Math.pow(2, p - 1);
    h.dispatchEvent(new CustomEvent("retry", { detail: { attempt: p, maxAttempts: s.count, delay: O } })), S = setTimeout(() => {
      try {
        w();
      } catch (M) {
        h.dispatchEvent(new CustomEvent("error", { detail: M }));
      }
    }, O);
  }
}
const Qo = i.enum(["page", "debug", "trafficLog", "audit"]), ea = Qo.options, ta = "FEATURE_FLAGS";
function na() {
  try {
    return globalThis.localStorage;
  } catch {
    return;
  }
}
function rb(e) {
  const t = (e ?? "").split(",").map((o) => o.trim());
  return [...new Set(t.filter((o) => Qo.safeParse(o).success))];
}
function ui(e) {
  try {
    return rb(e?.getItem(ta));
  } catch {
    return [];
  }
}
const Kt = fe(ui(na()));
function Js(e = na()) {
  Kt.value = ui(e);
}
function jn(e) {
  return Kt.value.includes(e);
}
function $n(e, t, o = na()) {
  const a = Kt.value.filter((s) => s !== e);
  Kt.value = t ? [...a, e] : a;
  try {
    o?.setItem(ta, Kt.value.join(","));
  } catch (s) {
    U.warn("[featureFlags] not persisted:", s);
  }
}
function Ct(e) {
  return k({
    get: () => jn(e),
    set: (t) => $n(e, t)
  });
}
function Xs(e, t) {
  const o = Qo.safeParse(e);
  if (!o.success) throw new Error(`Unknown feature flag "${e}", known: ${ea.join(", ")}`);
  $n(o.data, t);
}
const lb = {
  unlock: () => $n("page", !0),
  lock: () => $n("page", !1),
  enable: (e) => Xs(e, !0),
  disable: (e) => Xs(e, !1),
  list: () => Object.fromEntries(ea.map((e) => [e, jn(e)]))
};
function oM() {
  return () => {
    Js(), window.addEventListener("storage", (t) => {
      (t.key === ta || t.key === null) && Js();
    });
    const e = window;
    e.evac = { ...e.evac, featureFlags: lb };
  };
}
function cb(e) {
  return typeof e == "object" && e !== null && "Error" in e && e.Error === "PermissionError";
}
const Qs = 1e3, fo = new x.BehaviorSubject(!1), ub = fo.pipe(x.distinctUntilChanged());
function aM(...e) {
  return new Map(e);
}
async function db(e) {
  const t = new AbortController(), o = /* @__PURE__ */ new Set();
  let a = null;
  try {
    const { services: r, url: d } = e;
    a = ib(d, { reconnect: !0 }), await mb(a), U.log("[ws] connection established");
    for (const [p, g] of r ?? [])
      o.add(p.start({ connection: a, source: a, storage: g, signal: t.signal }));
    if (e.tokenProvider) {
      const p = e.tokenProvider();
      p && (a.send(JSON.stringify({ Login: { Token: p } })), U.log("[ws] sent Login with token"));
    }
    throw fo.next(!0), await pb(a), new Error("[ws] connection closed");
  } catch (r) {
    return U.error(r), t.abort(), o.forEach((d) => d[Symbol.dispose]()), o.clear(), s();
  } finally {
    a?.[Symbol.dispose](), fo.next(!1);
  }
  async function s() {
    return U.info(`[ws] waiting ${Qs}ms before reconnecting...`), await new Promise((r) => setTimeout(r, Qs)), U.info("[ws] attempting to reconnect..."), db(e);
  }
}
function mb(e) {
  return new Promise((t, o) => {
    if (e.readyState === WebSocket.OPEN) {
      t();
      return;
    }
    e.addEventListener("open", s, { once: !0 }), e.addEventListener("error", r, { once: !0 }), e.addEventListener("close", d, { once: !0 });
    function a() {
      e.removeEventListener("open", s), e.removeEventListener("error", r), e.removeEventListener("close", d);
    }
    function s() {
      a(), t();
    }
    function r() {
      a(), o(new Error("[ws] connection error"));
    }
    function d() {
      a(), o(new Error("[ws] connection closed before open"));
    }
  });
}
async function pb(e) {
  for await (const t of e)
    jn("trafficLog") && U.debug("[ws] received message:", t), cb(t) && en("notice.permissionDenied");
}
function oa() {
  return { isOnline: Z(ub, { initialValue: !1, onError: U.error }) };
}
const W = i.enum({
  Ascending: 1,
  Descending: -1,
  None: 0
}), fb = i.object({
  key: i.string(),
  direction: W
}), gb = new Intl.Collator();
function Y(...e) {
  if (e.length)
    return e.length === 1 ? (a) => t(a, o(e[0])) : t(e[0], o(e[1]));
  return (a) => Array.from(a);
  function t(a, s) {
    const r = i.array(fb).parse(s);
    return Array.from(a).toSorted((d, p) => {
      for (const g of r) {
        if (g.direction === W.enum.None) continue;
        const S = d[g.key], h = p[g.key], _ = S == null, w = h == null;
        if (_ || w) {
          if (_ && w) continue;
          return _ ? 1 : -1;
        }
        if (typeof S == "string" && typeof h == "string") {
          const E = gb.compare(S, h);
          if (E !== 0) return E * g.direction;
          continue;
        }
        if (S < h)
          return -1 * g.direction;
        if (S > h)
          return 1 * g.direction;
      }
      return 0;
    });
  }
  function o(a) {
    return Array.isArray(a) ? a : [a];
  }
}
function vb(e, t) {
  const o = { ...e };
  return o.key === t ? o.direction = o.direction === W.enum.Ascending ? W.enum.Descending : W.enum.Ascending : (o.key = t, o.direction = W.enum.Ascending), o;
}
function bb({ initial: e, modelValue: t }) {
  if (!e && !t)
    throw new Error("Either initial or modelValue must be provided to useSort");
  const o = q(t?.value ?? e);
  return t && xd(o, t), {
    sort: o,
    sortBy: a
  };
  function a(s, r) {
    if (r) {
      o.value = { key: s, direction: r };
      return;
    }
    o.value = vb(o.value, s);
  }
}
const di = /* @__PURE__ */ Symbol("list");
function je(...e) {
  return e;
}
function Ae({ initialSort: e, fields: t }) {
  const { sort: o, sortBy: a } = bb({ initial: e }), s = k(() => [...hb(A(t))]), r = k(() => Object.fromEntries(yb(s.value))), d = k(() => ({
    display: "grid",
    "grid-template-columns": s.value.map((h) => h.fill ? "minmax(0, 1fr)" : "max-content").join(" ")
  })), p = k(() => {
    const g = s.value.length;
    return {
      "grid-column": `span ${g} / span ${g}`
    };
  });
  return pd(di, { gridStyle: d, rowStyle: p, sort: o, sortBy: a, visible: r }), {
    gridStyle: d,
    rowStyle: p,
    sort: o,
    sortBy: a,
    visible: r
  };
}
function* yb(e = []) {
  for (const t of e ?? [])
    yield [t.key, mi(t)];
}
function* hb(e = []) {
  for (const t of e ?? [])
    mi(t) && (yield t);
}
function mi(e) {
  return typeof e.visible > "u" ? !0 : A(e.visible) ?? !1;
}
function pi(e, t = 960) {
  const { width: o } = Cd(e);
  return k(() => o.value >= t);
}
function de(e) {
  const t = fd(di);
  if (e && !t)
    throw new Error("useListContext must be used within a useList provider");
  return t;
}
function me(e, t) {
  return e === t ? `${e}` : `${t} / ${e}`;
}
function aa(e, t = 7) {
  return (e ?? "").trim().slice(0, t);
}
function fi(e) {
  return new Intl.DateTimeFormat(e, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  });
}
const gi = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit"
};
function vi(e) {
  return new Intl.DateTimeFormat(e, gi);
}
function bi(e) {
  return new Intl.DateTimeFormat(e, { ...gi, second: "2-digit" });
}
function yi(e) {
  return Intl.NumberFormat(e, { style: "percent" });
}
function hi(e) {
  return new Intl.Collator(e, { usage: "sort", numeric: !0 });
}
const sM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  date: fi,
  dateTime: vi,
  dateTimeSeconds: bi,
  percent: yi,
  sort: hi
}, Symbol.toStringTag, { value: "Module" }));
function Oe() {
  const { locale: e } = R({ useScope: "global" }), t = Se(o());
  return Mt(() => Object.assign(t, o(e.value))), t;
  function o(a = Jv) {
    return {
      date: fi(a),
      dateTime: vi(a),
      dateTimeSeconds: bi(a),
      percent: yi(a),
      sort: hi(a),
      count: me
    };
  }
}
function Qe(e) {
  const t = "createType" in e ? e.createType : e.entityType, o = "live" in e ? e.live : void 0, a = e.seed ?? (() => ({}));
  function s() {
    const M = t.safeParse(A(e.input));
    return M.success ? M.data : a();
  }
  const r = Pn("formElement"), d = Se({
    element: r,
    data: Se(s()),
    title: "",
    hasChanges: !1,
    isCreate: !1,
    isUpdate: !1,
    reset: O,
    save: H(S),
    create: H(h),
    update: H(_),
    remove: H(E),
    undo: H(O)
  });
  return Mt(() => {
    if (!r.value) return;
    const M = s(), V = po({ ...d.data }), N = !M || !M.uuid, F = p(M, V);
    d.isCreate = N, d.isUpdate = !N, d.hasChanges = F, d.title = g(N, F);
  }), d;
  function p(M, V) {
    const N = t.safeParse(M);
    if (!N.success) return !1;
    const F = t.safeParse(V);
    return F.success ? _b(N.data, F.data, o) : !1;
  }
  function g(M, V) {
    return M ? (e.i18n.create ?? e.i18n.title)() : V ? e.i18n.edit() : e.i18n.title();
  }
  function S(M = {}) {
    if (d.isCreate)
      return h().then(() => {
        M?.created?.();
      });
    if (d.isUpdate)
      return _().then(() => {
        M?.updated?.();
      });
  }
  function h() {
    if (!("create" in e))
      throw new Error("Create operation is not supported.");
    return e.create(e.createType.parse(d.data));
  }
  function _() {
    const M = "live" in e && e.live ? $b(A(e.input), d.data, e.live) : d.data;
    return e.update(e.entityType.parse(M));
  }
  function w() {
    const { uuid: M } = e.entityType.parse(d.data);
    return e.remove(M);
  }
  function E(M) {
    return Xo(e.i18n.confirmRemove(), w, M);
  }
  function O() {
    d.data = Se(s());
    const M = r.value;
    M && M.reset();
  }
}
function _b(e, t, o = []) {
  return !Yo(Zs(e, o), Zs(t, o));
}
function $b(e, t, o) {
  return { ...t, ..._d(e, o) };
}
function iM({ modelValue: e, options: t }) {
  const o = k(() => {
    const s = /* @__PURE__ */ new Map();
    for (const r of A(t))
      s.set(r.value, r);
    return s;
  });
  return { detail: k({
    get() {
      const s = e.value;
      return s ? o.value.get(s) ?? null : null;
    },
    set(s) {
      e.value = s?.value || null;
    }
  }) };
}
function et({ state: e = /* @__PURE__ */ new Map(), options: t = null }) {
  const o = k(() => (A(t) ?? Array.from(A(e).values())).map(s)), a = k(() => new Map(Array.from(A(e).values()).map((r) => [r.uuid, s(r)])));
  return {
    options: o,
    state: a
  };
  function s(r) {
    return {
      label: r.name || r.uuid,
      value: r.uuid
    };
  }
}
const sa = "auth", Ee = i.enum(["Anonymous", "Admin", "Service", "External"]), ia = /* @__PURE__ */ new Set([Ee.enum.Anonymous]), ra = "Anonymous", _i = new Set(Ee.options), la = /* @__PURE__ */ new Set([Ee.enum.Admin]), ca = /* @__PURE__ */ new Set([...la, Ee.enum.Service]), $i = /* @__PURE__ */ new Set([...ca, Ee.enum.External]), ua = i.object({
  uuid: i.uuid(),
  username: i.string(),
  roles: i.set(Ee)
}), Si = i.object({
  uuid: i.uuid(),
  username: i.string(),
  roles: i.codec(i.array(Ee), i.set(Ee), {
    decode: (e) => new Set(e),
    encode: (e) => Array.from(e)
  })
}), Sb = i.object({
  isAuthenticated: i.boolean(),
  isAdmin: i.boolean(),
  isService: i.boolean(),
  isDashboard: i.boolean()
}), Zt = i.object({
  nonce: i.string(),
  user: i.uuid(),
  created: i.date()
}), ki = i.codec(
  Zt.extend({
    created: Ln
  }),
  Zt,
  {
    decode: (e) => ({
      nonce: e.nonce,
      user: e.user,
      created: e.created
    }),
    encode: (e) => ({
      nonce: e.nonce,
      user: e.user,
      created: e.created
    })
  }
), go = i.object({
  username: i.string(),
  password: i.string()
}), wi = i.codec(i.object({ UserInfo: Si }), ua, {
  decode: (e) => e.UserInfo,
  encode: (e) => ({ UserInfo: e })
}), xi = i.codec(i.object({ Login: i.object({ Login: go }) }), go, {
  decode: (e) => e.Login.Login,
  encode: (e) => ({ Login: { Login: e } })
}), Ci = i.codec(i.object({ Logout: i.null() }), i.null(), {
  decode: () => null,
  encode: () => ({ Logout: null })
}), Ti = i.codec(i.object({ TokenGetForUser: i.uuid() }), i.uuid(), {
  decode: (e) => e.TokenGetForUser,
  encode: (e) => ({ TokenGetForUser: e })
}), Ri = i.codec(i.object({ Login: i.object({ Token: i.string() }) }), i.string(), {
  decode: (e) => e.Login.Token,
  encode: (e) => ({ Login: { Token: e } })
}), Di = i.codec(i.object({ TokenGet: i.string().nullish() }), i.string().nullish(), {
  decode: (e) => e.TokenGet ?? "",
  encode: (e) => ({ TokenGet: e ?? null })
}), Mi = i.codec(i.object({ TokenDetail: ki }), Zt, {
  decode: (e) => e.TokenDetail,
  encode: (e) => ({ TokenDetail: e })
});
async function kb(e, t, o) {
  const a = await e.getItem(t);
  return a != null ? o.next(a) : await e.setItem(t, o.value), o.subscribe(async (r) => {
    if (r === null) {
      await e.removeItem(t);
      return;
    }
    await e.setItem(t, r);
  });
}
function wb(...e) {
  const t = e.filter((s) => s != null);
  if (t.length === 0)
    throw new TypeError("At least one AbortSignal is required to merge.");
  if (t.length === 1)
    return t[0];
  const o = new AbortController(), a = () => {
    o.abort(), t.forEach((s) => s.removeEventListener("abort", a));
  };
  for (const s of t)
    s.aborted ? a() : s.addEventListener("abort", a, { once: !0 });
  return o.signal;
}
function Ei(e) {
  return typeof e == "object" && e !== null && Symbol.asyncIterator in e;
}
function rM(e) {
  return typeof e == "object" && e !== null && "next" in e && typeof e.next == "function";
}
function Pi(e, ...t) {
  return {
    async *[Symbol.asyncIterator]() {
      if (r(), s()) return a();
      const o = e[Symbol.asyncIterator]();
      try {
        for (; !s(); ) {
          const p = await o.next();
          if (p.done) break;
          yield p.value;
        }
      } finally {
        a();
      }
      function a() {
        d();
        try {
          o.return?.();
        } catch {
        }
      }
      function s() {
        return t.some((p) => p?.aborted);
      }
      function r() {
        for (const p of t)
          p instanceof AbortSignal && p.addEventListener("abort", a, { once: !0 });
      }
      function d() {
        for (const p of t)
          p instanceof AbortSignal && p.removeEventListener("abort", a);
      }
    }
  };
}
function xb(e, t, o) {
  const { signal: a, ...s } = o ?? {};
  return {
    [Symbol.asyncIterator]() {
      return {
        next() {
          return new Promise((r) => {
            if (a?.aborted) {
              r({ value: void 0, done: !0 });
              return;
            }
            e.addEventListener(t, d, { ...s, once: !0 }), a?.addEventListener("abort", () => r({ value: void 0, done: !0 }), { once: !0 });
            function d(p) {
              r({ value: p, done: !1 });
            }
          });
        }
      };
    }
  };
}
async function* Cb(...e) {
  const t = e.map((a) => Ei(a) ? a[Symbol.asyncIterator]() : a), o = new Map(t.map((a) => [a, ei(a)]));
  try {
    for (; o.size > 0; ) {
      const a = await Promise.race(o.values());
      if (a.length === 3) {
        const [, d, p] = a;
        throw o.delete(d), p;
      }
      const [s, r] = a;
      s.done ? o.delete(r) : (setTimeout(() => {
        s.value = null;
      }), yield s.value, o.delete(r), o.set(r, ei(r)));
    }
  } finally {
    o.forEach((a, s) => {
      s.return?.();
    });
  }
}
async function ei(e) {
  return e.next().then((t) => [t, e]).catch((t) => [void 0, e, t]);
}
function lo() {
  let e, t;
  return { promise: new Promise((a, s) => {
    e = a, t = s;
  }), resolve: e, reject: t };
}
const co = {
  STATE: "state"
};
function le(e) {
  const { name: t, identity: o, storage: a, logger: s = U } = e, r = typeof a == "function" ? a : (G) => wd(G, t);
  let d = typeof a == "object" && a ? a : void 0, p = new AbortController(), g = p.signal;
  const S = lo();
  let h = lo(), _ = null, w = Promise.resolve();
  const E = [], O = new EventTarget();
  return Object.assign(O, {
    get name() {
      return t;
    },
    start: oe,
    stop: Re,
    get: V,
    set: _e,
    update: Ze,
    prime: F,
    withActions: ud,
    withSources: dd,
    [Symbol.asyncIterator]: M,
    [Symbol.dispose]: Re
  }), O;
  async function* M() {
    const G = await V();
    typeof G < "u" && (yield G);
    try {
      for await (const se of xb(O, "data"))
        yield o.parse(se.detail);
    } catch (se) {
      return s.error(new Error(`[${t}] Error occurred while observing data`, { cause: se })), M();
    }
  }
  async function V() {
    await S.promise;
    const G = await N();
    if (!(typeof G > "u"))
      try {
        return o.parse(G);
      } catch (se) {
        await d?.removeItem(co.STATE).catch(s.error), s.error(new Error(`[${t}] Failed to parse stored state`, { cause: se }));
      }
  }
  async function N() {
    if (d)
      try {
        return await d.getItemRaw(co.STATE) ?? void 0;
      } catch (G) {
        s.error(new Error(`[${t}] Failed to read stored state`, { cause: G }));
        return;
      }
  }
  function F(G) {
    G && (d = r(G)), S.resolve();
  }
  function oe({ connection: G, storage: se, signal: at }) {
    return p.signal.aborted || p.abort(), p = new AbortController(), g = at ? wb(p.signal, at) : p.signal, g.addEventListener("abort", Re, { once: !0 }), _ = G, se && (d = r(se)), S.resolve(), yt(), s.info(`[${t}] service started`), h.resolve(), O.dispatchEvent(new CustomEvent("start")), Object.freeze({
      name: t,
      stop: Re,
      [Symbol.dispose]: Re
    });
  }
  async function yt() {
    const G = Pi(Cb(...E.map((se) => gn(se))), g);
    for await (const se of G)
      await Bt(se);
    s.warn(`[${t}] observation ended`);
  }
  async function* gn(G) {
    if (G) {
      if (!_)
        throw new Error(`[${t}] Cannot connect data source - no active connection`);
      yield* G.call(O, _);
    }
  }
  function Re() {
    p.signal.aborted || p.abort(), h = lo(), g.removeEventListener("abort", Re), _ = null, s.warn(`[${t}] service stopped`), O.dispatchEvent(new CustomEvent("stop"));
  }
  function _e(G) {
    return Bt(() => o.parse(G));
  }
  function Ze(G) {
    return Bt(G);
  }
  function Bt(G) {
    const se = async () => {
      await S.promise;
      const vn = await N(), Gt = G(vn);
      Gt !== vn && (await cd(Gt), jn("trafficLog") && s.info(`[${t}] updated`, Gt), O.dispatchEvent(new CustomEvent("data", { detail: Gt })));
    }, at = w.then(se, se);
    return w = at.catch(() => {
    }), at;
  }
  async function cd(G) {
    d && await d.setItemRaw(co.STATE, G).catch((se) => s.error(new Error(`[${t}] Failed to save state`, { cause: se })));
  }
  function ud(G) {
    for (const [se, at] of Object.entries(G))
      Object.defineProperty(O, se, {
        value: async (...vn) => {
          if (_ || await h.promise, !_)
            throw new Error(`[${t}] Cannot perform action "${se}" - service is not started`);
          return at.call(O, _, ...vn);
        },
        enumerable: !1,
        configurable: !0
      });
    return O;
  }
  function dd(...G) {
    return E.push(...G), O;
  }
}
const Li = "version", Sn = i.object({
  commit: i.string(),
  number: i.string()
}), ji = i.codec(i.object({ Version: Sn }), Sn, {
  decode: (e) => e.Version,
  encode: (e) => ({ Version: e })
}), Ai = le({
  name: Li,
  identity: Sn
}).withSources(async function* (t) {
  for await (const o of t) {
    const a = ji.safeParse(o);
    a.success && (yield () => a.data);
  }
}), da = x.from(Ai).pipe(x.shareReplay(1)), An = le({
  name: `${sa}/tokenDetail`,
  identity: Zt.nullable()
}).withSources(async function* (t) {
  for await (const o of t) {
    const a = Mi.safeParse(o);
    a.success && (yield () => a.data);
  }
}).withActions({
  getToken(e, t) {
    e.send(Di.encode(t));
  },
  getTokenForUser(e, t) {
    e.send(Ti.encode(t));
  }
}), ct = le({
  name: `${sa}/userInfo`,
  identity: ua.nullable()
}).withSources(async function* (t) {
  for await (const o of t) {
    const a = wi.safeParse(o);
    a.success && (yield () => a.data);
  }
}).withActions({
  login(e, t) {
    e.send(xi.encode(t));
  },
  token(e, t) {
    e.send(Ri.encode(t ?? ""));
  },
  logout(e) {
    e.send(Ci.encode(null)), this.set(null), An.set(null);
  }
}), Tb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  tokenDetail: An,
  userInfo: ct
}, Symbol.toStringTag, { value: "Module" })), Oi = 1e3, tn = new x.BehaviorSubject(!0), Rb = tn.pipe(x.distinctUntilChanged()), Ui = x.from(An).pipe(x.shareReplay(1)), Db = Ui.pipe(
  x.map((e) => !!e),
  x.distinctUntilChanged(),
  x.shareReplay(1)
), vo = x.from(ct).pipe(x.distinctUntilChanged(hn.isDeepEqual), x.shareReplay(1)), Ke = vo.pipe(
  x.timeout({
    first: Oi,
    with: () => vo.pipe(x.startWith(null))
  }),
  x.distinctUntilChanged(),
  x.shareReplay(1)
), On = Ke.pipe(
  x.map((e) => e ? e.roles : ia),
  x.filter(Boolean)
), tt = Ke.pipe(x.map((e) => !!e && nn(_i, e.roles))), Vi = x.zip(Ke, tt).pipe(
  x.map(([e, t]) => !!e && t && nn(la, e.roles))
), Ii = x.zip(Ke, tt).pipe(
  x.map(([e, t]) => !!e && t && nn(ca, e.roles))
), Mb = x.zip(Ke, tt).pipe(
  x.map(([e, t]) => !!e && t && nn($i, e.roles))
), Eb = x.zip(Ke, tt).pipe(
  x.map(([e, t]) => !!e && t && e.roles.has(Ee.enum.Anonymous))
), zi = Ke.pipe(x.map((e) => e ? e.username : ra)), Ni = Ke.pipe(x.map((e) => e ? e.uuid : null));
function nn(e, t) {
  try {
    for (const o of e)
      if (t.has(o))
        return !0;
    return !1;
  } catch (o) {
    return U.error(o), !1;
  }
}
const nt = new x.BehaviorSubject(null), Fi = nt.pipe(x.distinctUntilChanged()), Bi = x.fromEvent(document, "visibilitychange", { passive: !0 }), Pb = x.merge(x.of(null), Bi).pipe(
  x.map(() => null),
  x.filter(Gb)
), Lb = Bi.pipe(x.filter(() => document.visibilityState === "hidden")), jb = Fi.pipe(
  x.skip(1),
  // Skip initial value (handled by orchestrator on connect)
  x.filter((e) => !!e),
  x.switchMap((e) => ct.token(e))
), Ab = Pb.pipe(
  x.switchMap(() => da),
  // Get immediately the current token
  x.map(() => nt.value),
  // If token exists, try to login with it
  x.switchMap((e) => e ? ct.token(e).then(() => e) : Promise.resolve(null)),
  // Wait briefly for the server's UserInfo response to arrive via WS
  x.delay(Oi),
  x.tap((e) => {
    tn.next(!1), e && x.firstValueFrom(tt).then((t) => {
      t || (U.warn("Token rejected by server, enforcing new login"), Gi());
    });
  })
), Ob = vo.pipe(
  x.filter(Boolean),
  // userInfo is available
  // at this point if a token exists, we used a previously stored token for login and we don't need to check further
  x.switchMap(
    () => Fi.pipe(
      x.take(1),
      // take the current token
      x.filter((e) => !e),
      // if token does not exist, we logged in using credentials, need to check tokenDetail
      x.tap(() => An.getToken(null))
    )
  )
), Ub = x.combineLatest([Ni, Ui]).pipe(
  x.map(([e, t]) => Ib(e, t)),
  x.tap((e) => {
    e && nt.next(e);
  })
), Vb = Lb.pipe(
  x.tap(() => {
    tn.next(!0);
  })
);
function Ib(e, t) {
  return !e || !t ? null : t.user === e && t.nonce ? t.nonce : null;
}
async function zb(e) {
  const t = await x.firstValueFrom(On);
  return nn(e, t);
}
function Nb() {
  const e = "token", t = new URLSearchParams(location.search), o = t.get(e);
  if (o) {
    nt.next(o), t.delete(e);
    const a = location.pathname + (t.toString() ? `?${t.toString()}` : "") + location.hash;
    history.replaceState({}, document.title, a), location.replace(a);
  }
}
function Gi() {
  nt.next(null);
}
function Fb(e) {
  return kb(e, "token", nt);
}
function Bb() {
  return x.firstValueFrom(tt.pipe(x.filter((e) => e))).then(() => {
    tn.next(!1);
  });
}
function Hi() {
  return nt.value;
}
function Ki() {
  ct.logout(), Gi();
}
async function qi(e) {
  const t = await fetch("/api/users/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(e)
  });
  if (!t.ok)
    throw new Error("Login failed");
  const o = await t.json();
  nt.next(o.token);
  const a = {
    uuid: o.user.uuid,
    username: o.user.username,
    roles: new Set(o.user.roles)
  };
  await ct.set(a), await ct.token(o.token), tn.next(!1);
}
function Gb() {
  return document.visibilityState === "visible";
}
function ma(...e) {
  if (e.length === 1) {
    const a = e[0];
    return (s) => ma(a, s);
  }
  if (e.length !== 2)
    throw new Error("Invalid number of arguments");
  const [t, o] = e;
  try {
    if (!o) return !1;
    for (const a of o)
      if (t.has(a))
        return !0;
    return !1;
  } catch (a) {
    return U.error(a), !1;
  }
}
const Yt = fe(/* @__PURE__ */ new Map());
let bn = null;
async function Wi() {
  if (!(Yt.value.size > 0))
    return bn || (bn = (async () => {
      const e = Hi(), t = await fetch("/api/users", {
        headers: e ? { Authorization: `Bearer ${e}` } : {}
      });
      if (!t.ok) return;
      const o = await t.json();
      Yt.value = new Map(o.map((a) => [a.uuid, a]));
    })(), bn);
}
function Zi() {
  return Wi().catch(U.error), { options: k(() => Array.from(Yt.value.values()).map((t) => ({ label: t.username, value: t.uuid }))), users: Yt };
}
function Yi(e) {
  return Wi().catch(U.error), { detail: k(() => {
    const o = e();
    return o ? Yt.value.get(o) ?? null : null;
  }) };
}
function Et() {
  const e = Z(tt, { onError: U.error, initialValue: !1 }), t = Z(Eb, { onError: U.error, initialValue: !1 }), o = Z(Vi, { onError: U.error, initialValue: !1 }), a = Z(Ii, { onError: U.error, initialValue: !1 }), s = Z(Mb, { onError: U.error, initialValue: !1 }), r = Z(On, { onError: U.error, initialValue: ia }), d = Z(zi, { onError: U.error, initialValue: ra }), p = k(() => ma(r.value)), g = Z(Rb, { onError: U.error, initialValue: !0 });
  return {
    isAuthenticated: e,
    isAnonymous: t,
    isAdmin: o,
    isService: a,
    isExternal: s,
    roles: r,
    username: d,
    checkRoles: p,
    pending: g
  };
}
function pa() {
  const e = Se(o());
  function t() {
    Object.assign(e, o());
  }
  function o() {
    return {
      username: "",
      password: ""
    };
  }
  return {
    formData: e,
    reset: H(t),
    login: H(async () => {
      await qi(e), t();
    }),
    logout: H(Ki)
  };
}
function Ce() {
  const { isAdmin: e } = Et(), t = Ct("debug");
  return {
    enabled: k(() => t.value && e.value)
  };
}
const Hb = { overview: "Přehled", configuration: "Konfigurace" }, Kb = { location: "Lokace", locations: "Lokace", room: "Místnost", rooms: "Místnosti", uuid: "UUID", name: "Název", description: "Popis", battery: "Baterie", activity: "Aktivita", enabled: "Povoleno", email: "E-mail", ip: "IP", mac: "MAC", notification: "Notifikace", contactGroup: "Skupina kontaktů", contact: "Kontakt", buzzer: "Bzučák", led: "LED", scan: "Skenovat", subject: "Předmět", text: "Text", shortText: "Krátký text", longText: "Dlouhý text", html: "HTML", version: "Verze", commit: "Commit", rssi: "RSSI", scanner: "Skener", scanners: "Skenery", kind: "Typ", address: "Adresa", contacts: "Kontakty" }, qb = { create: "Vytvořit", edit: "Upravit", delete: "Smazat", save: "Uložit", cancel: "Zrušit", cancelChanges: "Zrušit změny", confirm: "Potvrdit", refresh: "Obnovit", restore: "Obnovit", close: "Zavřít", add: "Přidat", remove: "Odebrat", download: "Stáhnout", upload: "Nahrát", clear: "Vymazat", copy: "kliknutím zkopírujete", copied: "Zkopírováno" }, Wb = { title: "Odpojeno!", message: "Aplikaci nelze používat dokud se připojení neobnoví." }, Zb = { dismiss: "Zavřít", actionFailed: "Akce se nezdařila.", selectionUnavailable: "Některá vybraná položka již není dostupná. Zkontrolujte výběr a zkuste to znovu.", permissionDenied: "Přístup odepřen. Platnost přihlášení mohla vypršet; odhlaste se a přihlaste znovu.", copyFailed: "Nepodařilo se zkopírovat do schránky. Označte text a zkopírujte jej ručně." }, Yb = {
  page: Hb,
  entity: Kb,
  action: qb,
  offline: Wb,
  notice: Zb
}, Jb = { overview: "Overview", configuration: "Configuration" }, Xb = { location: "Location", locations: "Locations", room: "Room", rooms: "Rooms", uuid: "UUID", name: "Name", description: "Description", battery: "Battery", activity: "Activity", enabled: "Enabled", email: "E-mail", ip: "IP", mac: "MAC", notification: "Notification", contactGroup: "Contact Group", contact: "Contact", buzzer: "Buzzer", led: "LED", scan: "Scan", subject: "Subject", text: "Text", shortText: "Short text", longText: "Long text", html: "HTML", version: "Version", commit: "Commit", rssi: "RSSI", scanner: "Scanner", scanners: "Scanners", kind: "Kind", address: "Address", contacts: "Contacts" }, Qb = { create: "Create", edit: "Edit", delete: "Delete", save: "Save", cancel: "Cancel", cancelChanges: "Cancel changes", confirm: "Confirm", refresh: "Refresh", restore: "Restore", close: "Close", add: "Add", remove: "Remove", download: "Download", upload: "Upload", clear: "Clear", copy: "click to copy", copied: "Copied" }, ey = { title: "Offline!", message: "The application cannot be used until the connection is restored." }, ty = { dismiss: "Dismiss", actionFailed: "The action failed.", selectionUnavailable: "A selected item is no longer available. Check the selection and try again.", permissionDenied: "Permission denied. Your session may have expired; sign out and sign in again.", copyFailed: "Could not copy to the clipboard. Select the text and copy it manually." }, ny = {
  page: Jb,
  entity: Xb,
  action: Qb,
  offline: ey,
  notice: ty
}, lM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cs: Yb,
  en: ny
}, Symbol.toStringTag, { value: "Module" }));
function cM(e) {
  const { basePath: t = eb, tokenProvider: o, onUnauthorized: a, logger: s = U } = e;
  async function r(p, g, S = {}) {
    const h = `${t}/${g}`, _ = o(), w = {
      Accept: S.accept ?? "application/json"
    };
    _ && (w.Authorization = `Bearer ${_}`), S.contentType && (w["Content-Type"] = S.contentType), s.debug(`[rest] ${p} ${h}`);
    const E = await fetch(h, { method: p, headers: w, body: S.body, signal: S.signal });
    if (!E.ok) {
      const O = await E.text().catch(() => "");
      let M = O || null;
      try {
        M = JSON.parse(O);
      } catch {
      }
      throw E.status === 401 && a && a(), new Jo(E.status, E.statusText, M);
    }
    return E;
  }
  async function d(p, g, S = {}) {
    const h = S.body !== void 0, _ = await r(p, g, {
      body: h ? JSON.stringify(S.body) : void 0,
      contentType: h ? "application/json" : void 0,
      signal: S.signal
    });
    if (_.status === 204)
      return;
    const w = await _.json();
    return S.schema ? S.schema.parse(w) : w;
  }
  return {
    get: (p, g, S) => d("GET", p, { schema: g, signal: S }),
    post: (p, g, S, h) => d("POST", p, { body: g, schema: S, signal: h }),
    put: (p, g, S, h) => d("PUT", p, { body: g, schema: S, signal: h }),
    delete: (p, g) => d("DELETE", p, { signal: g }),
    getBlob: async (p, g) => (await r("GET", p, { accept: "*/*", signal: g })).blob(),
    // No Content-Type: the browser sets the multipart boundary itself.
    postForm: async (p, g, S) => {
      await r("POST", p, { body: g, accept: "*/*", signal: S });
    }
  };
}
function qe() {
  return {
    toStore: (e) => new Map(e.map((t) => [t.uuid, t]))
  };
}
function We(e, t, o) {
  const { path: a, itemSchema: s, toStore: r, live: d, skipUnreadable: p } = o, g = i.array(s);
  function S(h) {
    return h.flatMap((_) => {
      const w = s.safeParse(_);
      return w.success ? [w.data] : (U.warn(`[${a}] skipping an item this build cannot read`, _), []);
    });
  }
  return {
    async fetchAll(h) {
      const _ = async () => r(p ? S(await e.get(a, i.array(i.unknown()), h)) : await e.get(a, g, h));
      if (d) return d.fetchInto(t, _);
      const w = await _();
      return await t.set(w), w;
    },
    async fetchOne(h, _) {
      try {
        return await e.get(`${a}/${h}`, s, _);
      } catch (w) {
        if (w instanceof Jo && w.isNotFound)
          return null;
        throw w;
      }
    },
    async save(h, _) {
      return e.post(a, h, s, _);
    },
    async remove(h, _) {
      await e.delete(`${a}/${h}`, _);
    }
  };
}
function uM(...e) {
  return e.length === 1 ? (t) => kn("union", t, e[0]) : kn("union", e[0], e[1]);
}
function ot(...e) {
  return e.length === 1 ? (t) => kn("intersection", t, e[0]) : kn("intersection", e[0], e[1]);
}
function* kn(e, t, o) {
  const a = e === "union" ? "some" : "every";
  let s = 0;
  for (const r of t)
    o[a]((d) => d(r, s++, t)) && (yield r);
}
function ti(e, t) {
  return t.aborted ? Promise.reject(new Error("Aborted")) : new Promise((o, a) => {
    t.addEventListener("abort", s, { once: !0 }), e.then((r) => {
      o(r);
    }).catch((r) => {
      a(r);
    }).finally(() => {
      t.removeEventListener("abort", s);
    });
    function s() {
      a(new Error("Aborted"));
    }
  });
}
const oy = 5e3;
function dM(e, t = AbortSignal.timeout(oy)) {
  return Sd(e) ? ti(kd(e), t) : e instanceof Promise ? ti(e, t) : Ei(e) ? Pi(e, t)[Symbol.asyncIterator]().next().then((o) => o.done && typeof o.value > "u" ? Promise.reject(new Error("No values in async iterable")) : o.value) : Promise.resolve(e);
}
const ay = i.object({
  uuid: i.uuid()
});
function sy(e) {
  const t = k(() => ay.safeParse(A(e))), o = k(() => t.value.success), a = k(() => t.value.success ? t.value.data.uuid : null);
  return {
    hasUuid: o,
    uuid: a
  };
}
const mM = {
  Content: qd,
  Header: Kd,
  Item: Hd,
  Root: Gd,
  Trigger: Bd
}, pM = {
  Root: nm,
  Trigger: tm,
  Portal: em,
  Content: Qd,
  Overlay: Xd,
  Cancel: Jd,
  Title: Yd,
  Description: Zd,
  Action: Wd
}, fM = {
  Root: sm,
  Fallback: am,
  Image: om
}, gM = {
  Root: bm,
  Header: vm,
  Heading: gm,
  Grid: fm,
  Cell: pm,
  HeadCell: mm,
  Next: dm,
  Prev: um,
  GridHead: cm,
  GridBody: lm,
  GridRow: rm,
  CellTrigger: im
}, vM = {
  GroupRoot: _m,
  Root: hm,
  Indicator: ym
}, bM = {
  Root: km,
  Trigger: Sm,
  Content: $m
}, yM = {
  Root: Im,
  Input: Vm,
  Anchor: Um,
  Empty: Om,
  Trigger: Am,
  Cancel: jm,
  Group: Lm,
  Label: Pm,
  Content: Em,
  Viewport: Mm,
  Virtualizer: Dm,
  Item: Rm,
  ItemIndicator: Tm,
  Separator: Cm,
  Arrow: xm,
  Portal: wm
}, hM = {
  Root: tp,
  Trigger: ep,
  Portal: Qm,
  Content: Xm,
  Arrow: Jm,
  Item: Ym,
  Group: Zm,
  Separator: Wm,
  CheckboxItem: qm,
  ItemIndicator: Km,
  Label: Hm,
  RadioGroup: Gm,
  RadioItem: Bm,
  Sub: Fm,
  SubContent: Nm,
  SubTrigger: zm
}, _M = {
  Root: op,
  Input: np
}, $M = {
  Root: kp,
  Header: Sp,
  Heading: $p,
  Grid: _p,
  Cell: hp,
  HeadCell: yp,
  Next: bp,
  Prev: vp,
  GridHead: gp,
  GridBody: fp,
  GridRow: pp,
  CellTrigger: mp,
  Input: dp,
  Calendar: up,
  Field: cp,
  Anchor: lp,
  Arrow: rp,
  Close: ip,
  Trigger: sp,
  Content: ap
}, SM = {
  Root: Hp,
  Header: Gp,
  Heading: Bp,
  Grid: Fp,
  Cell: Np,
  HeadCell: zp,
  Next: Ip,
  Prev: Vp,
  GridHead: Up,
  GridBody: Op,
  GridRow: Ap,
  CellTrigger: jp,
  Input: Lp,
  Calendar: Pp,
  Field: Ep,
  Anchor: Mp,
  Arrow: Dp,
  Close: Rp,
  Trigger: Tp,
  Content: Cp
}, kM = {
  Root: xp,
  Input: wp
}, T = {
  Root: Qp,
  Trigger: Xp,
  Portal: Jp,
  Content: Yp,
  Overlay: Zp,
  Close: Wp,
  Title: qp,
  Description: Kp
}, wM = {
  Root: vf,
  Trigger: gf,
  Portal: ff,
  Content: pf,
  Arrow: mf,
  Item: df,
  Group: uf,
  Separator: cf,
  CheckboxItem: lf,
  ItemIndicator: rf,
  Label: sf,
  RadioGroup: af,
  RadioItem: of,
  Sub: nf,
  SubContent: tf,
  SubTrigger: ef
}, xM = {
  Root: kf,
  Area: Sf,
  Input: $f,
  Preview: _f,
  SubmitTrigger: hf,
  CancelTrigger: yf,
  EditTrigger: bf
}, CM = {
  Root: Rf,
  Trigger: Tf,
  Portal: Cf,
  Content: xf,
  Arrow: wf
}, yn = {
  Root: Of,
  Content: Af,
  Filter: jf,
  Item: Lf,
  ItemIndicator: Pf,
  Virtualizer: Ef,
  Group: Mf,
  GroupLabel: Df
}, TM = {
  Root: Qf,
  Trigger: Xf,
  Portal: Jf,
  Content: Yf,
  Arrow: Zf,
  Item: Wf,
  Group: qf,
  Separator: Kf,
  CheckboxItem: Hf,
  ItemIndicator: Gf,
  Label: Bf,
  RadioGroup: Ff,
  RadioItem: Nf,
  Sub: zf,
  SubContent: If,
  SubTrigger: Vf,
  Menu: Uf
}, RM = {
  Root: lg,
  Content: rg,
  Indicator: ig,
  Item: sg,
  Link: ag,
  List: og,
  Sub: ng,
  Trigger: tg,
  Viewport: eg
}, DM = {
  Root: mg,
  Input: dg,
  Increment: ug,
  Decrement: cg
}, MM = {
  Root: _g,
  Ellipsis: hg,
  First: yg,
  Last: bg,
  List: vg,
  ListItem: gg,
  Next: fg,
  Prev: pg
}, EM = {
  Root: Sg,
  Input: $g
}, PM = {
  Root: Dg,
  Trigger: Rg,
  Portal: Tg,
  Content: Cg,
  Arrow: xg,
  Close: wg,
  Anchor: kg
}, LM = {
  Root: Eg,
  Indicator: Mg
}, jM = {
  Root: jg,
  Item: Lg,
  Indicator: Pg
}, AM = {
  Root: Kg,
  Header: Hg,
  Heading: Gg,
  Grid: Bg,
  Cell: Fg,
  HeadCell: Ng,
  Next: zg,
  Prev: Ig,
  GridHead: Vg,
  GridBody: Ug,
  GridRow: Og,
  CellTrigger: Ag
}, OM = {
  Root: Jg,
  Viewport: Yg,
  Scrollbar: Zg,
  Thumb: Wg,
  Corner: qg
}, ge = {
  Root: Fd,
  Trigger: Nd,
  Portal: zd,
  Content: Id,
  Arrow: Vd,
  Separator: Ud,
  ItemIndicator: Od,
  Label: Ad,
  Group: jd,
  Item: Ld,
  ItemText: Pd,
  Viewport: Ed,
  ScrollUpButton: Md,
  ScrollDownButton: Dd,
  Value: Rd,
  Icon: Td
}, UM = {
  Root: tv,
  Thumb: ev,
  Track: Qg,
  Range: Xg
}, VM = {
  Group: av,
  Panel: ov,
  ResizeHandle: nv
}, IM = {
  Root: dv,
  Item: uv,
  Trigger: cv,
  Description: lv,
  Title: rv,
  Indicator: iv,
  Separator: sv
}, ie = {
  Root: pv,
  Thumb: mv
}, ee = {
  Root: yv,
  List: bv,
  Content: vv,
  Trigger: gv,
  Indicator: fv
}, zM = {
  Root: wv,
  Input: kv,
  Item: Sv,
  ItemText: $v,
  ItemDelete: _v,
  Clear: hv
}, NM = {
  Provider: Ev,
  Root: Mv,
  Action: Dv,
  Close: Rv,
  Viewport: Tv,
  Title: Cv,
  Description: xv
}, FM = {
  Root: Lv,
  Item: Pv
}, BM = {
  Root: Iv,
  Button: Vv,
  Link: Uv,
  ToggleGroup: Ov,
  ToggleItem: Av,
  Separator: jv
}, GM = {
  Root: Hv,
  Trigger: Gv,
  Content: Bv,
  Arrow: Fv,
  Portal: Nv,
  Provider: zv
}, HM = {
  Root: Wv,
  Item: qv,
  Virtualizer: Kv
}, Un = (e, t) => {
  const o = e.__vccOpts || e;
  for (const [a, s] of t)
    o[a] = s;
  return o;
}, iy = {}, ry = { class: "badge" };
function ly(e, t) {
  return u(), v("figure", ry, [
    P(e.$slots, "default")
  ]);
}
const B = /* @__PURE__ */ Un(iy, [["render", ly]]), cy = {
  class: "icon",
  "aria-hidden": "true"
}, uy = ["href"], D = /* @__PURE__ */ C({
  __name: "Icon",
  props: {
    icon: {}
  },
  setup(e) {
    return (t, o) => (u(), v("svg", cy, [
      l("use", {
        href: `#icon-${e.icon}`
      }, null, 8, uy)
    ]));
  }
}), dy = ["title"], my = {
  key: 0,
  class: "shrink-0"
}, py = { class: "truncate" }, fy = {
  class: "sr-only",
  "aria-live": "polite"
}, it = /* @__PURE__ */ C({
  __name: "CopyBadge",
  props: {
    value: {},
    display: {},
    label: {}
  },
  setup(e) {
    const { t } = R({ useScope: "global" }), o = q(!1);
    let a;
    async function s() {
      try {
        await navigator.clipboard.writeText(e.value);
      } catch {
        en("notice.copyFailed");
        return;
      }
      o.value = !0, clearTimeout(a), a = setTimeout(() => o.value = !1, 1500);
    }
    return si(() => clearTimeout(a)), (r, d) => (u(), v("button", {
      type: "button",
      class: "badge max-w-full min-w-0 cursor-copy",
      title: `${e.value} (${n(t)("action.copy")})`,
      onClick: s
    }, [
      e.label ? (u(), v("span", my, c(e.label), 1)) : y("", !0),
      l("span", py, c(e.display ?? e.value), 1),
      m(D, {
        class: "shrink-0",
        icon: o.value ? "check" : "content_copy"
      }, null, 8, ["icon"]),
      l("span", fy, c(o.value ? n(t)("action.copied") : ""), 1)
    ], 8, dy));
  }
}), gy = ["title"], vy = {
  key: 0,
  class: "shrink-0"
}, by = { class: "truncate" }, Pt = /* @__PURE__ */ C({
  __name: "TruncatedBadge",
  props: {
    value: {},
    display: {},
    label: {}
  },
  setup(e) {
    return (t, o) => (u(), v("figure", {
      class: "badge max-w-full min-w-0",
      title: e.value
    }, [
      e.label ? (u(), v("span", vy, c(e.label), 1)) : y("", !0),
      l("span", by, c(e.display ?? e.value), 1)
    ], 8, gy));
  }
}), _t = /* @__PURE__ */ C({
  __name: "BooleanIcon",
  props: {
    value: { type: [Boolean, null] }
  },
  setup(e) {
    return (t, o) => e.value === !0 ? (u(), b(D, {
      key: 0,
      class: "fill-accent-green",
      icon: "check"
    })) : e.value === !1 ? (u(), b(D, {
      key: 1,
      class: "fill-accent-red",
      icon: "close"
    })) : y("", !0);
  }
}), re = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "SimpleSelect",
  props: /* @__PURE__ */ ve({
    options: {},
    placeholder: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = Q(e, "modelValue");
    return (o, a) => (u(), b(n(ge).Root, {
      modelValue: t.value,
      "onUpdate:modelValue": a[0] || (a[0] = (s) => t.value = s)
    }, {
      default: f(() => [
        m(n(ge).Trigger, ae({
          class: "input cursor-pointer justify-between",
          "aria-label": e.placeholder
        }, o.$attrs), {
          default: f(() => [
            m(n(ge).Value, {
              class: "truncate min-w-0",
              placeholder: e.placeholder
            }, null, 8, ["placeholder"]),
            m(n(ge).Icon, { "as-child": "" }, {
              default: f(() => [
                m(D, { icon: "keyboard_arrow_down" })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 16, ["aria-label"]),
        m(n(ge).Portal, null, {
          default: f(() => [
            m(n(ge).Content, {
              class: "p-0 bg-surface-elevated shadow-xl z-50 border border-(--input-border-color) rounded-(--input-corner-radius) w-(--reka-select-trigger-width) max-h-(--reka-select-content-available-height)",
              position: "popper"
            }, {
              default: f(() => [
                m(n(ge).ScrollUpButton, null, {
                  default: f(() => [
                    m(D, { icon: "keyboard_arrow_up" })
                  ]),
                  _: 1
                }),
                m(n(ge).Viewport, null, {
                  default: f(() => [
                    (u(!0), v(I, null, te(e.options, (s) => (u(), b(n(ge).Item, {
                      key: s.value,
                      value: s.value,
                      class: "flex gap-3 items-center px-3 py-2 hover:bg-emphasis-2 cursor-pointer first:rounded-t-(--input-corner-radius) last:rounded-b-(--input-corner-radius) data-highlighted:outline-none data-highlighted:bg-accent-blue"
                    }, {
                      default: f(() => [
                        m(n(ge).ItemText, null, {
                          default: f(() => [
                            P(o.$slots, "option", { option: s }, () => [
                              $(c(s.label), 1)
                            ])
                          ]),
                          _: 2
                        }, 1024),
                        m(n(ge).ItemIndicator, null, {
                          default: f(() => [
                            m(D, { icon: "check" })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["value"]))), 128))
                  ]),
                  _: 3
                }),
                m(n(ge).ScrollDownButton, null, {
                  default: f(() => [
                    m(D, { icon: "keyboard_arrow_down" })
                  ]),
                  _: 1
                })
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["modelValue"]));
  }
}), yy = /* @__PURE__ */ C({
  __name: "SortTrigger",
  props: {
    sortKey: {}
  },
  setup(e) {
    const { sort: t, sortBy: o } = de(!0);
    return (a, s) => (u(), v("button", {
      type: "button",
      class: "sort-trigger",
      onClick: s[0] || (s[0] = (r) => n(o)(e.sortKey))
    }, [
      P(a.$slots, "default"),
      n(t).key === e.sortKey ? (u(), b(D, {
        key: 0,
        class: "size-4",
        icon: n(t).direction === n(W).enum.Ascending ? "keyboard_arrow_up" : "keyboard_arrow_down"
      }, null, 8, ["icon"])) : y("", !0)
    ]));
  }
}), z = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SortTrigger: yy
}, Symbol.toStringTag, { value: "Module" })), hy = {}, _y = { class: "text-2xl font-black" };
function $y(e, t) {
  return u(), v("h1", _y, "EVAC");
}
const ni = /* @__PURE__ */ Un(hy, [["render", $y]]), Sy = { class: "grid place-items-center gap-4" }, ky = {
  key: 0,
  class: "ml-2 text-secondary"
}, Ji = /* @__PURE__ */ C({
  __name: "LoadingSpinner",
  props: {
    message: {}
  },
  setup(e) {
    return (t, o) => (u(), v("div", Sy, [
      m(D, {
        icon: "progress_activity",
        class: "animate-spin size-12 fill-accent-blue"
      }),
      e.message ? (u(), v("span", ky, c(e.message), 1)) : y("", !0)
    ]));
  }
}), wy = {
  key: 0,
  class: "grid grid-cols-[max-content_1fr] grid-rows-2 bg-accent-red text-white items-center gap-x-4 px-4 py-2 rounded-md shadow-md h-16"
}, xy = ["textContent"], Cy = ["textContent"], Ty = /* @__PURE__ */ C({
  __name: "OfflineWarning",
  setup(e) {
    const { t } = R({ useScope: "global" }), { isOnline: o } = oa();
    return (a, s) => n(o) ? y("", !0) : (u(), v("figure", wy, [
      m(D, {
        class: "size-8 row-span-2",
        icon: "signal_disconnected"
      }),
      l("figcaption", {
        class: "font-bold text-lg uppercase",
        textContent: c(n(t)("offline.title"))
      }, null, 8, xy),
      l("p", {
        class: "text-sm",
        textContent: c(n(t)("offline.message"))
      }, null, 8, Cy)
    ]));
  }
}), Ry = { class: "grow grid gap-1" }, Dy = ["textContent"], My = ["textContent"], Ey = ["aria-label", "onClick"], KM = /* @__PURE__ */ C({
  __name: "Notices",
  setup(e) {
    const { t } = R({ useScope: "global" });
    return (o, a) => (u(), b(gd, { to: "body" }, [
      l("ul", {
        class: "fixed bottom-6 right-6 z-[60] pointer-events-auto grid gap-2 max-w-md",
        "aria-live": "assertive",
        onPointerdown: a[0] || (a[0] = X(() => {
        }, ["stop"])),
        onFocusin: a[1] || (a[1] = X(() => {
        }, ["stop"]))
      }, [
        (u(!0), v(I, null, te(n(ob), (s) => (u(), v("li", {
          key: s.id,
          role: "alert",
          class: "flex gap-3 items-start bg-accent-red text-white px-4 py-3 rounded-md shadow-md"
        }, [
          m(D, {
            class: "size-6 shrink-0",
            icon: "warning"
          }),
          l("div", Ry, [
            l("p", {
              class: "font-bold",
              textContent: c(n(t)(s.key))
            }, null, 8, Dy),
            s.detail ? (u(), v("p", {
              key: 0,
              class: "text-sm break-words whitespace-pre-line",
              textContent: c(s.detail)
            }, null, 8, My)) : y("", !0)
          ]),
          l("button", {
            type: "button",
            class: "shrink-0",
            "aria-label": n(t)("notice.dismiss"),
            onClick: (r) => n(ci)(s.id)
          }, [
            m(D, {
              class: "size-5",
              icon: "close"
            })
          ], 8, Ey)
        ]))), 128))
      ], 32)
    ]));
  }
}), Py = {
  class: "content-header",
  "data-scope": "content"
}, Ly = {
  key: 0,
  class: "flex gap-4 items-center h-12"
}, jy = { class: "headline" }, Ay = {
  key: 1,
  class: "mt-3"
}, Oy = { class: "paragraph description" }, J = /* @__PURE__ */ C({
  __name: "ContentHeader",
  props: {
    title: {},
    description: {},
    icon: {}
  },
  setup(e) {
    return (t, o) => (u(), v("header", Py, [
      P(t.$slots, "default", {}, () => [
        t.$slots.title || e.title || e.icon ? (u(), v("div", Ly, [
          e.icon ? (u(), b(D, {
            key: 0,
            class: "size-8",
            icon: e.icon
          }, null, 8, ["icon"])) : y("", !0),
          P(t.$slots, "title", {}, () => [
            l("h1", jy, c(e.title), 1)
          ])
        ])) : y("", !0),
        t.$slots.description || e.description ? (u(), v("div", Ay, [
          P(t.$slots, "description", {}, () => [
            l("p", Oy, c(e.description), 1)
          ])
        ])) : y("", !0),
        P(t.$slots, "row")
      ])
    ]));
  }
}), Uy = {}, Vy = { class: "px-6 flex gap-3 items-center justify-center text-center text-xs text-gray-500" };
function Iy(e, t) {
  return u(), v("footer", Vy, [
    P(e.$slots, "default"),
    t[0] || (t[0] = l("span", null, "© Evac International s.r.o.", -1))
  ]);
}
const zy = /* @__PURE__ */ Un(Uy, [["render", Iy]]), Xi = i.enum(["Salted", "SymmetricEncrypted"]), bo = [
  { days: 1, key: "day" },
  { days: 7, key: "week" },
  { days: 30, key: "month" }
], yo = [
  { day: 1, key: "mon" },
  { day: 2, key: "tue" },
  { day: 3, key: "wed" },
  { day: 4, key: "thu" },
  { day: 5, key: "fri" },
  { day: 6, key: "sat" },
  { day: 7, key: "sun" }
], ut = i.object({
  configPath: i.string().default("data/server.json"),
  databaseUrl: i.string().default(""),
  backupPath: i.string().default("data/backups"),
  uploadPath: i.string().default("data/uploads"),
  querySize: i.number().min(1).default(16),
  activityDiff: i.number().default(15),
  rssiWindow: i.number().min(0).default(15),
  auditRetentionDays: i.number().int().min(0).max(4294967295).default(365),
  routine: i.number().min(0).default(5),
  batteryLowThreshold: i.number().default(20),
  batteryLowReadings: i.number().default(500),
  batteryLowHysteresis: i.number().default(5),
  batteryNotifyStart: i.string().default("09:00"),
  batteryNotifyEnd: i.string().default("17:00"),
  batteryNotifyDays: i.array(i.number()).default([1, 2, 3, 4, 5]),
  batteryNotifyIntervalDays: i.number().default(7),
  portWeb: i.string().default("0.0.0.0:3030"),
  portScanner: i.string().default("0.0.0.0:3031"),
  portBroadcast: i.string().default("255.255.255.255:3031"),
  loginExpiration: i.object({ secs: i.number(), nanos: i.number() }).default({ secs: 604800, nanos: 0 }),
  security: i.object({ kind: Xi }).default({ kind: "SymmetricEncrypted" })
}), fa = i.codec(ut, ut.required(), {
  decode: (e) => e,
  encode: (e) => e
}), Qi = "report", er = "events", tr = { key: "timestamp", direction: W.enum.Descending }, nr = {
  advertisement: "bluetooth",
  buttonPressed: "touch_app",
  buttonDoublePressed: "touch_double",
  buttonTriplePressed: "touch_triple",
  buttonLongPressed: "touch_long",
  buttonHold: "reminder",
  operator: "person",
  batteryLow: "battery_alert"
}, Lt = i.enum(["advertisement", "buttonPressed", "buttonDoublePressed", "buttonTriplePressed", "buttonLongPressed", "buttonHold", "operator", "batteryLow"]), or = /* @__PURE__ */ new Set(["batteryLow"]), dt = i.object({
  uuid: i.uuid().describe("Event UUID"),
  kind: Lt.describe("Event kind"),
  timestamp: i.date().describe("Event timestamp"),
  scanner: i.uuid().describe("Relative scanner UUID"),
  device: i.uuid().nullish().describe("Relative device UUID")
}), Ny = dt.omit({ timestamp: !0 }).extend({
  uuid: dt.shape.uuid.default(ye),
  timestamp: i.date().default(() => /* @__PURE__ */ new Date())
}), Fy = i.codec(i.string(), i.date(), {
  decode: (e) => new Date(Date.parse(e)),
  encode: (e) => e.toISOString()
}), on = dt.omit({ timestamp: !0 }).extend({
  timestamp: Fy
}), ga = i.map(i.uuid(), dt), ar = i.codec(i.object({ EventList: i.array(on) }), ga, {
  decode: (e) => new Map(e.EventList.map((t) => [t.uuid, t])),
  encode: (e) => ({ EventList: Array.from(e.values()) })
}), sr = i.codec(i.object({ Event: on }), dt, {
  decode: (e) => e.Event,
  encode: (e) => ({ Event: e })
}), ir = i.codec(i.object({ EventRemove: i.uuid() }), i.uuid(), {
  decode: (e) => e.EventRemove,
  encode: (e) => ({ EventRemove: e })
}), rr = i.codec(i.object({ EventRemoved: i.uuid() }), i.uuid(), {
  decode: (e) => e.EventRemoved,
  encode: (e) => ({ EventRemoved: e })
}), By = i.object({
  kind: Lt,
  scanner: i.uuid(),
  device: i.uuid(),
  rssi: i.number().int()
}), va = i.object({
  name: i.string().min(1),
  address: i.email({ pattern: i.regexes.html5Email })
}), lr = i.codec(i.tuple([i.string(), i.email({ pattern: i.regexes.html5Email })]), va, {
  decode: ([e, t]) => ({ name: e, address: t }),
  encode: ({ name: e, address: t }) => [e, t]
}), ba = i.object({
  from: va,
  password: i.string().min(1),
  port: i.number().min(1).max(65535).default(587),
  server: i.string().min(1).default("smtp"),
  tls: i.boolean().default(!1),
  username: i.string().min(1)
}), ya = i.object({
  auth: i.string(),
  login: i.string(),
  url: i.string()
  // TODO: change to z.url() when backend supports validation
}), ha = i.object({
  token: i.string()
}), _a = i.literal(Lt.options), $a = i.object({
  group: i.uuid().describe("Relative notification group UUID"),
  notification: i.uuid().describe("Relative notification UUID")
}), Vn = i.partialRecord(_a, $a), cr = i.map(_a, $a), Gy = i.codec(Vn, cr, {
  decode: (e) => new Map(Object.entries(e)),
  encode: (e) => Object.fromEntries(e.entries())
}), ur = i.object({
  connectors: i.object({
    email: ba,
    sms: ya,
    telegram: ha
  }),
  event: Vn,
  user: i.uuid()
}), Sa = i.object({
  connectors: i.object({
    email: ba.extend({
      from: lr
    }),
    sms: ya,
    telegram: ha
  }),
  event: Vn,
  user: i.uuid()
}), dr = "settings", mr = "config", Hy = /* @__PURE__ */ new Set(["Admin", "Service"]), ce = {
  locations: /* @__PURE__ */ new Set(["Admin"]),
  rooms: /* @__PURE__ */ new Set(["Admin"]),
  scanners: /* @__PURE__ */ new Set(["Admin"]),
  devices: /* @__PURE__ */ new Set(["Admin", "Service"]),
  alarms: /* @__PURE__ */ new Set(["Admin", "Service"]),
  notifications: /* @__PURE__ */ new Set(["Admin", "Service"]),
  contacts: /* @__PURE__ */ new Set(["Admin", "Service"]),
  eventMappings: /* @__PURE__ */ new Set(["Admin", "Service"]),
  users: /* @__PURE__ */ new Set(["Admin"]),
  backups: /* @__PURE__ */ new Set(["Admin"]),
  config: /* @__PURE__ */ new Set(["Admin"]),
  // The last two also need a per-browser feature flag (`audit`, `page`), so neither may become the fallback route.
  auditLog: /* @__PURE__ */ new Set(["Admin"]),
  featureFlags: /* @__PURE__ */ new Set(["Admin"])
}, ho = i.object({
  base: ut,
  notification: ur
}), ka = i.object({
  Config: i.object({
    base: fa,
    notification: Sa
  })
}), pr = i.object({
  ConfigSet: i.object({
    base: fa,
    notification: Sa
  })
});
async function fr() {
  const e = await x.firstValueFrom(On);
  return wa(e);
}
function wa(e) {
  const t = ma(e);
  for (const [o, a] of Object.entries(ce))
    if (t(a))
      return `config.${o}`;
  return null;
}
const Ky = { class: "px-6 grid grid-cols-[1fr_max-content_1fr] items-center justify-between" }, qy = { class: "flex gap-4 items-center col-start-1" }, Wy = {
  key: 0,
  class: "col-start-2 flex gap-4 items-center justify-center"
}, Zy = { class: "flex gap-4 items-center justify-end col-start-3" }, Yy = ["onClick"], Jy = ["onClick"], Xy = /* @__PURE__ */ C({
  __name: "PageHeader",
  setup(e) {
    const { t } = R({ useScope: "global" }), { roles: o } = Et(), a = Zv(), s = k(() => wa(o.value) ?? ""), r = k(() => {
      const { matched: d, name: p } = a, g = s.value;
      if (p === g) return !0;
      const S = (h) => {
        for (const _ of h)
          if (_.name === g || _.children?.length && S(_.children))
            return !0;
        return !1;
      };
      return S(d);
    });
    return (d, p) => {
      const g = ii("RouterLink");
      return u(), v("header", Ky, [
        l("div", qy, [
          P(d.$slots, "logo", {}, () => [
            p[0] || (p[0] = l("h1", { class: "text-2xl font-black" }, "EVAC", -1))
          ]),
          P(d.$slots, "logo:post")
        ]),
        d.$slots.center ? (u(), v("div", Wy, [
          P(d.$slots, "center")
        ])) : y("", !0),
        l("nav", Zy, [
          P(d.$slots, "nav"),
          s.value ? (u(), b(g, {
            key: 0,
            to: { name: s.value },
            custom: ""
          }, {
            default: f(({ navigate: S }) => [
              l("button", {
                class: ke(["btn", { hidden: r.value }]),
                onClick: S
              }, [
                m(D, { icon: "settings" }),
                l("span", null, c(n(t)("page.configuration")), 1)
              ], 10, Yy)
            ]),
            _: 1
          }, 8, ["to"])) : y("", !0),
          m(g, {
            to: { name: "dashboard" },
            custom: ""
          }, {
            default: f(({ isActive: S, navigate: h }) => [
              l("button", {
                class: ke(["btn", { hidden: S }]),
                onClick: h
              }, [
                m(D, { icon: "frame_person" }),
                l("span", null, c(n(t)("page.overview")), 1)
              ], 10, Jy)
            ]),
            _: 1
          }),
          P(d.$slots, "nav:post")
        ])
      ]);
    };
  }
}), Qy = { class: "flex gap-4 justify-end py-6" }, eh = {
  class: "btn btn-filled",
  type: "submit"
}, th = {
  class: "btn btn-filled",
  type: "submit"
}, he = /* @__PURE__ */ C({
  __name: "DialogActions",
  props: {
    hasData: { type: Boolean },
    hasChanges: { type: Boolean }
  },
  emits: ["close", "cancel", "remove", "undo"],
  setup(e) {
    const { t } = R({ useScope: "global" });
    return (o, a) => (u(), v("div", Qy, [
      e.hasData && e.hasChanges ? (u(), v(I, { key: 0 }, [
        l("button", {
          class: "btn",
          type: "button",
          onClick: a[0] || (a[0] = (s) => (o.$emit("cancel", s), o.$emit("undo", s)))
        }, [
          m(D, { icon: "undo" }),
          $(" " + c(n(t)("action.cancelChanges")), 1)
        ]),
        l("button", eh, [
          m(D, { icon: "check" }),
          $(" " + c(n(t)("action.save")), 1)
        ])
      ], 64)) : e.hasData ? (u(), v(I, { key: 1 }, [
        l("button", {
          class: "btn text-accent-red",
          type: "button",
          onClick: a[1] || (a[1] = (s) => o.$emit("remove", s))
        }, [
          m(D, { icon: "delete" }),
          $(" " + c(n(t)("action.delete")), 1)
        ]),
        a[4] || (a[4] = l("span", { class: "grow" }, null, -1)),
        l("button", {
          class: "btn",
          type: "button",
          onClick: a[2] || (a[2] = (s) => o.$emit("close", s))
        }, [
          m(D, { icon: "close" }),
          $(" " + c(n(t)("action.close")), 1)
        ])
      ], 64)) : (u(), v(I, { key: 2 }, [
        l("button", {
          class: "btn",
          type: "button",
          onClick: a[3] || (a[3] = (s) => o.$emit("close", s))
        }, [
          m(D, { icon: "close" }),
          $(" " + c(n(t)("action.close")), 1)
        ]),
        l("button", th, [
          m(D, { icon: "add" }),
          $(" " + c(n(t)("action.create")), 1)
        ])
      ], 64))
    ]));
  }
}), uo = " / ", gr = /* @__PURE__ */ C({
  __name: "Breadcrumbs",
  props: {
    location: {},
    room: {},
    scanner: {},
    device: {}
  },
  setup(e) {
    const t = e, o = k(() => {
      let d = [];
      return t.location && d.push(t.location), t.room && d.push(t.room), t.scanner && d.push(t.scanner), t.device && d.push(t.device), d;
    }), a = k(() => o.value.join(uo)), s = k(() => o.value.slice(0, -1).join(uo)), r = k(() => o.value.at(-1) || "");
    return (d, p) => P(d.$slots, "default", {
      full: a.value,
      rest: s.value,
      last: r.value,
      delimiter: uo
    });
  }
}), nh = /* @__PURE__ */ C({
  __name: "Uuid",
  props: {
    entity: {}
  },
  setup(e) {
    const t = e, { uuid: o, hasUuid: a } = sy(() => t.entity);
    return (s, r) => n(a) ? P(s.$slots, "default", {
      key: 0,
      uuid: n(o)
    }) : y("", !0);
  }
}), Ue = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "UuidBadge",
  props: {
    entity: {}
  },
  setup(e) {
    const { enabled: t } = Ce(), { t: o } = R({ useScope: "global" });
    return (a, s) => n(t) ? (u(), b(nh, {
      key: 0,
      entity: e.entity
    }, {
      default: f(({ uuid: r }) => [
        m(it, ae(a.$attrs, {
          label: n(o)("entity.uuid"),
          value: r ?? ""
        }), null, 16, ["label", "value"])
      ]),
      _: 1
    }, 8, ["entity"])) : y("", !0);
  }
}), oh = {}, ah = { class: "row-start-2 col-start-2 @container/main rounded-page bg-surface-elevated shadow-md min-h-0 overflow-x-hidden overflow-y-auto" };
function sh(e, t) {
  return u(), v("main", ah, [
    P(e.$slots, "default")
  ]);
}
const qM = /* @__PURE__ */ Un(oh, [["render", sh]]), ih = { class: "page" }, WM = /* @__PURE__ */ C({
  __name: "PageLayout",
  setup(e) {
    return (t, o) => (u(), v("div", ih, [
      m(n(Xy), { class: "row-start-1 col-span-3" }, {
        center: f(() => [
          m(n(Ty))
        ]),
        nav: f(() => [
          P(t.$slots, "nav")
        ]),
        "nav:post": f(() => [
          P(t.$slots, "nav:post")
        ]),
        _: 3
      }),
      P(t.$slots, "default"),
      m(n(zy), { class: "row-start-3 col-span-3" }, {
        default: f(() => [
          P(t.$slots, "footer")
        ]),
        _: 3
      })
    ]));
  }
}), vr = "detector_alarm", _o = "alarms:active", mt = i.object({
  uuid: i.uuid(),
  alarm: i.uuid(),
  device: i.string(),
  scanner: i.string(),
  location: i.string(),
  room: i.string(),
  event: i.uuid().optional()
}), br = i.map(i.uuid(), mt), yr = mt.extend({
  uuid: mt.shape.uuid.default(ye)
}), $o = i.codec(i.object({ Alarm: mt }), mt, {
  decode: (e) => e.Alarm,
  encode: (e) => ({ Alarm: e })
}), hr = i.object({ ActiveAlarmList: i.array(i.unknown()) });
function _r(e) {
  const t = e.flatMap((o) => {
    const a = mt.safeParse(o);
    return a.success ? [a.data] : [];
  });
  return { alarms: t, dropped: e.length - t.length };
}
const So = i.codec(i.object({ AlarmStop: i.uuid() }), i.uuid(), {
  decode: (e) => e.AlarmStop,
  encode: (e) => ({ AlarmStop: e })
});
function rh(e, t) {
  const o = new Map(e ?? []);
  return o.delete(t.uuid), o.set(t.uuid, t);
}
function lh(e, t) {
  if (!e?.has(t)) return e ?? /* @__PURE__ */ new Map();
  const o = new Map(e);
  return o.delete(t), o;
}
function ch(e, t) {
  const o = new Map(t.map((s) => [s.uuid, s])), a = /* @__PURE__ */ new Map();
  for (const s of e?.keys() ?? []) {
    const r = o.get(s);
    r && a.set(s, r);
  }
  for (const [s, r] of o)
    a.has(s) || a.set(s, r);
  return a;
}
function uh(e) {
  if (!e) return;
  let t;
  for (const o of e.values()) t = o;
  return t;
}
const rt = le({
  name: _o,
  identity: br
}).withSources(
  async function* (t) {
    for await (const o of t) {
      const a = $o.safeParse(o);
      a.success && (yield (s) => rh(s, a.data));
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = So.safeParse(o);
      a.success && (yield (s) => lh(s, a.data));
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = hr.safeParse(o);
      if (!a.success) continue;
      const { alarms: s, dropped: r } = _r(a.data.ActiveAlarmList);
      r > 0 && U.warn(`[${_o}] ignored ${r} malformed active alarm(s)`), yield (d) => ch(d, s);
    }
  }
).withActions({
  stopAlarm(e, t) {
    e.send(So.encode(t));
  },
  startAlarm(e, t) {
    const o = yr.parse(t);
    e.send($o.encode(o));
  }
}), $r = x.from(rt).pipe(
  x.map((e) => Array.from(e?.values() ?? [])),
  x.shareReplay(1)
), Sr = x.from(rt).pipe(x.map(uh), x.shareReplay(1));
function an() {
  const e = Z(Sr, { onError: U.error, initialValue: void 0 }), t = Z($r, { onError: U.error, initialValue: [] });
  return {
    state: e,
    alarms: t,
    startAlarm: H(rt.startAlarm.bind(rt)),
    stopAlarm: H(rt.stopAlarm.bind(rt))
  };
}
const dh = /* @__PURE__ */ C({
  __name: "Root",
  setup(e) {
    const { state: t } = an();
    return (o, a) => P(o.$slots, "default", {
      detail: n(t),
      state: n(t),
      isAlarm: !!n(t)
    });
  }
}), mh = {
  key: 0,
  class: "flex flex-wrap gap-4 justify-between items-center"
}, ph = ["disabled"], fh = /* @__PURE__ */ C({
  __name: "Actions",
  props: {
    detail: {}
  },
  setup(e) {
    const { t } = R(), { stopAlarm: o } = an();
    return (a, s) => e.detail ? (u(), v("div", mh, [
      s[1] || (s[1] = l("span", { class: "grow" }, null, -1)),
      l("button", {
        type: "button",
        class: "btn btn-filled",
        disabled: n(o).ongoing.value,
        onClick: s[0] || (s[0] = (r) => n(o).submit(e.detail.uuid))
      }, [
        m(n(D), { icon: "warning_off" }),
        $(" " + c(n(t)("alarm.stop")), 1)
      ], 8, ph)
    ])) : y("", !0);
  }
}), xa = "detector_alarm", kr = "alarms", Ca = { key: "name", direction: W.enum.Ascending }, we = i.object({
  name: i.string(),
  uuid: i.uuid(),
  notification: i.string(),
  buzzer: i.boolean(),
  led: i.boolean(),
  group: i.uuid().describe("Contact group to notify when alarm is triggered")
}), Ta = i.map(i.uuid(), we), In = we.extend({
  uuid: we.shape.uuid.default(ye)
}), Ra = we, wr = i.codec(i.object({ AlarmList: i.array(Ra) }), Ta, {
  decode: (e) => new Map(e.AlarmList.map((t) => [t.uuid, t])),
  encode: (e) => ({ AlarmList: Array.from(e.values()) })
}), xr = i.codec(i.object({ AlarmDetail: Ra }), we, {
  decode: (e) => e.AlarmDetail,
  encode: (e) => ({ AlarmDetail: e })
}), ko = i.codec(i.object({ AlarmSet: Ra }), we, {
  decode: (e) => e.AlarmSet,
  encode: (e) => ({ AlarmSet: e })
}), Cr = i.codec(i.object({ AlarmRemove: i.uuid() }), i.uuid(), {
  decode: (e) => e.AlarmRemove,
  encode: (e) => ({ AlarmRemove: e })
}), Tr = i.codec(i.object({ AlarmRemoved: i.uuid() }), i.uuid(), {
  decode: (e) => e.AlarmRemoved,
  encode: (e) => ({ AlarmRemoved: e })
});
function Da() {
  return {
    name: "",
    notification: "",
    buzzer: !1,
    led: !1,
    group: ""
  };
}
const Ie = le({
  name: kr,
  identity: Ta
}).withSources(
  async function* (t) {
    for await (const o of t) {
      const a = wr.safeParse(o);
      a.success && (yield () => a.data);
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = xr.safeParse(o);
      a.success && (yield (s) => new Map(s ?? []).set(a.data.uuid, a.data));
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = Tr.safeParse(o);
      a.success && (yield (s) => {
        const r = new Map(s ?? []);
        return r.delete(a.data), r;
      });
    }
  }
).withActions({
  create(e, t) {
    const o = In.parse(t);
    e.send(ko.encode(o));
  },
  remove(e, t) {
    e.send(Cr.encode(t));
  },
  update(e, t) {
    const o = we.parse(t);
    e.send(ko.encode(o));
  },
  seed: Da
}), Rr = x.from(Ie).pipe(x.shareReplay(1));
function jt(e = {}) {
  const t = k(() => A(e.sort) ?? [Ca]), o = Z(Rr, { onError: U.error, initialValue: /* @__PURE__ */ new Map() }), a = k(() => ne(o.value.values(), Y(A(t)))), s = k(() => ne(o.value.values(), Y(A(t))));
  return {
    count: k(() => me(o.value.size, s.value.length)),
    state: o,
    list: s,
    all: a
  };
}
function Ma(e) {
  const { state: t } = jt();
  return {
    detail: k(() => t.value.get(A(e)) ?? null)
  };
}
function Dr({ input: e } = {}) {
  const { t } = R({ useScope: "global" });
  return Qe({
    input: e,
    seed: Da,
    createType: In,
    entityType: we,
    create: (o) => Ie.create(o),
    update: (o) => Ie.update(o),
    remove: (o) => Ie.remove(o),
    i18n: {
      create: () => t("alarm.dialog.create", ""),
      edit: () => t("alarm.dialog.edit", ""),
      title: () => t("alarm.dialog.title", ""),
      confirmRemove: () => t("alarm.dialog.confirmDelete", "")
    }
  });
}
const Ea = "mail", Mr = "notifications", Pa = { key: "name", direction: W.enum.Ascending }, be = i.object({
  name: i.string(),
  uuid: i.uuid(),
  subject: i.string(),
  short: i.string(),
  long: i.string()
}), La = i.map(i.uuid(), be), zn = be.extend({
  uuid: be.shape.uuid.default(ye)
}).loose(), Nn = be, wo = be.pick({ subject: !0, short: !0, long: !0 }), Er = i.codec(i.object({ NotificationList: i.array(Nn) }), La, {
  decode: (e) => new Map(e.NotificationList.map((t) => [t.uuid, t])),
  encode: (e) => ({ NotificationList: Array.from(e.values()) })
}), xo = i.codec(i.object({ NotificationSet: Nn }), be, {
  decode: (e) => e.NotificationSet,
  encode: (e) => ({ NotificationSet: e })
}), Pr = i.codec(i.object({ NotificationDetail: Nn }), be, {
  decode: (e) => e.NotificationDetail,
  encode: (e) => ({ NotificationDetail: e })
}), Lr = i.codec(i.object({ NotificationRemove: i.uuid() }), i.uuid(), {
  decode: (e) => e.NotificationRemove,
  encode: (e) => ({ NotificationRemove: e })
}), jr = i.codec(i.object({ NotificationRemoved: i.uuid() }), i.uuid(), {
  decode: (e) => e.NotificationRemoved,
  encode: (e) => ({ NotificationRemoved: e })
}), Ar = i.codec(i.object({ Notification: wo }), wo, {
  decode: (e) => e.Notification,
  encode: (e) => ({ Notification: e })
});
function Jt(e) {
  return e.name.trim() || e.subject.trim();
}
function ja() {
  return {
    name: "",
    subject: "",
    short: "",
    long: ""
  };
}
const Me = le({
  name: Mr,
  identity: La
}).withSources(
  async function* (t) {
    for await (const o of t) {
      const a = Er.safeParse(o);
      a.success && (yield () => a.data);
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = Pr.safeParse(o);
      a.success && (yield (s) => new Map(s ?? []).set(a.data.uuid, a.data));
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = jr.safeParse(o);
      a.success && (yield (s) => {
        const r = new Map(s ?? []);
        return r.delete(a.data), r;
      });
    }
  }
).withActions({
  create(e, t) {
    e.send(xo.encode(zn.parse(t)));
  },
  remove(e, t) {
    e.send(Lr.encode(t));
  },
  update(e, t) {
    e.send(xo.encode(be.parse(t)));
  },
  seed: ja,
  async send(e, t) {
    e.send(Ar.encode(t));
  }
}), Or = x.from(Me).pipe(x.shareReplay(1));
function Fn(e = {}) {
  const t = k(() => A(e.sort) ?? [Pa]), o = Z(Or, { onError: U.error, initialValue: /* @__PURE__ */ new Map() }), a = k(() => ne(o.value.values(), Y(t.value))), s = k(() => ne(o.value.values(), Y(t.value)));
  return {
    count: k(() => me(o.value.size, s.value.length)),
    state: o,
    list: s,
    all: a,
    send: H(Me.send)
  };
}
function Aa(e) {
  const { state: t } = Fn();
  return {
    detail: k(() => t.value.get(A(e) ?? "") ?? null)
  };
}
function Ur({ input: e } = {}) {
  const { t } = R({ useScope: "global" });
  return Qe({
    input: e,
    seed: ja,
    createType: zn,
    entityType: be,
    create: (o) => Me.create(o),
    update: (o) => Me.update(o),
    remove: (o) => Me.remove(o),
    i18n: {
      create: () => t("notification.dialog.create", ""),
      edit: () => t("notification.dialog.edit", ""),
      title: () => t("notification.dialog.title", ""),
      confirmRemove: () => t("notification.dialog.confirmDelete", "")
    }
  });
}
const Vr = /* @__PURE__ */ C({
  __name: "Root",
  props: {
    uuid: {}
  },
  setup(e) {
    const t = e, { detail: o } = Aa(() => t.uuid);
    return (a, s) => P(a.$slots, "default", { detail: n(o) });
  }
}), gh = ["title"], vh = ["title"], bh = { key: 2 }, Oa = /* @__PURE__ */ C({
  __name: "Name",
  props: {
    uuid: {}
  },
  setup(e) {
    const t = e, { t: o } = R({ useScope: "global" }), { detail: a } = Aa(() => t.uuid), s = k(() => a.value ? Jt(a.value) : "");
    return (r, d) => s.value ? (u(), v("span", {
      key: 0,
      class: "truncate",
      title: s.value
    }, c(s.value), 9, gh)) : e.uuid && !n(a) ? (u(), v("span", {
      key: 1,
      class: "truncate text-muted",
      title: e.uuid
    }, c(n(o)("notification.unknown")), 9, vh)) : (u(), v("span", bh, "-"));
  }
}), yh = new Set(
  `@£$¥èéùìòÇ
Øø\rÅåΔΦΓΛΩΠΨΣΘΞÆæßÉ¤¡ÄÖÑÜ§¿äöñüà !"#%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà`.split("")
), hh = new Set("{}[]~|\\^€".split("")), Co = 160, To = 153, Ro = 70, Do = 67;
function Ua(e) {
  return yh.has(e);
}
function Va(e) {
  return hh.has(e);
}
function _h(e) {
  for (const t of e)
    if (!Ua(t) && !Va(t)) return !1;
  return !0;
}
function Ir(e) {
  let t = 0;
  for (const o of e)
    if (Ua(o))
      t += 1;
    else if (Va(o))
      t += 2;
    else
      return null;
  return t;
}
const $h = {
  á: "a",
  č: "c",
  ď: "d",
  é: "e",
  ě: "e",
  í: "i",
  ň: "n",
  ó: "o",
  ř: "r",
  š: "s",
  ť: "t",
  ú: "u",
  ů: "u",
  ý: "y",
  ž: "z",
  Á: "A",
  Č: "C",
  Ď: "D",
  É: "E",
  Ě: "E",
  Í: "I",
  Ň: "N",
  Ó: "O",
  Ř: "R",
  Š: "S",
  Ť: "T",
  Ú: "U",
  Ů: "U",
  Ý: "Y",
  Ž: "Z",
  ľ: "l",
  Ľ: "L",
  ŕ: "r",
  Ŕ: "R",
  ô: "o",
  Ô: "O"
};
function zr(e) {
  for (const t of e)
    if (t in $h) return !0;
  return !1;
}
function Nr(e) {
  const t = zr(e), o = Ir(e);
  if (o !== null) {
    const r = o <= Co ? 1 : Math.ceil(o / To);
    return {
      charCount: o,
      singleLimit: Co,
      concatLimit: To,
      segments: r,
      isGsm: !0,
      hasDiacritics: t
    };
  }
  const a = [...e].length, s = a <= Ro ? 1 : Math.ceil(a / Do);
  return {
    charCount: a,
    singleLimit: Ro,
    concatLimit: Do,
    segments: s,
    isGsm: !1,
    hasDiacritics: t
  };
}
const ZM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GSM_CONCAT_LIMIT: To,
  GSM_SINGLE_LIMIT: Co,
  UCS2_CONCAT_LIMIT: Do,
  UCS2_SINGLE_LIMIT: Ro,
  analyze: Nr,
  gsmSeptetCount: Ir,
  hasDiacritics: zr,
  isGsmBasic: Ua,
  isGsmCompatible: _h,
  isGsmExtension: Va
}, Symbol.toStringTag, { value: "Module" })), Sh = { class: "flex items-center gap-3 text-xs tabular-nums" }, kh = {
  key: 0,
  class: "text-muted"
}, wh = ["title"], xh = {
  key: 2,
  class: "text-amber-500"
}, Ch = /* @__PURE__ */ C({
  __name: "SmsCharCounter",
  props: {
    text: {}
  },
  setup(e) {
    const t = e, { t: o } = R({ useScope: "global" }), a = k(() => Nr(t.text)), s = k(() => a.value.segments <= 1 ? a.value.singleLimit : a.value.concatLimit), r = k(() => a.value.charCount > a.value.singleLimit);
    return (d, p) => (u(), v("div", Sh, [
      l("span", {
        class: ke(["font-mono", r.value ? "text-amber-500" : "text-muted"])
      }, c(a.value.charCount) + " / " + c(s.value), 3),
      a.value.segments > 1 ? (u(), v("span", kh, c(n(o)("notification.sms.segments", { count: a.value.segments })), 1)) : y("", !0),
      a.value.isGsm ? y("", !0) : (u(), v("span", {
        key: 1,
        class: "text-amber-500",
        title: n(o)("notification.sms.ucs2Tooltip")
      }, " UCS-2 ", 8, wh)),
      a.value.hasDiacritics && !a.value.isGsm ? (u(), v("span", xh, c(n(o)("notification.sms.diacriticsWarning")), 1)) : y("", !0)
    ]));
  }
}), Th = ["onSubmit"], Rh = ["aria-label"], Dh = ["textContent"], Mh = ["textContent"], Eh = ["placeholder"], Ph = { class: "px-6 grid gap-4" }, Lh = {
  class: "label",
  for: "notification-subject"
}, jh = { class: "label-text" }, Ah = {
  class: "label",
  for: "notification-short-text"
}, Oh = { class: "label-text" }, Uh = {
  class: "label",
  for: "notification-long-text"
}, Vh = { class: "label-text" }, Ia = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "Dialog",
  props: {
    notification: {}
  },
  setup(e) {
    const t = e, { t: o } = R({ useScope: "global" }), a = Ur({ input: () => t.notification });
    return (s, r) => (u(), b(n(T).Root, {
      "onUpdate:open": r[6] || (r[6] = (d) => n(a).reset())
    }, {
      default: f(({ close: d }) => [
        m(n(T).Trigger, { "as-child": "" }, {
          default: f(() => [
            P(s.$slots, "default", {}, () => [
              l("button", ae({
                type: "button",
                class: "btn"
              }, s.$attrs), [
                e.notification ? (u(), b(n(D), {
                  key: 0,
                  icon: "edit"
                })) : (u(), b(n(D), {
                  key: 1,
                  icon: "add"
                }))
              ], 16)
            ])
          ]),
          _: 3
        }),
        m(n(T).Portal, null, {
          default: f(() => [
            m(n(T).Overlay, { class: "overlay" }),
            m(n(T).Content, {
              class: "dialog",
              "as-child": ""
            }, {
              default: f(() => [
                l("form", {
                  ref: "formElement",
                  onSubmit: X((p) => n(a).save.submit({ created: d }), ["prevent"])
                }, [
                  n(a).isUpdate ? (u(), v("input", {
                    key: 0,
                    type: "text",
                    autofocus: "",
                    tabindex: "0",
                    class: "sr-only",
                    "aria-label": n(a).title
                  }, null, 8, Rh)) : y("", !0),
                  m(n(J), {
                    icon: Ea
                  }, {
                    title: f(() => [
                      m(n(T).Title, { class: "headline grow" }, {
                        default: f(() => [
                          l("span", {
                            class: "sr-only",
                            textContent: c(n(a).title)
                          }, null, 8, Dh),
                          l("label", {
                            for: "notification-name",
                            class: "sr-only",
                            textContent: c(n(o)("entity.name"))
                          }, null, 8, Mh),
                          L(l("input", {
                            id: "notification-name",
                            "onUpdate:modelValue": r[0] || (r[0] = (p) => n(a).data.name = p),
                            class: "input",
                            type: "text",
                            placeholder: n(o)("entity.name")
                          }, null, 8, Eh), [
                            [j, n(a).data.name]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    description: f(() => [
                      m(n(T).Description, { class: "paragraph description" }, {
                        default: f(() => [
                          $(c(n(o)("notification.dialog.description", "")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    row: f(() => [
                      m(n(Ue), { entity: e.notification }, null, 8, ["entity"])
                    ]),
                    _: 1
                  }, 8, ["icon"]),
                  l("div", Ph, [
                    l("label", Lh, [
                      l("span", jh, c(n(o)("entity.subject")), 1),
                      L(l("input", {
                        id: "notification-subject",
                        "onUpdate:modelValue": r[1] || (r[1] = (p) => n(a).data.subject = p),
                        class: "input w-full",
                        type: "text"
                      }, null, 512), [
                        [j, n(a).data.subject]
                      ])
                    ]),
                    l("label", Ah, [
                      l("span", Oh, c(n(o)("entity.shortText")), 1),
                      L(l("textarea", {
                        id: "notification-short-text",
                        "onUpdate:modelValue": r[2] || (r[2] = (p) => n(a).data.short = p),
                        rows: "5",
                        class: "input w-full min-h-24",
                        type: "text"
                      }, null, 512), [
                        [j, n(a).data.short]
                      ]),
                      m(Ch, {
                        text: n(a).data.short
                      }, null, 8, ["text"])
                    ]),
                    l("label", Uh, [
                      l("span", Vh, c(n(o)("entity.longText")), 1),
                      L(l("textarea", {
                        id: "notification-long-text",
                        "onUpdate:modelValue": r[3] || (r[3] = (p) => n(a).data.long = p),
                        rows: "5",
                        class: "input w-full min-h-48",
                        type: "text"
                      }, null, 512), [
                        [j, n(a).data.long]
                      ])
                    ])
                  ]),
                  m(n(he), {
                    class: "px-6",
                    "has-data": n(a).isUpdate,
                    "has-changes": n(a).hasChanges,
                    onClose: d,
                    onRemove: r[4] || (r[4] = (p) => n(a).remove.submit()),
                    onUndo: r[5] || (r[5] = (p) => n(a).reset())
                  }, null, 8, ["has-data", "has-changes", "onClose"])
                ], 40, Th)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }));
  }
}), Ih = ["title"], zh = ["title"], Nh = ["title"], Fh = ["title"], Fr = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "ListItem",
  props: {
    notification: {}
  },
  setup(e) {
    const { visible: t } = de(!0);
    return (o, a) => (u(), b(Ia, { notification: e.notification }, {
      default: f(() => [
        l("button", ae({
          type: "button",
          class: "item grid grid-cols-subgrid not-first:border-t h-12 items-center px-6 gap-4"
        }, o.$attrs), [
          n(t).name ? (u(), v("strong", {
            key: 0,
            class: "value text-left truncate max-w-60",
            title: Jt(e.notification)
          }, c(Jt(e.notification)), 9, Ih)) : y("", !0),
          n(t).uuid ? (u(), b(n(B), { key: 1 }, {
            default: f(() => [
              $(c(e.notification.uuid), 1)
            ]),
            _: 1
          })) : y("", !0),
          n(t).subject ? (u(), v("span", {
            key: 2,
            class: "value text-left font-normal truncate max-w-80",
            title: e.notification.subject
          }, c(e.notification.subject), 9, zh)) : y("", !0),
          n(t).short ? (u(), v("span", {
            key: 3,
            class: "value text-left font-normal truncate max-w-80",
            title: e.notification.short
          }, c(e.notification.short), 9, Nh)) : y("", !0),
          n(t).long ? (u(), v("span", {
            key: 4,
            class: "value text-left font-normal truncate max-w-80",
            title: e.notification.long
          }, c(e.notification.long), 9, Fh)) : y("", !0)
        ], 16)
      ]),
      _: 1
    }, 8, ["notification"]));
  }
}), Br = /* @__PURE__ */ C({
  __name: "List",
  props: {
    notifications: {}
  },
  setup(e) {
    const { t } = R({ useScope: "global" }), { gridStyle: o, rowStyle: a, visible: s } = de(!0);
    return (r, d) => (u(), v("section", {
      class: "list grid content-start",
      style: K(n(o))
    }, [
      l("header", {
        class: "headline",
        style: K(n(a))
      }, [
        n(s).name ? (u(), b(n(z).SortTrigger, {
          key: 0,
          "sort-key": "name"
        }, {
          default: f(() => [
            $(c(n(t)("entity.name")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).uuid ? (u(), b(n(z).SortTrigger, {
          key: 1,
          class: "justify-self-center",
          "sort-key": "uuid"
        }, {
          default: f(() => [
            $(c(n(t)("entity.uuid")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).subject ? (u(), b(n(z).SortTrigger, {
          key: 2,
          class: "justify-self-start",
          "sort-key": "subject"
        }, {
          default: f(() => [
            $(c(n(t)("entity.subject")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).short ? (u(), b(n(z).SortTrigger, {
          key: 3,
          class: "justify-self-start",
          "sort-key": "short"
        }, {
          default: f(() => [
            $(c(n(t)("entity.shortText")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).long ? (u(), b(n(z).SortTrigger, {
          key: 4,
          class: "justify-self-start",
          "sort-key": "long"
        }, {
          default: f(() => [
            $(c(n(t)("entity.longText")), 1)
          ]),
          _: 1
        })) : y("", !0)
      ], 4),
      (u(!0), v(I, null, te(e.notifications, (p) => (u(), b(Fr, {
        key: p.uuid,
        style: K(n(a)),
        notification: p
      }, null, 8, ["style", "notification"]))), 128)),
      P(r.$slots, "default")
    ], 4));
  }
}), za = /* @__PURE__ */ C({
  __name: "Select",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Q(e, "modelValue"), { t: o } = R({ useScope: "global" }), { list: a } = Fn(), s = k(
      () => Y(
        a.value.map((r) => ({ value: r.uuid, label: Jt(r) || r.uuid })),
        { key: "label", direction: W.enum.Ascending }
      )
    );
    return (r, d) => (u(), b(n(re), {
      modelValue: t.value,
      "onUpdate:modelValue": d[0] || (d[0] = (p) => t.value = p),
      options: s.value,
      placeholder: n(o)("notification.select.placeholder")
    }, null, 8, ["modelValue", "options", "placeholder"]));
  }
}), Bh = /%(device|scanner|location|room)%/g;
function Gh(e, t) {
  return e.replace(Bh, (o, a) => t[a]);
}
const Hh = { class: "p-4 shadow-md rounded-xl border-2 border-accent-red bg-accent-red/10 grid gap-3" }, Kh = { class: "flex gap-4 items-center" }, qh = ["textContent"], Wh = {
  key: 0,
  class: "overflow-y-auto"
}, Zh = ["textContent"], Yh = { class: "whitespace-pre-line" }, Jh = /* @__PURE__ */ C({
  __name: "Message",
  props: {
    detail: {}
  },
  setup(e) {
    const t = e, { detail: o } = Ma(() => t.detail.alarm), { t: a } = R();
    return (s, r) => (u(), v("section", Hh, [
      l("header", Kh, [
        m(n(D), {
          class: "size-8 fill-accent-red",
          icon: "warning"
        }),
        l("h1", {
          class: "headline",
          textContent: c(n(a)("alarm.title"))
        }, null, 8, qh),
        r[0] || (r[0] = l("span", { class: "grow" }, null, -1)),
        P(s.$slots, "actions")
      ]),
      e.detail.location ? (u(), b(n(B), { key: 0 }, {
        default: f(() => [
          m(n(gr), {
            location: e.detail.location,
            room: e.detail.room,
            scanner: e.detail.scanner,
            device: e.detail.device
          }, {
            default: f(({ delimiter: d, rest: p, last: g }) => [
              p.length ? (u(), v(I, { key: 0 }, [
                $(c(p + d), 1)
              ], 64)) : y("", !0),
              l("strong", null, c(g), 1)
            ]),
            _: 1
          }, 8, ["location", "room", "scanner", "device"])
        ]),
        _: 1
      })) : y("", !0),
      n(o) ? (u(), b(Vr, {
        key: 1,
        uuid: n(o).notification
      }, {
        default: f(({ detail: d }) => [
          d ? (u(), v("div", Wh, [
            l("h2", {
              class: "font-bold text-lg",
              textContent: c(d.subject)
            }, null, 8, Zh),
            l("div", Yh, c(Gh(d.long, e.detail)), 1)
          ])) : y("", !0)
        ]),
        _: 1
      }, 8, ["uuid"])) : y("", !0),
      P(s.$slots, "default")
    ]));
  }
}), Xh = { title: "Alarm", dialog: { title: "Detail alarmu", description: "", run: "Spustit alarm", create: "Vytvořit alarm", edit: "Upravit alarm", confirmDelete: "Opravdu chcete smazat tento alarm?" }, select: { placeholder: "Vyberte alarm" }, stop: "Zastavit" }, Qh = { config: { title: "Alarmy", description: "Spravujte alarmy systému Evac" } }, e_ = {
  alarm: Xh,
  alarms: Qh
}, t_ = { title: "Alarm", dialog: { title: "Alarm detail", description: "", run: "Run alarm", create: "Create alarm", edit: "Edit alarm", confirmDelete: "Are you sure you want to delete this alarm?" }, select: { placeholder: "Select alarm" }, stop: "Stop" }, n_ = { config: { title: "Alarms", description: "Manage alarms in the system" } }, o_ = {
  alarm: t_,
  alarms: n_
}, a_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cs: e_,
  en: o_
}, Symbol.toStringTag, { value: "Module" }));
function s_(e) {
  return We(e, Ie, {
    path: "alarms",
    itemSchema: we,
    ...qe()
  });
}
function i_(e) {
  Object.defineProperty(Ie, "create", {
    value: async (t) => e.save(In.parse(t)),
    configurable: !0
  }), Object.defineProperty(Ie, "update", {
    value: async (t) => e.save(we.parse(t)),
    configurable: !0
  }), Object.defineProperty(Ie, "remove", {
    value: async (t) => e.remove(t),
    configurable: !0
  });
}
const r_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bindActions: i_,
  createEndpoint: s_
}, Symbol.toStringTag, { value: "Module" })), l_ = /* @__PURE__ */ C({
  __name: "Root",
  props: {
    uuid: {}
  },
  setup(e) {
    const t = e, { detail: o } = Ma(() => t.uuid);
    return (a, s) => P(a.$slots, "default", { detail: n(o) });
  }
}), Na = "group", Gr = "contactGroups", wn = { key: "name", direction: W.enum.Ascending }, Ge = i.object({
  uuid: i.uuid(),
  name: i.string(),
  contacts: i.set(i.uuid())
}), Hr = i.codec(i.array(i.uuid()), i.set(i.uuid()), {
  decode: (e) => new Set(e),
  encode: (e) => Array.from(e)
}), pt = Ge.extend({
  contacts: Hr
}), Fa = i.map(i.uuid(), Ge), Bn = Ge.extend({
  uuid: Ge.shape.uuid.default(ye)
}).loose(), Kr = i.codec(i.object({ ContactGroupList: i.array(pt) }), Fa, {
  decode: (e) => new Map(e.ContactGroupList.map((t) => [t.uuid, t])),
  encode: (e) => ({ ContactGroupList: Array.from(e.values()) })
}), Mo = i.codec(i.object({ ContactGroupSet: pt }), Ge, {
  decode: (e) => e.ContactGroupSet,
  encode: (e) => ({ ContactGroupSet: e })
}), qr = i.codec(i.object({ ContactGroupDetail: pt }), Ge, {
  decode: (e) => e.ContactGroupDetail,
  encode: (e) => ({ ContactGroupDetail: e })
}), Wr = i.codec(i.object({ ContactGroupRemove: i.uuid() }), i.uuid(), {
  decode: (e) => e.ContactGroupRemove,
  encode: (e) => ({ ContactGroupRemove: e })
}), Zr = i.codec(i.object({ ContactGroupRemoved: i.uuid() }), i.uuid(), {
  decode: (e) => e.ContactGroupRemoved,
  encode: (e) => ({ ContactGroupRemoved: e })
});
function Ba() {
  return {
    name: "",
    contacts: /* @__PURE__ */ new Set()
  };
}
const ze = le({
  name: Gr,
  identity: Fa
}).withSources(
  async function* (t) {
    for await (const o of t) {
      const a = Kr.safeParse(o);
      a.success && (yield () => a.data);
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = qr.safeParse(o);
      a.success && (yield (s) => new Map(s ?? []).set(a.data.uuid, a.data));
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = Zr.safeParse(o);
      a.success && (yield (s) => {
        const r = new Map(s ?? []);
        return r.delete(a.data), r;
      });
    }
  }
).withActions({
  create(e, t) {
    const o = Bn.parse(t);
    e.send(Mo.encode(o));
  },
  remove(e, t) {
    e.send(Wr.encode(t));
  },
  update(e, t) {
    const o = Ge.parse(t);
    e.send(Mo.encode(o));
  },
  seed: Ba
}), Yr = x.from(ze).pipe(x.shareReplay(1));
function c_(e) {
  const t = e?.trim().toLowerCase() ?? "";
  return function(a) {
    return !t || a.name.toLowerCase().includes(t);
  };
}
function sn(e = {}) {
  const t = k(() => A(e.sort) ?? [wn]), o = Z(Yr, { onError: U.error, initialValue: /* @__PURE__ */ new Map() }), a = k(() => ne(o.value.values(), Y(t.value))), s = k(() => ne(o.value.values(), ot([c_(A(e.filter?.search))]), Y(t.value)));
  return {
    count: k(() => me(o.value.size, s.value.length)),
    state: o,
    list: s,
    all: a
  };
}
function Jr(e) {
  const { state: t } = sn();
  return {
    detail: k(() => t.value.get(A(e)) ?? null)
  };
}
function Xr({ input: e } = {}) {
  const { t } = R({ useScope: "global" });
  return Qe({
    input: e,
    seed: Ba,
    createType: Bn,
    entityType: Ge,
    create: (o) => ze.create(o),
    update: (o) => ze.update(o),
    remove: (o) => ze.remove(o),
    i18n: {
      create: () => t("contactGroup.dialog.create", ""),
      edit: () => t("contactGroup.dialog.edit", ""),
      title: () => t("contactGroup.dialog.title", ""),
      confirmRemove: () => t("contactGroup.dialog.confirmDelete", "")
    }
  });
}
const Ga = /* @__PURE__ */ C({
  __name: "Root",
  props: {
    uuid: {}
  },
  setup(e) {
    const t = e, { detail: o } = Jr(() => t.uuid);
    return (a, s) => P(a.$slots, "default", { detail: n(o) });
  }
}), Gn = "contacts", Qr = "contacts", u_ = "email", xn = { key: "name", direction: W.enum.Ascending }, Ha = i.object({
  number: i.string()
}), Ka = i.object({
  email: i.string()
}), qa = i.object({
  chatId: i.string()
}), Ve = i.enum(["sms", "email", "telegram"]), Hn = i.object({
  uuid: i.uuid(),
  name: i.string(),
  kind: Ve
}), Kn = Hn.extend({
  kind: i.literal(Ve.enum.email),
  ...Ka.shape
}), At = Hn.extend({
  kind: i.literal(Ve.enum.sms),
  ...Ha.shape
}), rn = Hn.extend({
  kind: i.literal(Ve.enum.telegram),
  ...qa.shape
}), Pe = i.discriminatedUnion("kind", [Kn, At, rn]), Wa = i.map(i.uuid(), Pe), qn = i.object({
  name: i.string(),
  kind: Ve
}), Za = qn.extend({
  uuid: At.shape.uuid.default(ye),
  kind: i.literal(Ve.enum.email),
  ...Ka.shape
}), Ya = qn.extend({
  uuid: At.shape.uuid.default(ye),
  kind: i.literal(Ve.enum.sms),
  ...Ha.shape
}), Ja = qn.extend({
  uuid: rn.shape.uuid.default(ye),
  kind: i.literal(Ve.enum.telegram),
  ...qa.shape
}), Wn = i.discriminatedUnion("kind", [Za, Ya, Ja]), el = i.object({
  sms: i.object({
    number: i.string()
  })
}), tl = i.object({
  email: i.object({
    email: i.string()
  })
}), nl = i.object({
  telegram: i.object({
    chat_id: i.string()
  })
}), ol = i.union([el, tl, nl]), Xt = i.object({
  uuid: i.uuid(),
  name: i.string(),
  kind: ol
}), Xa = i.codec(Xt, Pe, {
  decode(e) {
    const t = Xt.parse(e);
    if ("sms" in t.kind)
      return At.parse({
        uuid: t.uuid,
        name: t.name,
        kind: "sms",
        number: t.kind.sms.number
      });
    if ("email" in t.kind)
      return Kn.parse({
        uuid: t.uuid,
        name: t.name,
        kind: "email",
        email: t.kind.email.email
      });
    if ("telegram" in t.kind)
      return rn.parse({
        uuid: t.uuid,
        name: t.name,
        kind: "telegram",
        chatId: t.kind.telegram.chat_id
      });
    throw new Error("Unknown message kind");
  },
  encode(e) {
    switch (e.kind) {
      case "sms":
        return {
          uuid: e.uuid,
          name: e.name,
          kind: { sms: { number: e.number } }
        };
      case "email":
        return {
          uuid: e.uuid,
          name: e.name,
          kind: { email: { email: e.email } }
        };
      case "telegram":
        return {
          uuid: e.uuid,
          name: e.name,
          kind: { telegram: { chat_id: e.chatId } }
        };
    }
  }
}), al = i.codec(i.object({ ContactList: i.array(Xa) }), Wa, {
  decode: (e) => new Map(e.ContactList.map((t) => [t.uuid, t])),
  encode: (e) => ({ ContactList: Array.from(e.values()) })
}), Eo = i.codec(i.object({ ContactSet: Xa }), Pe, {
  decode: (e) => e.ContactSet,
  encode: (e) => ({ ContactSet: e })
}), sl = i.codec(i.object({ ContactDetail: Xa }), Pe, {
  decode: (e) => e.ContactDetail,
  encode: (e) => ({ ContactDetail: e })
}), il = i.codec(i.object({ ContactRemove: i.uuid() }), i.uuid(), {
  decode: (e) => e.ContactRemove,
  encode: (e) => ({ ContactRemove: e })
}), rl = i.codec(i.object({ ContactRemoved: i.uuid() }), i.uuid(), {
  decode: (e) => e.ContactRemoved,
  encode: (e) => ({ ContactRemoved: e })
});
function Qa(e) {
  switch (e) {
    case "sms":
      return {
        name: "",
        kind: "sms",
        number: ""
      };
    case "email":
      return {
        name: "",
        kind: "email",
        email: ""
      };
    case "telegram":
      return {
        name: "",
        kind: "telegram",
        chatId: ""
      };
    default:
      throw new Error("Invalid kind");
  }
}
const Ne = le({
  name: Qr,
  identity: Wa
}).withSources(
  async function* (t) {
    for await (const o of t) {
      const a = al.safeParse(o);
      a.success && (yield () => a.data);
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = sl.safeParse(o);
      a.success && (yield (s) => new Map(s ?? []).set(a.data.uuid, a.data));
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = rl.safeParse(o);
      a.success && (yield (s) => {
        const r = new Map(s ?? []);
        return r.delete(a.data), r;
      });
    }
  }
).withActions({
  create(e, t) {
    const o = Wn.parse(t);
    e.send(Eo.encode(o));
  },
  remove(e, t) {
    e.send(il.encode(t));
  },
  update(e, t) {
    const o = Pe.parse(t);
    e.send(Eo.encode(o));
  },
  seed(e, t) {
    return Qa(t);
  }
}), ll = x.from(Ne).pipe(x.shareReplay(1)), d_ = /* @__PURE__ */ new Map([
  ["email", cl],
  ["sms", ul],
  ["telegram", dl]
]);
function m_(e) {
  for (const [t, o] of d_)
    if (o(e))
      return t;
  throw new Error("Unknown kind");
}
function cl(e) {
  return Za.safeParse(e).success;
}
function ul(e) {
  return Ya.safeParse(e).success;
}
function dl(e) {
  return Ja.safeParse(e).success;
}
function p_(e) {
  const t = e?.trim().toLowerCase() ?? "";
  return function(a) {
    return t ? g_(a).some((s) => s.toLowerCase().includes(t)) : !0;
  };
}
function f_(e) {
  return function(o) {
    return e ? o.kind === e : !0;
  };
}
function oi(e) {
  switch (e.kind) {
    case "email":
      return e.email;
    case "sms":
      return e.number;
    case "telegram":
      return e.chatId;
  }
}
function g_(e) {
  switch (e.kind) {
    case "email":
      return [e.name, e.email];
    case "sms":
      return [e.name, e.number];
    case "telegram":
      return [e.name];
  }
}
function Ot(e = {}) {
  const t = k(() => A(e.sort) ?? [xn]), o = Z(ll, { onError: U.error, initialValue: /* @__PURE__ */ new Map() }), a = k(() => ne(o.value.values(), Y(t.value))), s = k(
    () => ne(o.value.values(), ot([p_(A(e.filter?.search)), f_(A(e.filter?.kind))]), Y(t.value))
  );
  return {
    count: k(() => me(o.value.size, s.value.length)),
    state: o,
    list: s,
    all: a
  };
}
function ml(e) {
  const { state: t } = Ot(), o = k(() => t.value.get(A(e)) ?? null), { kind: a } = Zn(() => o.value);
  return {
    detail: o,
    kind: a
  };
}
function Zn(e) {
  const { t } = R({ useScope: "global" }), o = k(() => {
    try {
      const a = A(e);
      return a ? m_(a) : null;
    } catch (a) {
      return U.error(a), null;
    }
  });
  return {
    get options() {
      return Ve.options.map((a) => ({
        value: a,
        label: t(`contact.kind.${a}`, a)
      }));
    },
    kind: o
  };
}
function pl({ input: e } = {}) {
  const { t } = R({ useScope: "global" }), o = Qe({
    input: e,
    seed: () => ({}),
    createType: Wn,
    entityType: Pe,
    create: (a) => Ne.create(a),
    update: (a) => Ne.update(a),
    remove: (a) => Ne.remove(a),
    i18n: {
      create: () => t("room.dialog.create", ""),
      edit: () => t("room.dialog.edit", ""),
      title: () => t("room.dialog.title", ""),
      confirmRemove: () => t("room.dialog.confirmDelete", "")
    }
  });
  return De(
    () => o.data.kind,
    (a, s) => {
      if (!a || a === s || o.isUpdate) return;
      const r = o.data.name, d = /* @__PURE__ */ new Set(["name", "kind"]);
      for (const g of Object.keys(o.data))
        d.has(g) || delete o.data[g];
      const p = Qa(a);
      Object.assign(o.data, p, { name: r });
    }
  ), o;
}
const fl = /* @__PURE__ */ C({
  __name: "KindBadge",
  props: {
    contact: {}
  },
  setup(e) {
    const t = e, { kind: o } = Zn(() => t.contact);
    return (a, s) => n(o) ? (u(), b(n(B), { key: 0 }, {
      default: f(() => [
        $(c(n(o)), 1)
      ]),
      _: 1
    })) : y("", !0);
  }
}), v_ = { class: "flex gap-2" }, b_ = { class: "value" }, es = /* @__PURE__ */ C({
  __name: "Label",
  props: {
    contact: {}
  },
  setup(e) {
    return (t, o) => (u(), v("span", v_, [
      l("strong", b_, c(e.contact.name), 1),
      m(fl, { contact: e.contact }, null, 8, ["contact"])
    ]));
  }
}), y_ = { class: "input flex pr-0" }, gl = /* @__PURE__ */ C({
  __name: "Picker",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Q(e, "modelValue"), { t: o } = R({ useScope: "global" }), a = q(""), { list: s } = Ot({ filter: { search: a } }), r = k({
      get: () => [...t.value ?? []],
      set: (d) => {
        t.value = new Set(d);
      }
    });
    return (d, p) => (u(), b(n(yn).Root, {
      modelValue: r.value,
      "onUpdate:modelValue": p[2] || (p[2] = (g) => r.value = g),
      class: "grid gap-3",
      multiple: ""
    }, {
      default: f(() => [
        l("span", y_, [
          m(n(yn).Filter, {
            modelValue: a.value,
            "onUpdate:modelValue": p[0] || (p[0] = (g) => a.value = g),
            class: "grow bg-transparent",
            placeholder: n(o)("contact.search", "")
          }, null, 8, ["modelValue", "placeholder"]),
          L(l("button", {
            type: "button",
            class: "btn text-primary",
            onClick: p[1] || (p[1] = (g) => a.value = "")
          }, [
            m(n(D), { icon: "close" })
          ], 512), [
            [xt, a.value]
          ])
        ]),
        m(n(yn).Content, { class: "flex flex-wrap gap-3" }, {
          default: f(() => [
            (u(!0), v(I, null, te(n(s), (g) => (u(), b(n(yn).Item, {
              key: g.uuid,
              value: g.uuid,
              "as-child": ""
            }, {
              default: f(() => [
                m(es, {
                  class: "btn btn-surface data-[state=checked]:btn-accent-blue data-highlighted:outline-2 data-highlighted:outline-offset-2 data-highlighted:outline-primary",
                  contact: g
                }, null, 8, ["contact"])
              ]),
              _: 2
            }, 1032, ["value"]))), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), h_ = ["onSubmit"], __ = ["aria-label"], $_ = ["textContent"], S_ = ["textContent"], k_ = ["placeholder"], w_ = { class: "px-6 grid gap-4" }, ts = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "Dialog",
  props: {
    contactGroup: {}
  },
  setup(e) {
    const t = e, { t: o } = R({ useScope: "global" }), a = Xr({ input: () => t.contactGroup });
    return (s, r) => (u(), b(n(T).Root, {
      "onUpdate:open": r[4] || (r[4] = (d) => n(a).reset())
    }, {
      default: f(({ close: d }) => [
        m(n(T).Trigger, { "as-child": "" }, {
          default: f(() => [
            P(s.$slots, "default", {}, () => [
              l("button", ae({
                type: "button",
                class: "btn"
              }, s.$attrs), [
                e.contactGroup ? (u(), b(n(D), {
                  key: 0,
                  icon: "edit"
                })) : (u(), b(n(D), {
                  key: 1,
                  icon: "add"
                }))
              ], 16)
            ])
          ]),
          _: 3
        }),
        m(n(T).Portal, null, {
          default: f(() => [
            m(n(T).Overlay, { class: "overlay" }),
            m(n(T).Content, {
              class: "dialog",
              "as-child": ""
            }, {
              default: f(() => [
                l("form", {
                  ref: "formElement",
                  onSubmit: X((p) => n(a).save.submit({ created: d }), ["prevent"])
                }, [
                  n(a).isUpdate ? (u(), v("input", {
                    key: 0,
                    type: "text",
                    autofocus: "",
                    tabindex: "0",
                    class: "sr-only",
                    "aria-label": n(a).title
                  }, null, 8, __)) : y("", !0),
                  m(n(J), {
                    icon: Na
                  }, {
                    title: f(() => [
                      m(n(T).Title, { class: "headline grow" }, {
                        default: f(() => [
                          l("span", {
                            class: "sr-only",
                            textContent: c(n(a).title)
                          }, null, 8, $_),
                          l("label", {
                            for: "contact-name",
                            class: "sr-only",
                            textContent: c(n(o)("entity.name"))
                          }, null, 8, S_),
                          L(l("input", {
                            id: "contact-name",
                            "onUpdate:modelValue": r[0] || (r[0] = (p) => n(a).data.name = p),
                            class: "input grow",
                            type: "text",
                            placeholder: n(o)("entity.name")
                          }, null, 8, k_), [
                            [j, n(a).data.name]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    description: f(() => [
                      m(n(T).Description, { class: "paragraph description" }, {
                        default: f(() => [
                          $(c(n(o)("contact.dialog.description", "")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    row: f(() => [
                      m(n(Ue), {
                        class: "grow",
                        entity: e.contactGroup
                      }, null, 8, ["entity"])
                    ]),
                    _: 1
                  }, 8, ["icon"]),
                  l("div", w_, [
                    m(gl, {
                      modelValue: n(a).data.contacts,
                      "onUpdate:modelValue": r[1] || (r[1] = (p) => n(a).data.contacts = p)
                    }, null, 8, ["modelValue"])
                  ]),
                  m(n(he), {
                    class: "px-6",
                    "has-data": n(a).isUpdate,
                    "has-changes": n(a).hasChanges,
                    onClose: d,
                    onRemove: r[2] || (r[2] = (p) => n(a).remove.submit()),
                    onUndo: r[3] || (r[3] = (p) => n(a).reset())
                  }, null, 8, ["has-data", "has-changes", "onClose"])
                ], 40, h_)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }));
  }
}), ns = /* @__PURE__ */ C({
  __name: "Select",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Q(e, "modelValue"), { t: o } = R({ useScope: "global" }), { list: a } = sn(), { options: s } = et({ options: a });
    return (r, d) => (u(), b(n(re), {
      modelValue: t.value,
      "onUpdate:modelValue": d[0] || (d[0] = (p) => t.value = p),
      options: n(s),
      placeholder: n(o)("contactGroup.placeholder")
    }, null, 8, ["modelValue", "options", "placeholder"]));
  }
}), x_ = { class: "grid content-start gap-4" }, C_ = { class: "flex flex-wrap gap-x-6 gap-y-2 items-center px-6" }, T_ = { class: "input w-56" }, R_ = { class: "sr-only" }, D_ = ["placeholder"], M_ = {
  key: 1,
  class: "self-center justify-self-end px-2"
}, E_ = ["title"], P_ = {
  key: 1,
  class: "value text-right tabular-nums"
}, L_ = {
  key: 0,
  class: "paragraph p-4 text-center text-muted col-span-full"
}, vl = /* @__PURE__ */ C({
  __name: "Table",
  setup(e) {
    const { t } = R({ useScope: "global" }), { enabled: o } = Ce(), a = je({ key: "name", fill: !0 }, { key: "contacts" }, { key: "uuid", visible: () => o.value }), { gridStyle: s, rowStyle: r, sort: d, visible: p } = Ae({ initialSort: wn, fields: a }), g = q(""), { list: S } = sn({ sort: () => [d.value, wn], filter: { search: g } });
    return (h, _) => (u(), v("div", x_, [
      l("div", C_, [
        l("label", T_, [
          m(n(D), { icon: "search" }),
          l("span", R_, c(n(t)("contactGroup.search")), 1),
          L(l("input", {
            "onUpdate:modelValue": _[0] || (_[0] = (w) => g.value = w),
            type: "search",
            class: "grow min-w-0 bg-transparent outline-none",
            placeholder: n(t)("contactGroup.search")
          }, null, 8, D_), [
            [j, g.value]
          ])
        ])
      ]),
      l("section", {
        class: "list grid content-start min-w-0",
        style: K(n(s))
      }, [
        l("header", {
          class: "headline",
          style: K(n(r))
        }, [
          n(p).name ? (u(), b(n(z).SortTrigger, {
            key: 0,
            "sort-key": "name"
          }, {
            default: f(() => [
              $(c(n(t)("entity.name")), 1)
            ]),
            _: 1
          })) : y("", !0),
          n(p).contacts ? (u(), v("span", M_, c(n(t)("entity.contacts")), 1)) : y("", !0),
          n(p).uuid ? (u(), b(n(z).SortTrigger, {
            key: 2,
            "sort-key": "uuid"
          }, {
            default: f(() => [
              $(c(n(t)("entity.uuid")), 1)
            ]),
            _: 1
          })) : y("", !0)
        ], 4),
        (u(!0), v(I, null, te(n(S), (w) => (u(), b(ts, {
          key: w.uuid,
          "contact-group": w
        }, {
          default: f(() => [
            l("button", {
              type: "button",
              class: "item grid grid-cols-subgrid not-first:border-t h-12 items-center px-6 gap-4",
              style: K(n(r))
            }, [
              n(p).name ? (u(), v("strong", {
                key: 0,
                class: "value text-left truncate",
                title: w.name
              }, c(w.name), 9, E_)) : y("", !0),
              n(p).contacts ? (u(), v("span", P_, c(w.contacts.size), 1)) : y("", !0),
              n(p).uuid ? (u(), b(n(Pt), {
                key: 2,
                class: "max-w-32",
                value: w.uuid
              }, null, 8, ["value"])) : y("", !0)
            ], 4)
          ]),
          _: 2
        }, 1032, ["contact-group"]))), 128)),
        n(S).length ? y("", !0) : (u(), v("p", L_, c(n(t)("contactGroup.empty")), 1))
      ], 4)
    ]));
  }
}), j_ = ["onSubmit"], A_ = ["textContent"], O_ = ["textContent"], U_ = ["placeholder"], V_ = { class: "px-6 grid gap-4" }, I_ = {
  class: "label",
  for: "alarm-notification"
}, z_ = { class: "label-text" }, N_ = {
  class: "label",
  for: "alarm-contact-group"
}, F_ = { class: "label-text" }, B_ = { class: "flex gap-4 justify-around" }, G_ = {
  class: "label grid gap-1 justify-items-center",
  for: "alarm-buzzer"
}, H_ = { class: "label-text" }, K_ = {
  class: "label grid gap-1 justify-items-center",
  for: "alarm-led"
}, q_ = { class: "label-text" }, os = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "Dialog",
  props: {
    alarm: {}
  },
  setup(e) {
    const t = e, { t: o } = R({ useScope: "global" }), a = Dr({ input: () => t.alarm });
    return (s, r) => (u(), b(n(T).Root, {
      "onUpdate:open": r[6] || (r[6] = (d) => n(a).reset())
    }, {
      default: f(({ close: d }) => [
        m(n(T).Trigger, { "as-child": "" }, {
          default: f(() => [
            P(s.$slots, "default", {}, () => [
              l("button", ae({
                type: "button",
                class: "btn"
              }, s.$attrs), [
                e.alarm ? (u(), b(n(D), {
                  key: 0,
                  icon: "edit"
                })) : (u(), b(n(D), {
                  key: 1,
                  icon: "add"
                }))
              ], 16)
            ])
          ]),
          _: 3
        }),
        m(n(T).Portal, null, {
          default: f(() => [
            m(n(T).Overlay, { class: "overlay" }),
            m(n(T).Content, {
              class: "dialog",
              "as-child": ""
            }, {
              default: f(() => [
                l("form", {
                  ref: "formElement",
                  onSubmit: X((p) => n(a).save.submit({ created: d }), ["prevent"])
                }, [
                  m(n(J), {
                    icon: xa
                  }, {
                    title: f(() => [
                      m(n(T).Title, { class: "headline grow" }, {
                        default: f(() => [
                          l("span", {
                            class: "sr-only",
                            textContent: c(n(a).title)
                          }, null, 8, A_),
                          l("label", {
                            for: "alarm-name",
                            class: "sr-only",
                            textContent: c(n(o)("entity.name"))
                          }, null, 8, O_),
                          L(l("input", {
                            id: "alarm-name",
                            "onUpdate:modelValue": r[0] || (r[0] = (p) => n(a).data.name = p),
                            class: "input",
                            type: "text",
                            placeholder: n(o)("entity.name")
                          }, null, 8, U_), [
                            [j, n(a).data.name]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    description: f(() => [
                      m(n(T).Description, { class: "paragraph description" }, {
                        default: f(() => [
                          $(c(n(o)("alarm.dialog.description", "")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    row: f(() => [
                      m(n(Ue), { entity: e.alarm }, null, 8, ["entity"])
                    ]),
                    _: 1
                  }, 8, ["icon"]),
                  l("div", V_, [
                    l("label", I_, [
                      l("span", z_, c(n(o)("entity.notification")), 1),
                      m(za, {
                        id: "alarm-notification",
                        modelValue: n(a).data.notification,
                        "onUpdate:modelValue": r[1] || (r[1] = (p) => n(a).data.notification = p),
                        class: "input w-full"
                      }, null, 8, ["modelValue"])
                    ]),
                    l("label", N_, [
                      l("span", F_, c(n(o)("entity.contactGroup")), 1),
                      m(ns, {
                        id: "alarm-contact-group",
                        modelValue: n(a).data.group,
                        "onUpdate:modelValue": r[2] || (r[2] = (p) => n(a).data.group = p),
                        class: "w-full"
                      }, null, 8, ["modelValue"])
                    ]),
                    l("div", B_, [
                      l("label", G_, [
                        l("span", H_, c(n(o)("entity.buzzer")), 1),
                        m(n(ie).Root, {
                          id: "alarm-buzzer",
                          modelValue: n(a).data.buzzer,
                          "onUpdate:modelValue": r[3] || (r[3] = (p) => n(a).data.buzzer = p),
                          class: "btn switch"
                        }, {
                          default: f(() => [
                            m(n(ie).Thumb, { class: "thumb" })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      l("label", K_, [
                        l("span", q_, c(n(o)("entity.led")), 1),
                        m(n(ie).Root, {
                          id: "alarm-led",
                          modelValue: n(a).data.led,
                          "onUpdate:modelValue": r[4] || (r[4] = (p) => n(a).data.led = p),
                          class: "btn switch"
                        }, {
                          default: f(() => [
                            m(n(ie).Thumb, { class: "thumb" })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  m(n(he), {
                    class: "px-6",
                    "has-data": n(a).isUpdate,
                    "has-changes": n(a).hasChanges,
                    onClose: d,
                    onRemove: (p) => n(a).remove.submit(d),
                    onUndo: r[5] || (r[5] = (p) => n(a).reset())
                  }, null, 8, ["has-data", "has-changes", "onClose", "onRemove"])
                ], 40, j_)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }));
  }
}), W_ = {
  key: 0,
  class: "value text-left"
}, Z_ = ["title"], bl = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "ListItem",
  props: {
    alarm: {}
  },
  setup(e) {
    const { visible: t } = de(!0);
    return (o, a) => (u(), b(os, { alarm: e.alarm }, {
      default: f(() => [
        l("button", ae({
          type: "button",
          class: "item grid grid-cols-subgrid not-first:border-t h-12 items-center px-6 gap-4"
        }, o.$attrs), [
          n(t).name ? (u(), v("strong", W_, c(e.alarm.name), 1)) : y("", !0),
          n(t).uuid ? (u(), b(n(B), { key: 1 }, {
            default: f(() => [
              $(c(e.alarm.uuid), 1)
            ]),
            _: 1
          })) : y("", !0),
          n(t).notification ? (u(), b(Oa, {
            key: 2,
            class: "value text-left font-normal max-w-60",
            uuid: e.alarm.notification
          }, null, 8, ["uuid"])) : y("", !0),
          n(t).group ? (u(), b(Ga, {
            key: 3,
            uuid: e.alarm.group
          }, {
            default: f(({ detail: s }) => [
              l("span", {
                class: "value text-left font-normal truncate",
                title: s?.name
              }, c(s?.name || "-"), 9, Z_)
            ]),
            _: 1
          }, 8, ["uuid"])) : y("", !0),
          n(t).buzzer ? (u(), b(n(_t), {
            key: 4,
            class: "justify-self-center",
            value: e.alarm.buzzer
          }, null, 8, ["value"])) : y("", !0),
          n(t).led ? (u(), b(n(_t), {
            key: 5,
            class: "justify-self-center",
            value: e.alarm.led
          }, null, 8, ["value"])) : y("", !0)
        ], 16)
      ]),
      _: 1
    }, 8, ["alarm"]));
  }
}), yl = /* @__PURE__ */ C({
  __name: "List",
  props: {
    alarms: {}
  },
  setup(e) {
    const { t } = R({ useScope: "global" }), { gridStyle: o, rowStyle: a, visible: s } = de(!0);
    return (r, d) => (u(), v("section", {
      class: "list grid content-start",
      style: K(n(o))
    }, [
      l("header", {
        class: "headline",
        style: K(n(a))
      }, [
        n(s).name ? (u(), b(n(z).SortTrigger, {
          key: 0,
          "sort-key": "name"
        }, {
          default: f(() => [
            $(c(n(t)("entity.name")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).uuid ? (u(), b(n(z).SortTrigger, {
          key: 1,
          class: "justify-self-center",
          "sort-key": "uuid"
        }, {
          default: f(() => [
            $(c(n(t)("entity.uuid")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).notification ? (u(), b(n(z).SortTrigger, {
          key: 2,
          class: "justify-self-start",
          "sort-key": "notification"
        }, {
          default: f(() => [
            $(c(n(t)("entity.notification")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).group ? (u(), b(n(z).SortTrigger, {
          key: 3,
          class: "justify-self-start",
          "sort-key": "group"
        }, {
          default: f(() => [
            $(c(n(t)("entity.contactGroup")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).buzzer ? (u(), b(n(z).SortTrigger, {
          key: 4,
          class: "justify-self-center",
          "sort-key": "buzzer"
        }, {
          default: f(() => [
            $(c(n(t)("entity.buzzer")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).led ? (u(), b(n(z).SortTrigger, {
          key: 5,
          class: "justify-self-center",
          "sort-key": "led"
        }, {
          default: f(() => [
            $(c(n(t)("entity.led")), 1)
          ]),
          _: 1
        })) : y("", !0)
      ], 4),
      (u(!0), v(I, null, te(e.alarms, (p) => (u(), b(bl, {
        key: p.uuid,
        style: K(n(a)),
        alarm: p
      }, null, 8, ["style", "alarm"]))), 128)),
      P(r.$slots, "default")
    ], 4));
  }
}), hl = /* @__PURE__ */ C({
  __name: "Select",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Q(e, "modelValue"), { t: o } = R({ useScope: "global" }), { list: a } = jt({ sort: [{ key: "name", direction: W.enum.Ascending }] }), { options: s } = et({ options: a });
    return (r, d) => (u(), b(n(re), {
      modelValue: t.value,
      "onUpdate:modelValue": d[0] || (d[0] = (p) => t.value = p),
      options: n(s),
      placeholder: n(o)("alarm.select.placeholder")
    }, null, 8, ["modelValue", "options", "placeholder"]));
  }
}), Y_ = { class: "headline" }, J_ = /* @__PURE__ */ C({
  __name: "Config",
  setup(e) {
    const { t } = R({ useScope: "global" }), { enabled: o } = Ce(), a = je(
      { key: "name" },
      { key: "uuid", visible: () => o.value },
      { key: "notification" },
      { key: "group", fill: !0 },
      { key: "buzzer" },
      { key: "led" }
    ), { sort: s } = Ae({ initialSort: Ca, fields: a }), { count: r, list: d } = jt({ sort: s });
    return (p, g) => (u(), v(I, null, [
      m(n(J), {
        description: n(t)("alarms.config.description", "")
      }, {
        title: f(() => [
          l("h1", Y_, c(n(t)("alarms.config.title")), 1),
          m(n(B), null, {
            default: f(() => [
              $(c(n(r)), 1)
            ]),
            _: 1
          }),
          g[0] || (g[0] = l("span", { class: "grow" }, null, -1)),
          m(n(os))
        ]),
        _: 1
      }, 8, ["description"]),
      m(n(yl), { alarms: n(d) }, null, 8, ["alarms"])
    ], 64));
  }
}), X_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Config: J_
}, Symbol.toStringTag, { value: "Module" })), YM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DEFAULT_SORT: Ca,
  Detail: we,
  DetailMessage: xr,
  Dialog: os,
  FormData: In,
  ICON: xa,
  List: yl,
  ListItem: bl,
  ListMessage: wr,
  RemoveMessage: Cr,
  RemovedMessage: Tr,
  Root: l_,
  SCOPE: kr,
  Select: hl,
  SetMessage: ko,
  Store: Ta,
  i18n: a_,
  rest: r_,
  seed: Da,
  service: Ie,
  state$: Rr,
  useDetail: Ma,
  useForm: Dr,
  useState: jt,
  views: X_
}, Symbol.toStringTag, { value: "Module" })), Q_ = "notifications_active", _l = "activity", $l = { key: "timestamp", direction: W.enum.Ascending }, Xe = i.object({
  device: i.uuid(),
  scanner: i.uuid(),
  rssi: i.number(),
  timestamp: i.date(),
  /** Seconds after `timestamp` the position stays valid (the server's `activityDiff`). */
  ttl: i.number()
});
function Sl(e, t) {
  return t - e.timestamp.getTime() <= e.ttl * 1e3;
}
const e1 = i.codec(i.union([i.string(), i.number()]), i.date(), {
  decode: (e) => new Date(typeof e == "string" ? Date.parse(e) : e),
  encode: (e) => e.toISOString()
}), as = i.map(i.uuid(), Xe), Yn = i.codec(Xe.extend({ timestamp: e1, ttl: i.number().default(15) }), Xe, {
  decode: (e) => structuredClone(e),
  encode: (e) => structuredClone(e)
}), kl = i.codec(i.object({ Activity: Yn }), Xe, {
  decode: (e) => structuredClone(e.Activity),
  encode: (e) => ({ Activity: structuredClone(e) })
}), wl = i.codec(i.object({ ActivityList: i.array(Yn) }), as, {
  decode: (e) => new Map(e.ActivityList.map((t) => [t.device, t])),
  encode: (e) => ({ ActivityList: Array.from(e.values()) })
}), ss = "devices_wearables", xl = "devices", Qt = { key: "name", direction: W.enum.Ascending }, Ye = i.enum(["all", "room", "location", "unallocated"]), Te = i.object({
  uuid: i.uuid(),
  name: i.string().nullish(),
  mac: li,
  lastActivity: i.date(),
  enabled: i.boolean(),
  battery: i.number().min(0).max(100).nullish(),
  // Servers older than #77 do not send the flag; default it so their messages still parse.
  batteryLow: i.boolean().optional().default(!1)
}), t1 = Te.extend({
  rssi: Xe.shape.rssi,
  timestamp: Xe.shape.timestamp
}), is = i.map(i.uuid(), Te), Cl = Te.extend({
  rssi: Xe.shape.rssi.nullable(),
  scanner: i.uuid().nullable(),
  scannerName: i.string().nullable().describe("Name of the scanner that heard the device, falling back to its UUID"),
  room: i.uuid().nullable(),
  roomName: i.string().nullable(),
  location: i.uuid().nullable()
}), n1 = i.map(i.uuid(), Cl), Tl = i.enum(["enabled", "all", "disabled"]), ln = Te.extend({
  lastActivity: Ln
});
function rs(e) {
  return Te.parse(e);
}
const Rl = i.codec(i.object({ DeviceList: i.array(ln) }), is, {
  decode: (e) => new Map(e.DeviceList.map((t) => [t.uuid, t])),
  encode: (e) => ({ DeviceList: Array.from(e.values(), rs) })
}), Dl = i.codec(i.object({ DeviceDetail: ln }), Te, {
  decode: (e) => e.DeviceDetail,
  encode: (e) => ({ DeviceDetail: rs(e) })
}), Ml = i.codec(i.object({ DeviceSet: ln }), Te, {
  decode: (e) => e.DeviceSet,
  encode: (e) => ({ DeviceSet: rs(e) })
}), El = i.codec(i.object({ DeviceRemove: i.uuid() }), i.uuid(), {
  decode: (e) => e.DeviceRemove,
  encode: (e) => ({ DeviceRemove: e })
}), Pl = i.codec(i.object({ DeviceRemoved: i.uuid() }), i.uuid(), {
  decode: (e) => e.DeviceRemoved,
  encode: (e) => ({ DeviceRemoved: e })
}), o1 = { title: "Zařízení", batteryLow: "Slabá baterie", unlocated: "Mimo systém", rssiValue: "{rssi} dBm", dialog: { title: "Detail zařízení", description: "", edit: "Upravit zařízení", confirmDelete: "Opravdu chcete smazat toto zařízení?" }, select: { placeholder: "Vyberte zařízení" }, filter: { search: "Hledat název nebo MAC", minRssi: "Min. RSSI", minRssiHint: "Skrýt zařízení, jejichž nejlepší nedávný signál je slabší (dBm). Prázdné = bez limitu.", dBm: "dBm", lowBatteryOnly: "Jen slabá baterie", enabledState: { enabled: "Povolená", all: "Všechna", disabled: "Nepovolená" }, empty: "Filtrům neodpovídá žádné zařízení." } }, a1 = { config: { title: "Zařízení", description: "Spravujte fyzická bluetooth tlačítka" } }, s1 = {
  device: o1,
  devices: a1
}, i1 = { title: "Device", batteryLow: "Low battery", unlocated: "Unlocated", rssiValue: "{rssi} dBm", dialog: { title: "Device details", description: "", edit: "Edit device", confirmDelete: "Are you sure you want to delete this device?" }, select: { placeholder: "Select device" }, filter: { search: "Search name or MAC", minRssi: "Min. RSSI", minRssiHint: "Hide devices whose best recent signal is weaker than this (dBm). Leave empty for no limit.", dBm: "dBm", lowBatteryOnly: "Low battery only", enabledState: { enabled: "Enabled", all: "All", disabled: "Not enabled" }, empty: "No device matches the filters." } }, r1 = { config: { title: "Devices", description: "Manage physical bluetooth devices used for scanning." } }, l1 = {
  device: i1,
  devices: r1
}, c1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cs: s1,
  en: l1
}, Symbol.toStringTag, { value: "Module" }));
function Ll() {
  const e = /* @__PURE__ */ new Set();
  let t = 0, o = 0, a = /* @__PURE__ */ new Map();
  return {
    /** To be called for every change from the socket. */
    note(s) {
      for (const r of e) r.push(s);
    },
    /** Run `load`, then store its snapshot with what the socket said meanwhile. */
    async fetchInto(s, r) {
      const d = ++t, p = [];
      e.add(p);
      try {
        const g = new Map(await r());
        if (d < o) return a;
        for (const { uuid: S, detail: h } of p)
          h ? g.set(S, h) : g.delete(S);
        return o = d, a = g, await s.set(g), g;
      } finally {
        e.delete(p);
      }
    }
  };
}
const Cn = Ll(), ft = le({
  name: xl,
  identity: is
}).withSources(
  async function* (t) {
    for await (const o of t) {
      const a = Rl.safeParse(o);
      a.success && (yield () => a.data);
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = Dl.safeParse(o);
      a.success && (Cn.note({ uuid: a.data.uuid, detail: a.data }), yield (s) => new Map(s ?? []).set(a.data.uuid, a.data));
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = Pl.safeParse(o);
      a.success && (Cn.note({ uuid: a.data, detail: null }), yield (s) => {
        const r = new Map(s ?? []);
        return r.delete(a.data), r;
      });
    }
  }
).withActions({
  remove(e, t) {
    e.send(El.encode(t));
  },
  update(e, t) {
    const o = Te.parse(t);
    e.send(Ml.encode(o));
  }
});
function u1(e) {
  return We(e, ft, {
    path: "devices",
    itemSchema: ln,
    ...qe(),
    // A reconnect refetches with the socket open, and a snapshot read before a live update
    // must not overwrite it.
    live: Cn
  });
}
function d1(e) {
  Object.defineProperty(ft, "update", {
    value: async (t) => e.save(Te.parse(t)),
    configurable: !0
  }), Object.defineProperty(ft, "remove", {
    value: async (t) => e.remove(t),
    configurable: !0
  });
}
const m1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bindActions: d1,
  createEndpoint: u1
}, Symbol.toStringTag, { value: "Module" })), p1 = { title: "Konfigurace", description: "Nastavení aplikace Evac", config: { title: "Nastavení", description: "Obecná nastavení aplikace Evac", language: "Jazyk", light: "Světlé", dark: "Tmavé", system: "Systémové" }, save: "Uložit", cancel: "Zrušit", requiredField: "Toto pole je povinné", invalidIp: "Neplatná IP adresa", invalidPort: "Neplatný port", basic: { title: "Základní", description: "Základní nastavení aplikace Evac", paths: "Cesty", ports: "Porty", misc: "Různé", configPath: "Cesta ke konfiguraci", authPath: "Cesta k autentizaci", dataPath: "Cesta k datům", backupPath: "Cesta k zálohám", uploadPath: "Cesta k nahranému obsahu", portBroadcast: "Port pro broadcast", portScanner: "Port pro skener", portWeb: "Port pro web", activityDiff: "Rozdíl aktivity", rssiWindow: "Okno nejlepšího signálu (s)", auditRetentionDays: "Uchování auditního logu ve dnech (0 = navždy)", querySize: "Velikost dotazu", routine: "Rutina", battery: "Slabá baterie", batteryLowThreshold: "Slabá pod (%)", batteryLowReadings: "Počet po sobě jdoucích nízkých měření", batteryLowHysteresis: "Zotavení nad hranicí o (%)", batteryNotifyStart: "Zprávy od", batteryNotifyEnd: "Zprávy do", batteryNotifyInterval: "Připomínat každý", batteryNotifyIntervalDays: "Připomínat po (dnech)", batteryNotifyDays: "Dny pro zprávy", batteryNotifyHint: "Časy jsou v místním čase serveru. Zpráva splatná mimo tyto hodiny počká na další otevřené okno; svátky se neberou v úvahu.", interval: { day: "Den", week: "Týden", month: "Měsíc (30 dní)", custom: "Vlastní" }, weekday: { mon: "Po", tue: "Út", wed: "St", thu: "Čt", fri: "Pá", sat: "So", sun: "Ne" } }, notification: { title: "Notifikace", description: "Nastavení notifikací aplikace Evac", email: { title: "E-mail", description: "Nastavení e-mailových notifikací", from: "Odesílatel jméno/adresa", password: "Heslo", username: "Uživatelské jméno", server: "SMTP server", port: "SMTP port", secure: "Použít zabezpečené připojení (SSL/TLS)" }, sms: { title: "SMS", description: "Nastavení SMS notifikací", url: "URL SMS brány", login: "Přihlašovací jméno", auth: "Autentizační token" }, telegram: { title: "Telegram", description: "Nastavení Telegram notifikací", token: "Token bota" }, event: { title: "Události", description: "Nastavení událostních vazeb pro notifikace" }, user: { title: "Uživatel" } }, server: { title: "Server", restartRequired: "Uloženo. Některé změny (adresa databáze, cesty, webový port, velikost fronty, rutina) se projeví až po restartu serveru." } }, f1 = {
  config: p1
}, g1 = { title: "Configuration", description: "Settings for the Evac application", config: { title: "Configuration", description: "General settings for the Evac application", language: "Language", light: "Light", dark: "Dark", system: "System" }, save: "Save", cancel: "Cancel", requiredField: "This field is required", invalidIp: "Invalid IP address", invalidPort: "Invalid port", server: { title: "Server", restartRequired: "Saved. Some changes (database URL, paths, web port, queue size, routine) take effect after the server is restarted." }, basic: { title: "Basic", description: "Basic settings for the Evac application", paths: "Paths", ports: "Ports", misc: "Miscellaneous", configPath: "Config path", databaseUrl: "Database URL", backupPath: "Backup path", uploadPath: "Upload path", portBroadcast: "Port broadcast", portScanner: "Port scanner", portWeb: "Port web", activityDiff: "Activity Diff", rssiWindow: "Best Signal Window (s)", auditRetentionDays: "Audit log retention in days (0 = keep forever)", querySize: "Query Size", routine: "Routine", security: "Security", battery: "Low battery", batteryLowThreshold: "Low below (%)", batteryLowReadings: "Consecutive low readings", batteryLowHysteresis: "Recovers above low by (%)", batteryNotifyStart: "Messages from", batteryNotifyEnd: "Messages until", batteryNotifyInterval: "Remind every", batteryNotifyIntervalDays: "Remind every (days)", batteryNotifyDays: "Message days", batteryNotifyHint: "Times are in the server's local time. A message due outside these hours waits for the next open window; holidays are not considered.", interval: { day: "Day", week: "Week", month: "Month (30 days)", custom: "Custom" }, weekday: { mon: "Mon", tue: "Tue", wed: "Wed", thu: "Thu", fri: "Fri", sat: "Sat", sun: "Sun" } }, notification: { title: "Notification", description: "Notification settings for the Evac application", email: { title: "E-mail", description: "E-mail notification settings", from: "From name/address", password: "Password", username: "Username", server: "SMTP server", port: "SMTP port", secure: "Use secure connection (SSL/TLS)" }, sms: { title: "SMS", description: "SMS notification settings", url: "SMS gateway URL", login: "Login", auth: "Authentication token" }, telegram: { title: "Telegram", description: "Telegram notification settings", token: "Bot Token" }, event: { title: "Events", description: "Event bindings settings for notifications" }, user: { title: "User" } } }, v1 = {
  config: g1
}, b1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cs: f1,
  en: v1
}, Symbol.toStringTag, { value: "Module" })), Tt = le({
  name: mr,
  identity: ho
}).withSources(async function* (t) {
  for await (const o of t) {
    if (!o || !Reflect.has(o, "Config")) continue;
    const a = ka.safeParse(o);
    a.success && (yield () => a.data.Config);
  }
}).withActions({
  update(e, t) {
    const o = ho.parse(t);
    e.send(pr.encode({ ConfigSet: o })), this.set(o);
  }
}), y1 = ["href", "onClick"], h1 = { class: "col-start-2" }, ue = /* @__PURE__ */ C({
  __name: "Link",
  props: {
    to: {},
    icon: {}
  },
  setup(e) {
    return (t, o) => {
      const a = ii("RouterLink");
      return u(), b(a, {
        to: e.to,
        custom: ""
      }, {
        default: f(({ href: s, isActive: r, navigate: d }) => [
          l("a", {
            href: s,
            class: ke(["config-link", { active: r }]),
            onClick: X((p) => r ? null : d(), ["prevent"])
          }, [
            e.icon ? (u(), b(D, {
              key: 0,
              icon: e.icon
            }, null, 8, ["icon"])) : y("", !0),
            l("span", h1, [
              P(t.$slots, "default", {}, () => [
                $(c(e.to), 1)
              ])
            ])
          ], 10, y1)
        ]),
        _: 3
      }, 8, ["to"]);
    };
  }
}), ls = "history", jl = "00000000-0000-0000-0000-000000000000", qt = 50, Al = { kind: null, action: null, event: "", from: "", to: "" }, Po = { items: [], total: 0 }, Lo = "9999-12-31T23:59", Ol = [
  "event",
  "alarm",
  "alarm_config",
  "location",
  "room",
  "scanner",
  "device",
  "notification",
  "contact",
  "contact_group",
  "event_mapping",
  "config",
  "user",
  "token",
  "backup",
  "upload",
  "battery"
], Ul = [
  "occur",
  "trigger",
  "remove",
  "start",
  "stop",
  "send",
  "create",
  "update",
  "delete",
  "password",
  "restore",
  "upload",
  "download",
  "notify",
  "recovered"
], Vl = i.object({
  uuid: i.string(),
  time: Ln,
  kind: i.string(),
  action: i.string(),
  referenceUuid: i.string().nullable(),
  eventUuid: i.string().nullable(),
  actorUuid: i.string(),
  actorName: i.string(),
  details: i.unknown()
}), Il = i.object({
  items: i.array(Vl),
  total: i.number()
});
function zl(e) {
  const t = e.trim();
  return !t || i.guid().safeParse(t).success;
}
function cs(e) {
  return e.actorUuid === jl;
}
function Nl(e, t = qt) {
  return e > 0 ? Math.floor((e - 1) / t) * t : 0;
}
const _1 = ["name", "username", "kind", "event_kind", "device", "room", "user"], $1 = ["after", "before", "event", "alarm"];
function Fl(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e) ? e : null;
}
function S1(e) {
  const t = Fl(e);
  if (!t) return null;
  for (const o of _1) {
    const a = t[o];
    if (typeof a == "string" && a) return a;
  }
  return null;
}
function jo(e) {
  const t = Fl(e.details), o = $1.map((a) => t?.[a]);
  for (const a of [t, ...o]) {
    const s = S1(a);
    if (s) return s;
  }
  return e.referenceUuid ?? "";
}
function Bl(e) {
  return JSON.stringify(e, null, 2) ?? "";
}
const us = "notifications_active", k1 = "eventMappings", Rt = i.object({
  eventKind: i.string(),
  notificationUuid: i.uuid(),
  contactGroupUuid: i.uuid(),
  userUuid: i.uuid()
}), w1 = Rt;
function x1(e) {
  return e.charAt(0).toLowerCase() + e.slice(1);
}
function C1(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function ds(e) {
  return { ...e, eventKind: x1(e.eventKind) };
}
function Gl(e) {
  return { ...e, eventKind: C1(e.eventKind) };
}
function Hl() {
  return {
    eventKind: "",
    notificationUuid: "",
    contactGroupUuid: "",
    userUuid: ""
  };
}
const Kl = "flag", ql = ea.filter((e) => e !== "page"), ms = "location_on", Wl = "locations", Tn = { key: "name", direction: W.enum.Ascending }, pe = i.object({
  uuid: i.uuid(),
  name: i.string().min(1, { message: "validation.required" })
}), ps = i.map(i.uuid(), pe), Jn = pe.extend({
  uuid: pe.shape.uuid.default(ye)
}).loose(), Zl = i.codec(i.object({ LocationList: i.array(pe) }), ps, {
  decode: (e) => new Map(e.LocationList.map((t) => [t.uuid, t])),
  encode: (e) => ({ LocationList: Array.from(e.values()) })
}), Yl = i.codec(i.object({ LocationDetail: pe }), pe, {
  decode: (e) => e.LocationDetail,
  encode: (e) => ({ LocationDetail: e })
}), Ao = i.codec(i.object({ LocationSet: pe }), pe, {
  decode: (e) => e.LocationSet,
  encode: (e) => ({ LocationSet: e })
}), Jl = i.codec(i.object({ LocationRemove: i.uuid() }), i.uuid(), {
  decode: (e) => e.LocationRemove,
  encode: (e) => ({ LocationRemove: e })
}), fs = i.codec(i.object({ LocationRemoved: i.uuid() }), i.uuid(), {
  decode: (e) => e.LocationRemoved,
  encode: (e) => ({ LocationRemoved: e })
}), Wt = i.enum(["all", "include", "exclude"]), T1 = i.object({
  location: i.uuid()
});
function Xl() {
  return {
    name: ""
  };
}
const gs = "meeting_room", Ql = "rooms", Rn = { key: "name", direction: W.enum.Ascending }, ec = i.tuple([i.number(), i.number()]).describe("A point in 2D space [x, y]"), xe = i.object({
  uuid: i.uuid(),
  name: i.string(),
  location: i.uuid().describe("The UUID of the location this room belongs to"),
  points: i.array(ec).describe("A list of points defining the room boundary in 2D space")
}), vs = i.map(i.uuid(), xe), Xn = xe.extend({
  uuid: xe.shape.uuid.default(ye)
}).loose(), bs = xe, tc = i.codec(i.object({ RoomList: i.array(bs) }), vs, {
  decode: (e) => new Map(e.RoomList.map((t) => [t.uuid, t])),
  encode: (e) => ({ RoomList: Array.from(e.values()) })
}), nc = i.codec(i.object({ RoomDetail: bs }), xe, {
  decode: (e) => e.RoomDetail,
  encode: (e) => ({ RoomDetail: e })
}), Oo = i.codec(i.object({ RoomSet: bs }), xe, {
  decode: (e) => e.RoomSet,
  encode: (e) => ({ RoomSet: e })
}), oc = i.codec(i.object({ RoomRemove: i.uuid() }), i.uuid(), {
  decode: (e) => e.RoomRemove,
  encode: (e) => ({ RoomRemove: e })
}), ac = i.codec(i.object({ RoomRemoved: i.uuid() }), i.uuid(), {
  decode: (e) => e.RoomRemoved,
  encode: (e) => ({ RoomRemoved: e })
});
function ys() {
  return {
    name: "",
    location: "",
    points: []
  };
}
const hs = "infrared", sc = "scanners", _s = { key: "name", direction: W.enum.Ascending }, ic = i.number().min(0).max(2 ** 16 - 1), Le = i.object({
  uuid: i.uuid(),
  name: i.string().min(1, { message: "validation.required" }),
  commit: i.string(),
  room: i.uuid().nullish().describe("The UUID of the room this scanner belongs to"),
  ip: i.ipv4().or(i.ipv6()),
  port: ic,
  mac: li,
  buzzer: i.boolean(),
  scan: i.boolean(),
  led: i.boolean(),
  lastActivity: i.date(),
  version: i.string()
}), $s = i.map(Le.shape.uuid, Le), Dn = Le.extend({
  roomName: i.string().nullish().describe("The name of the room this scanner belongs to")
}), R1 = i.map(Dn.shape.uuid, Dn), cn = Le.extend({
  lastActivity: Ln
}), rc = i.codec(i.object({ ScannerList: i.array(cn) }), $s, {
  decode: (e) => new Map(e.ScannerList.map((t) => [t.uuid, t])),
  encode: (e) => ({ ScannerList: Array.from(e.values()) })
}), lc = i.codec(i.object({ ScannerDetail: cn }), Le, {
  decode: (e) => e.ScannerDetail,
  encode: (e) => ({ ScannerDetail: e })
}), cc = i.codec(i.object({ ScannerSet: cn }), Le, {
  decode: (e) => e.ScannerSet,
  encode: (e) => ({ ScannerSet: e })
}), uc = i.codec(i.object({ ScannerRemove: i.uuid() }), i.uuid(), {
  decode: (e) => e.ScannerRemove,
  encode: (e) => ({ ScannerRemove: e })
}), dc = i.codec(i.object({ ScannerRemoved: i.uuid() }), i.uuid(), {
  decode: (e) => e.ScannerRemoved,
  encode: (e) => ({ ScannerRemoved: e })
}), mc = "backup", pc = i.string(), Dt = ".dump";
function Ss(e) {
  return e.length > Dt.length && e.endsWith(Dt);
}
function fc(e) {
  const t = e.trim();
  return t ? Ss(t) ? t : `${t}${Dt}` : null;
}
function gc(e) {
  const t = (s) => String(s).padStart(2, "0"), o = `${e.getFullYear()}${t(e.getMonth() + 1)}${t(e.getDate())}`, a = `${t(e.getHours())}${t(e.getMinutes())}${t(e.getSeconds())}`;
  return `evac_${o}_${a}`;
}
const Qn = "group", vc = "key", D1 = "users", Mn = { key: "username", direction: W.enum.Ascending }, bc = ["Anonymous", "Admin", "Service", "External"], ks = i.object({
  uuid: i.string(),
  username: i.string().min(1, { message: "validation.required" }),
  roles: i.array(i.string())
}), M1 = i.map(i.string(), ks), E1 = i.object({
  uuid: i.string().default(ye),
  username: i.string().min(1, { message: "validation.required" }),
  password: i.string().optional(),
  roles: i.array(i.string())
}), ws = i.object({
  id: i.string(),
  nonce: i.string().optional(),
  user: i.string(),
  created: i.coerce.date(),
  expiration: i.coerce.date().nullable().optional()
}), P1 = i.map(i.string(), ws);
function Uo() {
  return {
    username: "",
    password: "",
    roles: []
  };
}
const L1 = {
  class: "grid content-center-safe min-h-0 overflow-x-hidden overflow-y-auto pl-3",
  "data-scope": "navigation"
}, j1 = /* @__PURE__ */ C({
  __name: "Navigation",
  setup(e) {
    const { t } = R({ useScope: "global" }), { checkRoles: o } = Et(), a = Ct("page"), s = Ct("audit");
    return (r, d) => (u(), v("div", L1, [
      n(o)(ce.locations) ? (u(), b(ue, {
        key: 0,
        icon: ms,
        to: { name: "config.locations" }
      }, {
        default: f(() => [
          $(c(n(t)("locations.config.title")), 1)
        ]),
        _: 1
      }, 8, ["icon"])) : y("", !0),
      n(o)(ce.rooms) ? (u(), b(ue, {
        key: 1,
        icon: gs,
        to: { name: "config.rooms" }
      }, {
        default: f(() => [
          $(c(n(t)("rooms.config.title")), 1)
        ]),
        _: 1
      }, 8, ["icon"])) : y("", !0),
      n(o)(ce.scanners) ? (u(), b(ue, {
        key: 2,
        icon: hs,
        to: { name: "config.scanners" }
      }, {
        default: f(() => [
          $(c(n(t)("scanners.config.title")), 1)
        ]),
        _: 1
      }, 8, ["icon"])) : y("", !0),
      n(o)(ce.devices) ? (u(), b(ue, {
        key: 3,
        icon: ss,
        to: { name: "config.devices" }
      }, {
        default: f(() => [
          $(c(n(t)("devices.config.title")), 1)
        ]),
        _: 1
      }, 8, ["icon"])) : y("", !0),
      n(o)(ce.alarms) ? (u(), b(ue, {
        key: 4,
        icon: xa,
        to: { name: "config.alarms" }
      }, {
        default: f(() => [
          $(c(n(t)("alarms.config.title")), 1)
        ]),
        _: 1
      }, 8, ["icon"])) : y("", !0),
      n(o)(ce.notifications) ? (u(), b(ue, {
        key: 5,
        icon: Ea,
        to: { name: "config.notifications" }
      }, {
        default: f(() => [
          $(c(n(t)("notifications.config.title")), 1)
        ]),
        _: 1
      }, 8, ["icon"])) : y("", !0),
      n(o)(ce.contacts) ? (u(), b(ue, {
        key: 6,
        icon: Gn,
        to: { name: "config.contacts" }
      }, {
        default: f(() => [
          $(c(n(t)("contacts.title")), 1)
        ]),
        _: 1
      }, 8, ["icon"])) : y("", !0),
      n(o)(ce.eventMappings) ? (u(), b(ue, {
        key: 7,
        icon: us,
        to: { name: "config.eventMappings" }
      }, {
        default: f(() => [
          $(c(n(t)("eventMappings.config.title")), 1)
        ]),
        _: 1
      }, 8, ["icon"])) : y("", !0),
      n(o)(ce.users) ? (u(), b(ue, {
        key: 8,
        icon: Qn,
        to: { name: "config.users" }
      }, {
        default: f(() => [
          $(c(n(t)("users.config.title")), 1)
        ]),
        _: 1
      }, 8, ["icon"])) : y("", !0),
      n(o)(ce.backups) ? (u(), b(ue, {
        key: 9,
        icon: mc,
        to: { name: "config.backups" }
      }, {
        default: f(() => [
          $(c(n(t)("backups.title")), 1)
        ]),
        _: 1
      }, 8, ["icon"])) : y("", !0),
      n(s) && n(o)(ce.auditLog) ? (u(), b(ue, {
        key: 10,
        icon: ls,
        to: { name: "config.auditLog" }
      }, {
        default: f(() => [
          $(c(n(t)("auditLog.title")), 1)
        ]),
        _: 1
      }, 8, ["icon"])) : y("", !0),
      n(o)(ce.config) ? (u(), b(ue, {
        key: 11,
        icon: dr,
        to: { name: "config.config" }
      }, {
        default: f(() => [
          $(c(n(t)("config.config.title")), 1)
        ]),
        _: 1
      }, 8, ["icon"])) : y("", !0),
      n(a) && n(o)(ce.featureFlags) ? (u(), b(ue, {
        key: 12,
        icon: Kl,
        to: { name: "config.featureFlags" }
      }, {
        default: f(() => [
          $(c(n(t)("featureFlags.title")), 1)
        ]),
        _: 1
      }, 8, ["icon"])) : y("", !0)
    ]));
  }
});
let Vo = null;
const A1 = i.object({
  from: i.tuple([i.string(), i.string()]),
  tls: i.boolean(),
  server: i.string(),
  port: i.number(),
  username: i.string(),
  password: i.string()
}), O1 = i.object({
  url: i.string(),
  login: i.string(),
  auth: i.string()
}), un = i.object({
  kind: i.string(),
  value: i.unknown(),
  // Server kind: a saved change (database URL) applies only after a restart.
  restartRequired: i.boolean().optional()
}), U1 = i.array(un), V1 = i.object({
  token: i.string()
}), $t = fe(), St = fe(), kt = fe(), wt = fe(), eo = fe(!1);
function I1(e) {
  return {
    from: { name: e.from[0], address: e.from[1] },
    tls: e.tls,
    server: e.server,
    port: e.port,
    username: e.username,
    password: e.password
  };
}
function z1(e) {
  return {
    from: [e.from.name, e.from.address],
    tls: e.tls,
    server: e.server,
    port: e.port,
    username: e.username,
    password: e.password
  };
}
function N1(e) {
  Vo = e;
}
function dn() {
  if (!Vo) throw new Error("Config REST client not initialized. Call init() first.");
  return Vo;
}
async function F1(e) {
  const o = await dn().get("config", U1, e);
  for (const a of o)
    if (a.kind === "Email") {
      const s = A1.safeParse(a.value);
      s.success && ($t.value = I1(s.data));
    } else if (a.kind === "Sms") {
      const s = O1.safeParse(a.value);
      s.success && (St.value = s.data);
    } else if (a.kind === "Telegram") {
      const s = V1.safeParse(a.value);
      s.success && (kt.value = s.data);
    } else if (a.kind === "Server") {
      const s = ut.safeParse(a.value);
      s.success && (wt.value = s.data), eo.value = a.restartRequired ?? !1;
    }
}
async function yc(e, t) {
  const o = dn(), a = z1(e);
  await o.post("config", { kind: "Email", value: a }, un, t), $t.value = e;
}
async function hc(e, t) {
  await dn().post("config", { kind: "Sms", value: e }, un, t), St.value = e;
}
async function _c(e, t) {
  await dn().post("config", { kind: "Telegram", value: e }, un, t), kt.value = e;
}
async function $c(e, t) {
  const a = await dn().post("config", { kind: "Server", value: e }, un, t), s = ut.safeParse(a.value);
  wt.value = s.success ? s.data : e, eo.value = a.restartRequired ?? !1;
}
const B1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  emailStore: $t,
  fetchAll: F1,
  init: N1,
  saveEmail: yc,
  saveServer: $c,
  saveSms: hc,
  saveTelegram: _c,
  serverRestartRequired: eo,
  serverStore: wt,
  smsStore: St,
  telegramStore: kt
}, Symbol.toStringTag, { value: "Module" }));
function G1() {
  return {
    from: { name: "", address: "" },
    tls: !1,
    server: "",
    port: 587,
    username: "",
    password: ""
  };
}
function H1() {
  return { url: "", login: "", auth: "" };
}
function Sc() {
  const e = q($t.value ?? G1());
  Mt(() => {
    $t.value && (e.value = $t.value);
  });
  const t = H((o) => yc(o));
  return { state: e, save: t };
}
function kc() {
  const e = q(St.value ?? H1());
  Mt(() => {
    St.value && (e.value = St.value);
  });
  const t = H((o) => hc(o));
  return { state: e, save: t };
}
function K1() {
  return { token: "" };
}
function wc() {
  const e = q(kt.value ?? K1());
  Mt(() => {
    kt.value && (e.value = kt.value);
  });
  const t = H((o) => _c(o));
  return { state: e, save: t };
}
function q1() {
  return ut.parse({});
}
function xc() {
  const e = q(wt.value ?? q1());
  Mt(() => {
    wt.value && (e.value = wt.value);
  });
  const t = H((o) => $c(o));
  return { state: e, save: t, restartRequired: eo };
}
const W1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useEmailConfig: Sc,
  useServerConfig: xc,
  useSmsConfig: kc,
  useTelegramConfig: wc
}, Symbol.toStringTag, { value: "Module" })), Z1 = { class: "grid grid-cols-2 gap-4" }, Y1 = ["textContent"], J1 = { class: "label grid grid-cols-subgrid gap-x-4 col-span-2" }, X1 = ["textContent"], Q1 = ["readonly"], e$ = ["readonly"], t$ = {
  class: "label",
  for: "email-username"
}, n$ = ["textContent"], o$ = ["readonly"], a$ = {
  class: "label",
  for: "email-password"
}, s$ = ["textContent"], i$ = ["readonly"], r$ = {
  class: "label",
  for: "email-server"
}, l$ = ["textContent"], c$ = ["readonly"], u$ = {
  class: "label",
  for: "email-port"
}, d$ = ["textContent"], m$ = ["readonly"], p$ = {
  class: "label flex gap-4 items-center",
  for: "email-tls"
}, f$ = ["textContent"], g$ = ["textContent"], Cc = /* @__PURE__ */ C({
  __name: "EmailConnectorForm",
  props: /* @__PURE__ */ ve({
    readonly: { type: Boolean, default: !1 }
  }, {
    connector: { required: !0 },
    connectorModifiers: {}
  }),
  emits: ["update:connector"],
  setup(e) {
    const t = Q(e, "connector"), { t: o } = R({ useScope: "global" });
    return (a, s) => (u(), v("form", Z1, [
      l("legend", {
        class: "label-text font-bold mb-2 col-span-2",
        textContent: c(n(o)("config.notification.email.title"))
      }, null, 8, Y1),
      l("div", J1, [
        l("label", {
          class: "label-text col-span-2",
          for: "email-from-name",
          textContent: c(n(o)("config.notification.email.from"))
        }, null, 8, X1),
        L(l("input", {
          id: "email-from-name",
          "onUpdate:modelValue": s[0] || (s[0] = (r) => t.value.from.name = r),
          class: "input w-full",
          type: "text",
          readonly: e.readonly
        }, null, 8, Q1), [
          [
            j,
            t.value.from.name,
            void 0,
            { lazy: !0 }
          ]
        ]),
        L(l("input", {
          id: "email-from-address",
          "onUpdate:modelValue": s[1] || (s[1] = (r) => t.value.from.address = r),
          class: "input w-full",
          type: "email",
          readonly: e.readonly
        }, null, 8, e$), [
          [
            j,
            t.value.from.address,
            void 0,
            { lazy: !0 }
          ]
        ])
      ]),
      l("label", t$, [
        l("span", {
          class: "label-text",
          textContent: c(n(o)("config.notification.email.username"))
        }, null, 8, n$),
        L(l("input", {
          id: "email-username",
          "onUpdate:modelValue": s[2] || (s[2] = (r) => t.value.username = r),
          class: "input w-full",
          type: "text",
          readonly: e.readonly
        }, null, 8, o$), [
          [
            j,
            t.value.username,
            void 0,
            { lazy: !0 }
          ]
        ])
      ]),
      l("label", a$, [
        l("span", {
          class: "label-text",
          textContent: c(n(o)("config.notification.email.password"))
        }, null, 8, s$),
        L(l("input", {
          id: "email-password",
          "onUpdate:modelValue": s[3] || (s[3] = (r) => t.value.password = r),
          class: "input w-full",
          type: "password",
          readonly: e.readonly
        }, null, 8, i$), [
          [
            j,
            t.value.password,
            void 0,
            { lazy: !0 }
          ]
        ])
      ]),
      l("label", r$, [
        l("span", {
          class: "label-text",
          textContent: c(n(o)("config.notification.email.server"))
        }, null, 8, l$),
        L(l("input", {
          id: "email-server",
          "onUpdate:modelValue": s[4] || (s[4] = (r) => t.value.server = r),
          class: "input w-full",
          type: "text",
          readonly: e.readonly
        }, null, 8, c$), [
          [
            j,
            t.value.server,
            void 0,
            { lazy: !0 }
          ]
        ])
      ]),
      l("label", u$, [
        l("span", {
          class: "label-text",
          textContent: c(n(o)("config.notification.email.port"))
        }, null, 8, d$),
        L(l("input", {
          id: "email-port",
          "onUpdate:modelValue": s[5] || (s[5] = (r) => t.value.port = r),
          class: "input w-full",
          type: "text",
          readonly: e.readonly
        }, null, 8, m$), [
          [
            j,
            t.value.port,
            void 0,
            { lazy: !0 }
          ]
        ])
      ]),
      l("label", p$, [
        l("span", {
          class: "label-text",
          textContent: c(n(o)("config.notification.email.secure"))
        }, null, 8, f$),
        m(n(ie).Root, {
          id: "email-tls",
          modelValue: t.value.tls,
          "onUpdate:modelValue": s[6] || (s[6] = (r) => t.value.tls = r),
          class: "btn switch",
          disabled: e.readonly
        }, {
          default: f(() => [
            m(n(ie).Thumb, { class: "thumb" })
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"])
      ]),
      e.readonly ? y("", !0) : (u(), v("button", {
        key: 0,
        class: "btn btn-filled justify-self-end",
        type: "submit",
        textContent: c(n(o)("action.save"))
      }, null, 8, g$))
    ]));
  }
}), v$ = { class: "grid grid-cols-2 gap-4" }, b$ = ["textContent"], y$ = {
  class: "label",
  for: "sms-login"
}, h$ = ["textContent"], _$ = ["readonly"], $$ = {
  class: "label",
  for: "sms-auth"
}, S$ = ["textContent"], k$ = ["readonly"], w$ = {
  class: "label",
  for: "sms-url"
}, x$ = ["textContent"], C$ = ["readonly"], T$ = ["textContent"], Tc = /* @__PURE__ */ C({
  __name: "SmsConnectorForm",
  props: /* @__PURE__ */ ve({
    readonly: { type: Boolean, default: !1 }
  }, {
    connector: { required: !0 },
    connectorModifiers: {}
  }),
  emits: ["update:connector"],
  setup(e) {
    const t = Q(e, "connector"), { t: o } = R({ useScope: "global" });
    return (a, s) => (u(), v("form", v$, [
      l("legend", {
        class: "label-text font-bold mb-2 col-span-2",
        textContent: c(n(o)("config.notification.sms.title"))
      }, null, 8, b$),
      l("label", y$, [
        l("span", {
          class: "label-text",
          textContent: c(n(o)("config.notification.sms.login"))
        }, null, 8, h$),
        L(l("input", {
          id: "sms-login",
          "onUpdate:modelValue": s[0] || (s[0] = (r) => t.value.login = r),
          class: "input w-full",
          type: "text",
          readonly: e.readonly
        }, null, 8, _$), [
          [
            j,
            t.value.login,
            void 0,
            { lazy: !0 }
          ]
        ])
      ]),
      l("label", $$, [
        l("span", {
          class: "label-text",
          textContent: c(n(o)("config.notification.sms.auth"))
        }, null, 8, S$),
        L(l("input", {
          id: "sms-auth",
          "onUpdate:modelValue": s[1] || (s[1] = (r) => t.value.auth = r),
          class: "input w-full",
          type: "password",
          readonly: e.readonly
        }, null, 8, k$), [
          [
            j,
            t.value.auth,
            void 0,
            { lazy: !0 }
          ]
        ])
      ]),
      l("label", w$, [
        l("span", {
          class: "label-text",
          textContent: c(n(o)("config.notification.sms.url"))
        }, null, 8, x$),
        L(l("input", {
          id: "sms-url",
          "onUpdate:modelValue": s[2] || (s[2] = (r) => t.value.url = r),
          class: "input w-full",
          type: "url",
          readonly: e.readonly
        }, null, 8, C$), [
          [
            j,
            t.value.url,
            void 0,
            { lazy: !0 }
          ]
        ])
      ]),
      e.readonly ? y("", !0) : (u(), v("button", {
        key: 0,
        class: "btn btn-filled justify-self-end",
        type: "submit",
        textContent: c(n(o)("action.save"))
      }, null, 8, T$))
    ]));
  }
}), R$ = { class: "grid grid-cols-2 gap-4" }, D$ = ["textContent"], M$ = {
  class: "label col-span-2",
  for: "telegram-token"
}, E$ = ["textContent"], P$ = ["readonly"], L$ = ["textContent"], j$ = /* @__PURE__ */ C({
  __name: "TelegramConnectorForm",
  props: /* @__PURE__ */ ve({
    readonly: { type: Boolean, default: !1 }
  }, {
    connector: { required: !0 },
    connectorModifiers: {}
  }),
  emits: ["update:connector"],
  setup(e) {
    const t = Q(e, "connector"), { t: o } = R({ useScope: "global" });
    return (a, s) => (u(), v("form", R$, [
      l("legend", {
        class: "label-text font-bold mb-2 col-span-2",
        textContent: c(n(o)("config.notification.telegram.title"))
      }, null, 8, D$),
      l("label", M$, [
        l("span", {
          class: "label-text",
          textContent: c(n(o)("config.notification.telegram.token"))
        }, null, 8, E$),
        L(l("input", {
          id: "telegram-token",
          "onUpdate:modelValue": s[0] || (s[0] = (r) => t.value.token = r),
          class: "input w-full",
          type: "password",
          readonly: e.readonly
        }, null, 8, P$), [
          [
            j,
            t.value.token,
            void 0,
            { lazy: !0 }
          ]
        ])
      ]),
      e.readonly ? y("", !0) : (u(), v("button", {
        key: 0,
        class: "btn btn-filled justify-self-end",
        type: "submit",
        textContent: c(n(o)("action.save"))
      }, null, 8, L$))
    ]));
  }
}), A$ = { class: "col-span-3 grid grid-cols-3 gap-4" }, O$ = ["textContent"], U$ = {
  class: "label",
  for: "config-batteryLowThreshold"
}, V$ = ["textContent"], I$ = ["readonly"], z$ = {
  class: "label",
  for: "config-batteryLowReadings"
}, N$ = ["textContent"], F$ = ["readonly"], B$ = {
  class: "label",
  for: "config-batteryLowHysteresis"
}, G$ = ["textContent"], H$ = ["readonly"], K$ = {
  class: "label",
  for: "config-batteryNotifyStart"
}, q$ = ["textContent"], W$ = ["readonly"], Z$ = {
  class: "label",
  for: "config-batteryNotifyEnd"
}, Y$ = ["textContent"], J$ = ["readonly"], X$ = {
  class: "label",
  for: "config-batteryNotifyInterval"
}, Q$ = ["textContent"], eS = ["aria-label"], tS = ["textContent"], nS = { class: "flex flex-wrap gap-4" }, oS = ["id", "checked", "disabled", "onChange"], aS = ["textContent"], sS = {
  key: 0,
  class: "label",
  for: "config-batteryNotifyIntervalDays"
}, iS = ["textContent"], rS = ["readonly"], lS = ["textContent"], Ht = "custom", cS = /* @__PURE__ */ C({
  __name: "BatteryFields",
  props: /* @__PURE__ */ ve({
    readonly: { type: Boolean, default: !1 }
  }, {
    config: { required: !0 },
    configModifiers: {}
  }),
  emits: ["update:config"],
  setup(e) {
    const t = Q(e, "config"), { t: o } = R({ useScope: "global" }), a = q(!1), s = k(() => [
      ...bo.map(({ days: h, key: _ }) => ({ value: String(h), label: o(`config.basic.interval.${_}`) })),
      { value: Ht, label: o("config.basic.interval.custom") }
    ]), r = k({
      get: () => a.value || !bo.some(({ days: h }) => h === t.value.batteryNotifyIntervalDays) ? Ht : String(t.value.batteryNotifyIntervalDays),
      set: (h) => {
        a.value = h === Ht, h && h !== Ht && (t.value.batteryNotifyIntervalDays = Number(h));
      }
    }), d = () => yo.map(({ day: h }) => h).filter((h) => t.value.batteryNotifyDays.includes(h)), p = (h) => t.value.batteryNotifyDays.includes(h), g = (h) => p(h) && d().length === 1;
    function S(h) {
      const _ = d();
      t.value.batteryNotifyDays = p(h) ? _.filter((w) => w !== h) : [..._, h].sort((w, E) => w - E);
    }
    return (h, _) => (u(), v("fieldset", A$, [
      l("legend", {
        class: "label-text font-bold mb-2 col-span-3",
        textContent: c(n(o)("config.basic.battery"))
      }, null, 8, O$),
      l("label", U$, [
        l("span", {
          class: "label-text",
          textContent: c(n(o)("config.basic.batteryLowThreshold"))
        }, null, 8, V$),
        L(l("input", {
          id: "config-batteryLowThreshold",
          "onUpdate:modelValue": _[0] || (_[0] = (w) => t.value.batteryLowThreshold = w),
          class: "input w-full",
          readonly: e.readonly,
          type: "number",
          min: "1",
          max: "100",
          step: "1",
          required: ""
        }, null, 8, I$), [
          [
            j,
            t.value.batteryLowThreshold,
            void 0,
            { lazy: !0 }
          ]
        ])
      ]),
      l("label", z$, [
        l("span", {
          class: "label-text",
          textContent: c(n(o)("config.basic.batteryLowReadings"))
        }, null, 8, N$),
        L(l("input", {
          id: "config-batteryLowReadings",
          "onUpdate:modelValue": _[1] || (_[1] = (w) => t.value.batteryLowReadings = w),
          class: "input w-full",
          readonly: e.readonly,
          type: "number",
          min: "1",
          step: "1",
          required: ""
        }, null, 8, F$), [
          [
            j,
            t.value.batteryLowReadings,
            void 0,
            { lazy: !0 }
          ]
        ])
      ]),
      l("label", B$, [
        l("span", {
          class: "label-text",
          textContent: c(n(o)("config.basic.batteryLowHysteresis"))
        }, null, 8, G$),
        L(l("input", {
          id: "config-batteryLowHysteresis",
          "onUpdate:modelValue": _[2] || (_[2] = (w) => t.value.batteryLowHysteresis = w),
          class: "input w-full",
          readonly: e.readonly,
          type: "number",
          min: "0",
          max: "50",
          step: "1",
          required: ""
        }, null, 8, H$), [
          [
            j,
            t.value.batteryLowHysteresis,
            void 0,
            { lazy: !0 }
          ]
        ])
      ]),
      l("label", K$, [
        l("span", {
          class: "label-text",
          textContent: c(n(o)("config.basic.batteryNotifyStart"))
        }, null, 8, q$),
        L(l("input", {
          id: "config-batteryNotifyStart",
          "onUpdate:modelValue": _[3] || (_[3] = (w) => t.value.batteryNotifyStart = w),
          class: "input w-full",
          readonly: e.readonly,
          type: "time",
          required: ""
        }, null, 8, W$), [
          [
            j,
            t.value.batteryNotifyStart,
            void 0,
            { lazy: !0 }
          ]
        ])
      ]),
      l("label", Z$, [
        l("span", {
          class: "label-text",
          textContent: c(n(o)("config.basic.batteryNotifyEnd"))
        }, null, 8, Y$),
        L(l("input", {
          id: "config-batteryNotifyEnd",
          "onUpdate:modelValue": _[4] || (_[4] = (w) => t.value.batteryNotifyEnd = w),
          class: "input w-full",
          readonly: e.readonly,
          type: "time",
          required: ""
        }, null, 8, J$), [
          [
            j,
            t.value.batteryNotifyEnd,
            void 0,
            { lazy: !0 }
          ]
        ])
      ]),
      l("label", X$, [
        l("span", {
          class: "label-text",
          textContent: c(n(o)("config.basic.batteryNotifyInterval"))
        }, null, 8, Q$),
        m(n(re), {
          id: "config-batteryNotifyInterval",
          modelValue: r.value,
          "onUpdate:modelValue": _[5] || (_[5] = (w) => r.value = w),
          class: "w-full",
          options: s.value,
          disabled: e.readonly
        }, null, 8, ["modelValue", "options", "disabled"])
      ]),
      l("div", {
        class: "col-span-2 grid gap-1",
        role: "group",
        "aria-label": n(o)("config.basic.batteryNotifyDays")
      }, [
        l("span", {
          class: "label-text",
          textContent: c(n(o)("config.basic.batteryNotifyDays"))
        }, null, 8, tS),
        l("div", nS, [
          (u(!0), v(I, null, te(yo, ({ day: w, key: E }) => (u(), v("label", {
            key: w,
            class: "flex items-center gap-2"
          }, [
            l("input", {
              id: `config-batteryNotifyDay-${w}`,
              type: "checkbox",
              checked: p(w),
              disabled: e.readonly || g(w),
              onChange: (O) => S(w)
            }, null, 40, oS),
            l("span", {
              textContent: c(n(o)(`config.basic.weekday.${E}`))
            }, null, 8, aS)
          ]))), 128))
        ])
      ], 8, eS),
      r.value === Ht ? (u(), v("label", sS, [
        l("span", {
          class: "label-text",
          textContent: c(n(o)("config.basic.batteryNotifyIntervalDays"))
        }, null, 8, iS),
        L(l("input", {
          id: "config-batteryNotifyIntervalDays",
          "onUpdate:modelValue": _[6] || (_[6] = (w) => t.value.batteryNotifyIntervalDays = w),
          class: "input w-full",
          readonly: e.readonly,
          type: "number",
          min: "1",
          step: "1",
          required: ""
        }, null, 8, rS), [
          [
            j,
            t.value.batteryNotifyIntervalDays,
            void 0,
            { lazy: !0 }
          ]
        ])
      ])) : y("", !0),
      l("p", {
        class: "col-span-3 text-sm text-muted",
        textContent: c(n(o)("config.basic.batteryNotifyHint"))
      }, null, 8, lS)
    ]));
  }
}), uS = { class: "col-start-1 -col-end-1 grid grid-cols-3 gap-4" }, dS = ["textContent"], mS = {
  class: "label",
  for: "config-configPath"
}, pS = ["textContent"], fS = ["readonly"], gS = {
  class: "label",
  for: "config-databaseUrl"
}, vS = ["textContent"], bS = ["readonly"], yS = {
  class: "label",
  for: "config-backupPath"
}, hS = ["textContent"], _S = ["readonly"], $S = {
  class: "label",
  for: "config-uploadPath"
}, SS = ["textContent"], kS = ["readonly"], wS = { class: "col-span-3 grid grid-cols-3 gap-4" }, xS = ["textContent"], CS = {
  class: "label col-start-1",
  for: "config-portBroadcast"
}, TS = ["textContent"], RS = ["readonly"], DS = {
  class: "label",
  for: "config-portScanner"
}, MS = ["textContent"], ES = ["readonly"], PS = {
  class: "label",
  for: "config-portWeb"
}, LS = ["textContent"], jS = ["readonly"], AS = { class: "col-span-3 grid grid-cols-3 gap-4" }, OS = ["textContent"], US = {
  class: "label",
  for: "config-querySize"
}, VS = ["textContent"], IS = ["readonly"], zS = {
  class: "label",
  for: "config-activityDiff"
}, NS = ["textContent"], FS = ["readonly"], BS = {
  class: "label",
  for: "config-rssiWindow"
}, GS = ["textContent"], HS = ["readonly"], KS = {
  key: 0,
  class: "label",
  for: "config-auditRetentionDays"
}, qS = ["textContent"], WS = ["readonly"], ZS = {
  class: "label",
  for: "config-routine"
}, YS = ["textContent"], JS = ["readonly"], XS = {
  class: "label",
  for: "config-security"
}, QS = ["textContent"], ek = {
  key: 0,
  class: "col-span-3 flex items-center justify-end"
}, tk = ["disabled"], Rc = /* @__PURE__ */ C({
  __name: "Form",
  props: /* @__PURE__ */ ve({
    readonly: { type: Boolean, default: !1 }
  }, {
    config: { required: !0 },
    configModifiers: {}
  }),
  emits: /* @__PURE__ */ ve(["submit"], ["update:config"]),
  setup(e, { emit: t }) {
    const o = Q(e, "config"), { t: a } = R({ useScope: "global" }), { isOnline: s } = oa(), r = Ct("audit"), d = t, p = /* @__PURE__ */ new Set();
    De(o, () => p.clear());
    function g(_) {
      _.target instanceof HTMLInputElement && p.add(_.target);
    }
    function S(_) {
      for (const w of p)
        if (w.isConnected && !w.reportValidity()) return;
      d("submit", _);
    }
    const h = [
      { label: "Salted", value: "Salted" },
      { label: "Symmetric Encrypted", value: "SymmetricEncrypted" }
    ];
    return (_, w) => o.value ? (u(), v("form", {
      key: 0,
      class: "grid grid-cols-3 gap-4",
      novalidate: "",
      onChange: g,
      onSubmit: X(S, ["prevent"])
    }, [
      l("fieldset", uS, [
        l("legend", {
          class: "label-text font-bold mb-2 col-span-3",
          textContent: c(n(a)("config.basic.paths"))
        }, null, 8, dS),
        l("label", mS, [
          l("span", {
            class: "label-text",
            textContent: c(n(a)("config.basic.configPath"))
          }, null, 8, pS),
          L(l("input", {
            id: "config-configPath",
            "onUpdate:modelValue": w[0] || (w[0] = (E) => o.value.configPath = E),
            class: "input w-full",
            readonly: e.readonly,
            type: "text"
          }, null, 8, fS), [
            [
              j,
              o.value.configPath,
              void 0,
              { lazy: !0 }
            ]
          ])
        ]),
        l("label", gS, [
          l("span", {
            class: "label-text",
            textContent: c(n(a)("config.basic.databaseUrl"))
          }, null, 8, vS),
          L(l("input", {
            id: "config-databaseUrl",
            "onUpdate:modelValue": w[1] || (w[1] = (E) => o.value.databaseUrl = E),
            class: "input w-full",
            readonly: e.readonly,
            type: "text"
          }, null, 8, bS), [
            [
              j,
              o.value.databaseUrl,
              void 0,
              { lazy: !0 }
            ]
          ])
        ]),
        l("label", yS, [
          l("span", {
            class: "label-text",
            textContent: c(n(a)("config.basic.backupPath"))
          }, null, 8, hS),
          L(l("input", {
            id: "config-backupPath",
            "onUpdate:modelValue": w[2] || (w[2] = (E) => o.value.backupPath = E),
            class: "input w-full",
            readonly: e.readonly,
            type: "text"
          }, null, 8, _S), [
            [
              j,
              o.value.backupPath,
              void 0,
              { lazy: !0 }
            ]
          ])
        ]),
        l("label", $S, [
          l("span", {
            class: "label-text",
            textContent: c(n(a)("config.basic.uploadPath"))
          }, null, 8, SS),
          L(l("input", {
            id: "config-uploadPath",
            "onUpdate:modelValue": w[3] || (w[3] = (E) => o.value.uploadPath = E),
            class: "input w-full",
            readonly: e.readonly,
            type: "text"
          }, null, 8, kS), [
            [
              j,
              o.value.uploadPath,
              void 0,
              { lazy: !0 }
            ]
          ])
        ])
      ]),
      l("fieldset", wS, [
        l("legend", {
          class: "label-text font-bold mb-2 col-span-3",
          textContent: c(n(a)("config.basic.ports"))
        }, null, 8, xS),
        l("label", CS, [
          l("span", {
            class: "label-text",
            textContent: c(n(a)("config.basic.portBroadcast"))
          }, null, 8, TS),
          L(l("input", {
            id: "config-portBroadcast",
            "onUpdate:modelValue": w[4] || (w[4] = (E) => o.value.portBroadcast = E),
            class: "input w-full",
            readonly: e.readonly,
            type: "text"
          }, null, 8, RS), [
            [
              j,
              o.value.portBroadcast,
              void 0,
              { lazy: !0 }
            ]
          ])
        ]),
        l("label", DS, [
          l("span", {
            class: "label-text",
            textContent: c(n(a)("config.basic.portScanner"))
          }, null, 8, MS),
          L(l("input", {
            id: "config-portScanner",
            "onUpdate:modelValue": w[5] || (w[5] = (E) => o.value.portScanner = E),
            class: "input w-full",
            readonly: e.readonly,
            type: "text"
          }, null, 8, ES), [
            [
              j,
              o.value.portScanner,
              void 0,
              { lazy: !0 }
            ]
          ])
        ]),
        l("label", PS, [
          l("span", {
            class: "label-text",
            textContent: c(n(a)("config.basic.portWeb"))
          }, null, 8, LS),
          L(l("input", {
            id: "config-portWeb",
            "onUpdate:modelValue": w[6] || (w[6] = (E) => o.value.portWeb = E),
            class: "input w-full",
            readonly: e.readonly,
            type: "text"
          }, null, 8, jS), [
            [
              j,
              o.value.portWeb,
              void 0,
              { lazy: !0 }
            ]
          ])
        ])
      ]),
      l("fieldset", AS, [
        l("legend", {
          class: "label-text font-bold mb-2 col-span-3",
          textContent: c(n(a)("config.basic.misc"))
        }, null, 8, OS),
        l("label", US, [
          l("span", {
            class: "label-text",
            textContent: c(n(a)("config.basic.querySize"))
          }, null, 8, VS),
          L(l("input", {
            id: "config-querySize",
            "onUpdate:modelValue": w[7] || (w[7] = (E) => o.value.querySize = E),
            class: "input w-full",
            readonly: e.readonly,
            type: "number",
            min: "1",
            step: "1",
            required: ""
          }, null, 8, IS), [
            [
              j,
              o.value.querySize,
              void 0,
              { lazy: !0 }
            ]
          ])
        ]),
        l("label", zS, [
          l("span", {
            class: "label-text",
            textContent: c(n(a)("config.basic.activityDiff"))
          }, null, 8, NS),
          L(l("input", {
            id: "config-activityDiff",
            "onUpdate:modelValue": w[8] || (w[8] = (E) => o.value.activityDiff = E),
            class: "input w-full",
            readonly: e.readonly,
            type: "number",
            required: ""
          }, null, 8, FS), [
            [
              j,
              o.value.activityDiff,
              void 0,
              { lazy: !0 }
            ]
          ])
        ]),
        l("label", BS, [
          l("span", {
            class: "label-text",
            textContent: c(n(a)("config.basic.rssiWindow"))
          }, null, 8, GS),
          L(l("input", {
            id: "config-rssiWindow",
            "onUpdate:modelValue": w[9] || (w[9] = (E) => o.value.rssiWindow = E),
            class: "input w-full",
            readonly: e.readonly,
            type: "number",
            min: "0",
            required: ""
          }, null, 8, HS), [
            [
              j,
              o.value.rssiWindow,
              void 0,
              { lazy: !0 }
            ]
          ])
        ]),
        n(r) ? (u(), v("label", KS, [
          l("span", {
            class: "label-text",
            textContent: c(n(a)("config.basic.auditRetentionDays"))
          }, null, 8, qS),
          L(l("input", {
            id: "config-auditRetentionDays",
            "onUpdate:modelValue": w[10] || (w[10] = (E) => o.value.auditRetentionDays = E),
            class: "input w-full",
            readonly: e.readonly,
            type: "number",
            min: "0",
            step: "1",
            required: ""
          }, null, 8, WS), [
            [
              j,
              o.value.auditRetentionDays,
              void 0,
              { lazy: !0 }
            ]
          ])
        ])) : y("", !0),
        l("label", ZS, [
          l("span", {
            class: "label-text",
            textContent: c(n(a)("config.basic.routine"))
          }, null, 8, YS),
          L(l("input", {
            id: "config-routine",
            "onUpdate:modelValue": w[11] || (w[11] = (E) => o.value.routine = E),
            class: "input w-full",
            readonly: e.readonly,
            type: "number",
            min: "1",
            max: "60",
            step: "1",
            required: ""
          }, null, 8, JS), [
            [
              j,
              o.value.routine,
              void 0,
              { lazy: !0 }
            ]
          ])
        ]),
        l("label", XS, [
          l("span", {
            class: "label-text",
            textContent: c(n(a)("config.basic.security"))
          }, null, 8, QS),
          m(n(re), {
            id: "config-security",
            modelValue: o.value.security.kind,
            "onUpdate:modelValue": w[12] || (w[12] = (E) => o.value.security.kind = E),
            class: "w-full",
            options: h,
            disabled: e.readonly
          }, null, 8, ["modelValue", "disabled"])
        ])
      ]),
      m(cS, {
        config: o.value,
        "onUpdate:config": w[13] || (w[13] = (E) => o.value = E),
        readonly: e.readonly
      }, null, 8, ["config", "readonly"]),
      e.readonly ? y("", !0) : (u(), v("div", ek, [
        l("button", {
          class: "btn btn-filled mt-4",
          type: "submit",
          disabled: !n(s)
        }, c(n(a)("action.save")), 9, tk)
      ]))
    ], 32)) : y("", !0);
  }
}), nk = { class: "headline" }, ok = ["textContent"], ak = "email", sk = /* @__PURE__ */ C({
  __name: "Config",
  setup(e) {
    const t = q(ak), { t: o } = R({ useScope: "global" }), { isOnline: a } = oa(), { isAdmin: s } = Et(), { state: r, save: d } = Sc(), { state: p, save: g } = kc(), { state: S, save: h } = wc(), { state: _, save: w, restartRequired: E } = xc();
    return (O, M) => (u(), v(I, null, [
      m(n(J), {
        description: n(o)("config.config.description", "")
      }, {
        title: f(() => [
          l("h1", nk, c(n(o)("config.config.title")), 1)
        ]),
        _: 1
      }, 8, ["description"]),
      m(n(ee).Root, {
        modelValue: t.value,
        "onUpdate:modelValue": M[8] || (M[8] = (V) => t.value = V),
        class: "grid grid-rows-[max-content_1fr] @container/tabs container-type-size",
        "unmount-on-hide": ""
      }, {
        default: f(() => [
          m(n(ee).List, { class: "flex gap-6 items-center justify-center relative border-b" }, {
            default: f(() => [
              m(n(ee).Trigger, {
                value: "email",
                class: "btn",
                "aria-label": n(o)("config.notification.email.title")
              }, {
                default: f(() => [
                  m(n(D), {
                    icon: "mail",
                    class: "mr-2"
                  }),
                  $(" " + c(n(o)("config.notification.email.title")), 1)
                ]),
                _: 1
              }, 8, ["aria-label"]),
              m(n(ee).Trigger, {
                value: "sms",
                class: "btn",
                "aria-label": n(o)("config.notification.sms.title")
              }, {
                default: f(() => [
                  m(n(D), {
                    icon: "sms",
                    class: "mr-2"
                  }),
                  $(" " + c(n(o)("config.notification.sms.title")), 1)
                ]),
                _: 1
              }, 8, ["aria-label"]),
              m(n(ee).Trigger, {
                value: "telegram",
                class: "btn",
                "aria-label": n(o)("config.notification.telegram.title")
              }, {
                default: f(() => [
                  m(n(D), {
                    icon: "send",
                    class: "mr-2"
                  }),
                  $(" " + c(n(o)("config.notification.telegram.title")), 1)
                ]),
                _: 1
              }, 8, ["aria-label"]),
              n(s) ? (u(), b(n(ee).Trigger, {
                key: 0,
                value: "server",
                class: "btn",
                "aria-label": n(o)("config.server.title")
              }, {
                default: f(() => [
                  m(n(D), {
                    icon: "dns",
                    class: "mr-2"
                  }),
                  $(" " + c(n(o)("config.server.title")), 1)
                ]),
                _: 1
              }, 8, ["aria-label"])) : y("", !0),
              m(n(ee).Indicator, { class: "absolute px-8 left-0 h-1.25 bg-accent-blue bottom-0 w-(--reka-tabs-indicator-size) translate-x-(--reka-tabs-indicator-position) translate-y-0.75 rounded-full transition-[width,transform] duration-300" }, {
                default: f(() => [...M[9] || (M[9] = [
                  l("div", { class: "bg-grass8 w-full h-full" }, null, -1)
                ])]),
                _: 1
              })
            ]),
            _: 1
          }),
          m(n(ee).Content, {
            value: "email",
            class: "px-6 pt-6 pb-12 overflow-y-auto"
          }, {
            default: f(() => [
              m(Cc, {
                connector: n(r),
                "onUpdate:connector": M[0] || (M[0] = (V) => st(r) ? r.value = V : null),
                readonly: !n(a),
                onSubmit: M[1] || (M[1] = X((V) => n(d).submit(n(r)), ["prevent"]))
              }, null, 8, ["connector", "readonly"])
            ]),
            _: 1
          }),
          m(n(ee).Content, {
            value: "sms",
            class: "px-6 pt-6 pb-12 overflow-y-auto"
          }, {
            default: f(() => [
              m(Tc, {
                connector: n(p),
                "onUpdate:connector": M[2] || (M[2] = (V) => st(p) ? p.value = V : null),
                readonly: !n(a),
                onSubmit: M[3] || (M[3] = X((V) => n(g).submit(n(p)), ["prevent"]))
              }, null, 8, ["connector", "readonly"])
            ]),
            _: 1
          }),
          m(n(ee).Content, {
            value: "telegram",
            class: "px-6 pt-6 pb-12 overflow-y-auto"
          }, {
            default: f(() => [
              m(j$, {
                connector: n(S),
                "onUpdate:connector": M[4] || (M[4] = (V) => st(S) ? S.value = V : null),
                readonly: !n(a),
                onSubmit: M[5] || (M[5] = X((V) => n(h).submit(n(S)), ["prevent"]))
              }, null, 8, ["connector", "readonly"])
            ]),
            _: 1
          }),
          n(s) ? (u(), b(n(ee).Content, {
            key: 0,
            value: "server",
            class: "px-6 pt-6 pb-12 overflow-y-auto"
          }, {
            default: f(() => [
              n(E) ? (u(), v("p", {
                key: 0,
                role: "status",
                class: "mb-4 rounded border border-accent-blue p-3",
                textContent: c(n(o)("config.server.restartRequired"))
              }, null, 8, ok)) : y("", !0),
              m(Rc, {
                config: n(_),
                "onUpdate:config": M[6] || (M[6] = (V) => st(_) ? _.value = V : null),
                readonly: !n(a),
                onSubmit: M[7] || (M[7] = X((V) => n(w).submit(n(_)), ["prevent"]))
              }, null, 8, ["config", "readonly"])
            ]),
            _: 1
          })) : y("", !0)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 64));
  }
}), ik = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Config: sk
}, Symbol.toStringTag, { value: "Module" })), Dc = x.from(Tt).pipe(x.shareReplay(1)), Mc = Dc.pipe(x.map((e) => e.base));
async function Io(e) {
  const t = await Tt.get();
  if (!t) throw new Error("Cannot set base config: service state is undefined");
  Tt.update({ ...t, base: e });
}
function rk() {
  const e = Z(Mc, { onError: U.error });
  return {
    state: k({
      get: () => e.value,
      set: (o) => {
        Io(o).catch(U.error);
      }
    }),
    update: Io
  };
}
const lk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Config: ut,
  Form: Rc,
  INTERVAL_PRESETS: bo,
  Message: fa,
  SecurityKind: Xi,
  WEEKDAYS: yo,
  state$: Mc,
  update: Io,
  useState: rk
}, Symbol.toStringTag, { value: "Module" })), xs = Dc.pipe(x.map((e) => e.notification)), ck = xs.pipe(
  x.map((e) => e.event),
  x.shareReplay(1)
);
async function zo(e) {
  const t = await Tt.get();
  if (!t) throw new Error("Cannot set notification config: service state is undefined");
  Tt.update({ ...t, notification: { ...t.notification, ...e } });
}
function Ec() {
  const e = Z(xs, { onError: U.error });
  return {
    state: k({
      get: () => e.value,
      set: (o) => {
        zo(o).catch(U.error);
      }
    }),
    update: zo
  };
}
const uk = { class: "grid grid-cols-2 gap-4" }, dk = ["textContent"], mk = { class: "label" }, pk = ["textContent"], fk = ["readonly"], gk = ["textContent"], vk = /* @__PURE__ */ C({
  __name: "UserForm",
  props: /* @__PURE__ */ ve({
    readonly: { type: Boolean, default: !1 }
  }, {
    user: { required: !0 },
    userModifiers: {}
  }),
  emits: ["update:user"],
  setup(e) {
    const t = Q(e, "user"), { t: o } = R({ useScope: "global" });
    return (a, s) => (u(), v("form", uk, [
      l("legend", {
        class: "label-text font-bold mb-2 col-span-2",
        textContent: c(n(o)("config.notification.user.title"))
      }, null, 8, dk),
      l("div", mk, [
        l("label", {
          class: "label-text col-span-2",
          for: "notification-user",
          textContent: c(n(o)("entity.uuid"))
        }, null, 8, pk),
        L(l("input", {
          id: "notification-user",
          "onUpdate:modelValue": s[0] || (s[0] = (r) => t.value = r),
          class: "input w-full",
          type: "text",
          readonly: e.readonly
        }, null, 8, fk), [
          [
            j,
            t.value,
            void 0,
            { lazy: !0 }
          ]
        ])
      ]),
      e.readonly ? y("", !0) : (u(), v("button", {
        key: 0,
        class: "btn btn-filled justify-self-end",
        type: "submit",
        textContent: c(n(o)("action.save"))
      }, null, 8, gk))
    ]));
  }
}), bk = { key: 0 }, yk = /* @__PURE__ */ C({
  __name: "Form",
  props: /* @__PURE__ */ ve({
    readonly: { type: Boolean, default: !1 }
  }, {
    config: { required: !0 },
    configModifiers: {}
  }),
  emits: ["update:config"],
  setup(e) {
    const t = Q(e, "config"), { update: o } = Ec();
    return (a, s) => t.value ? (u(), v("div", bk, [
      m(Cc, {
        class: "mb-4",
        connector: t.value.connectors.email,
        readonly: e.readonly,
        onSubmit: s[0] || (s[0] = X((r) => n(o)(t.value), ["prevent"]))
      }, null, 8, ["connector", "readonly"]),
      m(Tc, {
        class: "my-4",
        connector: t.value.connectors.sms,
        readonly: e.readonly,
        onSubmit: s[1] || (s[1] = X((r) => n(o)(t.value), ["prevent"]))
      }, null, 8, ["connector", "readonly"]),
      m(vk, {
        user: t.value.user,
        "onUpdate:user": s[2] || (s[2] = (r) => t.value.user = r),
        class: "mt-4",
        readonly: e.readonly,
        onSubmit: s[3] || (s[3] = X((r) => n(o)(t.value), ["prevent"]))
      }, null, 8, ["user", "readonly"])
    ])) : y("", !0);
  }
}), hk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Config: ur,
  Email: va,
  EmailCodec: lr,
  EmailConnector: ba,
  EventBinding: $a,
  EventBindingKey: _a,
  EventBindings: cr,
  EventBindingsCodec: Gy,
  EventBindingsMessage: Vn,
  Form: yk,
  Message: Sa,
  SmsConnector: ya,
  TelegramConnector: ha,
  event$: ck,
  state$: xs,
  update: zo,
  useState: Ec
}, Symbol.toStringTag, { value: "Module" })), JM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ALLOWED_ROLES: Hy,
  Base: lk,
  Connector: W1,
  ICON: dr,
  Link: ue,
  Message: ka,
  NAVIGATION_VISIBILITY: ce,
  Navigation: j1,
  Notification: hk,
  SCOPE: mr,
  SetMessage: pr,
  Store: ho,
  findAllowedRoute: fr,
  findRouteNameByRoles: wa,
  i18n: b1,
  rest: B1,
  service: Tt,
  views: ik
}, Symbol.toStringTag, { value: "Module" })), _k = 1e3, $k = x.interval(_k).pipe(x.switchMap(() => Ut.clean())), No = /* @__PURE__ */ new Set(), Ut = le({
  name: _l,
  identity: as
}).withSources(
  async function* (t) {
    for await (const o of t) {
      const a = wl.safeParse(o);
      a.success && (yield () => a.data);
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = kl.safeParse(o);
      a.success && (yield (s) => new Map(s ?? []).set(a.data.device, a.data));
    }
  },
  async function* (t) {
    for await (const o of t)
      ka.safeParse(o).success && (yield (s) => new Map(s ?? []));
  }
).withActions({
  async clean() {
    const e = await this.get();
    e && await this.update((t) => {
      const o = t ?? e, a = new Map(Sk(o));
      return a.size === o.size ? o : a;
    });
  }
});
Ut.addEventListener("start", () => {
  No.add($k.subscribe());
});
Ut.addEventListener("stop", () => {
  for (const e of No)
    e.unsubscribe();
  No.clear();
});
function* Sk(e) {
  const t = Date.now();
  for (const [o, a] of e)
    Sl(a, t) && (yield [o, a]);
}
let Fo = null;
function kk(e) {
  Fo = e;
}
function wk() {
  if (!Fo) throw new Error("Activity REST client not initialized. Call init() first.");
  return Fo;
}
async function xk(e) {
  const o = await wk().get("activities", i.array(Yn), e), a = new Map(o.map((s) => [s.device, s]));
  return await Ut.set(a), a;
}
const Ck = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchAll: xk,
  init: kk
}, Symbol.toStringTag, { value: "Module" })), vt = x.from(Ut).pipe(x.shareReplay(1)), Tk = vt.pipe(x.map((e) => Map.groupBy(e.values(), (t) => t.scanner)));
function Pc(e = {}) {
  const t = k(() => A(e.sort) ?? [$l]), o = Z(vt, { onError: U.error, initialValue: /* @__PURE__ */ new Map() }), a = k(() => ne(o.value.values(), Y(t.value))), s = k(() => ne(o.value.values(), Y(t.value)));
  return {
    count: k(() => me(o.value.size, s.value.length)),
    state: o,
    list: s,
    all: a
  };
}
function Rk(e) {
  const { state: t } = Pc();
  return {
    activity: k(() => t.value.get(A(e)) ?? null)
  };
}
const XM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ByDevice: as,
  DEFAULT_SORT: $l,
  Detail: Xe,
  DetailMessage: kl,
  ICON: Q_,
  ListMessage: wl,
  MessageItem: Yn,
  SCOPE: _l,
  devicesByScanner$: Tk,
  isFresh: Sl,
  rest: Ck,
  service: Ut,
  state$: vt,
  useActivityOnDevice: Rk,
  useState: Pc
}, Symbol.toStringTag, { value: "Module" })), Dk = { title: "Místnost", dialog: { title: "Detail místnosti", description: "", create: "Vytvořit místnost", edit: "Upravit místnost", confirmDelete: "Opravdu chcete smazat tuto místnost?" }, select: { placeholder: "Vyberte místnost" } }, Mk = { config: { title: "Místnosti", description: "Správa místností v systému" }, empty: "V této lokaci nejsou žádné místnosti." }, Ek = {
  room: Dk,
  rooms: Mk
}, Pk = { title: "Room", dialog: { title: "Room detail", description: "", create: "Create room", edit: "Edit room", confirmDelete: "Are you sure you want to delete this room?" }, select: { placeholder: "Select room" } }, Lk = { config: { title: "Rooms", description: "Manage rooms in the system" }, empty: "No rooms in this location." }, jk = {
  room: Pk,
  rooms: Lk
}, Ak = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cs: Ek,
  en: jk
}, Symbol.toStringTag, { value: "Module" })), Fe = le({
  name: Ql,
  identity: vs
}).withSources(
  async function* (t) {
    for await (const o of t) {
      const a = tc.safeParse(o);
      a.success && (yield () => a.data);
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = nc.safeParse(o);
      a.success && (yield (s) => new Map(s ?? []).set(a.data.uuid, a.data));
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = ac.safeParse(o);
      a.success && (yield (s) => {
        const r = new Map(s ?? []);
        return r.delete(a.data), r;
      });
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = fs.safeParse(o);
      if (!a.success) continue;
      const s = a.data;
      yield (r) => {
        const d = new Map(Iterator.from(r ?? []).filter(([, g]) => g.location !== s)), p = new Set(r?.keys()).difference(new Set(d.keys()));
        return p.size > 0 && U.info(`[rooms] ${p.size} rooms were affected by location removal (${[...p].join(", ")})`), d;
      };
    }
  }
).withActions({
  create(e, t) {
    e.send(Oo.encode(Xn.parse(t)));
  },
  remove(e, t) {
    e.send(oc.encode(t));
  },
  update(e, t) {
    e.send(Oo.encode(xe.parse(t)));
  },
  seed: ys
});
function Ok(e) {
  return We(e, Fe, {
    path: "rooms",
    itemSchema: xe,
    ...qe()
  });
}
function Uk(e) {
  Object.defineProperty(Fe, "create", {
    value: async (t) => e.save(Xn.parse(t)),
    configurable: !0
  }), Object.defineProperty(Fe, "update", {
    value: async (t) => e.save(xe.parse(t)),
    configurable: !0
  }), Object.defineProperty(Fe, "remove", {
    value: async (t) => e.remove(t),
    configurable: !0
  });
}
const Vk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bindActions: Uk,
  createEndpoint: Ok
}, Symbol.toStringTag, { value: "Module" })), mn = x.from(Fe).pipe(x.shareReplay(1));
function Ik(e) {
  return function(o) {
    return !e || e.trim() === "" ? !0 : o.name.toLowerCase().includes(e.toLowerCase());
  };
}
function zk(e) {
  return function(o) {
    return !e || e.trim() === "" ? !0 : o.location === e;
  };
}
function Vt(e = {}) {
  const t = k(() => A(e.sort) ?? [Rn]), o = Z(mn, { onError: U.error, initialValue: /* @__PURE__ */ new Map() }), a = k(() => ne(o.value.values(), Y(t.value))), s = k(
    () => ne(
      o.value.values(),
      ot([Ik(A(e.filter?.name) ?? ""), zk(A(e.filter?.location) ?? "")]),
      Y(t.value)
    )
  ), r = k(() => Map.groupBy(o.value.values(), (p) => p.location ?? ""));
  return {
    count: k(() => me(o.value.size, s.value.length)),
    state: o,
    list: s,
    all: a,
    byLocation: r,
    sort: t
  };
}
function Cs(e) {
  const { state: t } = Vt();
  return {
    detail: k(() => {
      const a = A(e);
      return a ? t.value.get(a) ?? null : null;
    })
  };
}
function Lc({ input: e } = {}) {
  const { t } = R({ useScope: "global" });
  return Qe({
    input: e,
    seed: ys,
    createType: Xn,
    entityType: xe,
    create: (o) => Fe.create(o),
    update: (o) => Fe.update(o),
    remove: (o) => Fe.remove(o),
    i18n: {
      create: () => t("room.dialog.create", ""),
      edit: () => t("room.dialog.edit", ""),
      title: () => t("room.dialog.title", ""),
      confirmRemove: () => t("room.dialog.confirmDelete", "")
    }
  });
}
const Nk = { title: "Lokace", dialog: { title: "Detail lokace", description: "", create: "Vytvořit lokaci", edit: "Upravit lokaci", confirmDelete: "Opravdu chcete smazat tuto lokaci?" }, select: { placeholder: "Vyberte lokaci" } }, Fk = { config: { title: "Lokace", description: "Správa lokací v systému" } }, Bk = {
  location: Nk,
  locations: Fk
}, Gk = { title: "Location", dialog: { title: "Location detail", description: "", create: "Create location", edit: "Edit location", confirmDelete: "Are you sure you want to delete this location?" }, select: { placeholder: "Select location" } }, Hk = { config: { title: "Locations", description: "Manage locations in the system" } }, Kk = {
  location: Gk,
  locations: Hk
}, qk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cs: Bk,
  en: Kk
}, Symbol.toStringTag, { value: "Module" })), Be = le({
  name: Wl,
  identity: ps
}).withSources(
  async function* (t) {
    for await (const o of t) {
      const a = Zl.safeParse(o);
      a.success && (yield () => a.data);
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = Yl.safeParse(o);
      a.success && (yield (s) => new Map(s ?? []).set(a.data.uuid, a.data));
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = fs.safeParse(o);
      a.success && (yield (s) => {
        const r = new Map(s ?? []);
        return r.delete(a.data), r;
      });
    }
  }
).withActions({
  create(e, t) {
    e.send(Ao.encode(Jn.parse(t)));
  },
  remove(e, t) {
    e.send(Jl.encode(t));
  },
  update(e, t) {
    e.send(Ao.encode(pe.parse(t)));
  },
  seed() {
    return {
      name: ""
    };
  }
});
function Wk(e) {
  return We(e, Be, {
    path: "locations",
    itemSchema: pe,
    ...qe()
  });
}
function Zk(e) {
  Object.defineProperty(Be, "create", {
    value: async (t) => e.save(Jn.parse(t)),
    configurable: !0
  }), Object.defineProperty(Be, "update", {
    value: async (t) => e.save(pe.parse(t)),
    configurable: !0
  }), Object.defineProperty(Be, "remove", {
    value: async (t) => e.remove(t),
    configurable: !0
  });
}
const Yk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bindActions: Zk,
  createEndpoint: Wk
}, Symbol.toStringTag, { value: "Module" })), jc = x.from(Be).pipe(x.shareReplay(1));
function Jk(e) {
  return function(o) {
    return !e || e.trim() === "" ? !0 : o.name.toLowerCase().includes(e.toLowerCase());
  };
}
function Xk(e, t = /* @__PURE__ */ new Set()) {
  return (o) => {
    switch (e) {
      case Wt.enum.include:
        return new Set(Iterator.from(t).map((s) => s.location)).has(o.uuid);
      case Wt.enum.exclude:
        return !new Set(Iterator.from(t).map((s) => s.location)).has(o.uuid);
      case Wt.enum.all:
      default:
        return !0;
    }
  };
}
function It(e = {}) {
  const t = k(() => A(e.sort) ?? [Tn]), o = Z(jc, { onError: U.error, initialValue: /* @__PURE__ */ new Map() }), a = k(() => ne(o.value.values(), Y(t.value))), s = k(
    () => ne(
      o.value.values(),
      ot([Jk(A(e.filter?.name) ?? ""), Xk(A(e.filter?.reference) ?? Wt.enum.all)]),
      Y(t.value)
    )
  );
  return {
    count: k(() => me(o.value.size, s.value.length)),
    state: o,
    list: s,
    all: a
  };
}
function Ts(e) {
  const { state: t } = It();
  return {
    detail: k(() => {
      const a = A(e);
      return a ? t.value.get(a) ?? null : null;
    })
  };
}
function Ac({ input: e } = {}) {
  const { t } = R({ useScope: "global" });
  return Qe({
    input: e,
    seed: Xl,
    createType: Jn,
    entityType: pe,
    create: (o) => Be.create(o),
    update: (o) => Be.update(o),
    remove: (o) => Be.remove(o),
    i18n: {
      create: () => t("location.dialog.create", ""),
      edit: () => t("location.dialog.edit", ""),
      title: () => t("location.dialog.title", ""),
      confirmRemove: () => t("location.dialog.confirmDelete", "")
    }
  });
}
const Qk = ["onSubmit"], ew = ["aria-label"], tw = ["textContent"], nw = ["textContent"], ow = ["placeholder"], Rs = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "Dialog",
  props: {
    location: {}
  },
  setup(e) {
    const t = e, { t: o } = R({ useScope: "global" }), a = Ac({ input: () => t.location });
    return (s, r) => (u(), b(n(T).Root, {
      "onUpdate:open": r[3] || (r[3] = (d) => n(a).reset())
    }, {
      default: f(({ close: d }) => [
        m(n(T).Trigger, { "as-child": "" }, {
          default: f(() => [
            P(s.$slots, "default", {}, () => [
              l("button", ae({
                type: "button",
                class: "btn"
              }, s.$attrs), [
                e.location ? (u(), b(n(D), {
                  key: 0,
                  icon: "edit"
                })) : (u(), b(n(D), {
                  key: 1,
                  icon: "add"
                }))
              ], 16)
            ])
          ]),
          _: 3
        }),
        m(n(T).Portal, null, {
          default: f(() => [
            m(n(T).Overlay, { class: "overlay" }),
            m(n(T).Content, {
              class: "dialog",
              "as-child": ""
            }, {
              default: f(() => [
                l("form", {
                  ref: "formElement",
                  onSubmit: X((p) => n(a).save.submit({ created: d }), ["prevent"])
                }, [
                  n(a).isUpdate ? (u(), v("input", {
                    key: 0,
                    type: "text",
                    autofocus: "",
                    tabindex: "0",
                    class: "sr-only",
                    "aria-label": n(a).title
                  }, null, 8, ew)) : y("", !0),
                  m(n(J), {
                    icon: ms
                  }, {
                    title: f(() => [
                      m(n(T).Title, { class: "headline grow" }, {
                        default: f(() => [
                          l("span", {
                            class: "sr-only",
                            textContent: c(n(a).title)
                          }, null, 8, tw),
                          l("label", {
                            for: "location-name",
                            class: "sr-only",
                            textContent: c(n(o)("entity.name"))
                          }, null, 8, nw),
                          L(l("input", {
                            id: "location-name",
                            "onUpdate:modelValue": r[0] || (r[0] = (p) => n(a).data.name = p),
                            class: "input",
                            type: "text",
                            placeholder: n(o)("entity.name")
                          }, null, 8, ow), [
                            [j, n(a).data.name]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    description: f(() => [
                      m(n(T).Description, { class: "paragraph description" }, {
                        default: f(() => [
                          $(c(n(o)("location.dialog.description", "")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    row: f(() => [
                      m(n(Ue), { entity: e.location }, null, 8, ["entity"])
                    ]),
                    _: 1
                  }, 8, ["icon"]),
                  m(n(he), {
                    class: "px-6",
                    "has-data": n(a).isUpdate,
                    "has-changes": n(a).hasChanges,
                    onClose: d,
                    onRemove: r[1] || (r[1] = (p) => n(a).remove.submit()),
                    onUndo: r[2] || (r[2] = (p) => n(a).reset())
                  }, null, 8, ["has-data", "has-changes", "onClose"])
                ], 40, Qk)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }));
  }
}), aw = ["title"], sw = {
  key: 1,
  class: "value text-right tabular-nums"
}, Oc = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "ListItem",
  props: {
    location: {},
    roomCount: {}
  },
  setup(e) {
    const { visible: t } = de(!0);
    return (o, a) => (u(), b(Rs, { location: e.location }, {
      default: f(() => [
        l("button", ae({
          type: "button",
          class: "item grid grid-cols-subgrid not-first:border-t h-12 items-center px-6 gap-4"
        }, o.$attrs), [
          n(t).name ? (u(), v("strong", {
            key: 0,
            class: "value text-left truncate",
            title: e.location.name
          }, c(e.location.name), 9, aw)) : y("", !0),
          n(t).rooms ? (u(), v("span", sw, c(e.roomCount), 1)) : y("", !0),
          n(t).uuid ? (u(), b(n(Pt), {
            key: 2,
            class: "max-w-32",
            value: e.location.uuid
          }, null, 8, ["value"])) : y("", !0)
        ], 16)
      ]),
      _: 1
    }, 8, ["location"]));
  }
}), Uc = /* @__PURE__ */ C({
  __name: "List",
  props: {
    locations: {}
  },
  setup(e) {
    const { t } = R({ useScope: "global" }), { gridStyle: o, rowStyle: a, visible: s } = de(!0);
    return (r, d) => (u(), v("section", {
      class: "list grid content-start min-w-0",
      style: K(n(o))
    }, [
      l("header", {
        class: "headline",
        style: K(n(a))
      }, [
        n(s).name ? (u(), b(n(z).SortTrigger, {
          key: 0,
          "sort-key": "name"
        }, {
          default: f(() => [
            $(c(n(t)("entity.name")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).rooms ? (u(), b(n(z).SortTrigger, {
          key: 1,
          class: "justify-self-end",
          "sort-key": "roomCount"
        }, {
          default: f(() => [
            $(c(n(t)("entity.rooms")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).uuid ? (u(), b(n(z).SortTrigger, {
          key: 2,
          "sort-key": "uuid"
        }, {
          default: f(() => [
            $(c(n(t)("entity.uuid")), 1)
          ]),
          _: 1
        })) : y("", !0)
      ], 4),
      (u(!0), v(I, null, te(e.locations, (p) => (u(), b(Oc, {
        key: p.uuid,
        style: K(n(a)),
        location: p,
        "room-count": p.roomCount
      }, null, 8, ["style", "location", "room-count"]))), 128)),
      P(r.$slots, "default")
    ], 4));
  }
}), iw = /* @__PURE__ */ C({
  __name: "Root",
  props: {
    uuid: {}
  },
  setup(e) {
    const t = e, { detail: o } = Ts(() => t.uuid);
    return (a, s) => P(a.$slots, "default", { detail: n(o) });
  }
}), to = /* @__PURE__ */ C({
  __name: "Select",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Q(e, "modelValue"), { t: o } = R({ useScope: "global" }), { list: a } = It({ sort: [{ key: "name", direction: W.enum.Ascending }] }), { options: s } = et({ options: a });
    return (r, d) => (u(), b(n(re), {
      modelValue: t.value,
      "onUpdate:modelValue": d[0] || (d[0] = (p) => t.value = p),
      options: n(s),
      placeholder: n(o)("location.select.placeholder")
    }, null, 8, ["modelValue", "options", "placeholder"]));
  }
}), rw = { class: "headline" }, lw = /* @__PURE__ */ C({
  __name: "Config",
  setup(e) {
    const { t } = R({ useScope: "global" }), { enabled: o } = Ce(), a = je({ key: "name", fill: !0 }, { key: "rooms" }, { key: "uuid", visible: () => o.value }), { sort: s } = Ae({ initialSort: Tn, fields: a }), { count: r, list: d } = It(), { byLocation: p } = Vt(), g = k(
      () => Y(
        d.value.map((S) => ({ ...S, roomCount: p.value.get(S.uuid)?.length ?? 0 })),
        [s.value, Tn]
      )
    );
    return (S, h) => (u(), v(I, null, [
      m(n(J), {
        description: n(t)("locations.config.description", "")
      }, {
        title: f(() => [
          l("h1", rw, c(n(t)("locations.config.title")), 1),
          m(n(B), null, {
            default: f(() => [
              $(c(n(r)), 1)
            ]),
            _: 1
          }),
          h[0] || (h[0] = l("span", { class: "grow" }, null, -1)),
          m(Rs)
        ]),
        _: 1
      }, 8, ["description"]),
      m(Uc, {
        class: "pb-12",
        locations: g.value
      }, null, 8, ["locations"])
    ], 64));
  }
}), cw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Config: lw
}, Symbol.toStringTag, { value: "Module" })), QM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DEFAULT_SORT: Tn,
  Detail: pe,
  DetailMessage: Yl,
  Dialog: Rs,
  FormData: Jn,
  ICON: ms,
  List: Uc,
  ListItem: Oc,
  ListMessage: Zl,
  Reference: T1,
  ReferenceFilter: Wt,
  RemoveMessage: Jl,
  RemovedMessage: fs,
  Root: iw,
  SCOPE: Wl,
  Select: to,
  SetMessage: Ao,
  Store: ps,
  i18n: qk,
  rest: Yk,
  seed: Xl,
  service: Be,
  state$: jc,
  useDetail: Ts,
  useForm: Ac,
  useState: It,
  views: cw
}, Symbol.toStringTag, { value: "Module" })), uw = ["onSubmit"], dw = ["aria-label"], mw = ["textContent"], pw = ["textContent"], fw = ["placeholder"], gw = { class: "px-6 grid gap-4" }, vw = {
  class: "label",
  for: "room-location"
}, bw = { class: "label-text" }, Ds = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "Dialog",
  props: {
    room: {}
  },
  setup(e) {
    const t = e, { t: o } = R({ useScope: "global" }), a = Lc({ input: () => t.room });
    return (s, r) => (u(), b(n(T).Root, {
      "onUpdate:open": r[4] || (r[4] = (d) => n(a).reset())
    }, {
      default: f(({ close: d }) => [
        m(n(T).Trigger, { "as-child": "" }, {
          default: f(() => [
            P(s.$slots, "default", {}, () => [
              l("button", ae({
                type: "button",
                class: "btn"
              }, s.$attrs), [
                e.room ? (u(), b(n(D), {
                  key: 0,
                  icon: "edit"
                })) : (u(), b(n(D), {
                  key: 1,
                  icon: "add"
                }))
              ], 16)
            ])
          ]),
          _: 3
        }),
        m(n(T).Portal, null, {
          default: f(() => [
            m(n(T).Overlay, { class: "overlay" }),
            m(n(T).Content, {
              class: "dialog",
              "as-child": ""
            }, {
              default: f(() => [
                l("form", {
                  ref: "formElement",
                  onSubmit: X((p) => n(a).save.submit({ created: d }), ["prevent"])
                }, [
                  n(a).isUpdate ? (u(), v("input", {
                    key: 0,
                    type: "text",
                    autofocus: "",
                    tabindex: "0",
                    class: "sr-only",
                    "aria-label": n(a).title
                  }, null, 8, dw)) : y("", !0),
                  m(n(J), {
                    icon: gs
                  }, {
                    title: f(() => [
                      m(n(T).Title, { class: "headline grow" }, {
                        default: f(() => [
                          l("span", {
                            class: "sr-only",
                            textContent: c(n(a).title)
                          }, null, 8, mw),
                          l("label", {
                            for: "room-name",
                            class: "sr-only",
                            textContent: c(n(o)("entity.name"))
                          }, null, 8, pw),
                          L(l("input", {
                            id: "room-name",
                            "onUpdate:modelValue": r[0] || (r[0] = (p) => n(a).data.name = p),
                            class: "input",
                            type: "text",
                            placeholder: n(o)("entity.name")
                          }, null, 8, fw), [
                            [j, n(a).data.name]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    description: f(() => [
                      m(n(T).Description, { class: "paragraph description" }, {
                        default: f(() => [
                          $(c(n(o)("room.dialog.description", "")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    row: f(() => [
                      m(n(Ue), { entity: e.room }, null, 8, ["entity"])
                    ]),
                    _: 1
                  }, 8, ["icon"]),
                  l("div", gw, [
                    l("label", vw, [
                      l("span", bw, c(n(o)("entity.location")), 1),
                      m(to, {
                        id: "room-location",
                        modelValue: n(a).data.location,
                        "onUpdate:modelValue": r[1] || (r[1] = (p) => n(a).data.location = p),
                        class: "input w-full"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  m(n(he), {
                    class: "px-6",
                    "has-data": n(a).isUpdate,
                    "has-changes": n(a).hasChanges,
                    onClose: d,
                    onRemove: r[2] || (r[2] = (p) => n(a).remove.submit()),
                    onUndo: r[3] || (r[3] = (p) => n(a).reset())
                  }, null, 8, ["has-data", "has-changes", "onClose"])
                ], 40, uw)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }));
  }
}), Vc = /* @__PURE__ */ C({
  __name: "List",
  setup(e) {
    const { t } = R({ useScope: "global" }), { gridStyle: o, rowStyle: a, visible: s } = de(!0);
    return (r, d) => (u(), v("section", {
      class: "list grid content-start min-w-0",
      style: K(n(o))
    }, [
      l("header", {
        class: "headline",
        style: K(n(a))
      }, [
        n(s).name ? (u(), b(n(z).SortTrigger, {
          key: 0,
          "sort-key": "name"
        }, {
          default: f(() => [
            $(c(n(t)("entity.name")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).scanners ? (u(), b(n(z).SortTrigger, {
          key: 1,
          class: "justify-self-end",
          "sort-key": "scannerCount"
        }, {
          default: f(() => [
            $(c(n(t)("entity.scanners")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).uuid ? (u(), b(n(z).SortTrigger, {
          key: 2,
          "sort-key": "uuid"
        }, {
          default: f(() => [
            $(c(n(t)("entity.uuid")), 1)
          ]),
          _: 1
        })) : y("", !0)
      ], 4),
      P(r.$slots, "default")
    ], 4));
  }
}), yw = ["title"], hw = {
  key: 1,
  class: "value text-right tabular-nums"
}, Ic = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "ListItem",
  props: {
    room: {},
    scannerCount: {}
  },
  setup(e) {
    const { visible: t } = de(!0);
    return (o, a) => (u(), b(Ds, { room: e.room }, {
      default: f(() => [
        l("button", ae({
          type: "button",
          class: "item grid grid-cols-subgrid not-first:border-t h-12 items-center px-6 gap-4"
        }, o.$attrs), [
          n(t).name ? (u(), v("strong", {
            key: 0,
            class: "value text-left truncate",
            title: e.room.name
          }, c(e.room.name), 9, yw)) : y("", !0),
          n(t).scanners ? (u(), v("span", hw, c(e.scannerCount), 1)) : y("", !0),
          n(t).uuid ? (u(), b(n(Pt), {
            key: 2,
            class: "max-w-32",
            value: e.room.uuid
          }, null, 8, ["value"])) : y("", !0)
        ], 16)
      ]),
      _: 1
    }, 8, ["room"]));
  }
}), _w = /* @__PURE__ */ C({
  __name: "Root",
  props: {
    uuid: {}
  },
  setup(e) {
    const t = e, { detail: o } = Cs(() => t.uuid);
    return (a, s) => P(a.$slots, "default", { detail: n(o) });
  }
}), no = /* @__PURE__ */ C({
  __name: "Select",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Q(e, "modelValue"), { t: o } = R({ useScope: "global" }), { list: a } = Vt({ sort: [{ key: "name", direction: W.enum.Ascending }] }), { options: s } = et({ options: a });
    return (r, d) => (u(), b(n(re), {
      modelValue: t.value,
      "onUpdate:modelValue": d[0] || (d[0] = (p) => t.value = p),
      options: n(s),
      placeholder: n(o)("room.select.placeholder")
    }, null, 8, ["modelValue", "options", "placeholder"]));
  }
}), $w = { title: "Skener", dialog: { title: "Detail skeneru", description: "", edit: "Upravit skener", confirmDelete: "Opravdu chcete smazat tento skener?" }, select: { placeholder: "Vyberte skener" } }, Sw = { config: { title: "Skenery", description: "Správa skenerů v systému" }, empty: "Žádné skenery nebyly nalezeny." }, kw = {
  scanner: $w,
  scanners: Sw
}, ww = { title: "Scanner", dialog: { title: "Scanner detail", description: "", edit: "Edit scanner", confirmDelete: "Are you sure you want to delete this scanner?" }, select: { placeholder: "Select scanner" } }, xw = { config: { title: "Scanners", description: "Manage scanners in the system" }, empty: "No scanners found." }, Cw = {
  scanner: ww,
  scanners: xw
}, Tw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cs: kw,
  en: Cw
}, Symbol.toStringTag, { value: "Module" })), gt = le({
  name: sc,
  identity: $s
}).withSources(
  async function* (t) {
    for await (const o of t) {
      const a = rc.safeParse(o);
      a.success && (yield () => a.data);
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = lc.safeParse(o);
      a.success && (yield (s) => new Map(s ?? []).set(a.data.uuid, a.data));
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = dc.safeParse(o);
      a.success && (yield (s) => {
        const r = new Map(s ?? []);
        return r.delete(a.data), r;
      });
    }
  }
).withActions({
  remove(e, t) {
    e.send(uc.encode(t));
  },
  update(e, t) {
    const o = Le.parse(t);
    e.send(cc.encode(o));
  }
});
function Rw(e) {
  return We(e, gt, {
    path: "scanners",
    itemSchema: cn,
    ...qe()
  });
}
function Dw(e) {
  Object.defineProperty(gt, "update", {
    value: async (t) => e.save(Le.parse(t)),
    configurable: !0
  }), Object.defineProperty(gt, "remove", {
    value: async (t) => e.remove(t),
    configurable: !0
  });
}
const Mw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bindActions: Dw,
  createEndpoint: Rw
}, Symbol.toStringTag, { value: "Module" })), pn = x.from(gt).pipe(x.shareReplay(1)), zc = x.combineLatest([pn, mn]).pipe(
  x.map(([e, t]) => new Map(
    e.entries().map(([o, a]) => {
      const s = a.room ? t.get(a.room) ?? null : null;
      return [o, Dn.parse({ ...a, roomName: s ? s.name : null })];
    })
  ))
);
function Ew(e) {
  return function(o) {
    return !e || e.trim() === "" ? !0 : o.name.toLowerCase().includes(e.toLowerCase());
  };
}
function Pw(e) {
  return function(o) {
    return !e || e.trim() === "" ? !0 : o.room === e;
  };
}
function zt(e = {}) {
  const t = k(() => A(e.sort) ?? [_s]), o = Z(zc, { onError: U.error, initialValue: /* @__PURE__ */ new Map() }), a = k(() => ne([...o.value.values()], Y(t.value))), s = k(
    () => ne(a.value, ot([Ew(A(e.filter?.name) ?? ""), Pw(A(e.filter?.room) ?? "")]), Y(t.value))
  ), r = k(() => Map.groupBy(o.value.values(), (p) => p.room ?? ""));
  return {
    count: k(() => me(o.value.size, s.value.length)),
    state: o,
    list: s,
    all: a,
    byRoom: r
  };
}
function Ms(e) {
  const { state: t } = zt();
  return {
    detail: k(() => {
      const a = A(e);
      return a ? t.value.get(a) ?? null : null;
    })
  };
}
function Nc({ input: e }) {
  const { t } = R({ useScope: "global" });
  return Qe({
    input: e,
    entityType: Le,
    live: ["lastActivity", "ip", "port", "version", "commit", "mac"],
    update: (o) => gt.update(o),
    remove: (o) => gt.remove(o),
    i18n: {
      edit: () => t("scanner.dialog.edit", ""),
      title: () => t("scanner.dialog.title", ""),
      confirmRemove: () => t("scanner.dialog.confirmDelete", "")
    }
  });
}
const Lw = /* @__PURE__ */ C({
  __name: "Root",
  props: {
    uuid: {}
  },
  setup(e) {
    const t = e, { detail: o } = Ms(() => t.uuid);
    return (a, s) => n(o) ? P(a.$slots, "default", {
      key: 0,
      detail: n(o)
    }) : y("", !0);
  }
}), jw = ["onSubmit"], Aw = ["aria-label"], Ow = ["textContent"], Uw = ["textContent"], Vw = ["placeholder"], Iw = { class: "grid grid-cols-2 gap-4 min-w-0" }, zw = { class: "px-6 grid gap-4" }, Nw = {
  class: "label",
  for: "scanner-room"
}, Fw = { class: "label-text" }, Bw = { class: "flex flex-wrap gap-4 justify-between" }, Gw = { class: "flex gap-4 justify-around" }, Hw = {
  class: "label grid gap-1 justify-items-center",
  for: "scanner-buzzer"
}, Kw = { class: "label-text" }, qw = {
  class: "label grid gap-1 justify-items-center",
  for: "scanner-led"
}, Ww = { class: "label-text" }, Zw = {
  class: "label grid gap-1 justify-items-center",
  for: "scanner-scan"
}, Yw = { class: "label-text" }, Fc = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "Dialog",
  props: {
    scanner: {}
  },
  setup(e) {
    const t = e, { t: o } = R({ useScope: "global" }), a = Oe(), s = Nc({ input: () => t.scanner });
    return (r, d) => (u(), b(n(T).Root, {
      "onUpdate:open": d[7] || (d[7] = (p) => n(s).reset())
    }, {
      default: f(({ close: p }) => [
        m(n(T).Trigger, { "as-child": "" }, {
          default: f(() => [
            P(r.$slots, "default", {}, () => [
              l("button", ae({
                type: "button",
                class: "btn"
              }, r.$attrs), [
                e.scanner ? (u(), b(n(D), {
                  key: 0,
                  icon: "edit"
                })) : (u(), b(n(D), {
                  key: 1,
                  icon: "add"
                }))
              ], 16)
            ])
          ]),
          _: 3
        }),
        m(n(T).Portal, null, {
          default: f(() => [
            m(n(T).Overlay, { class: "overlay" }),
            m(n(T).Content, {
              class: "dialog",
              "as-child": ""
            }, {
              default: f(() => [
                l("form", {
                  ref: "formElement",
                  onSubmit: X((g) => n(s).save.submit({ created: p }), ["prevent"])
                }, [
                  n(s).isUpdate ? (u(), v("input", {
                    key: 0,
                    type: "text",
                    autofocus: "",
                    tabindex: "0",
                    class: "sr-only",
                    "aria-label": n(s).title
                  }, null, 8, Aw)) : y("", !0),
                  m(n(J), {
                    icon: hs
                  }, {
                    title: f(() => [
                      m(n(T).Title, { class: "headline grow" }, {
                        default: f(() => [
                          l("span", {
                            class: "sr-only",
                            textContent: c(n(s).title)
                          }, null, 8, Ow),
                          l("label", {
                            for: "scanner-name",
                            class: "sr-only",
                            textContent: c(n(o)("entity.name"))
                          }, null, 8, Uw),
                          L(l("input", {
                            id: "scanner-name",
                            "onUpdate:modelValue": d[0] || (d[0] = (g) => n(s).data.name = g),
                            class: "input",
                            type: "text",
                            placeholder: n(o)("entity.name")
                          }, null, 8, Vw), [
                            [j, n(s).data.name]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    description: f(() => [
                      m(n(T).Description, { class: "paragraph description" }, {
                        default: f(() => [
                          $(c(n(o)("scanner.dialog.description", "")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    row: f(() => [
                      l("div", Iw, [
                        m(n(Ue), {
                          class: "col-span-2",
                          entity: e.scanner
                        }, null, 8, ["entity"]),
                        m(n(it), {
                          label: n(o)("entity.version"),
                          value: e.scanner.version
                        }, null, 8, ["label", "value"]),
                        m(n(it), {
                          label: n(o)("entity.commit"),
                          value: e.scanner.commit,
                          display: n(aa)(e.scanner.commit)
                        }, null, 8, ["label", "value", "display"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["icon"]),
                  l("div", zw, [
                    l("label", Nw, [
                      l("span", Fw, c(n(o)("entity.room")), 1),
                      m(no, {
                        id: "scanner-room",
                        modelValue: n(s).data.room,
                        "onUpdate:modelValue": d[1] || (d[1] = (g) => n(s).data.room = g),
                        class: "input w-full"
                      }, null, 8, ["modelValue"])
                    ]),
                    l("div", Bw, [
                      m(n(it), {
                        label: n(o)("entity.mac"),
                        value: e.scanner.mac
                      }, null, 8, ["label", "value"]),
                      m(n(it), {
                        label: n(o)("entity.ip"),
                        value: `${e.scanner.ip}${e.scanner.port ? `:${e.scanner.port}` : ""}`
                      }, null, 8, ["label", "value"]),
                      m(n(B), null, {
                        default: f(() => [
                          $(c(n(o)("entity.activity")) + " " + c(n(a).dateTime.format(e.scanner.lastActivity)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    l("div", Gw, [
                      l("label", Hw, [
                        l("span", Kw, c(n(o)("entity.buzzer")), 1),
                        m(n(ie).Root, {
                          id: "scanner-buzzer",
                          modelValue: n(s).data.buzzer,
                          "onUpdate:modelValue": d[2] || (d[2] = (g) => n(s).data.buzzer = g),
                          class: "btn switch"
                        }, {
                          default: f(() => [
                            m(n(ie).Thumb, { class: "thumb" })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      l("label", qw, [
                        l("span", Ww, c(n(o)("entity.led")), 1),
                        m(n(ie).Root, {
                          id: "scanner-led",
                          modelValue: n(s).data.led,
                          "onUpdate:modelValue": d[3] || (d[3] = (g) => n(s).data.led = g),
                          class: "btn switch"
                        }, {
                          default: f(() => [
                            m(n(ie).Thumb, { class: "thumb" })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      l("label", Zw, [
                        l("span", Yw, c(n(o)("entity.scan")), 1),
                        m(n(ie).Root, {
                          id: "scanner-scan",
                          modelValue: n(s).data.scan,
                          "onUpdate:modelValue": d[4] || (d[4] = (g) => n(s).data.scan = g),
                          class: "btn switch"
                        }, {
                          default: f(() => [
                            m(n(ie).Thumb, { class: "thumb" })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  m(n(he), {
                    class: "px-6",
                    "has-data": n(s).isUpdate,
                    "has-changes": n(s).hasChanges,
                    onClose: p,
                    onRemove: d[5] || (d[5] = (g) => n(s).remove.submit()),
                    onUndo: d[6] || (d[6] = (g) => n(s).reset())
                  }, null, 8, ["has-data", "has-changes", "onClose"])
                ], 40, jw)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }));
  }
}), Jw = ["title"], Xw = ["title"], Bc = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "ListItem",
  props: {
    scanner: {}
  },
  setup(e) {
    const t = Oe(), { visible: o } = de(!0);
    return (a, s) => (u(), b(Fc, { scanner: e.scanner }, {
      default: f(() => [
        l("button", ae({
          type: "button",
          class: "item grid grid-cols-subgrid not-first:border-t h-12 items-center px-6 gap-4"
        }, a.$attrs), [
          n(o).name ? (u(), v("strong", {
            key: 0,
            class: "value text-left truncate",
            title: e.scanner.name
          }, c(e.scanner.name), 9, Jw)) : y("", !0),
          n(o).room ? (u(), v("span", {
            key: 1,
            class: "value text-left truncate max-w-32",
            title: e.scanner.roomName ?? void 0
          }, c(e.scanner.roomName ?? "-"), 9, Xw)) : y("", !0),
          n(o).uuid ? (u(), b(n(B), { key: 2 }, {
            default: f(() => [
              $(c(e.scanner.uuid), 1)
            ]),
            _: 1
          })) : y("", !0),
          n(o).commit ? (u(), b(n(B), {
            key: 3,
            title: e.scanner.commit
          }, {
            default: f(() => [
              $(c(n(aa)(e.scanner.commit)), 1)
            ]),
            _: 1
          }, 8, ["title"])) : y("", !0),
          n(o).version ? (u(), b(n(B), { key: 4 }, {
            default: f(() => [
              $(c(e.scanner.version), 1)
            ]),
            _: 1
          })) : y("", !0),
          n(o).mac ? (u(), b(n(B), { key: 5 }, {
            default: f(() => [
              $(c(e.scanner.mac), 1)
            ]),
            _: 1
          })) : y("", !0),
          n(o).ip ? (u(), b(n(B), { key: 6 }, {
            default: f(() => [
              $(c(e.scanner.ip) + c(e.scanner.port ? `:${e.scanner.port}` : ""), 1)
            ]),
            _: 1
          })) : y("", !0),
          n(o).lastActivity ? (u(), b(n(B), { key: 7 }, {
            default: f(() => [
              $(c(n(t).dateTime.format(e.scanner.lastActivity)), 1)
            ]),
            _: 1
          })) : y("", !0),
          n(o).buzzer ? (u(), b(n(_t), {
            key: 8,
            class: "justify-self-center",
            value: e.scanner.buzzer
          }, null, 8, ["value"])) : y("", !0),
          n(o).led ? (u(), b(n(_t), {
            key: 9,
            class: "justify-self-center",
            value: e.scanner.led
          }, null, 8, ["value"])) : y("", !0),
          n(o).scan ? (u(), b(n(_t), {
            key: 10,
            class: "justify-self-center",
            value: e.scanner.scan
          }, null, 8, ["value"])) : y("", !0)
        ], 16)
      ]),
      _: 1
    }, 8, ["scanner"]));
  }
}), Gc = /* @__PURE__ */ C({
  __name: "List",
  props: {
    scanners: {}
  },
  setup(e) {
    const { t } = R({ useScope: "global" }), { gridStyle: o, rowStyle: a, visible: s } = de(!0);
    return (r, d) => (u(), v("section", {
      class: "list grid content-start min-w-0 overflow-x-auto",
      style: K(n(o))
    }, [
      l("header", {
        class: "headline",
        style: K(n(a))
      }, [
        n(s).name ? (u(), b(n(z).SortTrigger, {
          key: 0,
          "sort-key": "name"
        }, {
          default: f(() => [
            $(c(n(t)("entity.name")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).room ? (u(), b(n(z).SortTrigger, {
          key: 1,
          "sort-key": "roomName"
        }, {
          default: f(() => [
            $(c(n(t)("entity.room")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).uuid ? (u(), b(n(z).SortTrigger, {
          key: 2,
          class: "justify-self-center",
          "sort-key": "uuid"
        }, {
          default: f(() => [
            $(c(n(t)("entity.uuid")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).commit ? (u(), b(n(z).SortTrigger, {
          key: 3,
          class: "justify-self-center",
          "sort-key": "commit"
        }, {
          default: f(() => [
            $(c(n(t)("entity.commit")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).version ? (u(), b(n(z).SortTrigger, {
          key: 4,
          class: "justify-self-center",
          "sort-key": "version"
        }, {
          default: f(() => [
            $(c(n(t)("entity.version")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).mac ? (u(), b(n(z).SortTrigger, {
          key: 5,
          class: "justify-self-center",
          "sort-key": "mac"
        }, {
          default: f(() => [
            $(c(n(t)("entity.mac")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).ip ? (u(), b(n(z).SortTrigger, {
          key: 6,
          class: "justify-self-center",
          "sort-key": "ip"
        }, {
          default: f(() => [
            $(c(n(t)("entity.ip")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).lastActivity ? (u(), b(n(z).SortTrigger, {
          key: 7,
          class: "justify-self-center",
          "sort-key": "lastActivity"
        }, {
          default: f(() => [
            $(c(n(t)("entity.activity")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).buzzer ? (u(), b(n(z).SortTrigger, {
          key: 8,
          class: "justify-self-center",
          "sort-key": "buzzer"
        }, {
          default: f(() => [
            $(c(n(t)("entity.buzzer")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).led ? (u(), b(n(z).SortTrigger, {
          key: 9,
          class: "justify-self-center",
          "sort-key": "led"
        }, {
          default: f(() => [
            $(c(n(t)("entity.led")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).scan ? (u(), b(n(z).SortTrigger, {
          key: 10,
          class: "justify-self-center",
          "sort-key": "scan"
        }, {
          default: f(() => [
            $(c(n(t)("entity.scan")), 1)
          ]),
          _: 1
        })) : y("", !0)
      ], 4),
      (u(!0), v(I, null, te(e.scanners, (p) => (u(), b(Bc, {
        key: p.uuid,
        style: K(n(a)),
        scanner: p
      }, null, 8, ["style", "scanner"]))), 128)),
      P(r.$slots, "default")
    ], 4));
  }
}), Es = /* @__PURE__ */ C({
  __name: "Select",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Q(e, "modelValue"), { t: o } = R({ useScope: "global" }), { list: a } = zt({ sort: [{ key: "name", direction: W.enum.Ascending }] }), { options: s } = et({ options: a });
    return (r, d) => (u(), b(n(re), {
      modelValue: t.value,
      "onUpdate:modelValue": d[0] || (d[0] = (p) => t.value = p),
      options: n(s),
      placeholder: n(o)("scanner.select.placeholder")
    }, null, 8, ["modelValue", "options", "placeholder"]));
  }
}), Qw = { class: "headline" }, ex = {
  key: 1,
  class: "px-6"
}, tx = { class: "paragraph p-4 text-center border-emphasis-4 border rounded-md" }, nx = /* @__PURE__ */ C({
  __name: "Config",
  setup(e) {
    const { t } = R({ useScope: "global" }), { enabled: o } = Ce(), a = pi(Pn("list")), s = je(
      { key: "name", fill: !0 },
      { key: "room" },
      { key: "uuid", visible: () => o.value },
      { key: "commit", visible: () => o.value },
      { key: "version", visible: () => o.value },
      { key: "mac", visible: () => o.value },
      { key: "ip" },
      { key: "lastActivity", visible: () => a.value },
      { key: "buzzer" },
      { key: "led" },
      { key: "scan" }
    ), { sort: r } = Ae({ initialSort: _s, fields: s }), { count: d, list: p } = zt({ sort: r });
    return (g, S) => (u(), v(I, null, [
      m(n(J), {
        description: n(t)("scanners.config.description", "")
      }, {
        title: f(() => [
          l("h1", Qw, c(n(t)("scanners.config.title")), 1),
          m(n(B), null, {
            default: f(() => [
              $(c(n(d)), 1)
            ]),
            _: 1
          }),
          S[0] || (S[0] = l("span", { class: "grow" }, null, -1))
        ]),
        _: 1
      }, 8, ["description"]),
      n(p).length ? (u(), b(n(Gc), {
        key: 0,
        ref: "list",
        class: "pb-12",
        scanners: n(p)
      }, null, 8, ["scanners"])) : (u(), v("div", ex, [
        l("p", tx, c(n(t)("scanners.empty")), 1)
      ]))
    ], 64));
  }
}), ox = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Config: nx
}, Symbol.toStringTag, { value: "Module" })), e8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DEFAULT_SORT: _s,
  Detail: Le,
  DetailMessage: lc,
  Dialog: Fc,
  Display: Dn,
  DisplayState: R1,
  ICON: hs,
  List: Gc,
  ListItem: Bc,
  ListMessage: rc,
  MessageItem: cn,
  PortNumber: ic,
  RemoveMessage: uc,
  RemovedMessage: dc,
  Root: Lw,
  SCOPE: sc,
  Select: Es,
  SetMessage: cc,
  Store: $s,
  displayState$: zc,
  i18n: Tw,
  rest: Mw,
  service: gt,
  state$: pn,
  useDetail: Ms,
  useForm: Nc,
  useState: zt,
  views: ox
}, Symbol.toStringTag, { value: "Module" })), ax = { class: "headline" }, sx = { class: "col-span-full px-6 pt-6 pb-2 text-lg font-bold" }, ix = {
  key: 0,
  class: "col-span-full px-6 pb-2 text-muted"
}, rx = /* @__PURE__ */ C({
  __name: "Config",
  setup(e) {
    const { t } = R({ useScope: "global" }), { enabled: o } = Ce(), a = je({ key: "name", fill: !0 }, { key: "scanners" }, { key: "uuid", visible: () => o.value }), { sort: s, rowStyle: r } = Ae({ initialSort: Rn, fields: a }), { list: d } = It({ sort: [{ key: "name", direction: W.enum.Ascending }] }), { count: p, byLocation: g } = Vt(), { byRoom: S } = zt(), h = k((w) => {
      const E = new Map(Array.from(S.value, ([O, M]) => [O, M.length]));
      return w && Yo(w, E) ? w : E;
    }), _ = k(() => {
      const w = Array.from(g.value, ([E, O]) => {
        const M = O.map((V) => ({ ...V, scannerCount: h.value.get(V.uuid) ?? 0 }));
        return [E, Y(M, [s.value, Rn])];
      });
      return new Map(w);
    });
    return (w, E) => (u(), v(I, null, [
      m(n(J), {
        description: n(t)("rooms.config.description", "")
      }, {
        title: f(() => [
          l("h1", ax, c(n(t)("rooms.config.title")), 1),
          m(n(B), null, {
            default: f(() => [
              $(c(n(p)), 1)
            ]),
            _: 1
          }),
          E[0] || (E[0] = l("span", { class: "grow" }, null, -1)),
          m(Ds)
        ]),
        _: 1
      }, 8, ["description"]),
      m(Vc, { class: "pb-12" }, {
        default: f(() => [
          (u(!0), v(I, null, te(n(d), (O) => (u(), v(I, {
            key: O.uuid
          }, [
            l("h2", sx, c(O.name), 1),
            (u(!0), v(I, null, te(_.value.get(O.uuid), (M) => (u(), b(Ic, {
              key: M.uuid,
              style: K(n(r)),
              room: M,
              "scanner-count": M.scannerCount
            }, null, 8, ["style", "room", "scanner-count"]))), 128)),
            n(g).get(O.uuid)?.length ? y("", !0) : (u(), v("p", ix, c(n(t)("rooms.empty")), 1))
          ], 64))), 128))
        ]),
        _: 1
      })
    ], 64));
  }
}), lx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Config: rx
}, Symbol.toStringTag, { value: "Module" })), t8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DEFAULT_SORT: Rn,
  Detail: xe,
  DetailMessage: nc,
  Dialog: Ds,
  FormData: Xn,
  ICON: gs,
  List: Vc,
  ListItem: Ic,
  ListMessage: tc,
  Point: ec,
  RemoveMessage: oc,
  RemovedMessage: ac,
  Root: _w,
  SCOPE: Ql,
  Select: no,
  SetMessage: Oo,
  Store: vs,
  i18n: Ak,
  rest: Vk,
  seed: ys,
  service: Fe,
  state$: mn,
  useDetail: Cs,
  useForm: Lc,
  useState: Vt,
  views: lx
}, Symbol.toStringTag, { value: "Module" }));
function* cx(e, t) {
  const o = Map.groupBy(t.rooms, hn.prop("location"));
  for (const a of o.get(e) ?? [])
    yield* Hc(a.uuid, t);
}
function* Hc(e, t) {
  const o = Map.groupBy(t.activity.values(), hn.prop("scanner")), s = Map.groupBy(t.scanners, hn.prop("room")).get(e) ?? [];
  for (const r of s)
    for (const d of o.get(r.uuid) ?? []) {
      const p = t.devices.get(d.device);
      p && (yield {
        ...p,
        rssi: d.rssi,
        timestamp: d.timestamp
      });
    }
}
function ux(e, { activity: t, scanners: o, rooms: a }) {
  const s = t.get(e.uuid), r = s ? o.get(s.scanner) : void 0, d = r?.room ? a.get(r.room) : void 0;
  return {
    ...e,
    rssi: s?.rssi ?? null,
    scanner: s?.scanner ?? null,
    scannerName: s ? r?.name ?? s.scanner : null,
    room: d?.uuid ?? null,
    roomName: d?.name ?? null,
    location: d?.location ?? null
  };
}
function* dx({ activity: e, devices: t }) {
  for (const o of t.values())
    e.has(o.uuid) || (yield o);
}
const Nt = x.from(ft).pipe(x.shareReplay(1)), Kc = x.combineLatest([
  Nt,
  vt.pipe(x.startWith(/* @__PURE__ */ new Map())),
  pn.pipe(x.startWith(/* @__PURE__ */ new Map())),
  mn.pipe(x.startWith(/* @__PURE__ */ new Map()))
]).pipe(
  x.map(([e, t, o, a]) => new Map(e.entries().map(([s, r]) => [s, ux(r, { activity: t, scanners: o, rooms: a })])))
), qc = x.combineLatest([vt, Nt]).pipe(
  x.map(([e, t]) => Iterator.from(dx({ activity: e, devices: t }))),
  x.map((e) => new Map(e.map((t) => [t.uuid, t])))
);
function Wc() {
  return x.pipe(x.switchMap(Yc));
}
function Zc() {
  return x.pipe(x.switchMap(Jc));
}
function Yc(e) {
  return x.combineLatest([vt, Nt, pn]).pipe(
    x.map(([t, o, a]) => Iterator.from(Hc(e, { activity: t, devices: o, scanners: new Set(a.values()) }))),
    x.map((t) => new Map(t.map((o) => [o.uuid, o])))
    // Actually it's Map<string, $DeviceWithActivity> but we want to make sure it's compatible with def.Store
  );
}
function Jc(e) {
  return x.combineLatest([vt, Nt, pn, mn]).pipe(
    x.map(
      ([t, o, a, s]) => Iterator.from(cx(e, { activity: t, devices: o, rooms: new Set(s.values()), scanners: new Set(a.values()) }))
    ),
    x.map((t) => new Map(t.map((o) => [o.uuid, o])))
    // Actually it's Map<string, $DeviceWithActivity> but we want to make sure it's compatible with def.Store
  );
}
function Xc(e) {
  return (t) => e === "all" ? !0 : t.enabled === (e === "enabled");
}
function mx(e) {
  const t = e?.trim().toLowerCase() ?? "";
  return function(a) {
    return t ? [a.name ?? "", a.mac].some((s) => s.toLowerCase().includes(t)) : !0;
  };
}
function px(e) {
  return function(o) {
    return typeof e != "number" || !Number.isFinite(e) || o.rssi === null ? !0 : o.rssi >= e;
  };
}
function fx(e) {
  return (t) => e ? t.batteryLow : !0;
}
function gx(e) {
  return (t) => e ? t.room === e : !0;
}
function vx(e) {
  return (t) => e ? t.location === e : !0;
}
const Bo = "evac:device:rssiThreshold";
function Qc() {
  try {
    return globalThis.localStorage;
  } catch {
    return;
  }
}
function Ps(e) {
  if (e == null || e === "") return null;
  const t = Number(e);
  return Number.isFinite(t) ? t : null;
}
function bx(e = Qc()) {
  try {
    return Ps(e?.getItem(Bo));
  } catch {
    return null;
  }
}
function yx(e, t = Qc()) {
  try {
    const o = Ps(e);
    o === null ? t?.removeItem(Bo) : t?.setItem(Bo, String(o));
  } catch {
  }
}
const eu = "enabled";
function lt(e = {}) {
  const t = hx(e), o = k(() => A(e.sort) ?? [Qt]), a = Z(t, { onError: U.error, initialValue: /* @__PURE__ */ new Map() }), s = k(() => ne(a.value.values(), Y(o.value))), r = k(() => ne(a.value.values(), ot([Xc(A(e.filter?.enabled) ?? "all")]), Y(o.value)));
  return {
    count: k(() => me(a.value.size, r.value.length)),
    state: a,
    list: r,
    all: s
  };
}
function tu(e = {}) {
  const t = k(() => A(e.sort) ?? [Qt]), o = Z(Kc, { onError: U.error, initialValue: /* @__PURE__ */ new Map() }), a = k(() => {
    const r = A(e.filter) ?? {};
    return ne(
      o.value.values(),
      ot([
        mx(r.search),
        Xc(r.enabled ?? eu),
        fx(r.lowBatteryOnly ?? !1),
        px(r.minRssi),
        gx(r.room),
        vx(r.location)
      ]),
      Y(t.value)
    );
  });
  return {
    count: k(() => me(o.value.size, a.value.length)),
    state: o,
    list: a
  };
}
let mo;
function nu() {
  if (!mo) {
    const e = q(bx());
    vd(!0).run(() => De(e, (t) => yx(t))), mo = e;
  }
  return mo;
}
function ou(e = {}) {
  return Se({
    search: "",
    enabled: eu,
    lowBatteryOnly: !1,
    room: null,
    location: null,
    ...e,
    minRssi: nu()
  });
}
function hx(e) {
  const { sourceType: t = Ye.enum.all, room: o, location: a } = e;
  if (t === Ye.enum.all)
    return Nt;
  if (t === Ye.enum.unallocated)
    return qc;
  if (t === Ye.enum.room) {
    if (!o) throw new Error('Room UUID must be provided when sourceType is "room"');
    return Ws(Ys(o), { immediate: !0 }).pipe(x.filter(Boolean), Wc());
  }
  if (t === Ye.enum.location) {
    if (!a) throw new Error('Location UUID must be provided when sourceType is "location"');
    return Ws(Ys(a), { immediate: !0 }).pipe(x.filter(Boolean), Zc());
  }
  throw new Error(`Unsupported source type: ${t}`);
}
function Ls(e) {
  const { state: t } = lt();
  return {
    detail: k(() => {
      const a = A(e);
      return a ? t.value.get(a) ?? null : null;
    })
  };
}
function au({ input: e }) {
  const { t } = R({ useScope: "global" });
  return Qe({
    input: e,
    entityType: Te,
    live: ["lastActivity", "battery", "batteryLow", "mac"],
    update: (o) => ft.update(o),
    remove: (o) => ft.remove(o),
    i18n: {
      edit: () => t("device.dialog.edit", ""),
      title: () => t("device.dialog.title", ""),
      confirmRemove: () => t("device.dialog.confirmDelete", "")
    }
  });
}
const su = /* @__PURE__ */ C({
  __name: "BatteryBadge",
  props: {
    battery: {}
  },
  setup(e) {
    const t = Oe();
    return (o, a) => typeof e.battery == "number" && Number.isFinite(e.battery) ? (u(), b(n(B), {
      key: 0,
      class: ke({
        "badge-accent-orange": e.battery < 20 && e.battery !== 0,
        "badge-accent-red": e.battery === 0
      })
    }, {
      default: f(() => [
        P(o.$slots, "label"),
        $(" " + c(n(t).percent.format((e.battery ?? 0) / 100)), 1)
      ]),
      _: 3
    }, 8, ["class"])) : (u(), b(n(B), { key: 1 }, {
      default: f(() => [
        P(o.$slots, "label"),
        a[0] || (a[0] = $(" - ", -1))
      ]),
      _: 3
    }));
  }
}), _x = { class: "inline-flex items-center justify-end gap-1" }, $x = ["title"], Sx = { class: "sr-only" }, kx = {
  key: 2,
  class: "text-center text-muted"
}, iu = /* @__PURE__ */ C({
  __name: "BatteryValue",
  props: {
    battery: {},
    low: { type: Boolean }
  },
  setup(e) {
    const { t } = R({ useScope: "global" }), o = Oe();
    return (a, s) => (u(), v("span", _x, [
      e.low ? (u(), v("span", {
        key: 0,
        class: "inline-flex",
        title: n(t)("device.batteryLow")
      }, [
        m(n(D), {
          class: "size-5 fill-accent-orange",
          icon: "battery_alert"
        }),
        l("span", Sx, c(n(t)("device.batteryLow")), 1)
      ], 8, $x)) : y("", !0),
      typeof e.battery == "number" && Number.isFinite(e.battery) ? (u(), v("span", {
        key: 1,
        class: ke(["text-right", {
          "text-accent-orange": e.battery < 20 && e.battery !== 0,
          "text-accent-red": !e.battery
        }])
      }, c(n(o).percent.format(e.battery / 100)), 3)) : (u(), v("span", kx, " - "))
    ]));
  }
}), wx = ["onSubmit"], xx = ["aria-label"], Cx = ["textContent"], Tx = ["textContent"], Rx = ["placeholder"], Dx = { class: "px-6 grid gap-4" }, Mx = { class: "flex flex-wrap gap-4 justify-between" }, Ex = { class: "flex gap-4 justify-around" }, Px = {
  class: "label grid gap-1 justify-items-center",
  for: "device-enabled"
}, Lx = { class: "label-text" }, ru = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "Dialog",
  props: {
    device: {}
  },
  setup(e) {
    const t = e, { t: o } = R({ useScope: "global" }), a = Oe(), s = au({ input: () => t.device });
    return (r, d) => (u(), b(n(T).Root, {
      "onUpdate:open": d[4] || (d[4] = (p) => n(s).reset())
    }, {
      default: f(({ close: p }) => [
        m(n(T).Trigger, { "as-child": "" }, {
          default: f(() => [
            P(r.$slots, "default", {}, () => [
              l("button", ae({
                type: "button",
                class: "btn"
              }, r.$attrs), [
                e.device ? (u(), b(n(D), {
                  key: 0,
                  icon: "edit"
                })) : (u(), b(n(D), {
                  key: 1,
                  icon: "add"
                }))
              ], 16)
            ])
          ]),
          _: 3
        }),
        m(n(T).Portal, null, {
          default: f(() => [
            m(n(T).Overlay, { class: "overlay" }),
            m(n(T).Content, {
              class: "dialog",
              "as-child": ""
            }, {
              default: f(() => [
                l("form", {
                  ref: "formElement",
                  onSubmit: X((g) => n(s).save.submit({ created: p }), ["prevent"])
                }, [
                  n(s).isUpdate ? (u(), v("input", {
                    key: 0,
                    type: "text",
                    autofocus: "",
                    tabindex: "0",
                    class: "sr-only",
                    "aria-label": n(s).title
                  }, null, 8, xx)) : y("", !0),
                  m(n(J), {
                    icon: ss
                  }, {
                    title: f(() => [
                      m(n(T).Title, { class: "headline grow" }, {
                        default: f(() => [
                          l("span", {
                            class: "sr-only",
                            textContent: c(n(s).title)
                          }, null, 8, Cx),
                          l("label", {
                            for: "device-name",
                            class: "sr-only",
                            textContent: c(n(o)("entity.name"))
                          }, null, 8, Tx),
                          L(l("input", {
                            id: "device-name",
                            "onUpdate:modelValue": d[0] || (d[0] = (g) => n(s).data.name = g),
                            class: "input",
                            type: "text",
                            placeholder: n(o)("entity.name")
                          }, null, 8, Rx), [
                            [j, n(s).data.name]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    description: f(() => [
                      m(n(T).Description, { class: "paragraph description" }, {
                        default: f(() => [
                          $(c(n(o)("device.dialog.description", "")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    row: f(() => [
                      m(n(Ue), { entity: e.device }, null, 8, ["entity"])
                    ]),
                    _: 1
                  }, 8, ["icon"]),
                  l("div", Dx, [
                    l("div", Mx, [
                      m(n(it), {
                        label: n(o)("entity.mac"),
                        value: e.device.mac
                      }, null, 8, ["label", "value"]),
                      m(n(B), null, {
                        default: f(() => [
                          $(c(n(o)("entity.activity")) + " " + c(n(a).dateTime.format(e.device.lastActivity)), 1)
                        ]),
                        _: 1
                      }),
                      m(su, {
                        battery: e.device.battery
                      }, {
                        label: f(() => [
                          $(c(n(o)("entity.battery")), 1)
                        ]),
                        _: 1
                      }, 8, ["battery"]),
                      e.device.batteryLow ? (u(), b(n(B), {
                        key: 0,
                        class: "badge-accent-orange"
                      }, {
                        default: f(() => [
                          m(n(D), { icon: "battery_alert" }),
                          $(" " + c(n(o)("device.batteryLow")), 1)
                        ]),
                        _: 1
                      })) : y("", !0)
                    ]),
                    l("div", Ex, [
                      l("label", Px, [
                        l("span", Lx, c(n(o)("entity.enabled")), 1),
                        m(n(ie).Root, {
                          id: "device-enabled",
                          modelValue: n(s).data.enabled,
                          "onUpdate:modelValue": d[1] || (d[1] = (g) => n(s).data.enabled = g),
                          class: "btn switch"
                        }, {
                          default: f(() => [
                            m(n(ie).Thumb, { class: "thumb" })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  m(n(he), {
                    class: "px-6",
                    "has-data": n(s).isUpdate,
                    "has-changes": n(s).hasChanges,
                    onClose: p,
                    onRemove: d[2] || (d[2] = (g) => n(s).remove.submit()),
                    onUndo: d[3] || (d[3] = (g) => n(s).reset())
                  }, null, 8, ["has-data", "has-changes", "onClose"])
                ], 40, wx)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }));
  }
}), jx = { class: "flex flex-wrap gap-x-6 gap-y-2 items-center" }, Ax = { class: "input w-56" }, Ox = { class: "sr-only" }, Ux = ["placeholder"], Vx = { class: "flex items-center gap-1" }, Ix = ["aria-label"], zx = { class: "flex items-center gap-1" }, Nx = ["aria-label"], Fx = ["title"], Bx = ["placeholder"], Gx = {
  key: 0,
  class: "flex items-center gap-2"
}, Hx = { class: "flex items-center gap-4" }, lu = /* @__PURE__ */ C({
  __name: "Filters",
  props: /* @__PURE__ */ ve({
    hideEnabled: { type: Boolean }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = Q(e, "modelValue"), { t: o } = R({ useScope: "global" }), a = k(() => Tl.options.map((r) => ({ value: r, label: o(`device.filter.enabledState.${r}`) }))), s = k({
      get: () => t.value.minRssi ?? "",
      set: (r) => t.value.minRssi = Ps(r)
    });
    return (r, d) => (u(), v("div", jx, [
      l("label", Ax, [
        m(n(D), { icon: "search" }),
        l("span", Ox, c(n(o)("device.filter.search")), 1),
        L(l("input", {
          "onUpdate:modelValue": d[0] || (d[0] = (p) => t.value.search = p),
          type: "search",
          class: "grow min-w-0 bg-transparent outline-none",
          placeholder: n(o)("device.filter.search")
        }, null, 8, Ux), [
          [j, t.value.search]
        ])
      ]),
      l("div", Vx, [
        m(to, {
          modelValue: t.value.location,
          "onUpdate:modelValue": d[1] || (d[1] = (p) => t.value.location = p),
          class: "w-44"
        }, null, 8, ["modelValue"]),
        L(l("button", {
          type: "button",
          class: "btn",
          "aria-label": n(o)("action.clear"),
          onClick: d[2] || (d[2] = (p) => t.value.location = null)
        }, [
          m(n(D), { icon: "close" })
        ], 8, Ix), [
          [xt, t.value.location]
        ])
      ]),
      l("div", zx, [
        m(no, {
          modelValue: t.value.room,
          "onUpdate:modelValue": d[3] || (d[3] = (p) => t.value.room = p),
          class: "w-44"
        }, null, 8, ["modelValue"]),
        L(l("button", {
          type: "button",
          class: "btn",
          "aria-label": n(o)("action.clear"),
          onClick: d[4] || (d[4] = (p) => t.value.room = null)
        }, [
          m(n(D), { icon: "close" })
        ], 8, Nx), [
          [xt, t.value.room]
        ])
      ]),
      l("label", {
        class: "flex items-center gap-2",
        title: n(o)("device.filter.minRssiHint")
      }, [
        l("span", null, c(n(o)("device.filter.minRssi")), 1),
        L(l("input", {
          "onUpdate:modelValue": d[5] || (d[5] = (p) => s.value = p),
          type: "number",
          class: "input w-28 min-w-0",
          min: "-127",
          max: "0",
          step: "1",
          placeholder: n(o)("device.filter.dBm")
        }, null, 8, Bx), [
          [
            j,
            s.value,
            void 0,
            { number: !0 }
          ]
        ])
      ], 8, Fx),
      e.hideEnabled ? y("", !0) : (u(), v("label", Gx, [
        l("span", null, c(n(o)("entity.enabled")), 1),
        m(n(re), {
          modelValue: t.value.enabled,
          "onUpdate:modelValue": d[6] || (d[6] = (p) => t.value.enabled = p),
          class: "w-40",
          options: a.value,
          placeholder: n(o)("entity.enabled")
        }, null, 8, ["modelValue", "options", "placeholder"])
      ])),
      l("label", Hx, [
        l("span", null, c(n(o)("device.filter.lowBatteryOnly")), 1),
        m(n(ie).Root, {
          modelValue: t.value.lowBatteryOnly,
          "onUpdate:modelValue": d[7] || (d[7] = (p) => t.value.lowBatteryOnly = p),
          class: "btn switch"
        }, {
          default: f(() => [
            m(n(ie).Thumb, { class: "thumb" })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]));
  }
}), Kx = ["title"], qx = {
  key: 2,
  class: "font-mono text-sm text-left"
}, Wx = ["title"], Zx = ["title"], cu = /* @__PURE__ */ C({
  __name: "Row",
  props: {
    device: {},
    as: { default: "div" }
  },
  setup(e) {
    const { t } = R({ useScope: "global" }), o = Oe(), { visible: a } = de(!0);
    return (s, r) => (u(), b(bd(e.as), { class: "grid grid-cols-subgrid not-first:border-t h-12 items-center px-6 gap-4" }, {
      default: f(() => [
        n(a).name ? (u(), v("strong", {
          key: 0,
          class: "value text-left truncate",
          title: e.device.name ?? void 0
        }, c(e.device.name), 9, Kx)) : y("", !0),
        n(a).uuid ? (u(), b(n(Pt), {
          key: 1,
          class: "max-w-32",
          value: e.device.uuid
        }, null, 8, ["value"])) : y("", !0),
        n(a).mac ? (u(), v("span", qx, c(e.device.mac), 1)) : y("", !0),
        n(a).room ? (u(), v("span", {
          key: 3,
          class: ke(["value text-left truncate max-w-40", { "text-muted": !e.device.roomName }]),
          title: e.device.roomName ?? void 0
        }, c(e.device.roomName ?? n(t)("device.unlocated")), 11, Wx)) : y("", !0),
        n(a).battery ? (u(), b(iu, {
          key: 4,
          class: "value justify-self-end",
          battery: e.device.battery,
          low: e.device.batteryLow
        }, null, 8, ["battery", "low"])) : y("", !0),
        n(a).rssi ? (u(), v("span", {
          key: 5,
          class: ke(["value text-right tabular-nums", { "text-muted": e.device.rssi === null }])
        }, c(e.device.rssi === null ? "-" : n(t)("device.rssiValue", { rssi: e.device.rssi })), 3)) : y("", !0),
        n(a).scanner ? (u(), v("span", {
          key: 6,
          class: ke(["value text-left truncate max-w-32", { "text-muted": !e.device.scannerName }]),
          title: e.device.scannerName ?? void 0
        }, c(e.device.scannerName ?? "-"), 11, Zx)) : y("", !0),
        n(a).lastActivity ? (u(), b(n(B), { key: 7 }, {
          default: f(() => [
            $(c(n(o).dateTime.format(e.device.lastActivity)), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(a).enabled ? (u(), b(n(_t), {
          key: 8,
          class: "justify-self-center",
          value: e.device.enabled
        }, null, 8, ["value"])) : y("", !0)
      ]),
      _: 1
    }));
  }
}), uu = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "ListItem",
  props: {
    device: {}
  },
  setup(e) {
    return (t, o) => (u(), b(ru, { device: e.device }, {
      default: f(() => [
        m(cu, ae({
          as: "button",
          type: "button",
          class: "item",
          device: e.device
        }, t.$attrs), null, 16, ["device"])
      ]),
      _: 1
    }, 8, ["device"]));
  }
}), du = /* @__PURE__ */ C({
  __name: "List",
  props: {
    devices: {}
  },
  setup(e) {
    const { t } = R({ useScope: "global" }), { gridStyle: o, rowStyle: a, visible: s } = de(!0);
    return (r, d) => (u(), v("section", {
      class: "list grid content-start min-w-0 overflow-x-auto",
      style: K(n(o))
    }, [
      l("header", {
        class: "headline",
        style: K(n(a))
      }, [
        n(s).name ? (u(), b(n(z).SortTrigger, {
          key: 0,
          "sort-key": "name"
        }, {
          default: f(() => [
            $(c(n(t)("entity.name")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).uuid ? (u(), b(n(z).SortTrigger, {
          key: 1,
          class: "justify-self-center",
          "sort-key": "uuid"
        }, {
          default: f(() => [
            $(c(n(t)("entity.uuid")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).mac ? (u(), b(n(z).SortTrigger, {
          key: 2,
          "sort-key": "mac"
        }, {
          default: f(() => [
            $(c(n(t)("entity.mac")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).room ? (u(), b(n(z).SortTrigger, {
          key: 3,
          "sort-key": "roomName"
        }, {
          default: f(() => [
            $(c(n(t)("entity.room")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).battery ? (u(), b(n(z).SortTrigger, {
          key: 4,
          class: "justify-self-end",
          "sort-key": "battery"
        }, {
          default: f(() => [
            $(c(n(t)("entity.battery")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).rssi ? (u(), b(n(z).SortTrigger, {
          key: 5,
          class: "justify-self-end",
          "sort-key": "rssi"
        }, {
          default: f(() => [
            $(c(n(t)("entity.rssi")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).scanner ? (u(), b(n(z).SortTrigger, {
          key: 6,
          "sort-key": "scannerName"
        }, {
          default: f(() => [
            $(c(n(t)("entity.scanner")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).lastActivity ? (u(), b(n(z).SortTrigger, {
          key: 7,
          class: "justify-self-center",
          "sort-key": "lastActivity"
        }, {
          default: f(() => [
            $(c(n(t)("entity.activity")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).enabled ? (u(), b(n(z).SortTrigger, {
          key: 8,
          class: "justify-self-center",
          "sort-key": "enabled"
        }, {
          default: f(() => [
            $(c(n(t)("entity.enabled")), 1)
          ]),
          _: 1
        })) : y("", !0)
      ], 4),
      (u(!0), v(I, null, te(e.devices, (p) => P(r.$slots, "item", {
        key: p.uuid,
        device: p,
        rowStyle: n(a)
      }, () => [
        m(uu, {
          style: K(n(a)),
          device: p
        }, null, 8, ["style", "device"])
      ])), 128)),
      P(r.$slots, "default")
    ], 4));
  }
}), Yx = /* @__PURE__ */ C({
  __name: "Root",
  props: {
    uuid: {}
  },
  setup(e) {
    const t = e, { detail: o } = Ls(() => t.uuid);
    return (a, s) => P(a.$slots, "default", { detail: n(o) });
  }
}), js = /* @__PURE__ */ C({
  __name: "Select",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Q(e, "modelValue"), { t: o } = R({ useScope: "global" }), { list: a } = lt({ sort: [{ key: "name", direction: W.enum.Ascending }], filter: { enabled: "enabled" } }), { options: s } = et({ options: a });
    return (r, d) => (u(), b(n(re), {
      modelValue: t.value,
      "onUpdate:modelValue": d[0] || (d[0] = (p) => t.value = p),
      options: n(s),
      placeholder: n(o)("device.select.placeholder")
    }, null, 8, ["modelValue", "options", "placeholder"]));
  }
}), Jx = /* @__PURE__ */ C({
  __name: "State",
  props: {
    sourceType: {},
    location: {},
    room: {},
    enabled: {}
  },
  setup(e) {
    const t = e, { list: o } = lt({
      sourceType: t.sourceType,
      location: () => t.location,
      room: () => t.room,
      filter: {
        enabled: () => t.enabled
      }
    });
    return (a, s) => P(a.$slots, "default", {
      list: n(o),
      count: n(o).length
    });
  }
}), Xx = { class: "headline" }, Qx = {
  key: 0,
  class: "paragraph p-4 text-center text-muted col-span-full"
}, eC = /* @__PURE__ */ C({
  __name: "Config",
  setup(e) {
    const { t } = R({ useScope: "global" }), { enabled: o } = Ce(), a = pi(Pn("list")), s = je(
      { key: "name", fill: !0 },
      { key: "uuid", visible: () => o.value },
      { key: "mac" },
      { key: "battery" },
      { key: "rssi" },
      { key: "scanner" },
      { key: "lastActivity", visible: () => a.value },
      { key: "enabled" }
    ), { sort: r } = Ae({ initialSort: Qt, fields: s }), d = q(ou()), { count: p, list: g } = tu({ sort: () => [r.value, Qt], filter: d });
    return (S, h) => (u(), v(I, null, [
      m(n(J), {
        description: n(t)("devices.config.description", "")
      }, {
        title: f(() => [
          l("h1", Xx, c(n(t)("devices.config.title")), 1),
          m(n(B), null, {
            default: f(() => [
              $(c(n(p)), 1)
            ]),
            _: 1
          }),
          h[1] || (h[1] = l("span", { class: "grow" }, null, -1))
        ]),
        row: f(() => [
          m(n(lu), {
            modelValue: d.value,
            "onUpdate:modelValue": h[0] || (h[0] = (_) => d.value = _),
            class: "mt-4"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["description"]),
      m(n(du), {
        ref: "list",
        class: "pb-12",
        devices: n(g)
      }, {
        default: f(() => [
          n(g).length ? y("", !0) : (u(), v("p", Qx, c(n(t)("device.filter.empty")), 1))
        ]),
        _: 1
      }, 8, ["devices"])
    ], 64));
  }
}), tC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Config: eC
}, Symbol.toStringTag, { value: "Module" })), n8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BatteryBadge: su,
  BatteryValue: iu,
  DEFAULT_SORT: Qt,
  Detail: Te,
  DetailMessage: Dl,
  Dialog: ru,
  Display: Cl,
  DisplayState: n1,
  EnabledFilter: Tl,
  Filters: lu,
  ICON: ss,
  List: du,
  ListItem: uu,
  ListMessage: Rl,
  MessageItem: ln,
  RemoveMessage: El,
  RemovedMessage: Pl,
  Root: Yx,
  Row: cu,
  SCOPE: xl,
  Select: js,
  SetMessage: Ml,
  SourceType: Ye,
  State: Jx,
  Store: is,
  WithActivity: t1,
  devicesByLocation: Jc,
  devicesByRoom: Yc,
  displayState$: Kc,
  i18n: c1,
  live: Cn,
  mapLocationToDevices: Zc,
  mapRoomToDevices: Wc,
  rest: m1,
  service: ft,
  state$: Nt,
  unallocatedDevices$: qc,
  useDetail: Ls,
  useDisplayFilters: ou,
  useDisplayState: tu,
  useForm: au,
  useRssiThreshold: nu,
  useState: lt,
  views: tC
}, Symbol.toStringTag, { value: "Module" }));
function nC(e, t) {
  const o = t.alarm(e.alarm), a = t.location(e.location), s = t.room(e.room), r = t.scanner(e.scanner), d = t.device(e.device);
  return !o || !a || !s || !r || !d ? null : {
    alarm: o.uuid,
    location: a.name,
    room: s.name,
    scanner: r.name,
    device: d.name ?? ""
  };
}
const oC = { class: "px-6 grid gap-4" }, aC = {
  class: "label",
  for: "active-alarm-location"
}, sC = { class: "label-text" }, iC = {
  class: "label",
  for: "active-alarm-room"
}, rC = { class: "label-text" }, lC = {
  class: "label",
  for: "active-alarm-scanner"
}, cC = { class: "label-text" }, uC = {
  class: "label",
  for: "active-alarm-device"
}, dC = { class: "label-text" }, mC = {
  class: "label",
  for: "active-alarm-alarm"
}, pC = { class: "label-text" }, fC = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "Dialog",
  setup(e) {
    const { t } = R({ useScope: "global" }), o = Se(M()), { list: a } = jt(), { state: s } = It(), { state: r } = Vt(), { state: d } = zt(), { state: p } = lt(), { list: g } = lt({ sourceType: Ye.enum.room, room: () => o.room }), { list: S } = lt({ sourceType: Ye.enum.unallocated }), h = k(() => [...g.value, ...S.value]), _ = k(() => !!(o.location && o.room && o.scanner && o.device && o.alarm));
    De(
      () => o.location,
      () => o.room = ""
    ), De(
      () => o.room,
      () => o.scanner = ""
    ), De(
      () => o.scanner,
      () => o.device = ""
    );
    const { startAlarm: w } = an();
    async function E(V) {
      if (!_.value || w.ongoing.value)
        return;
      const N = nC(o, {
        alarm: (F) => a.value.find((oe) => oe.uuid === F),
        location: (F) => s.value.get(F),
        room: (F) => r.value.get(F),
        scanner: (F) => d.value.get(F),
        device: (F) => p.value.get(F)
      });
      if (!N) {
        en("notice.selectionUnavailable");
        return;
      }
      await w.submit(N) && V?.();
    }
    function O() {
      Object.assign(o, M());
    }
    function M() {
      return {
        location: "",
        room: "",
        scanner: "",
        device: "",
        alarm: ""
      };
    }
    return (V, N) => (u(), b(n(T).Root, {
      "onUpdate:open": N[6] || (N[6] = (F) => O())
    }, {
      default: f(({ close: F }) => [
        m(n(T).Trigger, { "as-child": "" }, {
          default: f(() => [
            P(V.$slots, "trigger", {}, () => [
              l("button", ae({
                type: "button",
                class: "btn"
              }, V.$attrs), [
                m(n(D), { icon: "add" })
              ], 16)
            ])
          ]),
          _: 3
        }),
        m(n(T).Portal, null, {
          default: f(() => [
            m(n(T).Overlay, { class: "overlay" }),
            m(n(T).Content, {
              class: "dialog",
              as: "form",
              onSubmit: X((oe) => E(F), ["prevent"])
            }, {
              default: f(() => [
                m(n(J), null, {
                  title: f(() => [
                    m(n(D), {
                      class: "size-8",
                      icon: vr
                    }, null, 8, ["icon"]),
                    m(n(T).Title, { class: "headline" }, {
                      default: f(() => [
                        $(c(n(t)("alarm.dialog.create", "")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  description: f(() => [
                    m(n(T).Description, { class: "description" }, {
                      default: f(() => [
                        $(c(n(t)("alarm.dialog.description", "")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                l("div", oC, [
                  l("label", aC, [
                    l("span", sC, c(n(t)("location.title")), 1),
                    m(to, {
                      id: "active-alarm-location",
                      modelValue: o.location,
                      "onUpdate:modelValue": N[0] || (N[0] = (oe) => o.location = oe),
                      class: "w-full"
                    }, null, 8, ["modelValue"])
                  ]),
                  l("label", iC, [
                    l("span", rC, c(n(t)("room.title")), 1),
                    m(no, {
                      id: "active-alarm-room",
                      modelValue: o.room,
                      "onUpdate:modelValue": N[1] || (N[1] = (oe) => o.room = oe),
                      class: "w-full",
                      disabled: !o.location
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  l("label", lC, [
                    l("span", cC, c(n(t)("scanner.title")), 1),
                    m(Es, {
                      id: "active-alarm-scanner",
                      modelValue: o.scanner,
                      "onUpdate:modelValue": N[2] || (N[2] = (oe) => o.scanner = oe),
                      class: "w-full",
                      disabled: !o.room
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  l("label", uC, [
                    l("span", dC, c(n(t)("device.title")), 1),
                    m(js, {
                      id: "active-alarm-device",
                      modelValue: o.device,
                      "onUpdate:modelValue": N[3] || (N[3] = (oe) => o.device = oe),
                      class: "w-full",
                      disabled: !h.value.length
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  l("label", mC, [
                    l("span", pC, c(n(t)("alarm.title")), 1),
                    m(hl, {
                      id: "active-alarm-alarm",
                      modelValue: o.alarm,
                      "onUpdate:modelValue": N[4] || (N[4] = (oe) => o.alarm = oe),
                      class: "w-full",
                      disabled: !n(a).length
                    }, null, 8, ["modelValue", "disabled"])
                  ])
                ]),
                m(n(he), {
                  class: "px-6",
                  onCancel: N[5] || (N[5] = (oe) => O()),
                  onClose: F
                }, null, 8, ["onClose"])
              ]),
              _: 2
            }, 1032, ["onSubmit"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }));
  }
}), o8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Actions: fh,
  Detail: mt,
  Dialog: fC,
  FormData: yr,
  ICON: vr,
  ListMessage: hr,
  Message: Jh,
  Root: dh,
  SCOPE: _o,
  StartMessage: $o,
  StopMessage: So,
  Store: br,
  alarms$: $r,
  service: rt,
  state$: Sr,
  useState: an,
  validAlarms: _r
}, Symbol.toStringTag, { value: "Module" })), gC = { title: "Auditní log", description: "Kdo, co a kdy udělal: alarmy, události a změny konfigurace", empty: "Žádné záznamy neodpovídají.", error: "Auditní log se nepodařilo načíst.", column: { time: "Čas", kind: "Druh", action: "Akce", target: "Cíl", operator: "Operátor" }, filter: { event: "UUID události", invalidEvent: "Toto není platné UUID. Seznam se nezmění, dokud ho neopravíte nebo nevymažete.", from: "Od", to: "Do" }, pager: { label: "Stránky", range: "{first}–{last} z {total}", previous: "Předchozí stránka", next: "Další stránka" }, detail: { reference: "UUID cíle", event: "UUID události", actor: "UUID operátora" }, kind: { event: "Událost", alarm: "Aktivní alarm", alarm_config: "Konfigurace alarmu", location: "Lokalita", room: "Místnost", scanner: "Skener", device: "Zařízení", notification: "Notifikace", contact: "Kontakt", contact_group: "Skupina kontaktů", event_mapping: "Mapování událostí", config: "Konfigurace", user: "Uživatel", token: "API token", backup: "Záloha", upload: "Nahraný soubor", battery: "Baterie" }, action: { trigger: "Vyvolání", remove: "Odebrání", start: "Spuštění", stop: "Zastavení", send: "Odeslání", create: "Vytvoření", update: "Úprava", delete: "Smazání", password: "Změna hesla", restore: "Obnovení", upload: "Nahrání", download: "Stažení", occur: "Výskyt", notify: "Zpráva předána k odeslání", recovered: "Zotavení" }, system: "Systém" }, vC = {
  auditLog: gC
}, bC = { title: "Audit log", description: "Who did what and when: alarms, events and configuration changes", empty: "No records match.", error: "The audit log could not be loaded.", column: { time: "Time", kind: "Kind", action: "Action", target: "Target", operator: "Operator" }, filter: { event: "Event UUID", invalidEvent: "This is not a valid UUID. The list stays as it is until you correct or clear it.", from: "From", to: "To" }, pager: { label: "Pages", range: "{first}–{last} of {total}", previous: "Previous page", next: "Next page" }, detail: { reference: "Target UUID", event: "Event UUID", actor: "Operator UUID" }, kind: { event: "Event", alarm: "Active alarm", alarm_config: "Alarm configuration", location: "Location", room: "Room", scanner: "Scanner", device: "Device", notification: "Notification", contact: "Contact", contact_group: "Contact group", event_mapping: "Event mapping", config: "Configuration", user: "User", token: "API token", backup: "Backup", upload: "Uploaded file", battery: "Battery" }, action: { trigger: "Trigger", remove: "Remove", start: "Start", stop: "Stop", send: "Send", create: "Create", update: "Update", delete: "Delete", password: "Password change", restore: "Restore", upload: "Upload", download: "Download", occur: "Occurrence", notify: "Message dispatched", recovered: "Recovered" }, system: "System" }, yC = {
  auditLog: bC
}, hC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cs: vC,
  en: yC
}, Symbol.toStringTag, { value: "Module" }));
let Go = null;
function _C(e) {
  Go = e;
}
function $C() {
  if (!Go) throw new Error("AuditLog REST client not initialized. Call init() first.");
  return Go;
}
function ai(e) {
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? null : t.toISOString();
}
function mu(e, { offset: t, limit: o }) {
  const a = new URLSearchParams(), s = e.event.trim();
  e.kind && a.set("kind", e.kind), e.action && a.set("action", e.action), s && a.set("event", s);
  const r = ai(e.from);
  r && a.set("from", r);
  const d = ai(e.to);
  return d && a.set("to", d.replace(/:00\.000Z$/, ":59.999999Z")), a.set("offset", String(t)), a.set("limit", String(o)), `audit-log?${a}`;
}
function pu(e, t, o) {
  return $C().get(mu(e, t), Il, o);
}
const SC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  auditLogPath: mu,
  fetchPage: pu,
  init: _C
}, Symbol.toStringTag, { value: "Module" }));
function fu() {
  const e = q({ ...Al }), t = q(0), o = q(0), a = fe(Po), s = q(!1), r = k(() => zl(e.value.event));
  let d = null;
  const p = H(async () => {
    d?.abort();
    const S = new AbortController();
    d = S, s.value = !0;
    try {
      const h = t.value, _ = await pu(e.value, { offset: h, limit: qt }, S.signal);
      if (S.signal.aborted) return;
      a.value = _, o.value = h, !_.items.length && t.value > 0 && (t.value = Nl(_.total));
    } catch (h) {
      if (S.signal.aborted) return;
      throw a.value = Po, h;
    } finally {
      d === S && (s.value = !1);
    }
  });
  function g() {
    r.value && p.submit();
  }
  return De(
    e,
    () => {
      r.value && (t.value = 0);
    },
    { deep: !0, flush: "sync" }
  ), De([e, t], g, { deep: !0, immediate: !0 }), si(() => d?.abort()), {
    filters: e,
    eventValid: r,
    rows: k(() => a.value.items),
    total: k(() => a.value.total),
    offset: k(() => o.value),
    hasPrevious: k(() => r.value && t.value > 0),
    hasNext: k(() => r.value && t.value + a.value.items.length < a.value.total),
    previous: () => t.value = Math.max(0, t.value - qt),
    next: () => t.value += qt,
    loading: k(() => s.value),
    error: p.error,
    reload: g
  };
}
function oo() {
  const { t: e, te: t } = R({ useScope: "global" }), o = (a, s) => {
    const r = `auditLog.${a}.${s}`;
    return t(r) ? e(r) : s;
  };
  return {
    kindLabel: (a) => o("kind", a),
    actionLabel: (a) => o("action", a),
    actorLabel: (a) => cs(a) ? e("auditLog.system") : a.actorName
  };
}
const kC = { class: "px-6 grid gap-4" }, wC = { class: "grid grid-cols-[max-content_minmax(0,1fr)] gap-x-4 gap-y-1" }, xC = { class: "truncate" }, CC = { class: "truncate" }, TC = { class: "truncate" }, RC = { class: "bg-emphasis-1 rounded-md p-3 text-sm overflow-auto max-h-96" }, DC = { class: "flex justify-end p-6" }, MC = ["onClick"], gu = /* @__PURE__ */ C({
  __name: "DetailDialog",
  props: {
    row: {},
    time: {}
  },
  setup(e) {
    const { t } = R({ useScope: "global" }), { kindLabel: o, actionLabel: a, actorLabel: s } = oo();
    return (r, d) => (u(), b(n(T).Root, null, {
      default: f(({ close: p }) => [
        m(n(T).Trigger, { "as-child": "" }, {
          default: f(() => [
            P(r.$slots, "default")
          ]),
          _: 3
        }),
        m(n(T).Portal, null, {
          default: f(() => [
            m(n(T).Overlay, { class: "overlay" }),
            m(n(T).Content, { class: "dialog" }, {
              default: f(() => [
                m(n(J), {
                  icon: ls
                }, {
                  title: f(() => [
                    m(n(T).Title, { class: "headline grow" }, {
                      default: f(() => [
                        $(c(n(o)(e.row.kind)) + ": " + c(n(a)(e.row.action)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  description: f(() => [
                    m(n(T).Description, { class: "paragraph description" }, {
                      default: f(() => [
                        $(c(e.time) + ", " + c(n(s)(e.row)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["icon"]),
                l("div", kC, [
                  l("dl", wC, [
                    l("dt", null, c(n(t)("auditLog.detail.reference")), 1),
                    l("dd", xC, c(e.row.referenceUuid ?? "-"), 1),
                    l("dt", null, c(n(t)("auditLog.detail.event")), 1),
                    l("dd", CC, c(e.row.eventUuid ?? "-"), 1),
                    l("dt", null, c(n(t)("auditLog.detail.actor")), 1),
                    l("dd", TC, c(cs(e.row) ? "-" : e.row.actorUuid), 1)
                  ]),
                  l("pre", RC, c(Bl(e.row.details)), 1)
                ]),
                l("div", DC, [
                  l("button", {
                    class: "btn",
                    type: "button",
                    onClick: (g) => p()
                  }, [
                    m(n(D), { icon: "close" }),
                    $(" " + c(n(t)("action.close")), 1)
                  ], 8, MC)
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }));
  }
}), EC = { class: "flex flex-wrap gap-x-6 gap-y-2 items-center px-6" }, PC = { class: "flex items-center gap-1" }, LC = ["aria-label"], jC = { class: "flex items-center gap-1" }, AC = ["aria-label"], OC = { class: "sr-only" }, UC = ["aria-invalid", "placeholder"], VC = { class: "flex items-center gap-2" }, IC = ["max"], zC = { class: "flex items-center gap-2" }, NC = ["max"], FC = {
  key: 0,
  role: "alert",
  class: "w-full text-accent-red text-sm"
}, vu = /* @__PURE__ */ C({
  __name: "Filters",
  props: /* @__PURE__ */ ve({
    eventValid: { type: Boolean }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = Q(e, "modelValue"), { t: o } = R({ useScope: "global" }), { kindLabel: a, actionLabel: s } = oo(), r = Oe(), d = (S, h) => S.map((_) => ({ value: _, label: h(_) })).sort((_, w) => r.sort.compare(_.label, w.label)), p = k(() => d(Ol, a)), g = k(() => d(Ul, s));
    return (S, h) => (u(), v("div", EC, [
      l("div", PC, [
        m(n(re), {
          modelValue: t.value.kind,
          "onUpdate:modelValue": h[0] || (h[0] = (_) => t.value.kind = _),
          class: "w-48",
          options: p.value,
          placeholder: n(o)("auditLog.column.kind")
        }, null, 8, ["modelValue", "options", "placeholder"]),
        L(l("button", {
          type: "button",
          class: "btn",
          "aria-label": n(o)("action.clear"),
          onClick: h[1] || (h[1] = (_) => t.value.kind = null)
        }, [
          m(n(D), { icon: "close" })
        ], 8, LC), [
          [xt, t.value.kind]
        ])
      ]),
      l("div", jC, [
        m(n(re), {
          modelValue: t.value.action,
          "onUpdate:modelValue": h[2] || (h[2] = (_) => t.value.action = _),
          class: "w-48",
          options: g.value,
          placeholder: n(o)("auditLog.column.action")
        }, null, 8, ["modelValue", "options", "placeholder"]),
        L(l("button", {
          type: "button",
          class: "btn",
          "aria-label": n(o)("action.clear"),
          onClick: h[3] || (h[3] = (_) => t.value.action = null)
        }, [
          m(n(D), { icon: "close" })
        ], 8, AC), [
          [xt, t.value.action]
        ])
      ]),
      l("label", {
        class: ke(["input w-96", { "border-accent-red": !e.eventValid }])
      }, [
        m(n(D), { icon: "search" }),
        l("span", OC, c(n(o)("auditLog.filter.event")), 1),
        L(l("input", {
          "onUpdate:modelValue": h[4] || (h[4] = (_) => t.value.event = _),
          type: "search",
          class: "grow min-w-0 bg-transparent outline-none",
          "aria-invalid": !e.eventValid,
          placeholder: n(o)("auditLog.filter.event"),
          onSearch: h[5] || (h[5] = (_) => t.value.event = _.target.value)
        }, null, 40, UC), [
          [
            j,
            t.value.event,
            void 0,
            { lazy: !0 }
          ]
        ])
      ], 2),
      l("label", VC, [
        l("span", null, c(n(o)("auditLog.filter.from")), 1),
        L(l("input", {
          "onUpdate:modelValue": h[6] || (h[6] = (_) => t.value.from = _),
          type: "datetime-local",
          max: Lo,
          class: "input w-56 min-w-0"
        }, null, 8, IC), [
          [
            j,
            t.value.from,
            void 0,
            { lazy: !0 }
          ]
        ])
      ]),
      l("label", zC, [
        l("span", null, c(n(o)("auditLog.filter.to")), 1),
        L(l("input", {
          "onUpdate:modelValue": h[7] || (h[7] = (_) => t.value.to = _),
          type: "datetime-local",
          max: Lo,
          class: "input w-56 min-w-0"
        }, null, 8, NC), [
          [
            j,
            t.value.to,
            void 0,
            { lazy: !0 }
          ]
        ])
      ]),
      e.eventValid ? y("", !0) : (u(), v("p", FC, c(n(o)("auditLog.filter.invalidEvent")), 1))
    ]));
  }
}), BC = ["aria-label"], GC = { class: "text-muted" }, HC = ["disabled", "aria-label"], KC = ["disabled", "aria-label"], bu = /* @__PURE__ */ C({
  __name: "Pager",
  props: {
    first: {},
    last: {},
    total: {},
    hasPrevious: { type: Boolean },
    hasNext: { type: Boolean }
  },
  emits: ["previous", "next"],
  setup(e) {
    const { t } = R({ useScope: "global" });
    return (o, a) => (u(), v("nav", {
      class: "flex gap-2 items-center justify-end px-6",
      "aria-label": n(t)("auditLog.pager.label")
    }, [
      l("span", GC, c(n(t)("auditLog.pager.range", { first: e.first, last: e.last, total: e.total })), 1),
      l("button", {
        type: "button",
        class: "btn",
        disabled: !e.hasPrevious,
        "aria-label": n(t)("auditLog.pager.previous"),
        onClick: a[0] || (a[0] = (s) => o.$emit("previous"))
      }, [
        m(n(D), { icon: "chevron_left" })
      ], 8, HC),
      l("button", {
        type: "button",
        class: "btn",
        disabled: !e.hasNext,
        "aria-label": n(t)("auditLog.pager.next"),
        onClick: a[1] || (a[1] = (s) => o.$emit("next"))
      }, [
        m(n(D), { icon: "chevron_right" })
      ], 8, KC)
    ], 8, BC));
  }
}), qC = { class: "self-center px-2" }, WC = { class: "self-center px-2" }, ZC = { class: "self-center px-2" }, YC = { class: "self-center px-2" }, JC = { class: "self-center px-2" }, XC = { class: "text-left whitespace-nowrap" }, QC = ["title"], eT = ["title"], tT = {
  key: 1,
  role: "alert",
  class: "grid gap-2 justify-items-center p-4 col-span-full"
}, nT = { class: "paragraph text-accent-red" }, oT = {
  key: 2,
  class: "paragraph p-4 text-center text-muted col-span-full"
}, yu = /* @__PURE__ */ C({
  __name: "Table",
  props: {
    rows: {},
    loading: { type: Boolean },
    failed: { type: Boolean }
  },
  emits: ["retry"],
  setup(e) {
    const { t } = R({ useScope: "global" }), o = Oe(), { kindLabel: a, actionLabel: s, actorLabel: r } = oo(), d = je({ key: "time" }, { key: "kind" }, { key: "action" }, { key: "target", fill: !0 }, { key: "operator" }), { gridStyle: p, rowStyle: g } = Ae({ initialSort: { key: "time", direction: W.enum.Descending }, fields: d });
    return (S, h) => (u(), v("section", {
      class: "list grid content-start min-w-0 overflow-x-auto",
      style: K(n(p))
    }, [
      l("header", {
        class: "headline",
        style: K(n(g))
      }, [
        l("span", qC, c(n(t)("auditLog.column.time")), 1),
        l("span", WC, c(n(t)("auditLog.column.kind")), 1),
        l("span", ZC, c(n(t)("auditLog.column.action")), 1),
        l("span", YC, c(n(t)("auditLog.column.target")), 1),
        l("span", JC, c(n(t)("auditLog.column.operator")), 1)
      ], 4),
      (u(!0), v(I, null, te(e.rows, (_) => (u(), b(gu, {
        key: _.uuid,
        row: _,
        time: n(o).dateTimeSeconds.format(_.time)
      }, {
        default: f(() => [
          l("button", {
            type: "button",
            class: "item grid grid-cols-subgrid not-first:border-t h-12 items-center px-6 gap-4",
            style: K(n(g))
          }, [
            l("span", XC, c(n(o).dateTimeSeconds.format(_.time)), 1),
            m(n(B), { class: "justify-self-start" }, {
              default: f(() => [
                $(c(n(a)(_.kind)), 1)
              ]),
              _: 2
            }, 1024),
            m(n(B), { class: "justify-self-start" }, {
              default: f(() => [
                $(c(n(s)(_.action)), 1)
              ]),
              _: 2
            }, 1024),
            l("span", {
              class: "text-left truncate",
              title: jo(_)
            }, c(jo(_)), 9, QC),
            l("strong", {
              class: "value text-left truncate max-w-48",
              title: n(r)(_)
            }, c(n(r)(_)), 9, eT)
          ], 4)
        ]),
        _: 2
      }, 1032, ["row", "time"]))), 128)),
      e.rows.length ? y("", !0) : (u(), v(I, { key: 0 }, [
        e.loading ? (u(), b(n(Ji), {
          key: 0,
          class: "p-4 col-span-full"
        })) : e.failed ? (u(), v("div", tT, [
          l("p", nT, c(n(t)("auditLog.error")), 1),
          l("button", {
            type: "button",
            class: "btn",
            onClick: h[0] || (h[0] = (_) => S.$emit("retry"))
          }, [
            m(n(D), { icon: "refresh" }),
            $(" " + c(n(t)("action.refresh")), 1)
          ])
        ])) : (u(), v("p", oT, c(n(t)("auditLog.empty")), 1))
      ], 64))
    ], 4));
  }
}), aT = { class: "headline" }, sT = ["disabled", "aria-label", "title"], iT = { class: "grid content-start gap-4 pt-6 pb-12" }, rT = /* @__PURE__ */ C({
  __name: "Config",
  setup(e) {
    const { t } = R({ useScope: "global" }), { filters: o, eventValid: a, rows: s, total: r, offset: d, hasPrevious: p, hasNext: g, previous: S, next: h, loading: _, error: w, reload: E } = fu();
    return (O, M) => (u(), v(I, null, [
      m(n(J), {
        description: n(t)("auditLog.description", "")
      }, {
        title: f(() => [
          l("h1", aT, c(n(t)("auditLog.title")), 1),
          m(n(B), null, {
            default: f(() => [
              $(c(n(r)), 1)
            ]),
            _: 1
          }),
          l("button", {
            type: "button",
            class: "btn",
            disabled: n(_),
            "aria-label": n(t)("action.refresh"),
            title: n(t)("action.refresh"),
            onClick: M[0] || (M[0] = //@ts-ignore
            (...V) => n(E) && n(E)(...V))
          }, [
            m(n(D), { icon: "refresh" })
          ], 8, sT)
        ]),
        _: 1
      }, 8, ["description"]),
      l("div", iT, [
        m(vu, {
          modelValue: n(o),
          "onUpdate:modelValue": M[1] || (M[1] = (V) => st(o) ? o.value = V : null),
          "event-valid": n(a)
        }, null, 8, ["modelValue", "event-valid"]),
        m(yu, {
          rows: n(s),
          loading: n(_),
          failed: !!n(w) && n(a),
          onRetry: n(E)
        }, null, 8, ["rows", "loading", "failed", "onRetry"]),
        n(s).length ? (u(), b(bu, {
          key: 0,
          first: n(d) + 1,
          last: n(d) + n(s).length,
          total: n(r),
          "has-previous": n(p),
          "has-next": n(g),
          onPrevious: n(S),
          onNext: n(h)
        }, null, 8, ["first", "last", "total", "has-previous", "has-next", "onPrevious", "onNext"])) : y("", !0)
      ])
    ], 64));
  }
}), lT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Config: rT
}, Symbol.toStringTag, { value: "Module" })), a8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DetailDialog: gu,
  EMPTY_FILTERS: Al,
  EMPTY_PAGE: Po,
  Filters: vu,
  ICON: ls,
  KNOWN_ACTIONS: Ul,
  KNOWN_KINDS: Ol,
  MAX_DATE_FILTER: Lo,
  PAGE_SIZE: qt,
  Page: Il,
  Pager: bu,
  Row: Vl,
  SYSTEM_ACTOR: jl,
  Table: yu,
  formatDetails: Bl,
  i18n: hC,
  isEventFilter: zl,
  isSystemRow: cs,
  lastPageOffset: Nl,
  rest: SC,
  targetLabel: jo,
  useAuditLog: fu,
  useLabels: oo,
  views: lT
}, Symbol.toStringTag, { value: "Module" })), cT = { username: "Uživatelské jméno", password: "Heslo", login: "Přihlásit se", logout: "Odhlásit se", denied: "Přístup do aplikace odepřen" }, uT = {
  auth: cT
}, dT = { username: "Username", password: "Password", login: "Login", logout: "Logout", denied: "Access to the application is denied" }, mT = {
  auth: dT
}, pT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cs: uT,
  en: mT
}, Symbol.toStringTag, { value: "Module" })), hu = /* @__PURE__ */ C({
  __name: "LogoutButton",
  setup(e) {
    const { t } = R({ useScope: "global" }), { logout: o } = pa();
    return (a, s) => (u(), v("button", {
      type: "button",
      class: "btn",
      onClick: s[0] || (s[0] = (r) => n(o).submit())
    }, [
      m(n(D), { icon: "logout" }),
      $(" " + c(n(t)("auth.logout")), 1)
    ]));
  }
}), fT = {
  class: "label",
  for: "login-username"
}, gT = { class: "text-sm mb-2 text-secondary" }, vT = {
  class: "label",
  for: "login-password"
}, bT = { class: "text-sm mb-2 text-secondary" }, yT = {
  type: "submit",
  class: "btn btn-filled w-full"
}, hT = /* @__PURE__ */ C({
  __name: "LoginForm",
  setup(e) {
    const { t } = R({ useScope: "global" }), { formData: o, login: a } = pa();
    return (s, r) => (u(), v("form", {
      class: "grid gap-6 bg-surface-elevated p-10 rounded-page shadow-md",
      onSubmit: r[2] || (r[2] = X((d) => n(a).submit(), ["prevent"]))
    }, [
      l("label", fT, [
        l("span", gT, c(n(t)("auth.username")), 1),
        L(l("input", {
          id: "login-username",
          "onUpdate:modelValue": r[0] || (r[0] = (d) => n(o).username = d),
          type: "text",
          autocomplete: "username",
          class: "input w-full",
          required: ""
        }, null, 512), [
          [j, n(o).username]
        ])
      ]),
      l("label", vT, [
        l("span", bT, c(n(t)("auth.password")), 1),
        L(l("input", {
          id: "login-password",
          "onUpdate:modelValue": r[1] || (r[1] = (d) => n(o).password = d),
          type: "password",
          autocomplete: "current-password",
          class: "input w-full",
          required: ""
        }, null, 512), [
          [j, n(o).password]
        ])
      ]),
      l("button", yT, [
        m(n(D), { icon: "login" }),
        $(" " + c(n(t)("auth.login")), 1)
      ])
    ], 32));
  }
}), _T = { class: "grid w-screen h-screen bg-surface-subtle place-content-center justify-items-center gap-6" }, $T = {
  key: 1,
  class: "grid w-screen h-screen bg-surface-subtle place-items-center"
}, ST = {
  key: 2,
  class: "grid grid-rows-[auto_1fr] w-screen h-screen bg-surface-subtle"
}, kT = { class: "h-20 flex px-6 items-center" }, wT = /* @__PURE__ */ C({
  __name: "Wall",
  setup(e) {
    const { isAuthenticated: t, isAnonymous: o, pending: a } = Et(), { t: s } = R({ useScope: "global" });
    return (r, d) => n(t) && !n(a) ? (u(), v(I, { key: 0 }, [
      n(o) ? P(r.$slots, "anonymous", { key: 0 }, () => [
        l("div", _T, [
          m(ni),
          l("p", null, c(n(s)("auth.denied")), 1),
          m(hu)
        ])
      ]) : P(r.$slots, "default", { key: 1 })
    ], 64)) : n(a) ? (u(), v("div", $T, [
      m(Ji)
    ])) : (u(), v("div", ST, [
      l("header", kT, [
        m(ni)
      ]),
      P(r.$slots, "login")
    ]));
  }
}), _u = /* @__PURE__ */ C({
  __name: "UserSelect",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Q(e, "modelValue"), { t: o } = R({ useScope: "global" }), { options: a } = Zi();
    return (s, r) => (u(), b(n(re), {
      modelValue: t.value,
      "onUpdate:modelValue": r[0] || (r[0] = (d) => t.value = d),
      options: n(a),
      placeholder: n(o)("eventMapping.select.user")
    }, null, 8, ["modelValue", "options", "placeholder"]));
  }
});
function xT({ storage: e }) {
  return function() {
    const o = [Fb(e)];
    Nb(), Promise.all(o).then(Bb);
    const a = [
      jb.subscribe({ error: U.error }),
      Ab.subscribe({ error: U.error }),
      Ob.subscribe({ error: U.error }),
      Ub.subscribe({ error: U.error }),
      Vb.subscribe({ error: U.error })
    ];
    return async () => {
      for (const s of a)
        s.unsubscribe();
      await Promise.all(o.map((s) => s.then((r) => r.unsubscribe())));
    };
  };
}
const s8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DEFAULT_ROLES: ia,
  DEFAULT_USERNAME: ra,
  LoginCredentials: go,
  LoginForm: hT,
  LoginMessage: xi,
  LogoutButton: hu,
  LogoutMessage: Ci,
  Role: Ee,
  SCOPE: sa,
  State: Sb,
  TokenDetail: Zt,
  TokenDetailCodec: ki,
  TokenDetailMessage: Mi,
  TokenGetForUserMessage: Ti,
  TokenGetMessage: Di,
  TokenMessage: Ri,
  UserInfo: ua,
  UserInfoCodec: Si,
  UserInfoMessage: wi,
  UserSelect: _u,
  Wall: wT,
  adminRoles: la,
  externalRoles: $i,
  getCurrentToken: Hi,
  i18n: pT,
  isAdmin$: Vi,
  isAuthenticated$: tt,
  isService$: Ii,
  loginViaRest: qi,
  logout: Ki,
  plugin: xT,
  roles$: On,
  service: Tb,
  serviceRoles: ca,
  tokenIsValid$: Db,
  useForm: pa,
  useState: Et,
  useUserDetail: Yi,
  useUserList: Zi,
  userInfo$: Ke,
  username$: zi,
  uuid$: Ni,
  validRoles: _i,
  validateUserRoles: zb
}, Symbol.toStringTag, { value: "Module" })), CT = { title: "Kontakt", dialog: { title: "Detail kontaktu", description: "", create: "Vytvořit kontakt", edit: "Upravit kontakt", confirmDelete: "Opravdu chcete smazat tento kontakt?" }, placeholder: "Vyberte kontakt", search: "Hledat kontakt", kind: { sms: "SMS", email: "E-mail", telegram: "Telegram", placeholder: "Vyberte druh kontaktu", label: "Druh kontaktu" }, empty: "Filtrům neodpovídá žádný kontakt." }, TT = { title: "Kontakty", config: { title: "Správa kontaktů", description: "Zde můžete vytvářet a spravovat své kontakty." } }, RT = {
  contact: CT,
  contacts: TT
}, DT = { title: "Contact", dialog: { title: "Contact Detail", description: "", create: "Create Contact", edit: "Edit Contact", confirmDelete: "Are you sure you want to delete this contact?" }, placeholder: "Select contact", search: "Search contact", kind: { sms: "SMS", email: "E-mail", telegram: "Telegram", placeholder: "Select contact kind", label: "Contact Kind" }, empty: "No contact matches the filters." }, MT = { title: "Contacts", config: { title: "Manage Contacts", description: "Create and manage your contacts here." } }, ET = {
  contact: DT,
  contacts: MT
}, PT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cs: RT,
  en: ET
}, Symbol.toStringTag, { value: "Module" })), Ho = i.codec(Xt, Pe, {
  decode(e) {
    const t = Xt.parse(e);
    if ("sms" in t.kind)
      return At.parse({
        uuid: t.uuid,
        name: t.name,
        kind: "sms",
        number: t.kind.sms.number
      });
    if ("email" in t.kind)
      return Kn.parse({
        uuid: t.uuid,
        name: t.name,
        kind: "email",
        email: t.kind.email.email
      });
    if ("telegram" in t.kind)
      return rn.parse({
        uuid: t.uuid,
        name: t.name,
        kind: "telegram",
        chatId: t.kind.telegram.chat_id
      });
    throw new Error("Unknown contact kind");
  },
  encode(e) {
    switch (e.kind) {
      case "sms":
        return { uuid: e.uuid, name: e.name, kind: { sms: { number: e.number } } };
      case "email":
        return { uuid: e.uuid, name: e.name, kind: { email: { email: e.email } } };
      case "telegram":
        return { uuid: e.uuid, name: e.name, kind: { telegram: { chat_id: e.chatId } } };
    }
  }
});
function LT(e) {
  return We(e, Ne, {
    path: "contacts",
    itemSchema: Ho,
    ...qe()
  });
}
function jT(e) {
  Object.defineProperty(Ne, "create", {
    value: async (t) => e.save(Ho.encode(Wn.parse(t))),
    configurable: !0
  }), Object.defineProperty(Ne, "update", {
    value: async (t) => e.save(Ho.encode(t)),
    configurable: !0
  }), Object.defineProperty(Ne, "remove", {
    value: async (t) => e.remove(t),
    configurable: !0
  });
}
const AT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bindActions: jT,
  createEndpoint: LT
}, Symbol.toStringTag, { value: "Module" })), OT = /* @__PURE__ */ C({
  __name: "Root",
  props: {
    uuid: {}
  },
  setup(e) {
    const t = e, { detail: o } = ml(() => t.uuid);
    return (a, s) => P(a.$slots, "default", { detail: n(o) });
  }
}), As = /* @__PURE__ */ C({
  __name: "SelectKind",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Q(e, "modelValue"), { t: o } = R({ useScope: "global" }), { options: a } = Zn();
    return (s, r) => (u(), b(n(re), {
      modelValue: t.value,
      "onUpdate:modelValue": r[0] || (r[0] = (d) => t.value = d),
      options: n(a),
      placeholder: n(o)("contact.kind.placeholder")
    }, null, 8, ["modelValue", "options", "placeholder"]));
  }
}), UT = {
  class: "label",
  for: "contact-email"
}, VT = { class: "label-text" }, IT = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "EmailForm",
  props: {
    email: {},
    emailModifiers: {}
  },
  emits: ["update:email"],
  setup(e) {
    const t = Q(e, "email"), { t: o } = R({ useScope: "global" });
    return (a, s) => (u(), v("label", UT, [
      l("span", VT, c(n(o)("contact.kind.email")), 1),
      L(l("input", {
        id: "contact-email",
        "onUpdate:modelValue": s[0] || (s[0] = (r) => t.value = r),
        type: "email",
        class: "input w-full"
      }, null, 512), [
        [j, t.value]
      ])
    ]));
  }
}), zT = {
  class: "label",
  for: "contact-phone"
}, NT = { class: "label-text" }, FT = ["placeholder"], BT = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "SmsForm",
  props: {
    number: {},
    numberModifiers: {}
  },
  emits: ["update:number"],
  setup(e) {
    const t = Q(e, "number"), { t: o } = R({ useScope: "global" });
    return (a, s) => (u(), v("label", zT, [
      l("span", NT, c(n(o)("contact.kind.sms")), 1),
      L(l("input", {
        id: "contact-phone",
        "onUpdate:modelValue": s[0] || (s[0] = (r) => t.value = r),
        type: "tel",
        class: "input w-full",
        placeholder: n(o)("contact.kind.sms")
      }, null, 8, FT), [
        [j, t.value]
      ])
    ]));
  }
}), GT = {
  class: "label",
  for: "contact-chat-id"
}, HT = { class: "label-text" }, KT = ["placeholder"], qT = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "TelegramForm",
  props: {
    chatId: {},
    chatIdModifiers: {}
  },
  emits: ["update:chatId"],
  setup(e) {
    const t = Q(e, "chatId"), { t: o } = R({ useScope: "global" });
    return (a, s) => (u(), v("label", GT, [
      l("span", HT, c(n(o)("contact.kind.telegram")), 1),
      L(l("input", {
        id: "contact-chat-id",
        "onUpdate:modelValue": s[0] || (s[0] = (r) => t.value = r),
        type: "text",
        class: "input w-full",
        placeholder: n(o)("contact.kind.telegram")
      }, null, 8, KT), [
        [j, t.value]
      ])
    ]));
  }
}), WT = ["onSubmit"], ZT = ["aria-label"], YT = ["textContent"], JT = ["textContent"], XT = { class: "flex gap-2 items-center" }, QT = ["placeholder"], e0 = { class: "px-6 grid gap-4" }, t0 = {
  key: 0,
  class: "label",
  for: "contact-kind"
}, n0 = { class: "label-text" }, Os = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "Dialog",
  props: {
    contact: {}
  },
  setup(e) {
    const t = e, { t: o } = R({ useScope: "global" }), a = pl({ input: () => t.contact });
    return (s, r) => (u(), b(n(T).Root, {
      "onUpdate:open": r[7] || (r[7] = (d) => n(a).reset())
    }, {
      default: f(({ close: d }) => [
        m(n(T).Trigger, { "as-child": "" }, {
          default: f(() => [
            P(s.$slots, "default", {}, () => [
              l("button", ae({
                type: "button",
                class: "btn"
              }, s.$attrs), [
                e.contact ? (u(), b(n(D), {
                  key: 0,
                  icon: "edit"
                })) : (u(), b(n(D), {
                  key: 1,
                  icon: "add"
                }))
              ], 16)
            ])
          ]),
          _: 3
        }),
        m(n(T).Portal, null, {
          default: f(() => [
            m(n(T).Overlay, { class: "overlay" }),
            m(n(T).Content, {
              class: "dialog",
              "as-child": ""
            }, {
              default: f(() => [
                l("form", {
                  ref: "formElement",
                  onSubmit: X((p) => n(a).save.submit({ created: d }), ["prevent"])
                }, [
                  n(a).isUpdate ? (u(), v("input", {
                    key: 0,
                    type: "text",
                    autofocus: "",
                    tabindex: "0",
                    class: "sr-only",
                    "aria-label": n(a).title
                  }, null, 8, ZT)) : y("", !0),
                  m(n(J), {
                    icon: Gn
                  }, {
                    title: f(() => [
                      m(n(T).Title, { class: "headline grow" }, {
                        default: f(() => [
                          l("span", {
                            class: "sr-only",
                            textContent: c(n(a).title)
                          }, null, 8, YT),
                          l("label", {
                            for: "contact-name",
                            class: "sr-only",
                            textContent: c(n(o)("entity.name"))
                          }, null, 8, JT),
                          l("div", XT, [
                            L(l("input", {
                              id: "contact-name",
                              "onUpdate:modelValue": r[0] || (r[0] = (p) => n(a).data.name = p),
                              class: "input grow",
                              type: "text",
                              placeholder: n(o)("entity.name")
                            }, null, 8, QT), [
                              [j, n(a).data.name]
                            ]),
                            e.contact && Pe.safeParse(e.contact).success ? (u(), b(n(B), { key: 0 }, {
                              default: f(() => [
                                $(c(e.contact.kind), 1)
                              ]),
                              _: 1
                            })) : y("", !0)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    description: f(() => [
                      m(n(T).Description, { class: "paragraph description" }, {
                        default: f(() => [
                          $(c(n(o)("contact.dialog.description", "")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    row: f(() => [
                      m(n(Ue), {
                        class: "grow",
                        entity: e.contact
                      }, null, 8, ["entity"])
                    ]),
                    _: 1
                  }, 8, ["icon"]),
                  l("div", e0, [
                    Pe.safeParse(e.contact).success ? y("", !0) : (u(), v("label", t0, [
                      l("span", n0, c(n(o)("contact.kind.label")), 1),
                      m(As, {
                        id: "contact-kind",
                        modelValue: n(a).data.kind,
                        "onUpdate:modelValue": r[1] || (r[1] = (p) => n(a).data.kind = p),
                        class: "input w-full"
                      }, null, 8, ["modelValue"])
                    ])),
                    n(cl)(n(a).data) ? (u(), b(IT, {
                      key: 1,
                      email: n(a).data.email,
                      "onUpdate:email": r[2] || (r[2] = (p) => n(a).data.email = p)
                    }, null, 8, ["email"])) : n(ul)(n(a).data) ? (u(), b(BT, {
                      key: 2,
                      number: n(a).data.number,
                      "onUpdate:number": r[3] || (r[3] = (p) => n(a).data.number = p)
                    }, null, 8, ["number"])) : n(dl)(n(a).data) ? (u(), b(qT, {
                      key: 3,
                      "chat-id": n(a).data.chatId,
                      "onUpdate:chatId": r[4] || (r[4] = (p) => n(a).data.chatId = p)
                    }, null, 8, ["chat-id"])) : y("", !0)
                  ]),
                  m(n(he), {
                    class: "px-6",
                    "has-data": n(a).isUpdate,
                    "has-changes": n(a).hasChanges,
                    onClose: d,
                    onRemove: r[5] || (r[5] = (p) => n(a).remove.submit()),
                    onUndo: r[6] || (r[6] = (p) => n(a).reset())
                  }, null, 8, ["has-data", "has-changes", "onClose"])
                ], 40, WT)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }));
  }
}), o0 = /* @__PURE__ */ C({
  __name: "Select",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Q(e, "modelValue"), { state: o, list: a } = Ot(), { options: s } = et({ options: a });
    return (r, d) => (u(), b(n(re), {
      modelValue: t.value,
      "onUpdate:modelValue": d[0] || (d[0] = (p) => t.value = p),
      options: n(s)
    }, {
      option: f(({ option: p }) => [
        m(es, {
          contact: n(o).get(p.value)
        }, null, 8, ["contact"])
      ]),
      _: 1
    }, 8, ["modelValue", "options"]));
  }
}), a0 = { class: "grid content-start gap-4" }, s0 = { class: "flex flex-wrap gap-x-6 gap-y-2 items-center px-6" }, i0 = { class: "input w-56" }, r0 = { class: "sr-only" }, l0 = ["placeholder"], c0 = { class: "flex items-center gap-1" }, u0 = ["aria-label"], d0 = {
  key: 2,
  class: "self-center px-2"
}, m0 = ["title"], p0 = ["title"], f0 = {
  key: 0,
  class: "paragraph p-4 text-center text-muted col-span-full"
}, $u = /* @__PURE__ */ C({
  __name: "Table",
  setup(e) {
    const { t } = R({ useScope: "global" }), { enabled: o } = Ce(), a = je({ key: "name" }, { key: "kind" }, { key: "address", fill: !0 }, { key: "uuid", visible: () => o.value }), { gridStyle: s, rowStyle: r, sort: d, visible: p } = Ae({ initialSort: xn, fields: a }), g = q(""), S = q(null), { list: h } = Ot({ sort: () => [d.value, xn], filter: { search: g, kind: S } });
    return (_, w) => (u(), v("div", a0, [
      l("div", s0, [
        l("label", i0, [
          m(n(D), { icon: "search" }),
          l("span", r0, c(n(t)("contact.search")), 1),
          L(l("input", {
            "onUpdate:modelValue": w[0] || (w[0] = (E) => g.value = E),
            type: "search",
            class: "grow min-w-0 bg-transparent outline-none",
            placeholder: n(t)("contact.search")
          }, null, 8, l0), [
            [j, g.value]
          ])
        ]),
        l("div", c0, [
          m(As, {
            modelValue: S.value,
            "onUpdate:modelValue": w[1] || (w[1] = (E) => S.value = E),
            class: "w-48"
          }, null, 8, ["modelValue"]),
          L(l("button", {
            type: "button",
            class: "btn",
            "aria-label": n(t)("action.clear"),
            onClick: w[2] || (w[2] = (E) => S.value = null)
          }, [
            m(n(D), { icon: "close" })
          ], 8, u0), [
            [xt, S.value]
          ])
        ])
      ]),
      l("section", {
        class: "list grid content-start min-w-0",
        style: K(n(s))
      }, [
        l("header", {
          class: "headline",
          style: K(n(r))
        }, [
          n(p).name ? (u(), b(n(z).SortTrigger, {
            key: 0,
            "sort-key": "name"
          }, {
            default: f(() => [
              $(c(n(t)("entity.name")), 1)
            ]),
            _: 1
          })) : y("", !0),
          n(p).kind ? (u(), b(n(z).SortTrigger, {
            key: 1,
            "sort-key": "kind"
          }, {
            default: f(() => [
              $(c(n(t)("entity.kind")), 1)
            ]),
            _: 1
          })) : y("", !0),
          n(p).address ? (u(), v("span", d0, c(n(t)("entity.address")), 1)) : y("", !0),
          n(p).uuid ? (u(), b(n(z).SortTrigger, {
            key: 3,
            "sort-key": "uuid"
          }, {
            default: f(() => [
              $(c(n(t)("entity.uuid")), 1)
            ]),
            _: 1
          })) : y("", !0)
        ], 4),
        (u(!0), v(I, null, te(n(h), (E) => (u(), b(Os, {
          key: E.uuid,
          contact: E
        }, {
          default: f(() => [
            l("button", {
              type: "button",
              class: "item grid grid-cols-subgrid not-first:border-t h-12 items-center px-6 gap-4",
              style: K(n(r))
            }, [
              n(p).name ? (u(), v("strong", {
                key: 0,
                class: "value text-left truncate max-w-64",
                title: E.name
              }, c(E.name), 9, m0)) : y("", !0),
              n(p).kind ? (u(), b(n(B), {
                key: 1,
                class: "justify-self-start"
              }, {
                default: f(() => [
                  $(c(n(t)(`contact.kind.${E.kind}`, E.kind)), 1)
                ]),
                _: 2
              }, 1024)) : y("", !0),
              n(p).address ? (u(), v("span", {
                key: 2,
                class: "text-left truncate",
                title: n(oi)(E)
              }, c(n(oi)(E)), 9, p0)) : y("", !0),
              n(p).uuid ? (u(), b(n(Pt), {
                key: 3,
                class: "max-w-32",
                value: E.uuid
              }, null, 8, ["value"])) : y("", !0)
            ], 4)
          ]),
          _: 2
        }, 1032, ["contact"]))), 128)),
        n(h).length ? y("", !0) : (u(), v("p", f0, c(n(t)("contact.empty")), 1))
      ], 4)
    ]));
  }
}), g0 = { title: "Skupina kontaktů", placeholder: "Vyberte skupinu kontaktů", dialog: { title: "Detail skupiny kontaktů", description: "", create: "Vytvořit novou skupinu kontaktů", edit: "Upravit skupinu kontaktů", confirmDelete: "Opravdu chcete smazat tuto skupinu kontaktů?" }, search: "Hledat skupinu", empty: "Hledání neodpovídá žádná skupina." }, v0 = { title: "Skupiny kontaktů", config: { title: "Správa skupin kontaktů", description: "Zde můžete vytvářet a spravovat své skupiny kontaktů." } }, b0 = {
  contactGroup: g0,
  contactGroups: v0
}, y0 = { title: "Contact Group", placeholder: "Select a contact group", dialog: { title: "Contact Group Detail", description: "", create: "Create Contact Group", edit: "Edit Contact Group", confirmDelete: "Are you sure you want to delete this contact group?" }, search: "Search group", empty: "No contact group matches the search." }, h0 = { title: "Contact Groups", config: { title: "Manage Contact Groups", description: "Create and manage your contact groups here." } }, _0 = {
  contactGroup: y0,
  contactGroups: h0
}, $0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cs: b0,
  en: _0
}, Symbol.toStringTag, { value: "Module" }));
function S0(e) {
  return We(e, ze, {
    path: "contact-groups",
    itemSchema: pt,
    ...qe()
  });
}
function k0(e) {
  Object.defineProperty(ze, "create", {
    value: async (t) => e.save(pt.encode(Bn.parse(t))),
    configurable: !0
  }), Object.defineProperty(ze, "update", {
    value: async (t) => e.save(pt.encode(t)),
    configurable: !0
  }), Object.defineProperty(ze, "remove", {
    value: async (t) => e.remove(t),
    configurable: !0
  });
}
const w0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bindActions: k0,
  createEndpoint: S0
}, Symbol.toStringTag, { value: "Module" })), i8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ContactsCodec: Hr,
  DEFAULT_SORT: wn,
  Detail: Ge,
  DetailCodec: pt,
  DetailMessage: qr,
  Dialog: ts,
  FormData: Bn,
  ICON: Na,
  ListMessage: Kr,
  RemoveMessage: Wr,
  RemovedMessage: Zr,
  Root: Ga,
  SCOPE: Gr,
  Select: ns,
  SetMessage: Mo,
  Store: Fa,
  Table: vl,
  i18n: $0,
  rest: w0,
  seed: Ba,
  service: ze,
  state$: Yr,
  useDetail: Jr,
  useForm: Xr,
  useState: sn
}, Symbol.toStringTag, { value: "Module" })), x0 = { class: "headline" }, C0 = "contacts", T0 = /* @__PURE__ */ C({
  __name: "Config",
  setup(e) {
    const { t } = R({ useScope: "global" }), { count: o } = Ot(), { count: a } = sn(), s = q(C0);
    return (r, d) => (u(), v(I, null, [
      m(n(J), { class: "pb-0" }, {
        title: f(() => [
          l("h1", x0, c(n(t)("contacts.config.title")), 1),
          m(n(B), null, {
            default: f(() => [
              $(c(s.value === "contacts" ? n(o) : n(a)), 1)
            ]),
            _: 1
          }),
          d[1] || (d[1] = l("span", { class: "grow" }, null, -1)),
          s.value === "contacts" ? (u(), b(Os, { key: 0 })) : s.value === "contactGroups" ? (u(), b(ts, { key: 1 })) : y("", !0)
        ]),
        _: 1
      }),
      m(n(ee).Root, {
        modelValue: s.value,
        "onUpdate:modelValue": d[0] || (d[0] = (p) => s.value = p),
        class: "grid grid-rows-[max-content_1fr]",
        "unmount-on-hide": ""
      }, {
        default: f(() => [
          m(n(ee).List, { class: "flex gap-6 items-center justify-center relative border-b" }, {
            default: f(() => [
              m(n(ee).Trigger, {
                value: "contacts",
                class: "btn",
                "aria-label": n(t)("contacts.config.title")
              }, {
                default: f(() => [
                  m(n(D), {
                    icon: Gn,
                    class: "mr-2"
                  }, null, 8, ["icon"]),
                  $(" " + c(n(t)("contacts.title")), 1)
                ]),
                _: 1
              }, 8, ["aria-label"]),
              m(n(ee).Trigger, {
                value: "contactGroups",
                class: "btn",
                "aria-label": n(t)("contactGroups.config.title")
              }, {
                default: f(() => [
                  m(n(D), {
                    icon: Na,
                    class: "mr-2"
                  }, null, 8, ["icon"]),
                  $(" " + c(n(t)("contactGroups.title")), 1)
                ]),
                _: 1
              }, 8, ["aria-label"]),
              m(n(ee).Indicator, { class: "absolute px-8 left-0 h-1.25 bg-accent-blue bottom-0 w-(--reka-tabs-indicator-size) translate-x-(--reka-tabs-indicator-position) translate-y-0.75 rounded-full transition-[width,transform] duration-300" }, {
                default: f(() => [...d[2] || (d[2] = [
                  l("div", { class: "bg-grass8 w-full h-full" }, null, -1)
                ])]),
                _: 1
              })
            ]),
            _: 1
          }),
          m(n(ee).Content, {
            value: "contacts",
            class: "pt-6 pb-12"
          }, {
            default: f(() => [
              m($u)
            ]),
            _: 1
          }),
          m(n(ee).Content, {
            value: "contactGroups",
            class: "pt-6 pb-12"
          }, {
            default: f(() => [
              m(vl)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 64));
  }
}), R0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Config: T0
}, Symbol.toStringTag, { value: "Module" })), r8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CreateFormData: qn,
  DEFAULT_KIND: u_,
  DEFAULT_SORT: xn,
  Detail: Pe,
  DetailBase: Hn,
  DetailMessage: sl,
  Dialog: Os,
  EmailDetail: Kn,
  EmailFormData: Za,
  EmailMessageKind: tl,
  EmailProps: Ka,
  FormData: Wn,
  ICON: Gn,
  Kind: Ve,
  KindBadge: fl,
  Label: es,
  ListMessage: al,
  MessageData: Xt,
  MessageKind: ol,
  Picker: gl,
  RemoveMessage: il,
  RemovedMessage: rl,
  Root: OT,
  SCOPE: Qr,
  Select: o0,
  SelectKind: As,
  SetMessage: Eo,
  SmsDetail: At,
  SmsFormData: Ya,
  SmsMessageKind: el,
  SmsProps: Ha,
  Store: Wa,
  Table: $u,
  TelegramDetail: rn,
  TelegramFormData: Ja,
  TelegramMessageKind: nl,
  TelegramProps: qa,
  i18n: PT,
  rest: AT,
  seed: Qa,
  service: Ne,
  state$: ll,
  useDetail: ml,
  useForm: pl,
  useKind: Zn,
  useState: Ot,
  views: R0
}, Symbol.toStringTag, { value: "Module" })), D0 = { title: "Událost", dialog: { confirmDelete: "Opravdu chcete smazat tuto událost?", trigger: "Vyvolat událost", triggerDescription: "Simulovat stisknutí tlačítka", rssi: "RSSI" }, select: { placeholder: "Vyberte událost", kind: "Typ události" }, advertisement: "Varování", buttonPressed: "Tlačítko stisknuto", buttonDoublePressed: "Tlačítko dvojitě stisknuto", buttonTriplePressed: "Tlačítko třikrát stisknuto", buttonLongPressed: "Tlačítko dlouze stisknuto", buttonHold: "Tlačítko podrženo", batteryLow: "Slabá baterie" }, M0 = { title: "Události" }, E0 = {
  event: D0,
  events: M0
}, P0 = { title: "Event", dialog: { confirmDelete: "Are you sure you want to delete this event?", trigger: "Trigger Event", triggerDescription: "Simulate a button press event", rssi: "RSSI" }, select: { placeholder: "Select event", kind: "Event kind" }, advertisement: "Advertisement", buttonPressed: "Button pressed", buttonDoublePressed: "Button double pressed", buttonTriplePressed: "Button triple pressed", buttonLongPressed: "Button long pressed", buttonHold: "Button hold", batteryLow: "Low battery" }, L0 = { title: "Events" }, j0 = {
  event: P0,
  events: L0
}, A0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cs: E0,
  en: j0
}, Symbol.toStringTag, { value: "Module" })), En = Ll(), fn = le({
  name: er,
  identity: ga
}).withSources(
  async function* (t) {
    for await (const o of t) {
      const a = ar.safeParse(o);
      a.success && (yield () => a.data);
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = sr.safeParse(o);
      a.success && (En.note({ uuid: a.data.uuid, detail: a.data }), yield (s) => new Map(s ?? []).set(a.data.uuid, a.data));
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = rr.safeParse(o);
      a.success && (En.note({ uuid: a.data, detail: null }), yield (s) => {
        const r = new Map(s ?? []);
        return r.delete(a.data), r;
      });
    }
  }
).withActions({
  remove(e, t) {
    e.send(ir.encode(t));
  }
});
let Ko = null;
function O0(e) {
  return We(e, fn, {
    path: "events",
    itemSchema: on,
    ...qe(),
    // A press card must never disappear: not to the socket racing a fetch, nor to one
    // unreadable event (a kind newer than this bundle) failing the list.
    live: En,
    skipUnreadable: !0
  });
}
function U0(e) {
  Object.defineProperty(fn, "remove", {
    value: async (t) => e.remove(t),
    configurable: !0
  });
}
function V0(e) {
  Ko = e;
}
async function Su(e) {
  if (!Ko) throw new Error("Event REST client not initialized");
  return Ko.post("events/trigger", e, on);
}
const I0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bindActions: U0,
  createEndpoint: O0,
  init: V0,
  trigger: Su
}, Symbol.toStringTag, { value: "Module" })), ku = x.from(fn).pipe(x.shareReplay(1));
function z0({ exclude: e, include: t }) {
  return function(a) {
    return t && t.size > 0 ? t.has(a.kind) : e && e.size > 0 ? !e.has(a.kind) : !0;
  };
}
function N0(e) {
  const t = (o) => or.has(o.kind);
  return [...e.filter((o) => !t(o)), ...e.filter(t)];
}
const F0 = /* @__PURE__ */ new Set([Lt.enum.advertisement]), B0 = /* @__PURE__ */ new Set([]);
function Us(e = {}) {
  const t = k(() => A(e.sort) ?? [tr]), o = Z(ku, { onError: U.error, initialValue: /* @__PURE__ */ new Map() }), a = k(() => ne(o.value.values(), Y(A(t)))), s = k(() => ne(o.value.values(), ot([z0({ exclude: F0, include: B0 })]), Y(A(t)))), r = k(() => N0(s.value));
  return {
    count: k(() => me(o.value.size, s.value.length)),
    state: o,
    list: s,
    dashboard: r,
    all: a
  };
}
function ao(e) {
  const { t } = R({ useScope: "global" }), { state: o } = Us(), a = k(() => {
    const S = A(e);
    return S ? o.value.get(S) ?? null : null;
  }), { detail: s } = Ls(() => a.value?.device ?? ""), { detail: r } = Ms(() => a.value?.scanner ?? ""), { detail: d } = Cs(() => r.value?.room ?? ""), { detail: p } = Ts(() => d.value?.location ?? ""), g = k(() => a.value ? t(`event.${a.value.kind}`, "") : "");
  return {
    detail: a,
    device: s,
    scanner: r,
    room: d,
    location: p,
    remove: H(() => fn.remove(dt.parse(a.value).uuid)),
    kindLabel: g
  };
}
function wu() {
  return {
    trigger: H((e) => Su(e))
  };
}
const G0 = /* @__PURE__ */ C({
  __name: "Root",
  props: {
    uuid: {}
  },
  setup(e) {
    const t = e, { detail: o, device: a, scanner: s, room: r, location: d, kindLabel: p, remove: g } = ao(() => t.uuid);
    return (S, h) => P(S.$slots, "default", {
      detail: n(o),
      device: n(a),
      scanner: n(s),
      room: n(r),
      location: n(d),
      kindLabel: n(p),
      remove: n(g)
    });
  }
}), Vs = /* @__PURE__ */ C({
  __name: "IconByKind",
  props: {
    kind: {}
  },
  setup(e) {
    return (t, o) => (u(), b(n(D), {
      icon: nr[e.kind]
    }, null, 8, ["icon"]));
  }
}), H0 = {
  type: "button",
  class: "btn btn-filled btn-accent-blue p-3 h-auto rounded-md shadow-md grid grid-cols-[auto_1fr_auto] gap-x-3 gap-y-0 justify-items-start items-center"
}, K0 = { class: "col-start-2 value" }, q0 = { class: "col-start-2 text-sm" }, xu = /* @__PURE__ */ C({
  __name: "Card",
  props: {
    event: {}
  },
  setup(e) {
    const t = e, { device: o, kindLabel: a } = ao(() => t.event.uuid);
    return (s, r) => (u(), v("button", H0, [
      m(Vs, {
        class: "size-6 mx-3 row-span-2",
        kind: e.event.kind
      }, null, 8, ["kind"]),
      l("figcaption", K0, c(n(a)), 1),
      l("span", q0, c(n(o)?.name), 1)
    ]));
  }
}), W0 = { class: "list" }, Z0 = /* @__PURE__ */ C({
  __name: "Cards",
  props: {
    events: {}
  },
  setup(e) {
    return (t, o) => (u(), v("div", W0, [
      (u(!0), v(I, null, te(e.events, (a, s) => P(t.$slots, "event", {
        key: a.uuid,
        event: a,
        index: s
      }, () => [
        m(xu, { event: a }, null, 8, ["event"])
      ])), 128)),
      P(t.$slots, "default")
    ]));
  }
});
function Y0(e, t, o) {
  return {
    alarm: e,
    event: t,
    location: o.location ?? "",
    room: o.room ?? "",
    scanner: o.scanner ?? "",
    device: o.device ?? ""
  };
}
const J0 = { class: "px-6 flex gap-3" }, X0 = {
  key: 0,
  class: "mt-6 px-6 flex flex-wrap gap-3"
}, Q0 = ["disabled", "onClick"], eR = { class: "flex gap-4 justify-between p-6" }, tR = ["onClick"], nR = ["onClick"], oR = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "Dialog",
  props: {
    detail: {}
  },
  setup(e) {
    const t = e, { t: o } = R({ useScope: "global" }), a = Oe(), { device: s, scanner: r, room: d, location: p, kindLabel: g, remove: S } = ao(() => t.detail.uuid), { list: h } = jt(), { state: _, startAlarm: w } = an();
    async function E(M, V) {
      w.ongoing.value || await w.submit(
        Y0(M, t.detail.uuid, {
          location: p.value?.name,
          room: d.value?.name,
          scanner: r.value?.name,
          device: s.value?.name
        })
      ) && V();
    }
    function O(M) {
      return Xo(o("event.dialog.confirmDelete", ""), async () => {
        await S.submit() && M?.();
      });
    }
    return (M, V) => (u(), b(n(T).Root, null, {
      default: f(({ close: N }) => [
        m(n(T).Trigger, { "as-child": "" }, {
          default: f(() => [
            P(M.$slots, "default")
          ]),
          _: 3
        }),
        m(n(T).Portal, null, {
          default: f(() => [
            m(n(T).Overlay, { class: "overlay" }),
            m(n(T).Content, {
              class: "dialog",
              as: "form"
            }, {
              default: f(() => [
                m(n(J), null, {
                  title: f(() => [
                    m(Vs, {
                      class: "size-6 mx-3 row-span-2",
                      kind: e.detail.kind
                    }, null, 8, ["kind"]),
                    m(n(T).Title, { class: "headline grow" }, {
                      default: f(() => [
                        $(c(n(g)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  description: f(() => [
                    m(n(T).Description, { class: "description" }, {
                      default: f(() => [
                        $(c(n(o)("device.dialog.description", "")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  row: f(() => [
                    m(n(Ue), { entity: e.detail }, null, 8, ["entity"])
                  ]),
                  _: 1
                }),
                l("div", J0, [
                  m(n(gr), {
                    location: n(p)?.name,
                    room: n(d)?.name,
                    scanner: n(r)?.name,
                    device: n(s)?.name
                  }, {
                    default: f(({ delimiter: F, rest: oe, last: yt }) => [
                      m(n(B), { class: "px-6 text-center grow" }, {
                        default: f(() => [
                          oe.length ? (u(), v(I, { key: 0 }, [
                            $(c(oe + F), 1)
                          ], 64)) : y("", !0),
                          l("strong", null, c(yt), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  }, 8, ["location", "room", "scanner", "device"]),
                  m(n(B), null, {
                    default: f(() => [
                      $(c(n(a).dateTime.format(e.detail.timestamp)), 1)
                    ]),
                    _: 1
                  })
                ]),
                n(_) ? y("", !0) : (u(), v("div", X0, [
                  (u(!0), v(I, null, te(n(h), (F) => (u(), v("button", {
                    key: F.uuid,
                    type: "button",
                    class: "btn btn-filled",
                    disabled: n(w).ongoing.value,
                    onClick: (oe) => E(F.uuid, N)
                  }, c(F.name), 9, Q0))), 128))
                ])),
                l("div", eR, [
                  l("button", {
                    class: "btn text-accent-red",
                    type: "button",
                    onClick: (F) => O(N)
                  }, [
                    m(n(D), { icon: "delete" }),
                    $(" " + c(n(o)("action.delete")), 1)
                  ], 8, tR),
                  l("button", {
                    class: "btn",
                    type: "button",
                    onClick: (F) => N()
                  }, [
                    m(n(D), { icon: "close" }),
                    $(" " + c(n(o)("action.close")), 1)
                  ], 8, nR)
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }));
  }
}), Is = /* @__PURE__ */ C({
  __name: "EventKindSelect",
  props: /* @__PURE__ */ ve({
    exclude: { default: () => [] }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = Q(e, "modelValue"), { t: o } = R({ useScope: "global" }), a = /* @__PURE__ */ new Set(["advertisement", "operator", ...e.exclude]), s = Lt.options.filter((r) => !a.has(r)).map((r) => ({
      label: o(`event.${r}`),
      value: r
    }));
    return (r, d) => (u(), b(n(re), {
      modelValue: t.value,
      "onUpdate:modelValue": d[0] || (d[0] = (p) => t.value = p),
      options: n(s),
      placeholder: n(o)("event.select.kind")
    }, null, 8, ["modelValue", "options", "placeholder"]));
  }
}), aR = /* @__PURE__ */ C({
  __name: "Select",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Q(e, "modelValue"), { t: o } = R({ useScope: "global" }), { list: a } = Us({ sort: [{ key: "name", direction: W.enum.Ascending }] }), { options: s } = et({ options: a });
    return (r, d) => (u(), b(n(re), {
      modelValue: t.value,
      "onUpdate:modelValue": d[0] || (d[0] = (p) => t.value = p),
      options: n(s),
      placeholder: n(o)("event.select.placeholder")
    }, null, 8, ["modelValue", "options", "placeholder"]));
  }
}), sR = { class: "px-6 grid gap-4" }, iR = {
  class: "label",
  for: "trigger-event-kind"
}, rR = { class: "label-text" }, lR = {
  class: "label",
  for: "trigger-event-scanner"
}, cR = { class: "label-text" }, uR = {
  class: "label",
  for: "trigger-event-device"
}, dR = { class: "label-text" }, mR = {
  class: "label",
  for: "trigger-event-rssi"
}, pR = { class: "label-text" }, fR = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "TriggerDialog",
  setup(e) {
    const { t } = R({ useScope: "global" }), o = Se(p()), a = k(() => !!(o.kind && o.scanner && o.device)), { trigger: s } = wu();
    function r(g) {
      a.value && s.submit({
        kind: o.kind,
        scanner: o.scanner,
        device: o.device,
        rssi: o.rssi
      }).then(g);
    }
    function d() {
      Object.assign(o, p());
    }
    function p() {
      return {
        scanner: "",
        device: "",
        kind: void 0,
        rssi: -50
      };
    }
    return (g, S) => (u(), b(n(T).Root, {
      "onUpdate:open": S[5] || (S[5] = (h) => d())
    }, {
      default: f(({ close: h }) => [
        m(n(T).Trigger, { "as-child": "" }, {
          default: f(() => [
            P(g.$slots, "trigger", {}, () => [
              l("button", ae({
                type: "button",
                class: "btn"
              }, g.$attrs), [
                m(n(D), { icon: "add" })
              ], 16)
            ])
          ]),
          _: 3
        }),
        m(n(T).Portal, null, {
          default: f(() => [
            m(n(T).Overlay, { class: "overlay" }),
            m(n(T).Content, {
              class: "dialog",
              as: "form",
              onSubmit: X((_) => r(h), ["prevent"])
            }, {
              default: f(() => [
                m(n(J), null, {
                  title: f(() => [
                    m(n(D), {
                      class: "size-8",
                      icon: Qi
                    }, null, 8, ["icon"]),
                    m(n(T).Title, { class: "headline" }, {
                      default: f(() => [
                        $(c(n(t)("event.dialog.trigger", "")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  description: f(() => [
                    m(n(T).Description, { class: "description" }, {
                      default: f(() => [
                        $(c(n(t)("event.dialog.triggerDescription", "")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                l("div", sR, [
                  l("label", iR, [
                    l("span", rR, c(n(t)("event.select.kind")), 1),
                    m(Is, {
                      id: "trigger-event-kind",
                      modelValue: o.kind,
                      "onUpdate:modelValue": S[0] || (S[0] = (_) => o.kind = _),
                      class: "w-full",
                      exclude: ["batteryLow"]
                    }, null, 8, ["modelValue"])
                  ]),
                  l("label", lR, [
                    l("span", cR, c(n(t)("scanner.title")), 1),
                    m(Es, {
                      id: "trigger-event-scanner",
                      modelValue: o.scanner,
                      "onUpdate:modelValue": S[1] || (S[1] = (_) => o.scanner = _),
                      class: "w-full"
                    }, null, 8, ["modelValue"])
                  ]),
                  l("label", uR, [
                    l("span", dR, c(n(t)("device.title")), 1),
                    m(js, {
                      id: "trigger-event-device",
                      modelValue: o.device,
                      "onUpdate:modelValue": S[2] || (S[2] = (_) => o.device = _),
                      class: "w-full"
                    }, null, 8, ["modelValue"])
                  ]),
                  l("label", mR, [
                    l("span", pR, c(n(t)("event.dialog.rssi", "RSSI")), 1),
                    L(l("input", {
                      id: "trigger-event-rssi",
                      "onUpdate:modelValue": S[3] || (S[3] = (_) => o.rssi = _),
                      type: "number",
                      class: "input w-full",
                      min: "-100",
                      max: "0"
                    }, null, 512), [
                      [
                        j,
                        o.rssi,
                        void 0,
                        { number: !0 }
                      ]
                    ])
                  ])
                ]),
                m(n(he), {
                  class: "px-6",
                  onCancel: S[4] || (S[4] = (_) => d()),
                  onClose: h
                }, null, 8, ["onClose"])
              ]),
              _: 2
            }, 1032, ["onSubmit"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }));
  }
}), l8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Card: xu,
  Cards: Z0,
  DEFAULT_SORT: tr,
  Detail: dt,
  DetailMessage: sr,
  Dialog: oR,
  EventKind: Lt,
  EventKindSelect: Is,
  FormData: Ny,
  ICON: Qi,
  ICON_BY_KIND: nr,
  IconByKind: Vs,
  ListMessage: ar,
  MAINTENANCE_KINDS: or,
  MessageItem: on,
  RemoveMessage: ir,
  RemovedMessage: rr,
  Root: G0,
  SCOPE: er,
  Select: aR,
  Store: ga,
  TriggerDialog: fR,
  TriggerEventRequest: By,
  i18n: A0,
  live: En,
  rest: I0,
  service: fn,
  state$: ku,
  useDetail: ao,
  useState: Us,
  useTrigger: wu
}, Symbol.toStringTag, { value: "Module" })), gR = { title: "Příznaky funkcí", description: "Experimentální a diagnostické funkce, uložené jen v tomto prohlížeči", flags: { debug: { title: "Ladění", description: "Zobrazí UUID, MAC adresy, commity firmwaru a dialog pro ruční spuštění alarmu" }, trafficLog: { title: "Výpis provozu", description: "Vypisuje každou zprávu WebSocketu a aktualizaci služeb do konzole prohlížeče" }, audit: { title: "Auditní log", description: "Zobrazí stránku auditního logu a nastavení jeho uchování; server zaznamenává akce operátorů v každém případě" } } }, vR = {
  featureFlags: gR
}, bR = { title: "Feature flags", description: "Experimental and diagnostic features, stored in this browser only", flags: { debug: { title: "Debug mode", description: "Show UUIDs, MAC addresses, firmware commits and the manual alarm run dialog" }, trafficLog: { title: "Traffic log", description: "Log every WebSocket message and service update to the browser console" }, audit: { title: "Audit log", description: "Show the audit log page and its retention setting; the server records operator actions either way" } } }, yR = {
  featureFlags: bR
}, hR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cs: vR,
  en: yR
}, Symbol.toStringTag, { value: "Module" })), _R = { class: "headline" }, $R = { class: "list grid grid-cols-[max-content_max-content_minmax(0,1fr)] content-start pb-12" }, SR = ["for"], kR = { class: "whitespace-nowrap" }, wR = ["title"], xR = /* @__PURE__ */ C({
  __name: "Config",
  setup(e) {
    const { t } = R({ useScope: "global" }), o = Yv(), a = Ct("page"), s = ql.map((r) => ({ flag: r, state: Ct(r) }));
    return De(a, async (r) => {
      r || await o.replace({ name: await fr() ?? "dashboard" });
    }), (r, d) => (u(), v(I, null, [
      m(n(J), {
        description: n(t)("featureFlags.description", "")
      }, {
        title: f(() => [
          l("h1", _R, c(n(t)("featureFlags.title")), 1)
        ]),
        _: 1
      }, 8, ["description"]),
      l("form", $R, [
        (u(!0), v(I, null, te(n(s), ({ flag: p, state: g }) => (u(), v("label", {
          key: p,
          class: "grid grid-cols-subgrid col-span-3 items-center gap-4 h-10 px-6 not-first:border-t",
          for: `feature-flag-${p}`
        }, [
          m(n(ie).Root, {
            id: `feature-flag-${p}`,
            modelValue: g.value,
            "onUpdate:modelValue": (S) => g.value = S,
            class: "btn switch"
          }, {
            default: f(() => [
              m(n(ie).Thumb, { class: "thumb" })
            ]),
            _: 1
          }, 8, ["id", "modelValue", "onUpdate:modelValue"]),
          l("strong", kR, c(n(t)(`featureFlags.flags.${p}.title`)), 1),
          l("small", {
            class: "truncate text-secondary",
            title: n(t)(`featureFlags.flags.${p}.description`)
          }, c(n(t)(`featureFlags.flags.${p}.description`)), 9, wR)
        ], 8, SR))), 128))
      ])
    ], 64));
  }
}), CR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Config: xR
}, Symbol.toStringTag, { value: "Module" })), c8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ICON: Kl,
  TOGGLEABLE: ql,
  i18n: hR,
  views: CR
}, Symbol.toStringTag, { value: "Module" })), TR = { title: "Vazba události", dialog: { title: "Detail vazby události", description: "", create: "Vytvořit vazbu události", edit: "Upravit vazbu události", confirmDelete: "Opravdu chcete smazat tuto vazbu události?" }, select: { user: "Vyberte uživatele" } }, RR = { config: { title: "Vazby událostí", description: "Nastavte, které notifikace se odesílají pro jednotlivé typy událostí" } }, DR = {
  eventMapping: TR,
  eventMappings: RR
}, MR = { title: "Event Mapping", dialog: { title: "Event Mapping Detail", description: "", create: "Create event mapping", edit: "Edit event mapping", confirmDelete: "Are you sure you want to delete this event mapping?" }, select: { user: "Select user" } }, ER = { config: { title: "Event Mappings", description: "Configure which notifications are sent for each event type" } }, PR = {
  eventMapping: MR,
  eventMappings: ER
}, LR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cs: DR,
  en: PR
}, Symbol.toStringTag, { value: "Module" }));
let qo = null;
const He = fe(/* @__PURE__ */ new Map());
function jR(e) {
  qo = e;
}
function zs() {
  if (!qo) throw new Error("EventMapping REST client not initialized. Call init() first.");
  return qo;
}
async function Cu(e) {
  const o = await zs().get("event-mappings", i.array(Rt), e);
  return He.value = new Map(
    o.map((a) => {
      const s = ds(a);
      return [s.eventKind, s];
    })
  ), He.value;
}
async function Tu(e, t) {
  const a = await zs().post("event-mappings", Gl(e), Rt, t), s = ds(a), r = new Map(He.value);
  return r.set(s.eventKind, s), He.value = r, s;
}
async function Ru(e, t) {
  const o = zs(), a = e.charAt(0).toUpperCase() + e.slice(1);
  await o.delete(`event-mappings/${a}`, t);
  const s = new Map(He.value);
  s.delete(e), He.value = s;
}
const AR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchAll: Cu,
  init: jR,
  remove: Ru,
  save: Tu,
  store: He
}, Symbol.toStringTag, { value: "Module" }));
function Du() {
  const e = He, t = k(() => Array.from(e.value.values()));
  return {
    count: k(() => `${e.value.size}`),
    state: e,
    list: t,
    refresh: Cu
  };
}
function OR(e) {
  const t = He;
  return { detail: k(() => t.value.get(A(e)) ?? null) };
}
function Mu({ input: e } = {}) {
  const { t } = R({ useScope: "global" });
  function o() {
    const _ = A(e);
    if (_) {
      const w = Rt.safeParse(_);
      if (w.success) return { ...w.data };
    }
    return Hl();
  }
  const a = Pn("formElement"), s = Se(o()), r = k(() => {
    const _ = A(e);
    return !!_ && !!_.eventKind;
  }), d = k(() => {
    const _ = o(), w = po({ ...s });
    return !Yo(_, w);
  }), p = k(() => r.value ? d.value ? t("eventMapping.dialog.edit", "") : t("eventMapping.dialog.title", "") : t("eventMapping.dialog.create", ""));
  async function g(_ = {}) {
    const w = Rt.parse(po({ ...s }));
    await Tu(w), r.value || _.created?.();
  }
  function S(_) {
    return Xo(t("eventMapping.dialog.confirmDelete", ""), () => Ru(s.eventKind), _);
  }
  function h() {
    Object.assign(s, o()), a.value?.reset();
  }
  return {
    data: s,
    element: a,
    isUpdate: r,
    hasChanges: d,
    title: p,
    save: H(g),
    remove: H(S),
    reset: h
  };
}
const UR = ["onSubmit"], VR = ["textContent"], IR = { class: "px-6 grid gap-4" }, zR = {
  class: "label",
  for: "mapping-event-kind"
}, NR = { class: "label-text" }, FR = {
  class: "label",
  for: "mapping-notification"
}, BR = { class: "label-text" }, GR = {
  class: "label",
  for: "mapping-contact-group"
}, HR = { class: "label-text" }, KR = {
  class: "label",
  for: "mapping-user"
}, qR = { class: "label-text" }, Ns = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "Dialog",
  props: {
    mapping: {}
  },
  setup(e) {
    const t = e, { t: o } = R({ useScope: "global" }), a = Mu({ input: () => t.mapping }), s = k({
      get: () => a.data.eventKind || void 0,
      set: (r) => {
        a.data.eventKind = r ?? "";
      }
    });
    return (r, d) => (u(), b(n(T).Root, {
      "onUpdate:open": d[5] || (d[5] = (p) => n(a).reset())
    }, {
      default: f(({ close: p }) => [
        m(n(T).Trigger, { "as-child": "" }, {
          default: f(() => [
            P(r.$slots, "default", {}, () => [
              l("button", ae({
                type: "button",
                class: "btn"
              }, r.$attrs), [
                e.mapping ? (u(), b(n(D), {
                  key: 0,
                  icon: "edit"
                })) : (u(), b(n(D), {
                  key: 1,
                  icon: "add"
                }))
              ], 16)
            ])
          ]),
          _: 3
        }),
        m(n(T).Portal, null, {
          default: f(() => [
            m(n(T).Overlay, { class: "overlay" }),
            m(n(T).Content, {
              class: "dialog",
              "as-child": ""
            }, {
              default: f(() => [
                l("form", {
                  ref: "formElement",
                  onSubmit: X((g) => n(a).save.submit({ created: p }), ["prevent"])
                }, [
                  m(n(J), {
                    icon: us
                  }, {
                    title: f(() => [
                      m(n(T).Title, { class: "headline grow" }, {
                        default: f(() => [
                          l("span", {
                            textContent: c(n(a).title)
                          }, null, 8, VR)
                        ]),
                        _: 1
                      })
                    ]),
                    description: f(() => [
                      m(n(T).Description, { class: "paragraph description" }, {
                        default: f(() => [
                          $(c(n(o)("eventMapping.dialog.description", "")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["icon"]),
                  l("div", IR, [
                    l("label", zR, [
                      l("span", NR, c(n(o)("event.select.kind")), 1),
                      m(Is, {
                        id: "mapping-event-kind",
                        modelValue: s.value,
                        "onUpdate:modelValue": d[0] || (d[0] = (g) => s.value = g),
                        class: "input w-full"
                      }, null, 8, ["modelValue"])
                    ]),
                    l("label", FR, [
                      l("span", BR, c(n(o)("entity.notification")), 1),
                      m(za, {
                        id: "mapping-notification",
                        modelValue: n(a).data.notificationUuid,
                        "onUpdate:modelValue": d[1] || (d[1] = (g) => n(a).data.notificationUuid = g),
                        class: "input w-full"
                      }, null, 8, ["modelValue"])
                    ]),
                    l("label", GR, [
                      l("span", HR, c(n(o)("entity.contactGroup")), 1),
                      m(ns, {
                        id: "mapping-contact-group",
                        modelValue: n(a).data.contactGroupUuid,
                        "onUpdate:modelValue": d[2] || (d[2] = (g) => n(a).data.contactGroupUuid = g),
                        class: "w-full"
                      }, null, 8, ["modelValue"])
                    ]),
                    l("label", KR, [
                      l("span", qR, c(n(o)("config.notification.user.title")), 1),
                      m(_u, {
                        id: "mapping-user",
                        modelValue: n(a).data.userUuid,
                        "onUpdate:modelValue": d[3] || (d[3] = (g) => n(a).data.userUuid = g),
                        class: "w-full"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  m(n(he), {
                    class: "px-6",
                    "has-data": n(a).isUpdate.value,
                    "has-changes": n(a).hasChanges.value,
                    onClose: p,
                    onRemove: (g) => n(a).remove.submit(p),
                    onUndo: d[4] || (d[4] = (g) => n(a).reset())
                  }, null, 8, ["has-data", "has-changes", "onClose", "onRemove"])
                ], 40, UR)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }));
  }
}), WR = { class: "value text-left" }, ZR = { class: "value text-left font-normal" }, YR = { class: "value text-left font-normal truncate" }, Eu = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "ListItem",
  props: {
    mapping: {}
  },
  setup(e) {
    const t = e, { t: o } = R({ useScope: "global" }), { detail: a } = Yi(() => t.mapping.userUuid), s = k(() => a.value?.username || t.mapping.userUuid || "-");
    return (r, d) => (u(), b(Ns, { mapping: e.mapping }, {
      default: f(() => [
        l("button", ae({
          type: "button",
          class: "item grid grid-cols-4 not-first:border-t h-12 items-center px-6 gap-4"
        }, r.$attrs), [
          l("strong", WR, c(n(o)(`event.${e.mapping.eventKind}`, e.mapping.eventKind)), 1),
          m(Oa, {
            class: "value text-left font-normal",
            uuid: e.mapping.notificationUuid
          }, null, 8, ["uuid"]),
          l("span", ZR, [
            m(Ga, {
              uuid: e.mapping.contactGroupUuid
            }, {
              default: f(({ detail: p }) => [
                $(c(p?.name || "-"), 1)
              ]),
              _: 1
            }, 8, ["uuid"])
          ]),
          l("span", YR, c(s.value), 1)
        ], 16)
      ]),
      _: 1
    }, 8, ["mapping"]));
  }
}), JR = { class: "list grid content-start" }, XR = { class: "headline grid grid-cols-4 gap-4 px-6" }, Pu = /* @__PURE__ */ C({
  __name: "List",
  props: {
    mappings: {}
  },
  setup(e) {
    const { t } = R({ useScope: "global" });
    return (o, a) => (u(), v("section", JR, [
      l("header", XR, [
        l("span", null, c(n(t)("event.select.kind")), 1),
        l("span", null, c(n(t)("entity.notification")), 1),
        l("span", null, c(n(t)("entity.contactGroup")), 1),
        l("span", null, c(n(t)("config.notification.user.title")), 1)
      ]),
      (u(!0), v(I, null, te(e.mappings, (s) => (u(), b(Eu, {
        key: s.eventKind,
        mapping: s
      }, null, 8, ["mapping"]))), 128)),
      P(o.$slots, "default")
    ]));
  }
}), QR = { class: "headline" }, eD = /* @__PURE__ */ C({
  __name: "Config",
  setup(e) {
    const { t } = R({ useScope: "global" }), { count: o, list: a } = Du();
    return (s, r) => (u(), v(I, null, [
      m(n(J), {
        description: n(t)("eventMappings.config.description", "")
      }, {
        title: f(() => [
          l("h1", QR, c(n(t)("eventMappings.config.title")), 1),
          m(n(B), null, {
            default: f(() => [
              $(c(n(o)), 1)
            ]),
            _: 1
          }),
          r[0] || (r[0] = l("span", { class: "grow" }, null, -1)),
          m(n(Ns))
        ]),
        _: 1
      }, 8, ["description"]),
      m(n(Pu), { mappings: n(a) }, null, 8, ["mappings"])
    ], 64));
  }
}), tD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Config: eD
}, Symbol.toStringTag, { value: "Module" })), u8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Detail: Rt,
  Dialog: Ns,
  FormData: w1,
  ICON: us,
  List: Pu,
  ListItem: Eu,
  SCOPE: k1,
  fromApi: ds,
  i18n: LR,
  rest: AR,
  seed: Hl,
  toApi: Gl,
  useDetail: OR,
  useForm: Mu,
  useState: Du,
  views: tD
}, Symbol.toStringTag, { value: "Module" })), nD = { title: "Notifikace", dialog: { title: "Detail notifikace", description: "", create: "Vytvořit notifikaci", edit: "Upravit notifikaci", confirmDelete: "Opravdu chcete smazat tuto notifikaci?" }, unknown: "Neznámá notifikace", select: { placeholder: "Vyberte notifikaci" }, sms: { segments: "{count} SMS", ucs2Tooltip: "Zpráva obsahuje znaky mimo GSM 7-bit. Limit se snižuje na 70 znaků na SMS.", diacriticsWarning: "Diakritika snižuje limit SMS. Bude odstraněna při odeslání." } }, oD = { config: { title: "Notifikace", description: "Spravujte notifikace systému Evac" } }, aD = {
  notification: nD,
  notifications: oD
}, sD = { title: "Notification", dialog: { title: "Notification detail", description: "", create: "Create notification", edit: "Edit notification", confirmDelete: "Are you sure you want to delete this notification?" }, unknown: "Unknown notification", select: { placeholder: "Select notification" }, sms: { segments: "{count} SMS", ucs2Tooltip: "Message contains characters outside GSM 7-bit. Limit is reduced to 70 characters per SMS.", diacriticsWarning: "Diacritics reduce SMS limit. They will be stripped on send." } }, iD = { config: { title: "Notifications", description: "Manage notifications in the system" } }, rD = {
  notification: sD,
  notifications: iD
}, lD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cs: aD,
  en: rD
}, Symbol.toStringTag, { value: "Module" }));
function cD(e) {
  return We(e, Me, {
    path: "notifications",
    itemSchema: be,
    ...qe()
  });
}
function uD(e) {
  Object.defineProperty(Me, "create", {
    value: async (t) => e.save(zn.parse(t)),
    configurable: !0
  }), Object.defineProperty(Me, "update", {
    value: async (t) => e.save(be.parse(t)),
    configurable: !0
  }), Object.defineProperty(Me, "remove", {
    value: async (t) => e.remove(t),
    configurable: !0
  });
}
const dD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bindActions: uD,
  createEndpoint: cD
}, Symbol.toStringTag, { value: "Module" })), mD = { class: "headline" }, pD = /* @__PURE__ */ C({
  __name: "Config",
  setup(e) {
    const { t } = R({ useScope: "global" }), { enabled: o } = Ce(), a = je({ key: "name" }, { key: "uuid", visible: () => o.value }, { key: "subject", fill: !0 }), { sort: s } = Ae({ initialSort: Pa, fields: a }), { count: r, list: d } = Fn({ sort: s });
    return (p, g) => (u(), v(I, null, [
      m(n(J), {
        description: n(t)("notifications.config.description", "")
      }, {
        title: f(() => [
          l("h1", mD, c(n(t)("notifications.config.title")), 1),
          m(n(B), null, {
            default: f(() => [
              $(c(n(r)), 1)
            ]),
            _: 1
          }),
          g[0] || (g[0] = l("span", { class: "grow" }, null, -1)),
          m(Ia)
        ]),
        _: 1
      }, 8, ["description"]),
      m(Br, { notifications: n(d) }, null, 8, ["notifications"])
    ], 64));
  }
}), fD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Config: pD
}, Symbol.toStringTag, { value: "Module" })), d8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DEFAULT_SORT: Pa,
  Detail: be,
  DetailCodec: Nn,
  DetailMessage: Pr,
  Dialog: Ia,
  FormData: zn,
  ICON: Ea,
  List: Br,
  ListItem: Fr,
  ListMessage: Er,
  Name: Oa,
  RemoveMessage: Lr,
  RemovedMessage: jr,
  Root: Vr,
  SCOPE: Mr,
  Select: za,
  SendMessage: Ar,
  SetMessage: xo,
  Store: La,
  ToSend: wo,
  displayName: Jt,
  i18n: lD,
  rest: dD,
  seed: ja,
  service: Me,
  state$: Or,
  useDetail: Aa,
  useForm: Ur,
  useState: Fn,
  views: fD
}, Symbol.toStringTag, { value: "Module" })), gD = { title: "Zálohy", description: "Správa záloh a obnovení dat aplikace Evac", new: "Nová záloha", upload: "Nahrát zálohu", dumpOnly: "Jako zálohu lze nahrát jen soubory {extension}.", restoreWarnings: "Záloha byla obnovena, ale databáze část odmítla. Zkontrolujte log serveru, data mohou chybět." }, vD = {
  backups: gD
}, bD = { title: "Backups", description: "Manage backups and restore Evac application data", new: "New backup", upload: "Upload a backup", dumpOnly: "Only {extension} files can be uploaded as backups.", restoreWarnings: "The backup was restored, but the database refused some of it. Check the server log, data may be missing." }, yD = {
  backups: bD
}, hD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cs: vD,
  en: yD
}, Symbol.toStringTag, { value: "Module" }));
let Wo = null;
const Fs = fe([]);
function _D(e) {
  Wo = e;
}
function Ft() {
  if (!Wo) throw new Error("Backup REST client not initialized. Call init() first.");
  return Wo;
}
function so(e, t) {
  const o = `backups/${encodeURIComponent(e)}`;
  return t ? `${o}/${t}` : o;
}
async function io(e) {
  Fs.value = await Ft().get("backups", i.array(pc), e);
}
async function Lu(e) {
  await Ft().post("backups", { name: fc(e) }, i.unknown()), await io();
}
async function ju(e) {
  await Ft().delete(so(e)), await io();
}
async function Au(e) {
  const { warnings: t } = await Ft().post(so(e, "restore"), void 0, i.object({ warnings: i.boolean().default(!1) }));
  t && en("backups.restoreWarnings");
}
async function Ou(e) {
  const t = await Ft().getBlob(so(e)), o = URL.createObjectURL(t);
  try {
    const a = document.createElement("a");
    a.href = o, a.download = e, a.click();
  } finally {
    setTimeout(() => URL.revokeObjectURL(o), 6e4);
  }
}
async function Bs(e) {
  const t = new FormData();
  t.append("filename", e.name), t.append("file", e), await Ft().postForm("backups/upload", t), await io();
}
const $D = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  backupPath: so,
  backups: Fs,
  create: Lu,
  download: Ou,
  fetchAll: io,
  init: _D,
  remove: ju,
  restore: Au,
  upload: Bs
}, Symbol.toStringTag, { value: "Module" }));
function Uu() {
  const e = Oe(), t = k(() => Fs.value), o = k(() => ne(t.value, $d(e.sort.compare)));
  return {
    count: k(() => e.count(t.value.length, o.value.length)),
    list: o,
    all: t
  };
}
function Gs() {
  return {
    remove: H(ju),
    restore: H(Au),
    set: H(Lu),
    download: H(Ou),
    upload: H(Bs)
  };
}
const SD = { class: "bg-emphasis-1 rounded-md shadow-sm p-3 min-h-24 grid grid-cols-[1fr_auto_auto] gap-2 items-center" }, kD = ["title"], wD = ["disabled"], Vu = /* @__PURE__ */ C({
  __name: "Card",
  props: {
    backup: {}
  },
  setup(e) {
    const { t } = R({ useScope: "global" }), { remove: o, restore: a, download: s } = Gs();
    return (r, d) => (u(), v("figure", SD, [
      l("figcaption", {
        class: "value col-span-3 min-w-0 truncate",
        title: e.backup
      }, c(e.backup), 9, kD),
      l("button", {
        type: "button",
        class: "btn text-accent-red justify-self-end",
        onClick: d[0] || (d[0] = (p) => n(o).submit(e.backup))
      }, [
        m(n(D), { icon: "delete" }),
        $(" " + c(n(t)("action.delete")), 1)
      ]),
      l("button", {
        type: "button",
        class: "btn",
        disabled: n(s).ongoing.value,
        onClick: d[1] || (d[1] = (p) => n(s).submit(e.backup))
      }, [
        m(n(D), { icon: "download" }),
        $(" " + c(n(t)("action.download")), 1)
      ], 8, wD),
      l("button", {
        type: "button",
        class: "btn btn-filled",
        onClick: d[2] || (d[2] = (p) => n(a).submit(e.backup))
      }, [
        m(n(D), { icon: "settings_backup_restore" }),
        $(" " + c(n(t)("action.restore")), 1)
      ])
    ]));
  }
}), xD = { class: "grid gap-4 grid-cols-[repeat(auto-fill,minmax(18rem,1fr))] items-center list" }, Iu = /* @__PURE__ */ C({
  __name: "Cards",
  props: {
    backups: {}
  },
  setup(e) {
    return (t, o) => (u(), v("div", xD, [
      (u(!0), v(I, null, te(e.backups, (a) => (u(), b(Vu, {
        key: a,
        backup: a
      }, null, 8, ["backup"]))), 128)),
      P(t.$slots, "default")
    ]));
  }
}), CD = { class: "value col-span-2" }, TD = ["id"], RD = {
  type: "submit",
  class: "btn btn-filled"
}, zu = /* @__PURE__ */ C({
  __name: "Form",
  setup(e) {
    const { t } = R({ useScope: "global" }), { set: o } = Gs(), a = ri(), s = q("");
    yd(r);
    function r() {
      s.value = gc(/* @__PURE__ */ new Date());
    }
    return (d, p) => (u(), v("form", {
      class: "bg-emphasis-1 rounded-md shadow-sm p-3 min-h-24 grid grid-cols-[1fr_auto] gap-2 items-center",
      onSubmit: p[1] || (p[1] = X((g) => n(o).submit(s.value).then((S) => S && r()), ["prevent"]))
    }, [
      l("figcaption", CD, c(n(t)("backups.new")), 1),
      L(l("input", {
        id: n(a),
        "onUpdate:modelValue": p[0] || (p[0] = (g) => s.value = g),
        class: "input w-full",
        type: "text"
      }, null, 8, TD), [
        [j, s.value]
      ]),
      l("button", RD, [
        m(n(D), { icon: "add" }),
        $(" " + c(n(t)("action.create")), 1)
      ])
    ], 32));
  }
}), DD = { class: "bg-emphasis-1 rounded-md shadow-sm p-3 min-h-24 grid grid-cols-[1fr_auto] gap-2 items-center" }, MD = { class: "value col-span-2" }, ED = ["id", "accept", "disabled"], PD = ["for", "aria-disabled"], Nu = /* @__PURE__ */ C({
  __name: "Upload",
  setup(e) {
    const { t } = R({ useScope: "global" }), o = ri(), a = H((r) => {
      if (!Ss(r.name)) throw new Error(t("backups.dumpOnly", { extension: Dt }));
      return Bs(r);
    });
    function s(r) {
      const d = r.target, p = d.files?.[0];
      d.value = "", p && a.submit(p);
    }
    return (r, d) => (u(), v("div", DD, [
      l("span", MD, c(n(t)("backups.upload")), 1),
      l("input", {
        id: n(o),
        class: "sr-only",
        type: "file",
        accept: Dt,
        disabled: n(a).ongoing.value,
        onChange: s
      }, null, 40, ED),
      l("label", {
        for: n(o),
        class: "btn btn-filled col-start-2",
        "aria-disabled": n(a).ongoing.value
      }, [
        m(n(D), { icon: "upload" }),
        $(" " + c(n(t)("action.upload")), 1)
      ], 8, PD)
    ]));
  }
}), Fu = /* @__PURE__ */ C({
  __name: "Section",
  setup(e) {
    const { list: t } = Uu();
    return (o, a) => (u(), v("section", null, [
      m(Iu, { backups: n(t) }, {
        default: f(() => [
          m(zu),
          m(Nu)
        ]),
        _: 1
      }, 8, ["backups"])
    ]));
  }
}), LD = { class: "headline" }, jD = { class: "py-4" }, AD = /* @__PURE__ */ C({
  __name: "Config",
  setup(e) {
    const { t } = R({ useScope: "global" });
    return (o, a) => (u(), v(I, null, [
      m(n(J), {
        description: n(t)("backups.description", "")
      }, {
        title: f(() => [
          l("h1", LD, c(n(t)("backups.title")), 1)
        ]),
        _: 1
      }, 8, ["description"]),
      l("div", jD, [
        m(Fu, { class: "px-6" })
      ])
    ], 64));
  }
}), OD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Config: AD
}, Symbol.toStringTag, { value: "Module" })), m8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BACKUP_EXTENSION: Dt,
  Card: Vu,
  Cards: Iu,
  Detail: pc,
  Form: zu,
  ICON: mc,
  Section: Fu,
  Upload: Nu,
  defaultBackupName: gc,
  i18n: hD,
  isBackupName: Ss,
  rest: $D,
  toBackupName: fc,
  useActions: Gs,
  useState: Uu,
  views: OD
}, Symbol.toStringTag, { value: "Module" })), Bu = "uploads", Gu = { key: "path", direction: W.enum.Ascending }, bt = i.object({
  path: i.string()
}), Hs = i.map(i.string(), bt), UD = bt.loose(), ro = i.codec(i.string(), bt, {
  decode: (e) => ({ uuid: ye(), path: e }),
  encode: (e) => e.path
}), Hu = i.codec(i.object({ StorageFiles: i.array(ro) }), Hs, {
  decode: (e) => new Map(e.StorageFiles.map((t) => [t.path, t])),
  encode: (e) => ({ StorageFiles: Array.from(e.values()) })
}), Ku = i.codec(i.object({ StorageSet: ro }), bt, {
  decode: (e) => e.StorageSet,
  encode: (e) => ({ StorageSet: e })
}), qu = i.codec(i.object({ Storage: ro }), bt, {
  decode: (e) => e.Storage,
  encode: (e) => ({ Storage: e })
}), Wu = i.codec(i.object({ StorageRemove: i.string() }), i.string(), {
  decode: (e) => e.StorageRemove,
  encode: (e) => ({ StorageRemove: e })
}), Zu = i.codec(i.object({ StorageRemoved: i.string() }), i.string(), {
  decode: (e) => e.StorageRemoved,
  encode: (e) => ({ StorageRemoved: e })
});
function Yu() {
  return {
    path: ""
  };
}
const Ju = le({
  name: Bu,
  identity: Hs
}).withSources(
  async function* (t) {
    for await (const o of t) {
      const a = Hu.safeParse(o);
      a.success && (yield () => a.data);
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = qu.safeParse(o);
      a.success && (yield (s) => new Map(s ?? []).set(a.data.path, a.data));
    }
  },
  async function* (t) {
    for await (const o of t) {
      const a = Zu.safeParse(o);
      a.success && (yield (s) => {
        const r = new Map(s ?? []);
        return r.delete(a.data), r;
      });
    }
  }
).withActions({
  remove(e, t) {
    e.send(Wu.encode(t));
  },
  update(e, t) {
    const o = bt.parse(t);
    e.send(Ku.encode(o));
  },
  seed: Yu
}), VD = x.from(Ju).pipe(x.shareReplay(1)), Ks = VD.pipe(
  x.map((e) => new Map(ID(e.values()).map((t) => [t.path, t]))),
  x.shareReplay(1)
), Xu = Ks.pipe(
  x.map((e) => e.values().next().value),
  x.filter(Boolean),
  x.shareReplay(1)
);
function* ID(e) {
  for (const t of e) {
    if (t.path.startsWith("/")) {
      yield t;
      continue;
    }
    const o = ["", "/api/uploads", t.path].join("/").replace(/\/\/+/g, "/");
    yield { ...t, path: o };
  }
}
function zD(e = {}) {
  const t = k(() => A(e.sort) ?? [Gu]), o = Z(Ks, { onError: U.error, initialValue: /* @__PURE__ */ new Map() }), a = k(() => ne(o.value.values(), Y(t.value))), s = k(() => ne(o.value.values(), Y(t.value)));
  return {
    count: k(() => me(o.value.size, s.value.length)),
    state: o,
    list: s,
    all: a
  };
}
function ND() {
  const e = Z(Xu, { onError: U.error, initialValue: null });
  return {
    path: k(() => e.value?.path)
  };
}
const p8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DEFAULT_SORT: Gu,
  Detail: bt,
  DetailMessage: qu,
  FormData: UD,
  ListMessage: Hu,
  MessageItem: ro,
  RemoveMessage: Wu,
  RemovedMessage: Zu,
  SCOPE: Bu,
  SetMessage: Ku,
  Store: Hs,
  planImage$: Xu,
  seed: Yu,
  service: Ju,
  state$: Ks,
  usePlanImage: ND,
  useState: zD
}, Symbol.toStringTag, { value: "Module" })), FD = { title: "Uzivatel", dialog: { title: "Detail uzivatele", description: "", create: "Vytvorit uzivatele", edit: "Upravit uzivatele", confirmDelete: "Opravdu chcete smazat tohoto uzivatele?" }, manage: "Spravovat uživatele", username: "Uzivatelske jmeno", password: { title: "Heslo", new: "Nove heslo", confirm: "Potvrzeni hesla", change: "Zmenit heslo", changed: "Heslo zmeneno", mismatch: "Hesla se neshoduji" }, roles: "Role", tokens: { title: "Tokeny", create: "Vytvorit token", revoke: "Zrusit", nonce: "Token", copyNow: "Token si teď zkopírujte: zobrazí se jen jednou.", created: "Vytvoreno", expiration: "Expirace", noExpiration: "Bez expirace", empty: "Zadne tokeny" } }, BD = { title: "Uzivatele", config: { title: "Uzivatele", description: "Sprava uzivatelu a jejich pristupovych tokenu" } }, GD = {
  user: FD,
  users: BD
}, HD = { title: "User", dialog: { title: "User detail", description: "", create: "Create user", edit: "Edit user", confirmDelete: "Are you sure you want to delete this user?" }, username: "Username", manage: "Manage user", password: { title: "Password", new: "New password", confirm: "Confirm password", change: "Change password", changed: "Password changed", mismatch: "Passwords do not match" }, roles: "Roles", tokens: { title: "Tokens", create: "Create token", revoke: "Revoke", nonce: "Token", copyNow: "Copy the token now: it is shown only once.", created: "Created", expiration: "Expiration", noExpiration: "No expiration", empty: "No tokens" } }, KD = { title: "Users", config: { title: "Users", description: "Manage users and their access tokens" } }, qD = {
  user: HD,
  users: KD
}, WD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cs: GD,
  en: qD
}, Symbol.toStringTag, { value: "Module" }));
function ZD(e) {
  const t = ks, o = i.array(t), a = ws, s = i.array(a), r = i.undefined();
  return {
    async fetchAll(d) {
      return e.get("users", o, d);
    },
    async fetchOne(d, p) {
      return e.get(`users/${d}`, t, p);
    },
    async create(d, p) {
      return e.post("users", { uuid: crypto.randomUUID(), ...d }, t, p);
    },
    async update(d, p, g) {
      return e.put(`users/${d}`, p, t, g);
    },
    async remove(d, p) {
      return e.delete(`users/${d}`, p);
    },
    async changePassword(d, p, g) {
      return e.put(`users/${d}/password`, { password: p }, r, g);
    },
    async fetchTokens(d, p) {
      return e.get(`users/${d}/tokens`, s, p);
    },
    async createToken(d, p, g) {
      return e.post(`users/${d}/tokens`, { expiration: p?.toISOString() ?? null }, a, g);
    },
    async revokeToken(d, p, g) {
      return e.delete(`users/${d}/tokens/${p}`, g);
    }
  };
}
const YD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createRestApi: ZD
}, Symbol.toStringTag, { value: "Module" }));
let Zo = null;
const $e = fe(/* @__PURE__ */ new Map());
function JD(e) {
  Zo = e;
}
function Je() {
  if (!Zo) throw new Error("User REST API not initialized. Call User.init() first.");
  return Zo;
}
async function XD() {
  const e = await Je().fetchAll(), t = new Map(e.map((o) => [o.uuid, o]));
  return $e.value = t, t;
}
function Qu(e = {}) {
  const t = k(() => Y($e.value.values(), A(e.sort) ?? Mn));
  return {
    count: k(() => me($e.value.size, t.value.length)),
    store: $e,
    list: t
  };
}
function QD(e) {
  return { detail: k(() => {
    const o = A(e);
    return o ? $e.value.get(o) ?? null : null;
  }) };
}
function ed({ input: e } = {}) {
  const { t } = R({ useScope: "global" }), o = Se(Uo()), a = q(null), s = k(() => !!a.value), r = k(() => a.value ? o.username !== a.value.username || JSON.stringify(o.roles) !== JSON.stringify(a.value.roles) : !0), d = k(() => s.value ? t("user.dialog.edit", "") : t("user.dialog.create", ""));
  function p() {
    const g = A(e);
    g ? (Object.assign(o, {
      uuid: g.uuid,
      username: g.username,
      password: "",
      roles: [...g.roles]
    }), a.value = g) : (Object.assign(o, Uo()), a.value = null);
  }
  return De(
    () => A(e),
    () => p(),
    { immediate: !0 }
  ), Se({
    data: o,
    isUpdate: s,
    hasChanges: r,
    title: d,
    reset: p,
    save: H(async (g) => {
      if (s.value) {
        const S = await Je().update(o.uuid, { username: o.username, roles: o.roles });
        $e.value = new Map($e.value).set(S.uuid, S);
      } else {
        const S = await Je().create({ username: o.username, password: o.password ?? "", roles: o.roles });
        $e.value = new Map($e.value).set(S.uuid, S), g?.created?.();
      }
    }),
    remove: H(async () => {
      if (!o.uuid) return;
      await Je().remove(o.uuid);
      const g = new Map($e.value);
      g.delete(o.uuid), $e.value = g;
    })
  });
}
function td(e) {
  const { t } = R({ useScope: "global" }), o = q(""), a = q(""), s = q(null), r = k(() => o.value.length > 0 && o.value === a.value);
  return {
    password: o,
    confirmPassword: a,
    error: s,
    isValid: r,
    submit: H(async () => {
      if (s.value = null, !r.value) {
        s.value = t("user.password.mismatch", "Passwords do not match");
        return;
      }
      await Je().changePassword(A(e), o.value), o.value = "", a.value = "";
    })
  };
}
function nd(e) {
  const t = fe([]), o = q(!1);
  async function a() {
    o.value = !0;
    try {
      t.value = await Je().fetchTokens(A(e));
    } catch (s) {
      U.error(s);
    } finally {
      o.value = !1;
    }
  }
  return {
    tokens: t,
    loading: o,
    fetchTokens: H(a),
    createToken: H(async (s) => {
      const r = await Je().createToken(A(e), s);
      t.value = [...t.value, r];
    }),
    revokeToken: H(async (s) => {
      await Je().revokeToken(A(e), s), t.value = t.value.filter((r) => r.id !== s);
    })
  };
}
const e2 = ["onSubmit"], t2 = ["aria-label"], n2 = ["textContent"], o2 = ["textContent"], a2 = ["placeholder"], s2 = { class: "px-6 grid gap-4" }, i2 = {
  for: "user-password",
  class: "label"
}, r2 = ["placeholder"], l2 = { class: "label" }, c2 = { class: "flex gap-2 flex-wrap" }, u2 = ["onClick"], qs = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "Dialog",
  props: {
    user: {}
  },
  setup(e) {
    const t = e, { t: o } = R({ useScope: "global" }), a = ed({ input: () => t.user });
    function s(r) {
      const d = a.data.roles.indexOf(r);
      d >= 0 ? a.data.roles.splice(d, 1) : a.data.roles.push(r);
    }
    return (r, d) => (u(), b(n(T).Root, {
      "onUpdate:open": d[4] || (d[4] = (p) => n(a).reset())
    }, {
      default: f(({ close: p }) => [
        m(n(T).Trigger, { "as-child": "" }, {
          default: f(() => [
            P(r.$slots, "default", {}, () => [
              l("button", ae({
                type: "button",
                class: "btn"
              }, r.$attrs), [
                e.user ? (u(), b(n(D), {
                  key: 0,
                  icon: "edit"
                })) : (u(), b(n(D), {
                  key: 1,
                  icon: "add"
                }))
              ], 16)
            ])
          ]),
          _: 3
        }),
        m(n(T).Portal, null, {
          default: f(() => [
            m(n(T).Overlay, { class: "overlay" }),
            m(n(T).Content, {
              class: "dialog",
              "as-child": ""
            }, {
              default: f(() => [
                l("form", {
                  ref: "formElement",
                  onSubmit: X((g) => n(a).save.submit({ created: p }), ["prevent"])
                }, [
                  n(a).isUpdate ? (u(), v("input", {
                    key: 0,
                    type: "text",
                    autofocus: "",
                    tabindex: "0",
                    class: "sr-only",
                    "aria-label": n(a).title
                  }, null, 8, t2)) : y("", !0),
                  m(n(J), {
                    icon: Qn
                  }, {
                    title: f(() => [
                      m(n(T).Title, { class: "headline grow" }, {
                        default: f(() => [
                          l("span", {
                            class: "sr-only",
                            textContent: c(n(a).title)
                          }, null, 8, n2),
                          l("label", {
                            for: "user-username",
                            class: "sr-only",
                            textContent: c(n(o)("user.username"))
                          }, null, 8, o2),
                          L(l("input", {
                            id: "user-username",
                            "onUpdate:modelValue": d[0] || (d[0] = (g) => n(a).data.username = g),
                            class: "input",
                            type: "text",
                            placeholder: n(o)("user.username")
                          }, null, 8, a2), [
                            [j, n(a).data.username]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    description: f(() => [
                      m(n(T).Description, { class: "paragraph description" }, {
                        default: f(() => [
                          $(c(n(o)("user.dialog.description", "")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    row: f(() => [
                      m(n(Ue), { entity: e.user }, null, 8, ["entity"])
                    ]),
                    _: 1
                  }, 8, ["icon"]),
                  l("div", s2, [
                    n(a).isUpdate ? y("", !0) : (u(), v(I, { key: 0 }, [
                      l("label", i2, c(n(o)("user.password.title")), 1),
                      L(l("input", {
                        id: "user-password",
                        "onUpdate:modelValue": d[1] || (d[1] = (g) => n(a).data.password = g),
                        class: "input",
                        type: "password",
                        placeholder: n(o)("user.password.new")
                      }, null, 8, r2), [
                        [j, n(a).data.password]
                      ])
                    ], 64)),
                    l("label", l2, c(n(o)("user.roles")), 1),
                    l("div", c2, [
                      (u(!0), v(I, null, te(bc, (g) => (u(), v("button", {
                        key: g,
                        type: "button",
                        class: ke(["btn", { "btn-filled": n(a).data.roles.includes(g) }]),
                        onClick: (S) => s(g)
                      }, c(g), 11, u2))), 128))
                    ])
                  ]),
                  m(n(he), {
                    class: "px-6",
                    "has-data": n(a).isUpdate,
                    "has-changes": n(a).hasChanges,
                    onClose: p,
                    onRemove: d[2] || (d[2] = (g) => n(a).remove.submit()),
                    onUndo: d[3] || (d[3] = (g) => n(a).reset())
                  }, null, 8, ["has-data", "has-changes", "onClose"])
                ], 40, e2)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }));
  }
}), d2 = { class: "grid gap-2" }, m2 = {
  for: "new-password",
  class: "label"
}, p2 = { class: "grid gap-2" }, f2 = {
  for: "confirm-password",
  class: "label"
}, g2 = {
  key: 0,
  class: "text-accent-red text-sm"
}, v2 = { class: "flex justify-end" }, b2 = ["disabled"], od = /* @__PURE__ */ C({
  __name: "PasswordForm",
  props: {
    uuid: {}
  },
  setup(e) {
    const t = e, { t: o } = R({ useScope: "global" }), { password: a, confirmPassword: s, error: r, isValid: d, submit: p } = td(() => t.uuid);
    return (g, S) => (u(), v("form", {
      class: "grid gap-4",
      onSubmit: S[2] || (S[2] = X((h) => n(p).submit(), ["prevent"]))
    }, [
      l("div", d2, [
        l("label", m2, c(n(o)("user.password.new")), 1),
        L(l("input", {
          id: "new-password",
          "onUpdate:modelValue": S[0] || (S[0] = (h) => st(a) ? a.value = h : null),
          class: "input",
          type: "password",
          autocomplete: "new-password"
        }, null, 512), [
          [j, n(a)]
        ])
      ]),
      l("div", p2, [
        l("label", f2, c(n(o)("user.password.confirm")), 1),
        L(l("input", {
          id: "confirm-password",
          "onUpdate:modelValue": S[1] || (S[1] = (h) => st(s) ? s.value = h : null),
          class: "input",
          type: "password",
          autocomplete: "new-password"
        }, null, 512), [
          [j, n(s)]
        ])
      ]),
      n(r) ? (u(), v("p", g2, c(n(r)), 1)) : y("", !0),
      l("div", v2, [
        l("button", {
          type: "submit",
          class: "btn btn-filled",
          disabled: !n(d)
        }, [
          m(n(D), { icon: "lock_reset" }),
          $(" " + c(n(o)("user.password.change")), 1)
        ], 8, b2)
      ])
    ], 32));
  }
}), y2 = { class: "grid gap-4" }, h2 = { class: "flex justify-end" }, _2 = {
  key: 0,
  class: "text-center py-4"
}, $2 = {
  key: 1,
  class: "text-center py-4 opacity-60"
}, S2 = {
  key: 2,
  class: "grid gap-2"
}, k2 = { class: "grid gap-1 grow min-w-0" }, w2 = { class: "flex items-center gap-2" }, x2 = {
  key: 0,
  class: "text-sm break-all select-all"
}, C2 = ["title"], T2 = {
  key: 0,
  class: "text-xs text-accent-red"
}, R2 = { class: "flex gap-4 text-xs opacity-60" }, D2 = ["onClick"], ad = /* @__PURE__ */ C({
  __name: "TokenList",
  props: {
    uuid: {}
  },
  setup(e) {
    const t = e, { t: o } = R({ useScope: "global" }), { tokens: a, loading: s, fetchTokens: r, createToken: d, revokeToken: p } = nd(() => t.uuid);
    hd(() => r.submit());
    function g(S) {
      return S ? (S instanceof Date ? S : new Date(S)).toLocaleString() : o("user.tokens.noExpiration");
    }
    return (S, h) => (u(), v("div", y2, [
      l("div", h2, [
        l("button", {
          type: "button",
          class: "btn btn-filled",
          onClick: h[0] || (h[0] = (_) => n(d).submit())
        }, [
          m(n(D), { icon: "add" }),
          $(" " + c(n(o)("user.tokens.create")), 1)
        ])
      ]),
      n(s) ? (u(), v("div", _2, [
        m(n(D), { icon: "hourglass_empty" })
      ])) : n(a).length === 0 ? (u(), v("div", $2, c(n(o)("user.tokens.empty")), 1)) : (u(), v("div", S2, [
        (u(!0), v(I, null, te(n(a), (_) => (u(), v("div", {
          key: _.id,
          class: "flex items-center gap-4 p-3 rounded-lg bg-surface-secondary"
        }, [
          l("div", k2, [
            l("div", w2, [
              m(n(D), {
                icon: "key",
                class: "opacity-60"
              }),
              _.nonce ? (u(), v("code", x2, c(_.nonce), 1)) : (u(), v("code", {
                key: 1,
                class: "text-sm truncate opacity-60",
                title: _.id
              }, c(_.id), 9, C2))
            ]),
            _.nonce ? (u(), v("div", T2, c(n(o)("user.tokens.copyNow")), 1)) : y("", !0),
            l("div", R2, [
              l("span", null, c(n(o)("user.tokens.created")) + ": " + c(g(_.created)), 1),
              l("span", null, c(n(o)("user.tokens.expiration")) + ": " + c(g(_.expiration)), 1)
            ])
          ]),
          l("button", {
            type: "button",
            class: "btn text-accent-red shrink-0",
            onClick: (w) => n(p).submit(_.id)
          }, [
            m(n(D), { icon: "delete" }),
            $(" " + c(n(o)("user.tokens.revoke")), 1)
          ], 8, D2)
        ]))), 128))
      ]))
    ]));
  }
}), M2 = ["aria-label"], E2 = { class: "grid gap-0" }, P2 = { class: "px-6 pt-6 pb-2 flex items-center gap-3" }, L2 = { class: "flex gap-1" }, j2 = { class: "flex justify-end px-6 pb-6" }, A2 = {
  type: "button",
  class: "btn"
}, sd = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "DetailPanel",
  props: {
    user: {}
  },
  setup(e) {
    const { t } = R({ useScope: "global" }), o = q("password");
    return (a, s) => (u(), b(n(T).Root, null, {
      default: f(() => [
        m(n(T).Trigger, { "as-child": "" }, {
          default: f(() => [
            P(a.$slots, "default", {}, () => [
              l("button", ae({
                type: "button",
                class: "btn",
                "aria-label": n(t)("user.manage")
              }, a.$attrs), [
                m(n(D), { icon: "manage_accounts" })
              ], 16, M2)
            ])
          ]),
          _: 3
        }),
        m(n(T).Portal, null, {
          default: f(() => [
            m(n(T).Overlay, { class: "overlay" }),
            m(n(T).Content, {
              class: "dialog",
              "as-child": ""
            }, {
              default: f(() => [
                l("div", E2, [
                  l("div", P2, [
                    m(n(D), {
                      icon: Qn
                    }, null, 8, ["icon"]),
                    m(n(T).Title, { class: "headline grow" }, {
                      default: f(() => [
                        $(c(e.user.username), 1)
                      ]),
                      _: 1
                    }),
                    l("div", L2, [
                      (u(!0), v(I, null, te(e.user.roles, (r) => (u(), b(n(B), { key: r }, {
                        default: f(() => [
                          $(c(r), 1)
                        ]),
                        _: 2
                      }, 1024))), 128))
                    ])
                  ]),
                  m(n(ee).Root, {
                    modelValue: o.value,
                    "onUpdate:modelValue": s[0] || (s[0] = (r) => o.value = r),
                    class: "grid grid-rows-[max-content_1fr]",
                    "unmount-on-hide": ""
                  }, {
                    default: f(() => [
                      m(n(ee).List, { class: "flex gap-6 items-center justify-center relative border-b px-6" }, {
                        default: f(() => [
                          m(n(ee).Trigger, {
                            value: "password",
                            class: "btn",
                            "aria-label": n(t)("user.password.title")
                          }, {
                            default: f(() => [
                              m(n(D), {
                                icon: "lock",
                                class: "mr-2"
                              }),
                              $(" " + c(n(t)("user.password.title")), 1)
                            ]),
                            _: 1
                          }, 8, ["aria-label"]),
                          m(n(ee).Trigger, {
                            value: "tokens",
                            class: "btn",
                            "aria-label": n(t)("user.tokens.title")
                          }, {
                            default: f(() => [
                              m(n(D), {
                                icon: vc,
                                class: "mr-2"
                              }, null, 8, ["icon"]),
                              $(" " + c(n(t)("user.tokens.title")), 1)
                            ]),
                            _: 1
                          }, 8, ["aria-label"]),
                          m(n(ee).Indicator, { class: "absolute px-8 left-0 h-1.25 bg-accent-blue bottom-0 w-(--reka-tabs-indicator-size) translate-x-(--reka-tabs-indicator-position) translate-y-0.75 rounded-full transition-[width,transform] duration-300" }, {
                            default: f(() => [...s[1] || (s[1] = [
                              l("div", { class: "bg-grass8 w-full h-full" }, null, -1)
                            ])]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      m(n(ee).Content, {
                        value: "password",
                        class: "px-6 pt-6 pb-6"
                      }, {
                        default: f(() => [
                          m(od, {
                            uuid: e.user.uuid
                          }, null, 8, ["uuid"])
                        ]),
                        _: 1
                      }),
                      m(n(ee).Content, {
                        value: "tokens",
                        class: "px-6 pt-6 pb-6"
                      }, {
                        default: f(() => [
                          m(ad, {
                            uuid: e.user.uuid
                          }, null, 8, ["uuid"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  l("div", j2, [
                    m(n(T).Close, { "as-child": "" }, {
                      default: f(() => [
                        l("button", A2, [
                          m(n(D), { icon: "close" }),
                          $(" " + c(n(t)("action.close", "Close")), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 3
    }));
  }
}), O2 = {
  key: 1,
  class: "self-center px-2"
}, U2 = { key: 3 }, V2 = {
  type: "button",
  class: "item grid grid-cols-subgrid col-[1/-2] h-12 items-center pl-6 gap-4"
}, I2 = ["title"], z2 = {
  key: 1,
  class: "flex gap-1 flex-wrap"
}, id = /* @__PURE__ */ C({
  __name: "List",
  props: {
    users: {}
  },
  setup(e) {
    const { t } = R({ useScope: "global" }), { gridStyle: o, rowStyle: a, visible: s } = de(!0);
    return (r, d) => (u(), v("section", {
      class: "list grid content-start min-w-0",
      style: K(n(o))
    }, [
      l("header", {
        class: "headline",
        style: K(n(a))
      }, [
        n(s).username ? (u(), b(n(z).SortTrigger, {
          key: 0,
          "sort-key": "username"
        }, {
          default: f(() => [
            $(c(n(t)("user.username")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).roles ? (u(), v("span", O2, c(n(t)("user.roles")), 1)) : y("", !0),
        n(s).uuid ? (u(), b(n(z).SortTrigger, {
          key: 2,
          "sort-key": "uuid"
        }, {
          default: f(() => [
            $(c(n(t)("entity.uuid")), 1)
          ]),
          _: 1
        })) : y("", !0),
        n(s).actions ? (u(), v("span", U2)) : y("", !0)
      ], 4),
      (u(!0), v(I, null, te(e.users, (p) => (u(), v("div", {
        key: p.uuid,
        class: "grid grid-cols-subgrid not-first:border-t items-center pr-6 gap-4",
        style: K(n(a))
      }, [
        m(qs, { user: p }, {
          default: f(() => [
            l("button", V2, [
              n(s).username ? (u(), v("strong", {
                key: 0,
                class: "value text-left truncate",
                title: p.username
              }, c(p.username), 9, I2)) : y("", !0),
              n(s).roles ? (u(), v("span", z2, [
                (u(!0), v(I, null, te(p.roles, (g) => (u(), b(n(B), { key: g }, {
                  default: f(() => [
                    $(c(g), 1)
                  ]),
                  _: 2
                }, 1024))), 128))
              ])) : y("", !0),
              n(s).uuid ? (u(), b(n(Pt), {
                key: 2,
                class: "max-w-32",
                value: p.uuid
              }, null, 8, ["value"])) : y("", !0)
            ])
          ]),
          _: 2
        }, 1032, ["user"]),
        n(s).actions ? (u(), b(sd, {
          key: 0,
          user: p
        }, null, 8, ["user"])) : y("", !0)
      ], 4))), 128)),
      P(r.$slots, "default")
    ], 4));
  }
}), N2 = { class: "headline" }, F2 = /* @__PURE__ */ C({
  __name: "Config",
  setup(e) {
    const { t } = R({ useScope: "global" }), { enabled: o } = Ce(), a = je({ key: "username", fill: !0 }, { key: "roles" }, { key: "uuid", visible: () => o.value }, { key: "actions" }), { sort: s } = Ae({ initialSort: Mn, fields: a }), { count: r, list: d } = Qu({ sort: () => [s.value, Mn] });
    return (p, g) => (u(), v(I, null, [
      m(n(J), {
        description: n(t)("users.config.description", "")
      }, {
        title: f(() => [
          l("h1", N2, c(n(t)("users.config.title")), 1),
          m(n(B), null, {
            default: f(() => [
              $(c(n(r)), 1)
            ]),
            _: 1
          }),
          g[0] || (g[0] = l("span", { class: "grow" }, null, -1)),
          m(qs)
        ]),
        _: 1
      }, 8, ["description"]),
      m(id, {
        class: "pb-12",
        users: n(d)
      }, null, 8, ["users"])
    ], 64));
  }
}), B2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Config: F2
}, Symbol.toStringTag, { value: "Module" })), f8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DEFAULT_SORT: Mn,
  Detail: ks,
  DetailPanel: sd,
  Dialog: qs,
  FormData: E1,
  ICON: Qn,
  List: id,
  PasswordForm: od,
  ROLES: bc,
  SCOPE: D1,
  Store: M1,
  TOKEN_ICON: vc,
  TokenDetail: ws,
  TokenList: ad,
  TokenStore: P1,
  fetchAll: XD,
  i18n: WD,
  init: JD,
  rest: YD,
  seed: Uo,
  useDetail: QD,
  useForm: ed,
  usePasswordForm: td,
  useState: Qu,
  useTokens: nd,
  views: B2
}, Symbol.toStringTag, { value: "Module" }));
function rd() {
  return {
    state: Z(da, { onError: U.error, initialValue: null })
  };
}
const ld = /* @__PURE__ */ C({
  __name: "Root",
  setup(e) {
    const { state: t } = rd();
    return (o, a) => P(o.$slots, "default", { state: n(t) });
  }
}), G2 = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "Info",
  setup(e) {
    const { enabled: t } = Ce();
    return (o, a) => (u(), b(ld, null, {
      default: f(({ state: s }) => [
        s ? (u(), v(I, { key: 0 }, [
          n(t) ? (u(), b(n(it), {
            key: 0,
            value: s.commit,
            display: n(aa)(s.commit)
          }, null, 8, ["value", "display"])) : y("", !0),
          $(" " + c(s.number), 1)
        ], 64)) : y("", !0)
      ]),
      _: 1
    }));
  }
}), g8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Backend: Sn,
  Info: G2,
  Root: ld,
  SCOPE: Li,
  VersionMessage: ji,
  service: Ai,
  state$: da,
  useState: rd
}, Symbol.toStringTag, { value: "Module" }));
export {
  tM as APP_CONFIG,
  mM as Accordion,
  o8 as ActiveAlarm,
  XM as Activity,
  YM as Alarm,
  pM as AlertDialog,
  _8 as AspectRatio,
  a8 as AuditLog,
  s8 as Auth,
  fM as Avatar,
  m8 as Backup,
  B as Badge,
  _t as BooleanIcon,
  gr as Breadcrumbs,
  gM as Calendar,
  vM as Checkbox,
  bM as Collapsible,
  yM as Combobox,
  JM as Config,
  r8 as Contact,
  i8 as ContactGroup,
  J as ContentHeader,
  hM as ContextMenu,
  it as CopyBadge,
  Jv as DEFAULT_LOCALE,
  _M as DateField,
  $M as DatePicker,
  kM as DateRangeField,
  SM as DateRangePicker,
  n8 as Device,
  T as Dialog,
  he as DialogActions,
  wM as DropdownMenu,
  xM as Editable,
  l8 as Event,
  u8 as EventMapping,
  ea as FEATURE_FLAGS,
  ta as FEATURE_FLAGS_KEY,
  Qo as FeatureFlag,
  c8 as FeatureFlags,
  CM as HoverCard,
  D as Icon,
  $8 as Label,
  z as List,
  yn as Listbox,
  Ji as LoadingSpinner,
  QM as Location,
  ni as Logo,
  Xv as MAC_BASE,
  li as MacAddress,
  TM as Menubar,
  tb as NOTICE_TIMEOUT,
  RM as NavigationMenu,
  KM as Notices,
  d8 as Notification,
  DM as NumberField,
  Ty as OfflineWarning,
  qM as PageContainer,
  zy as PageFooter,
  Xy as PageHeader,
  WM as PageLayout,
  MM as Pagination,
  EM as PinInput,
  PM as Popover,
  S8 as Presence,
  LM as Progress,
  Qv as REGEX,
  eb as REST_BASE_PATH,
  jM as RadioGroup,
  AM as RangeCalendar,
  Jo as RestApiError,
  t8 as Room,
  e8 as Scanner,
  OM as ScrollArea,
  ge as Select,
  k8 as Separator,
  re as SimpleSelect,
  UM as Slider,
  W as SortDirection,
  fb as SortRule,
  VM as Splitter,
  IM as Stepper,
  ie as Switch,
  ee as Tabs,
  zM as TagsInput,
  NM as Toast,
  w8 as Toggle,
  FM as ToggleGroup,
  BM as Toolbar,
  GM as Tooltip,
  HM as Tree,
  Pt as TruncatedBadge,
  p8 as Upload,
  f8 as User,
  nh as Uuid,
  Ue as UuidBadge,
  g8 as Version,
  x8 as Viewport,
  Pi as abortable,
  xb as asyncIterableFromEvent,
  vb as changeSortRule,
  Xo as confirmThen,
  ib as connectToWebSocket,
  ub as connected$,
  cM as createRestClient,
  lo as defer,
  je as defineListFields,
  We as defineRestEndpoint,
  le as defineService,
  aM as defineWebSocketServices,
  ab as describeError,
  nM as determineWebSocketURL,
  ci as dismissNotice,
  oM as featureFlags,
  lb as featureFlagsConsole,
  aa as formatCommit,
  me as formatCount,
  y8 as generateUUID,
  _b as hasFormChanges,
  lM as i18n,
  ot as intersectFilters,
  sM as intl,
  Ei as isAsyncIterable,
  rM as isAsyncIterator,
  jn as isFeatureEnabled,
  Ln as isoDatetimeToDate,
  U as logger,
  qe as mapStoreHelpers,
  Cb as mergeAsyncIterables,
  $b as mergeLiveFields,
  wb as mergeSignals,
  ob as notices,
  db as orchestrateWebSocketAndServices,
  rb as parseFeatureFlags,
  en as pushNotice,
  Js as reloadFeatureFlags,
  $n as setFeatureFlag,
  ZM as sms,
  Y as sortByRules,
  kb as syncStorageWithSubject,
  dM as toPromise,
  uM as unionFilters,
  H as useAction,
  oa as useConnection,
  Ce as useDebug,
  Qe as useEntityForm,
  sy as useEntityUuid,
  Ct as useFeatureFlag,
  Oe as useFormat,
  Ae as useList,
  de as useListContext,
  et as useNormalizedEntitySelect,
  iM as useSelect,
  bb as useSort,
  pi as useWideList,
  ti as withAbort
};
//# sourceMappingURL=index.js.map
